var nu = Object.defineProperty, su = Object.defineProperties;
var au = Object.getOwnPropertyDescriptors;
var Yo = Object.getOwnPropertySymbols;
var ru = Object.prototype.hasOwnProperty, iu = Object.prototype.propertyIsEnumerable;
var Uo = Math.pow, Br = (s, n, e) => n in s ? nu(s, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[n] = e, ge = (s, n) => {
  for (var e in n || (n = {}))
    ru.call(n, e) && Br(s, e, n[e]);
  if (Yo)
    for (var e of Yo(n))
      iu.call(n, e) && Br(s, e, n[e]);
  return s;
}, ct = (s, n) => su(s, au(n));
var Bo = (s, n, e) => (Br(s, typeof n != "symbol" ? n + "" : n, e), e);
var Re = (s, n, e) => new Promise((t, a) => {
  var i = (l) => {
    try {
      o(e.next(l));
    } catch (u) {
      a(u);
    }
  }, r = (l) => {
    try {
      o(e.throw(l));
    } catch (u) {
      a(u);
    }
  }, o = (l) => l.done ? t(l.value) : Promise.resolve(l.value).then(i, r);
  o((e = e.apply(s, n)).next());
});
import { readonly as ou, reactive as lu, computed as ls, openBlock as Me, createElementBlock as gt, createElementVNode as ae, toDisplayString as Ge, unref as Q, normalizeClass as na, watch as sa, onMounted as fn, onUnmounted as Ms, normalizeStyle as qa, createVNode as Zi, Fragment as yi, renderList as ic, ref as ln, createBlock as _t, createCommentVNode as mt, withDirectives as oc, vModelText as cu, vShow as du } from "vue";
function lc(s, n) {
  return function() {
    return s.apply(n, arguments);
  };
}
const { toString: uu } = Object.prototype, { getPrototypeOf: eo } = Object, wr = ((s) => (n) => {
  const e = uu.call(n);
  return s[e] || (s[e] = e.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), _n = (s) => (s = s.toLowerCase(), (n) => wr(n) === s), xr = (s) => (n) => typeof n === s, { isArray: Is } = Array, aa = xr("undefined");
function hu(s) {
  return s !== null && !aa(s) && s.constructor !== null && !aa(s.constructor) && Gt(s.constructor.isBuffer) && s.constructor.isBuffer(s);
}
const cc = _n("ArrayBuffer");
function mu(s) {
  let n;
  return typeof ArrayBuffer != "undefined" && ArrayBuffer.isView ? n = ArrayBuffer.isView(s) : n = s && s.buffer && cc(s.buffer), n;
}
const pu = xr("string"), Gt = xr("function"), dc = xr("number"), Cr = (s) => s !== null && typeof s == "object", fu = (s) => s === !0 || s === !1, Ga = (s) => {
  if (wr(s) !== "object")
    return !1;
  const n = eo(s);
  return (n === null || n === Object.prototype || Object.getPrototypeOf(n) === null) && !(Symbol.toStringTag in s) && !(Symbol.iterator in s);
}, _u = _n("Date"), vu = _n("File"), gu = _n("Blob"), yu = _n("FileList"), bu = (s) => Cr(s) && Gt(s.pipe), Du = (s) => {
  let n;
  return s && (typeof FormData == "function" && s instanceof FormData || Gt(s.append) && ((n = wr(s)) === "formdata" || // detect form-data instance
  n === "object" && Gt(s.toString) && s.toString() === "[object FormData]"));
}, wu = _n("URLSearchParams"), xu = (s) => s.trim ? s.trim() : s.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function ua(s, n, { allOwnKeys: e = !1 } = {}) {
  if (s === null || typeof s == "undefined")
    return;
  let t, a;
  if (typeof s != "object" && (s = [s]), Is(s))
    for (t = 0, a = s.length; t < a; t++)
      n.call(null, s[t], t, s);
  else {
    const i = e ? Object.getOwnPropertyNames(s) : Object.keys(s), r = i.length;
    let o;
    for (t = 0; t < r; t++)
      o = i[t], n.call(null, s[o], o, s);
  }
}
function uc(s, n) {
  n = n.toLowerCase();
  const e = Object.keys(s);
  let t = e.length, a;
  for (; t-- > 0; )
    if (a = e[t], n === a.toLowerCase())
      return a;
  return null;
}
const hc = (() => typeof globalThis != "undefined" ? globalThis : typeof self != "undefined" ? self : typeof window != "undefined" ? window : global)(), mc = (s) => !aa(s) && s !== hc;
function bi() {
  const { caseless: s } = mc(this) && this || {}, n = {}, e = (t, a) => {
    const i = s && uc(n, a) || a;
    Ga(n[i]) && Ga(t) ? n[i] = bi(n[i], t) : Ga(t) ? n[i] = bi({}, t) : Is(t) ? n[i] = t.slice() : n[i] = t;
  };
  for (let t = 0, a = arguments.length; t < a; t++)
    arguments[t] && ua(arguments[t], e);
  return n;
}
const Cu = (s, n, e, { allOwnKeys: t } = {}) => (ua(n, (a, i) => {
  e && Gt(a) ? s[i] = lc(a, e) : s[i] = a;
}, { allOwnKeys: t }), s), Su = (s) => (s.charCodeAt(0) === 65279 && (s = s.slice(1)), s), Tu = (s, n, e, t) => {
  s.prototype = Object.create(n.prototype, t), s.prototype.constructor = s, Object.defineProperty(s, "super", {
    value: n.prototype
  }), e && Object.assign(s.prototype, e);
}, Eu = (s, n, e, t) => {
  let a, i, r;
  const o = {};
  if (n = n || {}, s == null)
    return n;
  do {
    for (a = Object.getOwnPropertyNames(s), i = a.length; i-- > 0; )
      r = a[i], (!t || t(r, s, n)) && !o[r] && (n[r] = s[r], o[r] = !0);
    s = e !== !1 && eo(s);
  } while (s && (!e || e(s, n)) && s !== Object.prototype);
  return n;
}, ku = (s, n, e) => {
  s = String(s), (e === void 0 || e > s.length) && (e = s.length), e -= n.length;
  const t = s.indexOf(n, e);
  return t !== -1 && t === e;
}, Mu = (s) => {
  if (!s)
    return null;
  if (Is(s))
    return s;
  let n = s.length;
  if (!dc(n))
    return null;
  const e = new Array(n);
  for (; n-- > 0; )
    e[n] = s[n];
  return e;
}, Iu = ((s) => (n) => s && n instanceof s)(typeof Uint8Array != "undefined" && eo(Uint8Array)), Nu = (s, n) => {
  const t = (s && s[Symbol.iterator]).call(s);
  let a;
  for (; (a = t.next()) && !a.done; ) {
    const i = a.value;
    n.call(s, i[0], i[1]);
  }
}, Ou = (s, n) => {
  let e;
  const t = [];
  for (; (e = s.exec(n)) !== null; )
    t.push(e);
  return t;
}, Lu = _n("HTMLFormElement"), Au = (s) => s.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(e, t, a) {
    return t.toUpperCase() + a;
  }
), Vo = (({ hasOwnProperty: s }) => (n, e) => s.call(n, e))(Object.prototype), Ru = _n("RegExp"), pc = (s, n) => {
  const e = Object.getOwnPropertyDescriptors(s), t = {};
  ua(e, (a, i) => {
    let r;
    (r = n(a, i, s)) !== !1 && (t[i] = r || a);
  }), Object.defineProperties(s, t);
}, Pu = (s) => {
  pc(s, (n, e) => {
    if (Gt(s) && ["arguments", "caller", "callee"].indexOf(e) !== -1)
      return !1;
    const t = s[e];
    if (Gt(t)) {
      if (n.enumerable = !1, "writable" in n) {
        n.writable = !1;
        return;
      }
      n.set || (n.set = () => {
        throw Error("Can not rewrite read-only method '" + e + "'");
      });
    }
  });
}, zu = (s, n) => {
  const e = {}, t = (a) => {
    a.forEach((i) => {
      e[i] = !0;
    });
  };
  return Is(s) ? t(s) : t(String(s).split(n)), e;
}, Hu = () => {
}, Fu = (s, n) => (s = +s, Number.isFinite(s) ? s : n), Vr = "abcdefghijklmnopqrstuvwxyz", jo = "0123456789", fc = {
  DIGIT: jo,
  ALPHA: Vr,
  ALPHA_DIGIT: Vr + Vr.toUpperCase() + jo
}, Yu = (s = 16, n = fc.ALPHA_DIGIT) => {
  let e = "";
  const { length: t } = n;
  for (; s--; )
    e += n[Math.random() * t | 0];
  return e;
};
function Uu(s) {
  return !!(s && Gt(s.append) && s[Symbol.toStringTag] === "FormData" && s[Symbol.iterator]);
}
const Bu = (s) => {
  const n = new Array(10), e = (t, a) => {
    if (Cr(t)) {
      if (n.indexOf(t) >= 0)
        return;
      if (!("toJSON" in t)) {
        n[a] = t;
        const i = Is(t) ? [] : {};
        return ua(t, (r, o) => {
          const l = e(r, a + 1);
          !aa(l) && (i[o] = l);
        }), n[a] = void 0, i;
      }
    }
    return t;
  };
  return e(s, 0);
}, Vu = _n("AsyncFunction"), ju = (s) => s && (Cr(s) || Gt(s)) && Gt(s.then) && Gt(s.catch), X = {
  isArray: Is,
  isArrayBuffer: cc,
  isBuffer: hu,
  isFormData: Du,
  isArrayBufferView: mu,
  isString: pu,
  isNumber: dc,
  isBoolean: fu,
  isObject: Cr,
  isPlainObject: Ga,
  isUndefined: aa,
  isDate: _u,
  isFile: vu,
  isBlob: gu,
  isRegExp: Ru,
  isFunction: Gt,
  isStream: bu,
  isURLSearchParams: wu,
  isTypedArray: Iu,
  isFileList: yu,
  forEach: ua,
  merge: bi,
  extend: Cu,
  trim: xu,
  stripBOM: Su,
  inherits: Tu,
  toFlatObject: Eu,
  kindOf: wr,
  kindOfTest: _n,
  endsWith: ku,
  toArray: Mu,
  forEachEntry: Nu,
  matchAll: Ou,
  isHTMLForm: Lu,
  hasOwnProperty: Vo,
  hasOwnProp: Vo,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: pc,
  freezeMethods: Pu,
  toObjectSet: zu,
  toCamelCase: Au,
  noop: Hu,
  toFiniteNumber: Fu,
  findKey: uc,
  global: hc,
  isContextDefined: mc,
  ALPHABET: fc,
  generateString: Yu,
  isSpecCompliantForm: Uu,
  toJSONObject: Bu,
  isAsyncFn: Vu,
  isThenable: ju
};
function He(s, n, e, t, a) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = s, this.name = "AxiosError", n && (this.code = n), e && (this.config = e), t && (this.request = t), a && (this.response = a);
}
X.inherits(He, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: X.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const _c = He.prototype, vc = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((s) => {
  vc[s] = { value: s };
});
Object.defineProperties(He, vc);
Object.defineProperty(_c, "isAxiosError", { value: !0 });
He.from = (s, n, e, t, a, i) => {
  const r = Object.create(_c);
  return X.toFlatObject(s, r, function(l) {
    return l !== Error.prototype;
  }, (o) => o !== "isAxiosError"), He.call(r, s.message, n, e, t, a), r.cause = s, r.name = s.name, i && Object.assign(r, i), r;
};
const Wu = null;
function Di(s) {
  return X.isPlainObject(s) || X.isArray(s);
}
function gc(s) {
  return X.endsWith(s, "[]") ? s.slice(0, -2) : s;
}
function Wo(s, n, e) {
  return s ? s.concat(n).map(function(a, i) {
    return a = gc(a), !e && i ? "[" + a + "]" : a;
  }).join(e ? "." : "") : n;
}
function $u(s) {
  return X.isArray(s) && !s.some(Di);
}
const qu = X.toFlatObject(X, {}, null, function(n) {
  return /^is[A-Z]/.test(n);
});
function Sr(s, n, e) {
  if (!X.isObject(s))
    throw new TypeError("target must be an object");
  n = n || new FormData(), e = X.toFlatObject(e, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, g) {
    return !X.isUndefined(g[p]);
  });
  const t = e.metaTokens, a = e.visitor || c, i = e.dots, r = e.indexes, l = (e.Blob || typeof Blob != "undefined" && Blob) && X.isSpecCompliantForm(n);
  if (!X.isFunction(a))
    throw new TypeError("visitor must be a function");
  function u(f) {
    if (f === null)
      return "";
    if (X.isDate(f))
      return f.toISOString();
    if (!l && X.isBlob(f))
      throw new He("Blob is not supported. Use a Buffer instead.");
    return X.isArrayBuffer(f) || X.isTypedArray(f) ? l && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function c(f, p, g) {
    let v = f;
    if (f && !g && typeof f == "object") {
      if (X.endsWith(p, "{}"))
        p = t ? p : p.slice(0, -2), f = JSON.stringify(f);
      else if (X.isArray(f) && $u(f) || (X.isFileList(f) || X.endsWith(p, "[]")) && (v = X.toArray(f)))
        return p = gc(p), v.forEach(function(b, D) {
          !(X.isUndefined(b) || b === null) && n.append(
            // eslint-disable-next-line no-nested-ternary
            r === !0 ? Wo([p], D, i) : r === null ? p : p + "[]",
            u(b)
          );
        }), !1;
    }
    return Di(f) ? !0 : (n.append(Wo(g, p, i), u(f)), !1);
  }
  const d = [], m = Object.assign(qu, {
    defaultVisitor: c,
    convertValue: u,
    isVisitable: Di
  });
  function h(f, p) {
    if (!X.isUndefined(f)) {
      if (d.indexOf(f) !== -1)
        throw Error("Circular reference detected in " + p.join("."));
      d.push(f), X.forEach(f, function(v, y) {
        (!(X.isUndefined(v) || v === null) && a.call(
          n,
          v,
          X.isString(y) ? y.trim() : y,
          p,
          m
        )) === !0 && h(v, p ? p.concat(y) : [y]);
      }), d.pop();
    }
  }
  if (!X.isObject(s))
    throw new TypeError("data must be an object");
  return h(s), n;
}
function $o(s) {
  const n = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(s).replace(/[!'()~]|%20|%00/g, function(t) {
    return n[t];
  });
}
function to(s, n) {
  this._pairs = [], s && Sr(s, this, n);
}
const yc = to.prototype;
yc.append = function(n, e) {
  this._pairs.push([n, e]);
};
yc.toString = function(n) {
  const e = n ? function(t) {
    return n.call(this, t, $o);
  } : $o;
  return this._pairs.map(function(a) {
    return e(a[0]) + "=" + e(a[1]);
  }, "").join("&");
};
function Gu(s) {
  return encodeURIComponent(s).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function bc(s, n, e) {
  if (!n)
    return s;
  const t = e && e.encode || Gu, a = e && e.serialize;
  let i;
  if (a ? i = a(n, e) : i = X.isURLSearchParams(n) ? n.toString() : new to(n, e).toString(t), i) {
    const r = s.indexOf("#");
    r !== -1 && (s = s.slice(0, r)), s += (s.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return s;
}
class Xu {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(n, e, t) {
    return this.handlers.push({
      fulfilled: n,
      rejected: e,
      synchronous: t ? t.synchronous : !1,
      runWhen: t ? t.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(n) {
    this.handlers[n] && (this.handlers[n] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(n) {
    X.forEach(this.handlers, function(t) {
      t !== null && n(t);
    });
  }
}
const qo = Xu, Dc = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, Ku = typeof URLSearchParams != "undefined" ? URLSearchParams : to, Qu = typeof FormData != "undefined" ? FormData : null, Ju = typeof Blob != "undefined" ? Blob : null, Zu = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Ku,
    FormData: Qu,
    Blob: Ju
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, wc = typeof window != "undefined" && typeof document != "undefined", eh = ((s) => wc && ["ReactNative", "NativeScript", "NS"].indexOf(s) < 0)(typeof navigator != "undefined" && navigator.product), th = (() => typeof WorkerGlobalScope != "undefined" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), nh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: wc,
  hasStandardBrowserEnv: eh,
  hasStandardBrowserWebWorkerEnv: th
}, Symbol.toStringTag, { value: "Module" })), cn = ge(ge({}, nh), Zu);
function sh(s, n) {
  return Sr(s, new cn.classes.URLSearchParams(), Object.assign({
    visitor: function(e, t, a, i) {
      return cn.isNode && X.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : i.defaultVisitor.apply(this, arguments);
    }
  }, n));
}
function ah(s) {
  return X.matchAll(/\w+|\[(\w*)]/g, s).map((n) => n[0] === "[]" ? "" : n[1] || n[0]);
}
function rh(s) {
  const n = {}, e = Object.keys(s);
  let t;
  const a = e.length;
  let i;
  for (t = 0; t < a; t++)
    i = e[t], n[i] = s[i];
  return n;
}
function xc(s) {
  function n(e, t, a, i) {
    let r = e[i++];
    if (r === "__proto__")
      return !0;
    const o = Number.isFinite(+r), l = i >= e.length;
    return r = !r && X.isArray(a) ? a.length : r, l ? (X.hasOwnProp(a, r) ? a[r] = [a[r], t] : a[r] = t, !o) : ((!a[r] || !X.isObject(a[r])) && (a[r] = []), n(e, t, a[r], i) && X.isArray(a[r]) && (a[r] = rh(a[r])), !o);
  }
  if (X.isFormData(s) && X.isFunction(s.entries)) {
    const e = {};
    return X.forEachEntry(s, (t, a) => {
      n(ah(t), a, e, 0);
    }), e;
  }
  return null;
}
function ih(s, n, e) {
  if (X.isString(s))
    try {
      return (n || JSON.parse)(s), X.trim(s);
    } catch (t) {
      if (t.name !== "SyntaxError")
        throw t;
    }
  return (e || JSON.stringify)(s);
}
const no = {
  transitional: Dc,
  adapter: ["xhr", "http"],
  transformRequest: [function(n, e) {
    const t = e.getContentType() || "", a = t.indexOf("application/json") > -1, i = X.isObject(n);
    if (i && X.isHTMLForm(n) && (n = new FormData(n)), X.isFormData(n))
      return a && a ? JSON.stringify(xc(n)) : n;
    if (X.isArrayBuffer(n) || X.isBuffer(n) || X.isStream(n) || X.isFile(n) || X.isBlob(n))
      return n;
    if (X.isArrayBufferView(n))
      return n.buffer;
    if (X.isURLSearchParams(n))
      return e.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), n.toString();
    let o;
    if (i) {
      if (t.indexOf("application/x-www-form-urlencoded") > -1)
        return sh(n, this.formSerializer).toString();
      if ((o = X.isFileList(n)) || t.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return Sr(
          o ? { "files[]": n } : n,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return i || a ? (e.setContentType("application/json", !1), ih(n)) : n;
  }],
  transformResponse: [function(n) {
    const e = this.transitional || no.transitional, t = e && e.forcedJSONParsing, a = this.responseType === "json";
    if (n && X.isString(n) && (t && !this.responseType || a)) {
      const r = !(e && e.silentJSONParsing) && a;
      try {
        return JSON.parse(n);
      } catch (o) {
        if (r)
          throw o.name === "SyntaxError" ? He.from(o, He.ERR_BAD_RESPONSE, this, null, this.response) : o;
      }
    }
    return n;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: cn.classes.FormData,
    Blob: cn.classes.Blob
  },
  validateStatus: function(n) {
    return n >= 200 && n < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
X.forEach(["delete", "get", "head", "post", "put", "patch"], (s) => {
  no.headers[s] = {};
});
const so = no, oh = X.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), lh = (s) => {
  const n = {};
  let e, t, a;
  return s && s.split(`
`).forEach(function(r) {
    a = r.indexOf(":"), e = r.substring(0, a).trim().toLowerCase(), t = r.substring(a + 1).trim(), !(!e || n[e] && oh[e]) && (e === "set-cookie" ? n[e] ? n[e].push(t) : n[e] = [t] : n[e] = n[e] ? n[e] + ", " + t : t);
  }), n;
}, Go = Symbol("internals");
function zs(s) {
  return s && String(s).trim().toLowerCase();
}
function Xa(s) {
  return s === !1 || s == null ? s : X.isArray(s) ? s.map(Xa) : String(s);
}
function ch(s) {
  const n = /* @__PURE__ */ Object.create(null), e = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let t;
  for (; t = e.exec(s); )
    n[t[1]] = t[2];
  return n;
}
const dh = (s) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(s.trim());
function jr(s, n, e, t, a) {
  if (X.isFunction(t))
    return t.call(this, n, e);
  if (a && (n = e), !!X.isString(n)) {
    if (X.isString(t))
      return n.indexOf(t) !== -1;
    if (X.isRegExp(t))
      return t.test(n);
  }
}
function uh(s) {
  return s.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (n, e, t) => e.toUpperCase() + t);
}
function hh(s, n) {
  const e = X.toCamelCase(" " + n);
  ["get", "set", "has"].forEach((t) => {
    Object.defineProperty(s, t + e, {
      value: function(a, i, r) {
        return this[t].call(this, n, a, i, r);
      },
      configurable: !0
    });
  });
}
class Tr {
  constructor(n) {
    n && this.set(n);
  }
  set(n, e, t) {
    const a = this;
    function i(o, l, u) {
      const c = zs(l);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const d = X.findKey(a, c);
      (!d || a[d] === void 0 || u === !0 || u === void 0 && a[d] !== !1) && (a[d || l] = Xa(o));
    }
    const r = (o, l) => X.forEach(o, (u, c) => i(u, c, l));
    return X.isPlainObject(n) || n instanceof this.constructor ? r(n, e) : X.isString(n) && (n = n.trim()) && !dh(n) ? r(lh(n), e) : n != null && i(e, n, t), this;
  }
  get(n, e) {
    if (n = zs(n), n) {
      const t = X.findKey(this, n);
      if (t) {
        const a = this[t];
        if (!e)
          return a;
        if (e === !0)
          return ch(a);
        if (X.isFunction(e))
          return e.call(this, a, t);
        if (X.isRegExp(e))
          return e.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(n, e) {
    if (n = zs(n), n) {
      const t = X.findKey(this, n);
      return !!(t && this[t] !== void 0 && (!e || jr(this, this[t], t, e)));
    }
    return !1;
  }
  delete(n, e) {
    const t = this;
    let a = !1;
    function i(r) {
      if (r = zs(r), r) {
        const o = X.findKey(t, r);
        o && (!e || jr(t, t[o], o, e)) && (delete t[o], a = !0);
      }
    }
    return X.isArray(n) ? n.forEach(i) : i(n), a;
  }
  clear(n) {
    const e = Object.keys(this);
    let t = e.length, a = !1;
    for (; t--; ) {
      const i = e[t];
      (!n || jr(this, this[i], i, n, !0)) && (delete this[i], a = !0);
    }
    return a;
  }
  normalize(n) {
    const e = this, t = {};
    return X.forEach(this, (a, i) => {
      const r = X.findKey(t, i);
      if (r) {
        e[r] = Xa(a), delete e[i];
        return;
      }
      const o = n ? uh(i) : String(i).trim();
      o !== i && delete e[i], e[o] = Xa(a), t[o] = !0;
    }), this;
  }
  concat(...n) {
    return this.constructor.concat(this, ...n);
  }
  toJSON(n) {
    const e = /* @__PURE__ */ Object.create(null);
    return X.forEach(this, (t, a) => {
      t != null && t !== !1 && (e[a] = n && X.isArray(t) ? t.join(", ") : t);
    }), e;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([n, e]) => n + ": " + e).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(n) {
    return n instanceof this ? n : new this(n);
  }
  static concat(n, ...e) {
    const t = new this(n);
    return e.forEach((a) => t.set(a)), t;
  }
  static accessor(n) {
    const t = (this[Go] = this[Go] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function i(r) {
      const o = zs(r);
      t[o] || (hh(a, r), t[o] = !0);
    }
    return X.isArray(n) ? n.forEach(i) : i(n), this;
  }
}
Tr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
X.reduceDescriptors(Tr.prototype, ({ value: s }, n) => {
  let e = n[0].toUpperCase() + n.slice(1);
  return {
    get: () => s,
    set(t) {
      this[e] = t;
    }
  };
});
X.freezeMethods(Tr);
const Dn = Tr;
function Wr(s, n) {
  const e = this || so, t = n || e, a = Dn.from(t.headers);
  let i = t.data;
  return X.forEach(s, function(o) {
    i = o.call(e, i, a.normalize(), n ? n.status : void 0);
  }), a.normalize(), i;
}
function Cc(s) {
  return !!(s && s.__CANCEL__);
}
function ha(s, n, e) {
  He.call(this, s == null ? "canceled" : s, He.ERR_CANCELED, n, e), this.name = "CanceledError";
}
X.inherits(ha, He, {
  __CANCEL__: !0
});
function mh(s, n, e) {
  const t = e.config.validateStatus;
  !e.status || !t || t(e.status) ? s(e) : n(new He(
    "Request failed with status code " + e.status,
    [He.ERR_BAD_REQUEST, He.ERR_BAD_RESPONSE][Math.floor(e.status / 100) - 4],
    e.config,
    e.request,
    e
  ));
}
const ph = cn.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(s, n, e, t, a, i) {
      const r = [s + "=" + encodeURIComponent(n)];
      X.isNumber(e) && r.push("expires=" + new Date(e).toGMTString()), X.isString(t) && r.push("path=" + t), X.isString(a) && r.push("domain=" + a), i === !0 && r.push("secure"), document.cookie = r.join("; ");
    },
    read(s) {
      const n = document.cookie.match(new RegExp("(^|;\\s*)(" + s + ")=([^;]*)"));
      return n ? decodeURIComponent(n[3]) : null;
    },
    remove(s) {
      this.write(s, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function fh(s) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(s);
}
function _h(s, n) {
  return n ? s.replace(/\/?\/$/, "") + "/" + n.replace(/^\/+/, "") : s;
}
function Sc(s, n) {
  return s && !fh(n) ? _h(s, n) : n;
}
const vh = cn.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const n = /(msie|trident)/i.test(navigator.userAgent), e = document.createElement("a");
    let t;
    function a(i) {
      let r = i;
      return n && (e.setAttribute("href", r), r = e.href), e.setAttribute("href", r), {
        href: e.href,
        protocol: e.protocol ? e.protocol.replace(/:$/, "") : "",
        host: e.host,
        search: e.search ? e.search.replace(/^\?/, "") : "",
        hash: e.hash ? e.hash.replace(/^#/, "") : "",
        hostname: e.hostname,
        port: e.port,
        pathname: e.pathname.charAt(0) === "/" ? e.pathname : "/" + e.pathname
      };
    }
    return t = a(window.location.href), function(r) {
      const o = X.isString(r) ? a(r) : r;
      return o.protocol === t.protocol && o.host === t.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function gh(s) {
  const n = /^([-+\w]{1,25})(:?\/\/|:)/.exec(s);
  return n && n[1] || "";
}
function yh(s, n) {
  s = s || 10;
  const e = new Array(s), t = new Array(s);
  let a = 0, i = 0, r;
  return n = n !== void 0 ? n : 1e3, function(l) {
    const u = Date.now(), c = t[i];
    r || (r = u), e[a] = l, t[a] = u;
    let d = i, m = 0;
    for (; d !== a; )
      m += e[d++], d = d % s;
    if (a = (a + 1) % s, a === i && (i = (i + 1) % s), u - r < n)
      return;
    const h = c && u - c;
    return h ? Math.round(m * 1e3 / h) : void 0;
  };
}
function Xo(s, n) {
  let e = 0;
  const t = yh(50, 250);
  return (a) => {
    const i = a.loaded, r = a.lengthComputable ? a.total : void 0, o = i - e, l = t(o), u = i <= r;
    e = i;
    const c = {
      loaded: i,
      total: r,
      progress: r ? i / r : void 0,
      bytes: o,
      rate: l || void 0,
      estimated: l && r && u ? (r - i) / l : void 0,
      event: a
    };
    c[n ? "download" : "upload"] = !0, s(c);
  };
}
const bh = typeof XMLHttpRequest != "undefined", Dh = bh && function(s) {
  return new Promise(function(e, t) {
    let a = s.data;
    const i = Dn.from(s.headers).normalize();
    let { responseType: r, withXSRFToken: o } = s, l;
    function u() {
      s.cancelToken && s.cancelToken.unsubscribe(l), s.signal && s.signal.removeEventListener("abort", l);
    }
    let c;
    if (X.isFormData(a)) {
      if (cn.hasStandardBrowserEnv || cn.hasStandardBrowserWebWorkerEnv)
        i.setContentType(!1);
      else if ((c = i.getContentType()) !== !1) {
        const [p, ...g] = c ? c.split(";").map((v) => v.trim()).filter(Boolean) : [];
        i.setContentType([p || "multipart/form-data", ...g].join("; "));
      }
    }
    let d = new XMLHttpRequest();
    if (s.auth) {
      const p = s.auth.username || "", g = s.auth.password ? unescape(encodeURIComponent(s.auth.password)) : "";
      i.set("Authorization", "Basic " + btoa(p + ":" + g));
    }
    const m = Sc(s.baseURL, s.url);
    d.open(s.method.toUpperCase(), bc(m, s.params, s.paramsSerializer), !0), d.timeout = s.timeout;
    function h() {
      if (!d)
        return;
      const p = Dn.from(
        "getAllResponseHeaders" in d && d.getAllResponseHeaders()
      ), v = {
        data: !r || r === "text" || r === "json" ? d.responseText : d.response,
        status: d.status,
        statusText: d.statusText,
        headers: p,
        config: s,
        request: d
      };
      mh(function(b) {
        e(b), u();
      }, function(b) {
        t(b), u();
      }, v), d = null;
    }
    if ("onloadend" in d ? d.onloadend = h : d.onreadystatechange = function() {
      !d || d.readyState !== 4 || d.status === 0 && !(d.responseURL && d.responseURL.indexOf("file:") === 0) || setTimeout(h);
    }, d.onabort = function() {
      d && (t(new He("Request aborted", He.ECONNABORTED, s, d)), d = null);
    }, d.onerror = function() {
      t(new He("Network Error", He.ERR_NETWORK, s, d)), d = null;
    }, d.ontimeout = function() {
      let g = s.timeout ? "timeout of " + s.timeout + "ms exceeded" : "timeout exceeded";
      const v = s.transitional || Dc;
      s.timeoutErrorMessage && (g = s.timeoutErrorMessage), t(new He(
        g,
        v.clarifyTimeoutError ? He.ETIMEDOUT : He.ECONNABORTED,
        s,
        d
      )), d = null;
    }, cn.hasStandardBrowserEnv && (o && X.isFunction(o) && (o = o(s)), o || o !== !1 && vh(m))) {
      const p = s.xsrfHeaderName && s.xsrfCookieName && ph.read(s.xsrfCookieName);
      p && i.set(s.xsrfHeaderName, p);
    }
    a === void 0 && i.setContentType(null), "setRequestHeader" in d && X.forEach(i.toJSON(), function(g, v) {
      d.setRequestHeader(v, g);
    }), X.isUndefined(s.withCredentials) || (d.withCredentials = !!s.withCredentials), r && r !== "json" && (d.responseType = s.responseType), typeof s.onDownloadProgress == "function" && d.addEventListener("progress", Xo(s.onDownloadProgress, !0)), typeof s.onUploadProgress == "function" && d.upload && d.upload.addEventListener("progress", Xo(s.onUploadProgress)), (s.cancelToken || s.signal) && (l = (p) => {
      d && (t(!p || p.type ? new ha(null, s, d) : p), d.abort(), d = null);
    }, s.cancelToken && s.cancelToken.subscribe(l), s.signal && (s.signal.aborted ? l() : s.signal.addEventListener("abort", l)));
    const f = gh(m);
    if (f && cn.protocols.indexOf(f) === -1) {
      t(new He("Unsupported protocol " + f + ":", He.ERR_BAD_REQUEST, s));
      return;
    }
    d.send(a || null);
  });
}, wi = {
  http: Wu,
  xhr: Dh
};
X.forEach(wi, (s, n) => {
  if (s) {
    try {
      Object.defineProperty(s, "name", { value: n });
    } catch (e) {
    }
    Object.defineProperty(s, "adapterName", { value: n });
  }
});
const Ko = (s) => `- ${s}`, wh = (s) => X.isFunction(s) || s === null || s === !1, Tc = {
  getAdapter: (s) => {
    s = X.isArray(s) ? s : [s];
    const { length: n } = s;
    let e, t;
    const a = {};
    for (let i = 0; i < n; i++) {
      e = s[i];
      let r;
      if (t = e, !wh(e) && (t = wi[(r = String(e)).toLowerCase()], t === void 0))
        throw new He(`Unknown adapter '${r}'`);
      if (t)
        break;
      a[r || "#" + i] = t;
    }
    if (!t) {
      const i = Object.entries(a).map(
        ([o, l]) => `adapter ${o} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let r = n ? i.length > 1 ? `since :
` + i.map(Ko).join(`
`) : " " + Ko(i[0]) : "as no adapter specified";
      throw new He(
        "There is no suitable adapter to dispatch the request " + r,
        "ERR_NOT_SUPPORT"
      );
    }
    return t;
  },
  adapters: wi
};
function $r(s) {
  if (s.cancelToken && s.cancelToken.throwIfRequested(), s.signal && s.signal.aborted)
    throw new ha(null, s);
}
function Qo(s) {
  return $r(s), s.headers = Dn.from(s.headers), s.data = Wr.call(
    s,
    s.transformRequest
  ), ["post", "put", "patch"].indexOf(s.method) !== -1 && s.headers.setContentType("application/x-www-form-urlencoded", !1), Tc.getAdapter(s.adapter || so.adapter)(s).then(function(t) {
    return $r(s), t.data = Wr.call(
      s,
      s.transformResponse,
      t
    ), t.headers = Dn.from(t.headers), t;
  }, function(t) {
    return Cc(t) || ($r(s), t && t.response && (t.response.data = Wr.call(
      s,
      s.transformResponse,
      t.response
    ), t.response.headers = Dn.from(t.response.headers))), Promise.reject(t);
  });
}
const Jo = (s) => s instanceof Dn ? s.toJSON() : s;
function Ss(s, n) {
  n = n || {};
  const e = {};
  function t(u, c, d) {
    return X.isPlainObject(u) && X.isPlainObject(c) ? X.merge.call({ caseless: d }, u, c) : X.isPlainObject(c) ? X.merge({}, c) : X.isArray(c) ? c.slice() : c;
  }
  function a(u, c, d) {
    if (X.isUndefined(c)) {
      if (!X.isUndefined(u))
        return t(void 0, u, d);
    } else
      return t(u, c, d);
  }
  function i(u, c) {
    if (!X.isUndefined(c))
      return t(void 0, c);
  }
  function r(u, c) {
    if (X.isUndefined(c)) {
      if (!X.isUndefined(u))
        return t(void 0, u);
    } else
      return t(void 0, c);
  }
  function o(u, c, d) {
    if (d in n)
      return t(u, c);
    if (d in s)
      return t(void 0, u);
  }
  const l = {
    url: i,
    method: i,
    data: i,
    baseURL: r,
    transformRequest: r,
    transformResponse: r,
    paramsSerializer: r,
    timeout: r,
    timeoutMessage: r,
    withCredentials: r,
    withXSRFToken: r,
    adapter: r,
    responseType: r,
    xsrfCookieName: r,
    xsrfHeaderName: r,
    onUploadProgress: r,
    onDownloadProgress: r,
    decompress: r,
    maxContentLength: r,
    maxBodyLength: r,
    beforeRedirect: r,
    transport: r,
    httpAgent: r,
    httpsAgent: r,
    cancelToken: r,
    socketPath: r,
    responseEncoding: r,
    validateStatus: o,
    headers: (u, c) => a(Jo(u), Jo(c), !0)
  };
  return X.forEach(Object.keys(Object.assign({}, s, n)), function(c) {
    const d = l[c] || a, m = d(s[c], n[c], c);
    X.isUndefined(m) && d !== o || (e[c] = m);
  }), e;
}
const Ec = "1.6.5", ao = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((s, n) => {
  ao[s] = function(t) {
    return typeof t === s || "a" + (n < 1 ? "n " : " ") + s;
  };
});
const Zo = {};
ao.transitional = function(n, e, t) {
  function a(i, r) {
    return "[Axios v" + Ec + "] Transitional option '" + i + "'" + r + (t ? ". " + t : "");
  }
  return (i, r, o) => {
    if (n === !1)
      throw new He(
        a(r, " has been removed" + (e ? " in " + e : "")),
        He.ERR_DEPRECATED
      );
    return e && !Zo[r] && (Zo[r] = !0, console.warn(
      a(
        r,
        " has been deprecated since v" + e + " and will be removed in the near future"
      )
    )), n ? n(i, r, o) : !0;
  };
};
function xh(s, n, e) {
  if (typeof s != "object")
    throw new He("options must be an object", He.ERR_BAD_OPTION_VALUE);
  const t = Object.keys(s);
  let a = t.length;
  for (; a-- > 0; ) {
    const i = t[a], r = n[i];
    if (r) {
      const o = s[i], l = o === void 0 || r(o, i, s);
      if (l !== !0)
        throw new He("option " + i + " must be " + l, He.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (e !== !0)
      throw new He("Unknown option " + i, He.ERR_BAD_OPTION);
  }
}
const xi = {
  assertOptions: xh,
  validators: ao
}, Mn = xi.validators;
class or {
  constructor(n) {
    this.defaults = n, this.interceptors = {
      request: new qo(),
      response: new qo()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(n, e) {
    typeof n == "string" ? (e = e || {}, e.url = n) : e = n || {}, e = Ss(this.defaults, e);
    const { transitional: t, paramsSerializer: a, headers: i } = e;
    t !== void 0 && xi.assertOptions(t, {
      silentJSONParsing: Mn.transitional(Mn.boolean),
      forcedJSONParsing: Mn.transitional(Mn.boolean),
      clarifyTimeoutError: Mn.transitional(Mn.boolean)
    }, !1), a != null && (X.isFunction(a) ? e.paramsSerializer = {
      serialize: a
    } : xi.assertOptions(a, {
      encode: Mn.function,
      serialize: Mn.function
    }, !0)), e.method = (e.method || this.defaults.method || "get").toLowerCase();
    let r = i && X.merge(
      i.common,
      i[e.method]
    );
    i && X.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (f) => {
        delete i[f];
      }
    ), e.headers = Dn.concat(r, i);
    const o = [];
    let l = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(e) === !1 || (l = l && p.synchronous, o.unshift(p.fulfilled, p.rejected));
    });
    const u = [];
    this.interceptors.response.forEach(function(p) {
      u.push(p.fulfilled, p.rejected);
    });
    let c, d = 0, m;
    if (!l) {
      const f = [Qo.bind(this), void 0];
      for (f.unshift.apply(f, o), f.push.apply(f, u), m = f.length, c = Promise.resolve(e); d < m; )
        c = c.then(f[d++], f[d++]);
      return c;
    }
    m = o.length;
    let h = e;
    for (d = 0; d < m; ) {
      const f = o[d++], p = o[d++];
      try {
        h = f(h);
      } catch (g) {
        p.call(this, g);
        break;
      }
    }
    try {
      c = Qo.call(this, h);
    } catch (f) {
      return Promise.reject(f);
    }
    for (d = 0, m = u.length; d < m; )
      c = c.then(u[d++], u[d++]);
    return c;
  }
  getUri(n) {
    n = Ss(this.defaults, n);
    const e = Sc(n.baseURL, n.url);
    return bc(e, n.params, n.paramsSerializer);
  }
}
X.forEach(["delete", "get", "head", "options"], function(n) {
  or.prototype[n] = function(e, t) {
    return this.request(Ss(t || {}, {
      method: n,
      url: e,
      data: (t || {}).data
    }));
  };
});
X.forEach(["post", "put", "patch"], function(n) {
  function e(t) {
    return function(i, r, o) {
      return this.request(Ss(o || {}, {
        method: n,
        headers: t ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: i,
        data: r
      }));
    };
  }
  or.prototype[n] = e(), or.prototype[n + "Form"] = e(!0);
});
const Ka = or;
class ro {
  constructor(n) {
    if (typeof n != "function")
      throw new TypeError("executor must be a function.");
    let e;
    this.promise = new Promise(function(i) {
      e = i;
    });
    const t = this;
    this.promise.then((a) => {
      if (!t._listeners)
        return;
      let i = t._listeners.length;
      for (; i-- > 0; )
        t._listeners[i](a);
      t._listeners = null;
    }), this.promise.then = (a) => {
      let i;
      const r = new Promise((o) => {
        t.subscribe(o), i = o;
      }).then(a);
      return r.cancel = function() {
        t.unsubscribe(i);
      }, r;
    }, n(function(i, r, o) {
      t.reason || (t.reason = new ha(i, r, o), e(t.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(n) {
    if (this.reason) {
      n(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(n) : this._listeners = [n];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(n) {
    if (!this._listeners)
      return;
    const e = this._listeners.indexOf(n);
    e !== -1 && this._listeners.splice(e, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let n;
    return {
      token: new ro(function(a) {
        n = a;
      }),
      cancel: n
    };
  }
}
const Ch = ro;
function Sh(s) {
  return function(e) {
    return s.apply(null, e);
  };
}
function Th(s) {
  return X.isObject(s) && s.isAxiosError === !0;
}
const Ci = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Ci).forEach(([s, n]) => {
  Ci[n] = s;
});
const Eh = Ci;
function kc(s) {
  const n = new Ka(s), e = lc(Ka.prototype.request, n);
  return X.extend(e, Ka.prototype, n, { allOwnKeys: !0 }), X.extend(e, n, null, { allOwnKeys: !0 }), e.create = function(a) {
    return kc(Ss(s, a));
  }, e;
}
const yt = kc(so);
yt.Axios = Ka;
yt.CanceledError = ha;
yt.CancelToken = Ch;
yt.isCancel = Cc;
yt.VERSION = Ec;
yt.toFormData = Sr;
yt.AxiosError = He;
yt.Cancel = yt.CanceledError;
yt.all = function(n) {
  return Promise.all(n);
};
yt.spread = Sh;
yt.isAxiosError = Th;
yt.mergeConfig = Ss;
yt.AxiosHeaders = Dn;
yt.formToJSON = (s) => xc(X.isHTMLForm(s) ? new FormData(s) : s);
yt.getAdapter = Tc.getAdapter;
yt.HttpStatusCode = Eh;
yt.default = yt;
const kh = yt;
var Rt = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function io(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
const Mh = /* @__PURE__ */ new Set([
  "ENOTFOUND",
  "ENETUNREACH",
  // SSL errors from https://github.com/nodejs/node/blob/fc8e3e2cdc521978351de257030db0076d79e0ab/src/crypto/crypto_common.cc#L301-L328
  "UNABLE_TO_GET_ISSUER_CERT",
  "UNABLE_TO_GET_CRL",
  "UNABLE_TO_DECRYPT_CERT_SIGNATURE",
  "UNABLE_TO_DECRYPT_CRL_SIGNATURE",
  "UNABLE_TO_DECODE_ISSUER_PUBLIC_KEY",
  "CERT_SIGNATURE_FAILURE",
  "CRL_SIGNATURE_FAILURE",
  "CERT_NOT_YET_VALID",
  "CERT_HAS_EXPIRED",
  "CRL_NOT_YET_VALID",
  "CRL_HAS_EXPIRED",
  "ERROR_IN_CERT_NOT_BEFORE_FIELD",
  "ERROR_IN_CERT_NOT_AFTER_FIELD",
  "ERROR_IN_CRL_LAST_UPDATE_FIELD",
  "ERROR_IN_CRL_NEXT_UPDATE_FIELD",
  "OUT_OF_MEM",
  "DEPTH_ZERO_SELF_SIGNED_CERT",
  "SELF_SIGNED_CERT_IN_CHAIN",
  "UNABLE_TO_GET_ISSUER_CERT_LOCALLY",
  "UNABLE_TO_VERIFY_LEAF_SIGNATURE",
  "CERT_CHAIN_TOO_LONG",
  "CERT_REVOKED",
  "INVALID_CA",
  "PATH_LENGTH_EXCEEDED",
  "INVALID_PURPOSE",
  "CERT_UNTRUSTED",
  "CERT_REJECTED",
  "HOSTNAME_MISMATCH"
]);
var Ih = (s) => !Mh.has(s && s.code);
const Nh = /* @__PURE__ */ io(Ih), Mc = "axios-retry";
function Ic(s) {
  const n = ["ERR_CANCELED", "ECONNABORTED"];
  return s.response || !s.code || n.includes(s.code) ? !1 : Nh(s);
}
const Nc = ["get", "head", "options"], Oh = Nc.concat(["put", "delete"]);
function oo(s) {
  return s.code !== "ECONNABORTED" && (!s.response || s.response.status >= 500 && s.response.status <= 599);
}
function Lh(s) {
  var n;
  return (n = s.config) != null && n.method ? oo(s) && Nc.indexOf(s.config.method) !== -1 : !1;
}
function Oc(s) {
  var n;
  return (n = s.config) != null && n.method ? oo(s) && Oh.indexOf(s.config.method) !== -1 : !1;
}
function Lc(s) {
  return Ic(s) || Oc(s);
}
function Ah() {
  return 0;
}
function Rh(s = 0, n = void 0, e = 100) {
  const t = Uo(2, s) * e, a = t * 0.2 * Math.random();
  return t + a;
}
const Ph = {
  retries: 3,
  retryCondition: Lc,
  retryDelay: Ah,
  shouldResetTimeout: !1,
  onRetry: () => {
  },
  onMaxRetryTimesExceeded: () => {
  }
};
function zh(s, n) {
  return ge(ge(ge({}, Ph), n), s[Mc]);
}
function el(s, n) {
  const e = zh(s, n || {});
  return e.retryCount = e.retryCount || 0, e.lastRequestTime = e.lastRequestTime || Date.now(), s[Mc] = e, e;
}
function Hh(s, n) {
  s.defaults.agent === n.agent && delete n.agent, s.defaults.httpAgent === n.httpAgent && delete n.httpAgent, s.defaults.httpsAgent === n.httpsAgent && delete n.httpsAgent;
}
function Fh(s, n) {
  return Re(this, null, function* () {
    const { retries: e, retryCondition: t } = s, a = (s.retryCount || 0) < e && t(n);
    if (typeof a == "object")
      try {
        return (yield a) !== !1;
      } catch (i) {
        return !1;
      }
    return a;
  });
}
function Yh(s, n) {
  return Re(this, null, function* () {
    s.retryCount >= s.retries && (yield s.onMaxRetryTimesExceeded(n, s.retryCount));
  });
}
const is = (s, n) => {
  const e = s.interceptors.request.use((a) => (el(a, n), a)), t = s.interceptors.response.use(null, (a) => Re(void 0, null, function* () {
    const { config: i } = a;
    if (!i)
      return Promise.reject(a);
    const r = el(i, n);
    if (yield Fh(r, a)) {
      r.retryCount += 1;
      const { retryDelay: o, shouldResetTimeout: l, onRetry: u } = r, c = o(r.retryCount, a);
      if (Hh(s, i), !l && i.timeout && r.lastRequestTime) {
        const d = Date.now() - r.lastRequestTime, m = i.timeout - d - c;
        if (m <= 0)
          return Promise.reject(a);
        i.timeout = m;
      }
      return i.transformRequest = [(d) => d], yield u(r.retryCount, a, i), new Promise((d) => {
        setTimeout(() => d(s(i)), c);
      });
    }
    return yield Yh(r, a), Promise.reject(a);
  }));
  return { requestInterceptorId: e, responseInterceptorId: t };
};
is.isNetworkError = Ic;
is.isSafeRequestError = Lh;
is.isIdempotentRequestError = Oc;
is.isNetworkOrIdempotentRequestError = Lc;
is.exponentialDelay = Rh;
is.isRetryableError = oo;
var Ac = {}, lo = {};
lo.promiseFinally = (s, n) => {
  const e = (a) => (n(), a), t = (a) => (n(), Promise.reject(a));
  return Promise.resolve(s).then(e, t);
};
lo.toError = (s) => (s = typeof s == "function" ? s() : s, typeof s == "string" ? new Error(s) : s);
const { promiseFinally: Uh, toError: Bh } = lo;
var Vh = class Si {
  static set(n, e) {
    return new Si().set(n, e);
  }
  static wrap(n, e, t) {
    return new Si().wrap(n, e, t);
  }
  constructor() {
    this._id = null, this._delay = null;
  }
  get id() {
    return this._id;
  }
  get delay() {
    return this._delay;
  }
  set(n, e = "") {
    return new Promise((t, a) => {
      this.clear();
      const i = e ? () => a(Bh(e)) : t;
      this._id = setTimeout(i, n), this._delay = n;
    });
  }
  wrap(n, e, t = "") {
    const a = Uh(n, () => this.clear()), i = this.set(e, t);
    return Promise.race([
      a,
      i
    ]);
  }
  clear() {
    this._id && clearTimeout(this._id);
  }
}, co = {}, uo = {}, Er = {};
Object.defineProperty(Er, "__esModule", { value: !0 });
function jh(s) {
  const n = typeof s;
  return s != null && (n === "object" || n === "function");
}
Er.default = jh;
var ho = {}, mo = {};
Object.defineProperty(mo, "__esModule", { value: !0 });
const Wh = typeof Rt == "object" && Rt !== null && Rt.Object === Object && Rt;
mo.default = Wh;
var $h = Rt && Rt.__importDefault || function(s) {
  return s && s.__esModule ? s : { default: s };
};
Object.defineProperty(ho, "__esModule", { value: !0 });
const qh = $h(mo), Gh = typeof globalThis == "object" && globalThis !== null && globalThis.Object == Object && globalThis, Xh = typeof self == "object" && self !== null && self.Object === Object && self, Kh = Gh || qh.default || Xh || Function("return this")();
ho.default = Kh;
var Rc = Rt && Rt.__importDefault || function(s) {
  return s && s.__esModule ? s : { default: s };
};
Object.defineProperty(uo, "__esModule", { value: !0 });
const Qh = Rc(Er), Ia = Rc(ho);
function Jh(s, n, e) {
  let t, a, i, r, o, l, u = 0, c = !1, d = !1, m = !0;
  const h = !n && n !== 0 && typeof Ia.default.requestAnimationFrame == "function";
  if (typeof s != "function")
    throw new TypeError("Expected a function");
  n = +n || 0, (0, Qh.default)(e) && (c = !!e.leading, d = "maxWait" in e, i = d ? Math.max(+e.maxWait || 0, n) : i, m = "trailing" in e ? !!e.trailing : m);
  function f(L) {
    const H = t, A = a;
    return t = a = void 0, u = L, r = s.apply(A, H), r;
  }
  function p(L, H) {
    return h ? (Ia.default.cancelAnimationFrame(o), Ia.default.requestAnimationFrame(L)) : setTimeout(L, H);
  }
  function g(L) {
    if (h)
      return Ia.default.cancelAnimationFrame(L);
    clearTimeout(L);
  }
  function v(L) {
    return u = L, o = p(D, n), c ? f(L) : r;
  }
  function y(L) {
    const H = L - l, A = L - u, B = n - H;
    return d ? Math.min(B, i - A) : B;
  }
  function b(L) {
    const H = L - l, A = L - u;
    return l === void 0 || H >= n || H < 0 || d && A >= i;
  }
  function D() {
    const L = Date.now();
    if (b(L))
      return w(L);
    o = p(D, y(L));
  }
  function w(L) {
    return o = void 0, m && t ? f(L) : (t = a = void 0, r);
  }
  function C() {
    o !== void 0 && g(o), u = 0, t = l = a = o = void 0;
  }
  function T() {
    return o === void 0 ? r : w(Date.now());
  }
  function N() {
    return o !== void 0;
  }
  function O(...L) {
    const H = Date.now(), A = b(H);
    if (t = L, a = this, l = H, A) {
      if (o === void 0)
        return v(l);
      if (d)
        return o = p(D, n), f(l);
    }
    return o === void 0 && (o = p(D, n)), r;
  }
  return O.cancel = C, O.flush = T, O.pending = N, O;
}
uo.default = Jh;
var Pc = Rt && Rt.__importDefault || function(s) {
  return s && s.__esModule ? s : { default: s };
};
Object.defineProperty(co, "__esModule", { value: !0 });
const Zh = Pc(uo), em = Pc(Er);
function tm(s, n, e) {
  let t = !0, a = !0;
  if (typeof s != "function")
    throw new TypeError("Expected a function");
  return (0, em.default)(e) && (t = "leading" in e ? !!e.leading : t, a = "trailing" in e ? !!e.trailing : a), (0, Zh.default)(s, n, {
    leading: t,
    trailing: a,
    maxWait: n
  });
}
co.default = tm;
var zc = Rt && Rt.__importDefault || function(s) {
  return s && s.__esModule ? s : { default: s };
};
Object.defineProperty(Ac, "__esModule", { value: !0 });
const nm = zc(Vh), sm = zc(co);
var Ti;
(function(s) {
  s.Info = "INFO";
})(Ti || (Ti = {}));
class am {
  constructor(n) {
    this.meta = () => ({}), this.persistLogs = () => {
    }, this.postHandler = () => {
    }, this.LOG_SYNC_INTERVAL = 5e3;
    const { meta: e, persistHandler: t, postHandler: a, syncInterval: i } = n;
    this.meta = e, this.persistLogs = t, this.postHandler = a, i && (this.LOG_SYNC_INTERVAL = i), this.logs = [], this.isSyncing = !1, this.sync = (0, sm.default)(this._sync, this.LOG_SYNC_INTERVAL, {
      leading: !0
    }), setInterval(this.sync.bind(this), this.LOG_SYNC_INTERVAL);
  }
  info(n, e = {}) {
    const t = this.meta();
    try {
      this.store(Object.assign(Object.assign({
        level: Ti.Info,
        //  message: `${dayjs(meta.timestamp).toISOString()} INFO : ${msg}`,
        message: `${(/* @__PURE__ */ new Date()).toISOString()} INFO : ${n}`
      }, e), t));
    } catch (a) {
      setTimeout(() => {
        throw new Error(`Error while info logging ${a}`);
      });
    }
  }
  /**
   * Sotres a log and persists it to localstorage.
   * Note that logs are not saved while this class is syncing
   * It will attempt to save it for 10 seconds before throwing an error
   */
  store(n) {
    return Re(this, null, function* () {
      let t = 0;
      for (; this.isSyncing && t < 10; )
        t++, yield nm.default.set(1e3);
      if (t === 10)
        throw new Error(`No logs sync after ${t} retries ${n}`);
      this.logs.push(n), this.persistLogs(this.logs), this.sync();
    });
  }
  /**
   * Emptys logs and clears localstorage
   */
  clear() {
    this.logs = [], this.persistLogs(this.logs);
  }
  logsCount() {
    return this.logs.length;
  }
  _sync() {
    return Re(this, null, function* () {
      if (!(this.isSyncing || !this.logsCount()))
        try {
          this.isSyncing = !0, yield this.postHandler(this.logs), this.clear();
        } finally {
          this.isSyncing = !1;
        }
    });
  }
}
var rm = Ac.default = am, im = { chrome: "Google Chrome", brave: "Brave", crios: "Google Chrome", edge: "Microsoft Edge", edg: "Microsoft Edge", edgios: "Microsoft Edge", fennec: "Mozilla Firefox", jsdom: "JsDOM", mozilla: "Mozilla Firefox", fxios: "Mozilla Firefox", msie: "Microsoft Internet Explorer", opera: "Opera", opios: "Opera", opr: "Opera", opt: "Opera", rv: "Microsoft Internet Explorer", safari: "Safari", samsungbrowser: "Samsung Browser", electron: "Electron" }, om = { android: "Android", androidTablet: "Android Tablet", cros: "Chrome OS", fennec: "Android Tablet", ipad: "IPad", ipod: "IPod", iphone: "IPhone", jsdom: "JsDOM", linux: "Linux", mac: "Macintosh", tablet: "Android Tablet", win: "Windows", "windows phone": "Windows Phone", xbox: "Microsoft Xbox" }, lm = (s, n = -1) => {
  let e = new RegExp(`^-?\\d+(?:.\\d{0,${n}})?`), t = Number(s).toString().match(e);
  return t ? t[0] : null;
}, cm = { toFixed: lm }, dm = "4.1.0", tl = () => typeof window < "u" ? window.navigator : null, um = class {
  constructor(n) {
    Bo(this, "userAgent");
    var e;
    this.userAgent = n || ((e = tl()) == null ? void 0 : e.userAgent) || null;
  }
  static get VERSION() {
    return dm;
  }
  parseUserAgent(n) {
    var C, T, N;
    let e = {}, t = n || this.userAgent || "", a = t.toLowerCase().replace(/\s\s+/g, " "), i = /(edge)\/([\w.]+)/.exec(a) || /(edg)[/]([\w.]+)/.exec(a) || /(opr)[/]([\w.]+)/.exec(a) || /(opt)[/]([\w.]+)/.exec(a) || /(fxios)[/]([\w.]+)/.exec(a) || /(edgios)[/]([\w.]+)/.exec(a) || /(jsdom)[/]([\w.]+)/.exec(a) || /(samsungbrowser)[/]([\w.]+)/.exec(a) || /(electron)[/]([\w.]+)/.exec(a) || /(chrome)[/]([\w.]+)/.exec(a) || /(crios)[/]([\w.]+)/.exec(a) || /(opios)[/]([\w.]+)/.exec(a) || /(version)(applewebkit)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(a) || /(webkit)[/]([\w.]+).*(version)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(a) || /(applewebkit)[/]([\w.]+).*(safari)[/]([\w.]+)/.exec(a) || /(webkit)[/]([\w.]+)/.exec(a) || /(opera)(?:.*version|)[/]([\w.]+)/.exec(a) || /(msie) ([\w.]+)/.exec(a) || /(fennec)[/]([\w.]+)/.exec(a) || a.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec(a) || a.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(a) || [], r = /(ipad)/.exec(a) || /(ipod)/.exec(a) || /(iphone)/.exec(a) || /(jsdom)/.exec(a) || /(windows phone)/.exec(a) || /(xbox)/.exec(a) || /(win)/.exec(a) || /(tablet)/.exec(a) || /(android)/.test(a) && /(mobile)/.test(a) === !1 && ["androidTablet"] || /(android)/.exec(a) || /(mac)/.exec(a) || /(linux)/.exec(a) || /(cros)/.exec(a) || [], o = i[5] || i[3] || i[1] || null, l = r[0] || null, u = i[4] || i[2] || null, c = tl();
    o === "chrome" && typeof ((C = c == null ? void 0 : c.brave) == null ? void 0 : C.isBrave) == "function" && (o = "brave"), o && (e[o] = !0), l && (e[l] = !0);
    let d = !!(e.tablet || e.android || e.androidTablet), m = !!(e.ipad || e.tablet || e.androidTablet), h = !!(e.android || e.androidTablet || e.tablet || e.ipad || e.ipod || e.iphone || e["windows phone"]), f = !!(e.cros || e.mac || e.linux || e.win), p = !!(e.brave || e.chrome || e.crios || e.opr || e.safari || e.edg || e.electron), g = !!(e.msie || e.rv), v = !!(e.chrome || e.crios), y = !!(e.fxios || e.fennec || e.mozilla), b = !!e.safari, D = !!(e.opera || e.opios || e.opr || e.opt), w = !!(e.edg || e.edge || e.edgios);
    return { name: (T = im[o]) != null ? T : null, platform: (N = om[l]) != null ? N : null, userAgent: t, version: u, shortVersion: u ? cm.toFixed(parseFloat(u), 2) : null, isAndroid: d, isTablet: m, isMobile: h, isDesktop: f, isWebkit: p, isIE: g, isChrome: v, isFireFox: y, isSafari: b, isOpera: D, isEdge: w };
  }
  getBrowserInfo() {
    let n = this.parseUserAgent();
    return { name: n.name, platform: n.platform, userAgent: n.userAgent, version: n.version, shortVersion: n.shortVersion };
  }
}, hm = um;
let Na;
const mm = new Uint8Array(16);
function pm() {
  if (!Na && (Na = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !Na))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Na(mm);
}
const Ct = [];
for (let s = 0; s < 256; ++s)
  Ct.push((s + 256).toString(16).slice(1));
function fm(s, n = 0) {
  return Ct[s[n + 0]] + Ct[s[n + 1]] + Ct[s[n + 2]] + Ct[s[n + 3]] + "-" + Ct[s[n + 4]] + Ct[s[n + 5]] + "-" + Ct[s[n + 6]] + Ct[s[n + 7]] + "-" + Ct[s[n + 8]] + Ct[s[n + 9]] + "-" + Ct[s[n + 10]] + Ct[s[n + 11]] + Ct[s[n + 12]] + Ct[s[n + 13]] + Ct[s[n + 14]] + Ct[s[n + 15]];
}
const _m = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto), nl = {
  randomUUID: _m
};
function Hc(s, n, e) {
  if (nl.randomUUID && !n && !s)
    return nl.randomUUID();
  s = s || {};
  const t = s.random || (s.rng || pm)();
  if (t[6] = t[6] & 15 | 64, t[8] = t[8] & 63 | 128, n) {
    e = e || 0;
    for (let a = 0; a < 16; ++a)
      n[e + a] = t[a];
    return n;
  }
  return fm(t);
}
const bs = new rm({
  // Function that returns meta info for each log
  meta: () => {
    const [, s] = String(x.state.userToken).split("."), e = new hm(window.navigator.userAgent).parseUserAgent();
    return {
      // These are default for each app
      env: x.state.env,
      timestamp: Date.now(),
      app: "occupancy-calendar",
      logid: Hc(),
      groupId: x.state.groupId || "",
      lang: x.state.lang,
      userId: x.state.userId,
      userTokenBody: s,
      version: "1.0.36",
      appType: x.state.appType,
      userAgent: JSON.stringify(e, null, 2),
      sessionId: x.state.sessionId
    };
  },
  // Saves logs in the local storage
  persistHandler: () => {
  },
  // Saves logs on remote server.
  postHandler: (s) => Re(void 0, null, function* () {
    (s || s.length) && (yield vm(s));
  }),
  syncInterval: 2e3
}), vm = (s) => Re(void 0, null, function* () {
  const n = { logs: s };
  try {
    return (yield $m(n)).data;
  } catch (e) {
    throw new Error(e);
  }
});
var Fc = { exports: {} };
(function(s, n) {
  (function(e, t) {
    s.exports = t();
  })(Rt, function() {
    var e = 1e3, t = 6e4, a = 36e5, i = "millisecond", r = "second", o = "minute", l = "hour", u = "day", c = "week", d = "month", m = "quarter", h = "year", f = "date", p = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, v = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, y = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(I) {
      var S = ["th", "st", "nd", "rd"], k = I % 100;
      return "[" + I + (S[(k - 20) % 10] || S[k] || S[0]) + "]";
    } }, b = function(I, S, k) {
      var R = String(I);
      return !R || R.length >= S ? I : "" + Array(S + 1 - R.length).join(k) + I;
    }, D = { s: b, z: function(I) {
      var S = -I.utcOffset(), k = Math.abs(S), R = Math.floor(k / 60), z = k % 60;
      return (S <= 0 ? "+" : "-") + b(R, 2, "0") + ":" + b(z, 2, "0");
    }, m: function I(S, k) {
      if (S.date() < k.date())
        return -I(k, S);
      var R = 12 * (k.year() - S.year()) + (k.month() - S.month()), z = S.clone().add(R, d), W = k - z < 0, M = S.clone().add(R + (W ? -1 : 1), d);
      return +(-(R + (k - z) / (W ? z - M : M - z)) || 0);
    }, a: function(I) {
      return I < 0 ? Math.ceil(I) || 0 : Math.floor(I);
    }, p: function(I) {
      return { M: d, y: h, w: c, d: u, D: f, h: l, m: o, s: r, ms: i, Q: m }[I] || String(I || "").toLowerCase().replace(/s$/, "");
    }, u: function(I) {
      return I === void 0;
    } }, w = "en", C = {};
    C[w] = y;
    var T = "$isDayjsObject", N = function(I) {
      return I instanceof A || !(!I || !I[T]);
    }, O = function I(S, k, R) {
      var z;
      if (!S)
        return w;
      if (typeof S == "string") {
        var W = S.toLowerCase();
        C[W] && (z = W), k && (C[W] = k, z = W);
        var M = S.split("-");
        if (!z && M.length > 1)
          return I(M[0]);
      } else {
        var P = S.name;
        C[P] = S, z = P;
      }
      return !R && z && (w = z), z || !R && w;
    }, L = function(I, S) {
      if (N(I))
        return I.clone();
      var k = typeof S == "object" ? S : {};
      return k.date = I, k.args = arguments, new A(k);
    }, H = D;
    H.l = O, H.i = N, H.w = function(I, S) {
      return L(I, { locale: S.$L, utc: S.$u, x: S.$x, $offset: S.$offset });
    };
    var A = function() {
      function I(k) {
        this.$L = O(k.locale, null, !0), this.parse(k), this.$x = this.$x || k.x || {}, this[T] = !0;
      }
      var S = I.prototype;
      return S.parse = function(k) {
        this.$d = function(R) {
          var z = R.date, W = R.utc;
          if (z === null)
            return /* @__PURE__ */ new Date(NaN);
          if (H.u(z))
            return /* @__PURE__ */ new Date();
          if (z instanceof Date)
            return new Date(z);
          if (typeof z == "string" && !/Z$/i.test(z)) {
            var M = z.match(g);
            if (M) {
              var P = M[2] - 1 || 0, Y = (M[7] || "0").substring(0, 3);
              return W ? new Date(Date.UTC(M[1], P, M[3] || 1, M[4] || 0, M[5] || 0, M[6] || 0, Y)) : new Date(M[1], P, M[3] || 1, M[4] || 0, M[5] || 0, M[6] || 0, Y);
            }
          }
          return new Date(z);
        }(k), this.init();
      }, S.init = function() {
        var k = this.$d;
        this.$y = k.getFullYear(), this.$M = k.getMonth(), this.$D = k.getDate(), this.$W = k.getDay(), this.$H = k.getHours(), this.$m = k.getMinutes(), this.$s = k.getSeconds(), this.$ms = k.getMilliseconds();
      }, S.$utils = function() {
        return H;
      }, S.isValid = function() {
        return this.$d.toString() !== p;
      }, S.isSame = function(k, R) {
        var z = L(k);
        return this.startOf(R) <= z && z <= this.endOf(R);
      }, S.isAfter = function(k, R) {
        return L(k) < this.startOf(R);
      }, S.isBefore = function(k, R) {
        return this.endOf(R) < L(k);
      }, S.$g = function(k, R, z) {
        return H.u(k) ? this[R] : this.set(z, k);
      }, S.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, S.valueOf = function() {
        return this.$d.getTime();
      }, S.startOf = function(k, R) {
        var z = this, W = !!H.u(R) || R, M = H.p(k), P = function(te, Z) {
          var re = H.w(z.$u ? Date.UTC(z.$y, Z, te) : new Date(z.$y, Z, te), z);
          return W ? re : re.endOf(u);
        }, Y = function(te, Z) {
          return H.w(z.toDate()[te].apply(z.toDate("s"), (W ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(Z)), z);
        }, q = this.$W, U = this.$M, j = this.$D, ee = "set" + (this.$u ? "UTC" : "");
        switch (M) {
          case h:
            return W ? P(1, 0) : P(31, 11);
          case d:
            return W ? P(1, U) : P(0, U + 1);
          case c:
            var ne = this.$locale().weekStart || 0, G = (q < ne ? q + 7 : q) - ne;
            return P(W ? j - G : j + (6 - G), U);
          case u:
          case f:
            return Y(ee + "Hours", 0);
          case l:
            return Y(ee + "Minutes", 1);
          case o:
            return Y(ee + "Seconds", 2);
          case r:
            return Y(ee + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, S.endOf = function(k) {
        return this.startOf(k, !1);
      }, S.$set = function(k, R) {
        var z, W = H.p(k), M = "set" + (this.$u ? "UTC" : ""), P = (z = {}, z[u] = M + "Date", z[f] = M + "Date", z[d] = M + "Month", z[h] = M + "FullYear", z[l] = M + "Hours", z[o] = M + "Minutes", z[r] = M + "Seconds", z[i] = M + "Milliseconds", z)[W], Y = W === u ? this.$D + (R - this.$W) : R;
        if (W === d || W === h) {
          var q = this.clone().set(f, 1);
          q.$d[P](Y), q.init(), this.$d = q.set(f, Math.min(this.$D, q.daysInMonth())).$d;
        } else
          P && this.$d[P](Y);
        return this.init(), this;
      }, S.set = function(k, R) {
        return this.clone().$set(k, R);
      }, S.get = function(k) {
        return this[H.p(k)]();
      }, S.add = function(k, R) {
        var z, W = this;
        k = Number(k);
        var M = H.p(R), P = function(U) {
          var j = L(W);
          return H.w(j.date(j.date() + Math.round(U * k)), W);
        };
        if (M === d)
          return this.set(d, this.$M + k);
        if (M === h)
          return this.set(h, this.$y + k);
        if (M === u)
          return P(1);
        if (M === c)
          return P(7);
        var Y = (z = {}, z[o] = t, z[l] = a, z[r] = e, z)[M] || 1, q = this.$d.getTime() + k * Y;
        return H.w(q, this);
      }, S.subtract = function(k, R) {
        return this.add(-1 * k, R);
      }, S.format = function(k) {
        var R = this, z = this.$locale();
        if (!this.isValid())
          return z.invalidDate || p;
        var W = k || "YYYY-MM-DDTHH:mm:ssZ", M = H.z(this), P = this.$H, Y = this.$m, q = this.$M, U = z.weekdays, j = z.months, ee = z.meridiem, ne = function(Z, re, fe, he) {
          return Z && (Z[re] || Z(R, W)) || fe[re].slice(0, he);
        }, G = function(Z) {
          return H.s(P % 12 || 12, Z, "0");
        }, te = ee || function(Z, re, fe) {
          var he = Z < 12 ? "AM" : "PM";
          return fe ? he.toLowerCase() : he;
        };
        return W.replace(v, function(Z, re) {
          return re || function(fe) {
            switch (fe) {
              case "YY":
                return String(R.$y).slice(-2);
              case "YYYY":
                return H.s(R.$y, 4, "0");
              case "M":
                return q + 1;
              case "MM":
                return H.s(q + 1, 2, "0");
              case "MMM":
                return ne(z.monthsShort, q, j, 3);
              case "MMMM":
                return ne(j, q);
              case "D":
                return R.$D;
              case "DD":
                return H.s(R.$D, 2, "0");
              case "d":
                return String(R.$W);
              case "dd":
                return ne(z.weekdaysMin, R.$W, U, 2);
              case "ddd":
                return ne(z.weekdaysShort, R.$W, U, 3);
              case "dddd":
                return U[R.$W];
              case "H":
                return String(P);
              case "HH":
                return H.s(P, 2, "0");
              case "h":
                return G(1);
              case "hh":
                return G(2);
              case "a":
                return te(P, Y, !0);
              case "A":
                return te(P, Y, !1);
              case "m":
                return String(Y);
              case "mm":
                return H.s(Y, 2, "0");
              case "s":
                return String(R.$s);
              case "ss":
                return H.s(R.$s, 2, "0");
              case "SSS":
                return H.s(R.$ms, 3, "0");
              case "Z":
                return M;
            }
            return null;
          }(Z) || M.replace(":", "");
        });
      }, S.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, S.diff = function(k, R, z) {
        var W, M = this, P = H.p(R), Y = L(k), q = (Y.utcOffset() - this.utcOffset()) * t, U = this - Y, j = function() {
          return H.m(M, Y);
        };
        switch (P) {
          case h:
            W = j() / 12;
            break;
          case d:
            W = j();
            break;
          case m:
            W = j() / 3;
            break;
          case c:
            W = (U - q) / 6048e5;
            break;
          case u:
            W = (U - q) / 864e5;
            break;
          case l:
            W = U / a;
            break;
          case o:
            W = U / t;
            break;
          case r:
            W = U / e;
            break;
          default:
            W = U;
        }
        return z ? W : H.a(W);
      }, S.daysInMonth = function() {
        return this.endOf(d).$D;
      }, S.$locale = function() {
        return C[this.$L];
      }, S.locale = function(k, R) {
        if (!k)
          return this.$L;
        var z = this.clone(), W = O(k, R, !0);
        return W && (z.$L = W), z;
      }, S.clone = function() {
        return H.w(this.$d, this);
      }, S.toDate = function() {
        return new Date(this.valueOf());
      }, S.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, S.toISOString = function() {
        return this.$d.toISOString();
      }, S.toString = function() {
        return this.$d.toUTCString();
      }, I;
    }(), B = A.prototype;
    return L.prototype = B, [["$ms", i], ["$s", r], ["$m", o], ["$H", l], ["$W", u], ["$M", d], ["$y", h], ["$D", f]].forEach(function(I) {
      B[I[1]] = function(S) {
        return this.$g(S, I[0], I[1]);
      };
    }), L.extend = function(I, S) {
      return I.$i || (I(S, A, L), I.$i = !0), L;
    }, L.locale = O, L.isDayjs = N, L.unix = function(I) {
      return L(1e3 * I);
    }, L.en = C[w], L.Ls = C, L.p = {}, L;
  });
})(Fc);
var gm = Fc.exports;
const kt = /* @__PURE__ */ io(gm);
var Yc = { exports: {} };
(function(s, n) {
  (function(e, t) {
    s.exports = t();
  })(Rt, function() {
    var e = "minute", t = /[+-]\d\d(?::?\d\d)?/g, a = /([+-]|\d\d)/g;
    return function(i, r, o) {
      var l = r.prototype;
      o.utc = function(p) {
        var g = { date: p, utc: !0, args: arguments };
        return new r(g);
      }, l.utc = function(p) {
        var g = o(this.toDate(), { locale: this.$L, utc: !0 });
        return p ? g.add(this.utcOffset(), e) : g;
      }, l.local = function() {
        return o(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var u = l.parse;
      l.parse = function(p) {
        p.utc && (this.$u = !0), this.$utils().u(p.$offset) || (this.$offset = p.$offset), u.call(this, p);
      };
      var c = l.init;
      l.init = function() {
        if (this.$u) {
          var p = this.$d;
          this.$y = p.getUTCFullYear(), this.$M = p.getUTCMonth(), this.$D = p.getUTCDate(), this.$W = p.getUTCDay(), this.$H = p.getUTCHours(), this.$m = p.getUTCMinutes(), this.$s = p.getUTCSeconds(), this.$ms = p.getUTCMilliseconds();
        } else
          c.call(this);
      };
      var d = l.utcOffset;
      l.utcOffset = function(p, g) {
        var v = this.$utils().u;
        if (v(p))
          return this.$u ? 0 : v(this.$offset) ? d.call(this) : this.$offset;
        if (typeof p == "string" && (p = function(w) {
          w === void 0 && (w = "");
          var C = w.match(t);
          if (!C)
            return null;
          var T = ("" + C[0]).match(a) || ["-", 0, 0], N = T[0], O = 60 * +T[1] + +T[2];
          return O === 0 ? 0 : N === "+" ? O : -O;
        }(p), p === null))
          return this;
        var y = Math.abs(p) <= 16 ? 60 * p : p, b = this;
        if (g)
          return b.$offset = y, b.$u = p === 0, b;
        if (p !== 0) {
          var D = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (b = this.local().add(y + D, e)).$offset = y, b.$x.$localOffset = D;
        } else
          b = this.utc();
        return b;
      };
      var m = l.format;
      l.format = function(p) {
        var g = p || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return m.call(this, g);
      }, l.valueOf = function() {
        var p = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * p;
      }, l.isUTC = function() {
        return !!this.$u;
      }, l.toISOString = function() {
        return this.toDate().toISOString();
      }, l.toString = function() {
        return this.toDate().toUTCString();
      };
      var h = l.toDate;
      l.toDate = function(p) {
        return p === "s" && this.$offset ? o(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : h.call(this);
      };
      var f = l.diff;
      l.diff = function(p, g, v) {
        if (p && this.$u === p.$u)
          return f.call(this, p, g, v);
        var y = this.local(), b = o(p).local();
        return f.call(y, b, g, v);
      };
    };
  });
})(Yc);
var ym = Yc.exports;
const bm = /* @__PURE__ */ io(ym);
kt.extend(bm);
const sl = (s) => {
  const n = x.state.groupGraphqlModel.timeFormatB2bCustom;
  return s ? (s && typeof s != "string" || ([s] = s.split("+")), kt(s).format(n)) : x.state.locale["not-specified"];
}, Dm = () => kt().format("YYYY-MM-DD"), Oa = () => kt().format("HH:mm"), wm = (s) => kt(s).format("YYYY-MM-DD HH:mm"), La = (s) => kt(s).format("YYYY-MM-DD"), al = (s) => kt(s).unix(), xm = () => kt.utc().format("YYYY-MM-DD"), Cm = (s) => kt.utc(s).format(), po = (s) => {
  const { date: n, value: e, period: t, dateFormat: a = "" } = s;
  return kt.utc(n).add(e, t).format(a);
}, Sm = (s) => {
  const { date: n, value: e, period: t, dateFormat: a = "" } = s;
  return kt.utc(n).subtract(e, t).format(a);
}, rl = (s) => kt.utc(s).valueOf(), il = (s, n, e) => {
  const t = kt.utc(s).format("HH:mm"), a = kt.utc(s).format("YYYY/MM/DD");
  let i = "";
  e === "decrease" ? i = Tm(t, n) : i = Em(t, n);
  const r = `${a} ${i}`;
  return kt.utc(r).format();
}, Tm = (s, n) => {
  let [e, t] = s.split(":");
  e = parseInt(e), t = parseInt(t);
  let a = parseInt(t / n) * n % 60;
  return e = String(e).length === 2 ? e : `0${e}`, a = String(a).length === 2 ? a : `0${a}`, `${e}:${a}`;
}, Em = (s, n) => {
  let [e, t] = s.split(":");
  e = parseInt(e), t = parseInt(t);
  let a = t % n ? parseInt((t + n) / n) * n % 60 : t, i = t > 60 - n ? e === 23 ? 0 : e + 1 : e;
  return a = i !== e ? "00" : a, i = String(i).length === 2 ? i : `0${i}`, a = String(a).length === 2 ? a : `0${a}`, `${i}:${a}`;
}, Qe = Object.freeze({
  daily: "daily",
  dailyCountInside: "daily-count-inside"
}), Ze = Object.freeze({
  none: 0,
  customerFullName: 1,
  time: 2,
  bookingRef: 3,
  bookingState: 4,
  product: 5,
  ticket: 6,
  quantity: 7,
  extrasCount: 8,
  peopleInsideTickets: 9,
  bookingCustomFields: 10
}), Nt = Object.freeze({
  ascending: "asc",
  descending: "desc",
  custom: "custom"
}), km = Object.freeze({
  "mbsc-success": "#0edd4d",
  "mbsc-info": "#25c9ec",
  "mbsc-warning": "#eab464",
  "mbsc-danger": "#ff5722",
  "mbsc-default": "#d8d8d8"
}), ol = Object.freeze({
  0: "mbsc-default",
  1: "mbsc-default",
  2: "mbsc-info",
  3: "mbsc-success",
  4: "mbsc-default",
  5: "mbsc-warning",
  6: "mbsc-warning",
  7: "mbsc-danger",
  100: "mbsc-default"
}), Mm = Object.freeze({
  0: "impossible",
  1: "pending-info",
  2: "pending-payment",
  3: "completed",
  4: "canceled",
  5: "auth-capture",
  6: "to-refund",
  7: "abandoned",
  100: "none"
}), Im = Object.freeze({
  [Qe.daily]: {
    cardTitle: Ze.ticket,
    cardSubtitle1: Ze.time,
    // TODO - should be quantity in future
    cardSubtitle2: Ze.none,
    cardSubtitle3: Ze.none,
    cardSubtitle4: Ze.none,
    timeCellStep: 60,
    startTime: "07:00",
    endTime: "20:00",
    scanColor: "#30e5f6",
    fullScanColor: "#1c8a93"
  },
  [Qe.dailyCountInside]: {
    timeCellStep: 15,
    startTime: "07:00",
    endTime: "20:00"
  }
}), Nm = Object.freeze({
  [Qe.daily]: {
    cardTitle: !0,
    cardSubtitle1: !0,
    // TODO - should be quantity in future
    cardSubtitle2: !0,
    cardSubtitle3: !0,
    cardSubtitle4: !0,
    timeCellStep: !0,
    startTime: !0,
    endTime: !0,
    scanColor: !0,
    fullScanColor: !0
  },
  [Qe.dailyCountInside]: {
    cardTitle: !1,
    cardSubtitle1: !1,
    // TODO - should be quantity in future
    cardSubtitle2: !1,
    cardSubtitle3: !1,
    cardSubtitle4: !1,
    timeCellStep: !0,
    startTime: !0,
    endTime: !0,
    scanColor: !1,
    fullScanColor: !1
  }
}), Aa = Object.freeze({
  normal: 0,
  failed: 1,
  failedTimeOut: 2,
  failedRetry: 3
}), Om = (s, n) => {
  if (n === Qe.daily || n === Qe.dailyCountInside)
    return s ? `${s} 00:00` : `${xm()} 00:00`;
}, Lm = () => [
  { value: 0, text: x.state.locale.impossible },
  { value: 1, text: x.state.locale["pending-info"] },
  { value: 2, text: x.state.locale["pending-payment"] },
  { value: 3, text: x.state.locale.completed },
  { value: 4, text: x.state.locale.canceled },
  { value: 5, text: x.state.locale["auth-capture"] },
  { value: 6, text: x.state.locale["to-refund"] },
  { value: 7, text: x.state.locale.abandoned }
], Hs = () => [
  { value: Ze.none, text: x.state.locale.none },
  { value: Ze.customerFullName, text: x.state.locale["customer-full-name"] },
  { value: Ze.time, text: x.state.locale.time },
  { value: Ze.bookingRef, text: x.state.locale["booking-ref"] },
  { value: Ze.bookingState, text: x.state.locale["booking-state"] },
  { value: Ze.product, text: x.state.locale.product },
  { value: Ze.ticket, text: x.state.locale.ticket },
  { value: Ze.extrasCount, text: x.state.locale["number-extras"] },
  { value: Ze.peopleInsideTickets, text: x.state.locale["people-inside-tickets"] },
  { value: Ze.bookingCustomFields, text: x.state.locale["custom-fields"] }
  // TODO - temporary need hide quantity
  // { value: CALENDAR_SETTINGS_LABEL_TYPES.quantity, text: calendarsStore.state.locale["quantity"] },
], Am = () => [
  { value: 5, text: `5 ${x.state.locale.minutes}` },
  { value: 10, text: `10 ${x.state.locale.minutes}` },
  { value: 15, text: `15 ${x.state.locale.minutes}` },
  { value: 30, text: `30 ${x.state.locale.minutes}` },
  { value: 60, text: `1 ${x.state.locale.hour}` },
  { value: 120, text: `2 ${x.state.locale.hours}` },
  { value: 180, text: `3 ${x.state.locale.hours}` },
  { value: 240, text: `4 ${x.state.locale.hours}` },
  { value: 360, text: `6 ${x.state.locale.hours}` },
  { value: 480, text: `8 ${x.state.locale.hours}` },
  { value: 720, text: `12 ${x.state.locale.hours}` },
  { value: 1440, text: `24 ${x.state.locale.hours}` }
], Rm = (s, n) => {
  const e = {
    [Ze.none]: "",
    [Ze.customerFullName]: s.occupancyCustomerFullNameCustom,
    [Ze.time]: s.occupancyStartEndDateTimeCustom,
    [Ze.bookingRef]: s.occupancyBookingReference,
    [Ze.bookingState]: s.occupancyBookingStatusLangKeyCustom,
    [Ze.product]: s.occupancyProductName,
    [Ze.ticket]: s.occupancyTicketName,
    [Ze.extrasCount]: s.occupancyRetailProductCountString,
    [Ze.peopleInsideTickets]: s.occupancyPeopleInsideTicketsCustom,
    [Ze.bookingCustomFields]: s.occupancyBookingCustomFieldAnswersCustom
    // TODO - temporary need hide quantity
    // [CALENDAR_SETTINGS_LABEL_TYPES.quantity]: data.occupancyQuantityAttendeesCustom
  };
  return {
    cardTitle: e[n.cardTitle],
    cardSubtitle1: e[n.cardSubtitle1],
    cardSubtitle2: e[n.cardSubtitle2],
    cardSubtitle3: e[n.cardSubtitle3],
    cardSubtitle4: e[n.cardSubtitle4]
  };
}, Uc = (s) => {
  var l, u, c, d, m, h, f, p, g, v, y, b, D;
  const { userAdvancedSettings: n, calendarType: e, appType: t, groupId: a, viewId: i } = s, r = i || "custom", o = [`group-${a}`];
  return (m = (d = (c = (u = (l = n == null ? void 0 : n.calendars) == null ? void 0 : l["resource-calendar"]) == null ? void 0 : u[t]) == null ? void 0 : c[o]) == null ? void 0 : d[r]) != null && m[e] ? ((v = (g = (p = (f = (h = n == null ? void 0 : n.calendars) == null ? void 0 : h["resource-calendar"]) == null ? void 0 : f[t]) == null ? void 0 : p[o]) == null ? void 0 : g[r]) == null ? void 0 : v[e]) || { filters: [], settings: {}, sorting: {} } : ((D = (b = (y = n == null ? void 0 : n.calendars) == null ? void 0 : y[`occupancy-${e}-calendar`]) == null ? void 0 : b[t]) == null ? void 0 : D[a]) || { filters: [], settings: {}, sorting: {} };
}, Pm = (s) => {
  var l, u, c, d, m;
  const { userAdvancedSettings: n, appType: e, groupId: t, viewId: a, defaultType: i } = s, r = a || "custom", o = [`group-${t}`];
  return ((m = (d = (c = (u = (l = n == null ? void 0 : n.calendars) == null ? void 0 : l["resource-calendar"]) == null ? void 0 : u[e]) == null ? void 0 : c[o]) == null ? void 0 : d[r]) == null ? void 0 : m["calendar-type"]) || i;
}, zm = (s) => {
  var m, h, f, p, g, v, y, b, D, w, C, T, N, O, L;
  const { userAdvancedSettings: n, calendarType: e, appType: t, filters: a, settings: i, sorting: r, groupId: o, viewId: l } = s, u = l || "custom", c = [`group-${o}`];
  return { advancedSettings: JSON.stringify(ct(ge({}, n), {
    calendars: ct(ge({}, n == null ? void 0 : n.calendars), {
      "resource-calendar": ct(ge({}, (m = n == null ? void 0 : n.calendars) == null ? void 0 : m["resource-calendar"]), {
        [t]: ct(ge({}, (f = (h = n == null ? void 0 : n.calendars) == null ? void 0 : h["resource-calendar"]) == null ? void 0 : f[t]), {
          [c]: ct(ge({}, (v = (g = (p = n == null ? void 0 : n.calendars) == null ? void 0 : p["resource-calendar"]) == null ? void 0 : g[t]) == null ? void 0 : v[c]), {
            [u]: ct(ge({}, (w = (D = (b = (y = n == null ? void 0 : n.calendars) == null ? void 0 : y["resource-calendar"]) == null ? void 0 : b[t]) == null ? void 0 : D[c]) == null ? void 0 : w[u]), {
              [e]: ct(ge({}, (L = (O = (N = (T = (C = n == null ? void 0 : n.calendars) == null ? void 0 : C["resource-calendar"]) == null ? void 0 : T[t]) == null ? void 0 : N[c]) == null ? void 0 : O[u]) == null ? void 0 : L[e]), {
                settings: i,
                filters: a,
                sorting: r
              })
            })
          })
        })
      })
    })
  })) };
}, Hm = (s) => {
  var u, c, d, m, h, f, p, g, v, y;
  const { userAdvancedSettings: n, calendarType: e, appType: t, groupId: a, viewId: i } = s, r = i || "custom", o = [`group-${a}`];
  return { advancedSettings: JSON.stringify(ct(ge({}, n), {
    calendars: ct(ge({}, n == null ? void 0 : n.calendars), {
      "resource-calendar": ct(ge({}, (u = n == null ? void 0 : n.calendars) == null ? void 0 : u["resource-calendar"]), {
        [t]: ct(ge({}, (d = (c = n == null ? void 0 : n.calendars) == null ? void 0 : c["resource-calendar"]) == null ? void 0 : d[t]), {
          [o]: ct(ge({}, (f = (h = (m = n == null ? void 0 : n.calendars) == null ? void 0 : m["resource-calendar"]) == null ? void 0 : h[t]) == null ? void 0 : f[o]), {
            [r]: ct(ge({}, (y = (v = (g = (p = n == null ? void 0 : n.calendars) == null ? void 0 : p["resource-calendar"]) == null ? void 0 : g[t]) == null ? void 0 : v[o]) == null ? void 0 : y[r]), {
              "calendar-type": e
            })
          })
        })
      })
    })
  })) };
}, ll = (s) => {
  const { userAdvancedSettings: n, filter: e, appType: t, groupId: a, viewId: i, userToken: r, env: o } = x.state;
  return {
    accessToken: r,
    env: o,
    data: zm({
      userAdvancedSettings: n,
      calendarType: s,
      settings: x.getters.getCalendarSettings.value,
      filters: e.filters,
      sorting: x.state.sorting,
      appType: t,
      groupId: a,
      viewId: i
    })
  };
}, cl = (s) => {
  const { userAdvancedSettings: n, appType: e, groupId: t, viewId: a, userToken: i, env: r } = x.state;
  return {
    accessToken: i,
    env: r,
    data: Hm({
      userAdvancedSettings: n,
      calendarType: s,
      appType: e,
      groupId: t,
      viewId: a
    })
  };
}, Bc = (s, n) => n === Nt.ascending ? s.sort((e, t) => e.name.toLowerCase().localeCompare(t.name.toLowerCase(), void 0, {
  numeric: !0,
  sensitivity: "base"
})) : n === Nt.descending ? s.sort((e, t) => t.name.toLowerCase().localeCompare(e.name.toLowerCase(), void 0, {
  numeric: !0,
  sensitivity: "base"
})) : s;
class Fm {
  constructor(n) {
    this.service = kh.create(n), this.service.interceptors.request.use(this.reqSuccess, this.reqError), this.service.interceptors.response.use(this.resSuccess, this.resError), is(this.service, {
      retries: 3,
      shouldResetTimeout: !0,
      retryDelay() {
        return 1e3;
      },
      retryCondition(e) {
        return e.message.includes("timeout of") || e.code === "ERR_NETWORK";
      },
      onMaxRetryTimesExceeded(e, t) {
        var l, u, c;
        const a = `${e.config.baseURL || ""}${e.config.url || ""}`, i = a.includes("app-logger-new.smeetz.com"), r = ((u = (l = e == null ? void 0 : e.config) == null ? void 0 : l.metadata) == null ? void 0 : u.data) || {}, o = {
          params: JSON.stringify(r, null, 2),
          method: ((c = e == null ? void 0 : e.config) == null ? void 0 : c.method) || "",
          axiosErrorMessage: e.message || "",
          axiosError: JSON.stringify(e, null, 2),
          levelName: "ERROR",
          requestType: Aa.failedRetry
        };
        if (!i)
          try {
            bs.info(`ERROR. Request ${a} failed after ${t} counts`, o);
          } catch (d) {
            console.warn("Error while logger service", d);
          }
      }
    });
  }
  reqSuccess(n) {
    return n.metadata = { requestStartTime: Date.now(), data: n.data }, n;
  }
  reqError(n) {
    Promise.reject(n);
  }
  resSuccess(n) {
    var l;
    const e = n.config.metadata.requestStartTime, t = Date.now() - e, a = `${n.config.baseURL || ""}${n.config.url || ""}`, i = a.includes("app-logger-new.smeetz.com"), r = n.config.metadata.data || {}, o = {
      params: JSON.stringify(r, null, 2),
      latency: t,
      method: ((l = n == null ? void 0 : n.config) == null ? void 0 : l.method) || "",
      levelName: "INFO",
      requestType: Aa.normal
    };
    if (!i)
      try {
        bs.info(`Request for ${a} took ${t}ms`, o);
      } catch (u) {
        console.warn("Error while logger service", u);
      }
    return n;
  }
  resError(n) {
    var l, u, c;
    const e = n.config.metadata.requestStartTime, t = Date.now() - e, a = `${n.config.baseURL || ""}${n.config.url || ""}`, i = a.includes("app-logger-new.smeetz.com"), r = ((u = (l = n == null ? void 0 : n.config) == null ? void 0 : l.metadata) == null ? void 0 : u.data) || {}, o = {
      params: JSON.stringify(r, null, 2),
      latency: t,
      method: ((c = n == null ? void 0 : n.config) == null ? void 0 : c.method) || "",
      axiosErrorMessage: n.message || "",
      axiosError: JSON.stringify(n, null, 2),
      levelName: "ERROR",
      requestType: n.message.includes("timeout of") || n.code === "ERR_NETWORK" ? Aa.failedTimeOut : Aa.failed
    };
    if (!i)
      try {
        bs.info(`ERROR. Request for ${a} took ${t}ms`, o);
      } catch (d) {
        console.warn("Error while logger service", d);
      }
    return Promise.reject(n);
  }
}
const Ym = new Fm({
  timeout: 5e3
}), ma = Ym.service, Um = "https://e62df2395a2540beb80bbba627aac4d8.ent-search.eu-central-1.aws.cloud.es.io", Bm = "https://app-logger-new.smeetz.com/log", Vc = (s) => s === "prod" ? "yfgD7P5bCV9lrm03eeQmg8XJObvj07dlpl1KtePj" : "C4szU2oAuLf4ZYaX2kdgxBjhoghKrT8tNr7ZGT00", Vm = (s) => `occupancy-table-engine-${s}`, jc = (s) => `  https://api.smeetz.com/b2b2/${s}/en`, jm = (s) => s === "test" ? "https://graphql-test.smeetz.com/nc/smeetzgql_0g1n/v1/graphql" : s === "prod" ? "https://graphql.smeetz.com/nc/smeetzgql_0g1n/v1/graphql" : "https://graphql-dev.smeetz.com/nc/smeetzgql_0g1n/v1/graphql";
function Wm(s) {
  return Re(this, null, function* () {
    const { groupId: n, accessToken: e, env: t } = s, a = jc(t), i = Vc(t);
    return (yield ma({
      baseURL: a,
      url: `/group/${n}/stock`,
      method: "GET",
      headers: { "Content-Type": "application/json", "x-api-key": i, Authorization: e }
    })).data;
  });
}
function dl(s) {
  return Re(this, null, function* () {
    const { engineName: n, accessToken: e, filter: t } = s;
    return (yield ma({
      baseURL: Um,
      url: `/api/as/v1/engines/${n}/search`,
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${e}` },
      data: JSON.stringify(ge({}, t))
    })).data;
  });
}
function qr(s) {
  return Re(this, null, function* () {
    const { accessToken: n, env: e, data: t } = s, a = jc(e), i = Vc(e);
    return (yield ma({
      baseURL: a,
      url: "/user",
      method: "PATCH",
      headers: { "Content-Type": "application/json", "x-api-key": i, Authorization: n },
      data: t
    })).data;
  });
}
function Wc(s) {
  return Re(this, null, function* () {
    const { env: n, accessToken: e, variables: t, query: a } = s, i = jm(n);
    return (yield ma({
      url: i,
      method: "POST",
      headers: { "Content-Type": "application/json", "Smtz-Auth": e },
      data: JSON.stringify({ query: a, variables: t })
    })).data;
  });
}
function $m(s) {
  return Re(this, null, function* () {
    return (yield ma({
      baseURL: Bm,
      method: "post",
      data: s,
      headers: {
        "Content-Type": "application/json"
      }
    })).data;
  });
}
class qm {
  constructor(n) {
    this.opts = n, this._rawData = {};
  }
  /**
   * Fetch group graphql data
   *
   * @returns {Void}
   */
  fetch() {
    return Re(this, null, function* () {
      var e;
      const n = yield Wc(this.opts);
      this._rawData = ((e = n == null ? void 0 : n.data) == null ? void 0 : e.Group) || {};
    });
  }
  /**
   * Get date format b2b
   *
   * @return {String}
   */
  get dateFormatB2b() {
    var n;
    return ((n = this._rawData) == null ? void 0 : n.DateFormatB2b) || "d-m-Y";
  }
  /**
   * Get date format b2b for calendar
   *
   * @return {String}
   */
  get dateFormatB2bCustom() {
    return Object.freeze({
      "M j, Y": "MMM D, YYYYY",
      "D, j M Y": "DDD, D MMM YYYY",
      "Y-m-d": "YYYY-MM-DD",
      "m/d/Y": "MM/DD/YYYY",
      "d-m-Y": "DD-MM-YYYY",
      "d.m.Y": "DD.MM.YYYY"
    })[this.dateFormatB2b];
  }
  /**
   * Get time format b2b
   *
   * @return {Number}
   */
  get timeFormatB2b() {
    var n, e;
    return (e = (n = this._rawData) == null ? void 0 : n.TimeFormatB2b) != null ? e : 0;
  }
  /**
   * Get time format b2b for calendar
   *
   * @return {String}
   */
  get timeFormatB2bCustom() {
    return Object.freeze({
      1: "h:mm A",
      0: "HH:mm"
    })[this.timeFormatB2b];
  }
  /**
   * Get week start b2b
   *
   * @return {Number}
   */
  get weekStartB2b() {
    var n, e;
    return (e = (n = this._rawData) == null ? void 0 : n.WeekStartB2b) != null ? e : 1;
  }
}
class Gm {
  constructor(n) {
    this._rawData = n;
  }
  /**
   * Get document recorded
   *
   * @return {String}
   */
  get documentRecorded() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.document_recorded) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get group access
   *
   * @return {String}
   */
  get groupAccess() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.group_access) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get id
   *
   * @return {String | Null}
   */
  get id() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.id) == null ? void 0 : e.raw) || null;
  }
  /**
   * Get occupancy booking channel
   *
   * @return {String}
   */
  get occupancyBookingChannel() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_booking_channel) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy booking currency
   *
   * @return {String}
   */
  get occupancyBookingCurrency() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_booking_currency) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy booking document status
   *
   * @return {Number}
   */
  get occupancyBookingDocumentStatus() {
    var n, e, t;
    return (t = (e = (n = this._rawData) == null ? void 0 : n.occupancy_booking_document_status) == null ? void 0 : e.raw) != null ? t : 100;
  }
  /**
   * Get occupancy booking id
   *
   * @return {Number | Null}
   */
  get occupancyBookingId() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_booking_id) == null ? void 0 : e.raw) || null;
  }
  /**
   * Get occupancy booking reference
   *
   * @return {String}
   */
  get occupancyBookingReference() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_booking_reference) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy booking state
   *
   * @return {Number}
   */
  get occupancyBookingState() {
    var n, e, t;
    return (t = (e = (n = this._rawData) == null ? void 0 : n.occupancy_booking_state) == null ? void 0 : e.raw) != null ? t : 100;
  }
  /**
   * Get occupancy booking type
   *
   * @return {Number}
   */
  get occupancyBookingType() {
    var n, e, t;
    return (t = (e = (n = this._rawData) == null ? void 0 : n.occupancy_booking_type) == null ? void 0 : e.raw) != null ? t : 100;
  }
  /**
   * Get occupancy booking status color type by booking status
   *
   * @returns {String} 
  */
  get occupancyBookingStatusColorTypeCustom() {
    return ol[this.occupancyBookingState];
  }
  /**
   * Get occupancy booking status color code by booking status
   *
   * @returns {String}
  */
  get occupancyBookingStatusColorCodeCustom() {
    return km[ol[this.occupancyBookingState]];
  }
  /**
   * Get occupancy booking status lang key by booking status
   *
   * @return {String}
   */
  get occupancyBookingStatusLangKeyCustom() {
    return Mm[this.occupancyBookingState];
  }
  /**
   * Get info that occupancy booking status is completed (3)
   *
   * @return {Boolean}
   */
  get occupancyBookingIsCompletedCustom() {
    return this.occupancyBookingState === 3;
  }
  /**
   * Get occupancy customer address
   *
   * @return {String}
   */
  get occupancyCustomerAddress() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_customer_address) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy customer city
   *
   * @return {String}
   */
  get occupancyCustomerCity() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_customer_city) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy customer country
   *
   * @return {String}
   */
  get occupancyCustomerCountry() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_customer_country) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy customer email
   *
   * @return {String}
   */
  get occupancyCustomerEmail() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_customer_email) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy customer first name
   *
   * @return {String}
   */
  get occupancyCustomerFirstName() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_customer_first_name) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy customer full name
   *
   * @return {String}
   */
  get occupancyCustomerFullName() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_customer_full_name) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy customer full name as custom
   *
   * @returns {String}
  */
  get occupancyCustomerFullNameCustom() {
    return this.occupancyCustomerFirstName && this.occupancyCustomerLastName ? `${this.occupancyCustomerFirstName} ${this.occupancyCustomerLastName}` : this.occupancyCustomerFirstName || this.occupancyCustomerLastName || "";
  }
  /**
   * Get occupancy customer id
   *
   * @return {Number | Null}
   */
  get occupancyCustomerId() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_customer_id) == null ? void 0 : e.raw) || null;
  }
  /**
   * Get occupancy customer last name
   *
   * @return {String}
   */
  get occupancyCustomerLastName() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_customer_last_name) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy customer phone
   *
   * @return {String}
   */
  get occupancyCustomerPhone() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_customer_phone) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy customer zip
   *
   * @return {String}
   */
  get occupancyCustomerZip() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_customer_zip) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy end date time
   *
   * @return {String}
   */
  get occupancyEndDateTime() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_end_date_time) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy end date time as display time
   *
   * @return {String}
   */
  get occupancyEndDateTimeCustomTime() {
    return sl(this.occupancyEndDateTime);
  }
  /**
   * Get occupancy id
   *
   * @return {Number | Null}
   */
  get occupancyId() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_id) == null ? void 0 : e.raw) || null;
  }
  /**
   * Get occupancy product id
   *
   * @return {Number | Null}
   */
  get occupancyProductId() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_product_id) == null ? void 0 : e.raw) || null;
  }
  /**
   * Get occupancy product name
   *
   * @return {String}
   */
  get occupancyProductName() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_product_name) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy quantity
   *
   * @return {Number}
   */
  get occupancyQuantity() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_quantity) == null ? void 0 : e.raw) || 0;
  }
  /**
   * Get occupancy quantity with "attendee(s)" text
   *
   * @return {String}
   */
  get occupancyQuantityAttendeesCustom() {
    const n = x.state.locale.attendee, e = x.state.locale.attendees;
    return this.occupancyQuantity === 1 ? `${this.occupancyQuantity} ${n}` : `${this.occupancyQuantity} ${e}`;
  }
  /**
   * Get occupancy retail products
   *
   * @return {String[] | []}
   */
  get occupancyRetailProducts() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_retail_products) == null ? void 0 : e.raw) || [];
  }
  /**
   * Get occupancy retail products as array with objects
   *
   * @return {Object[] | []}
   */
  get occupancyRetailProductsCustomArray() {
    return this.occupancyRetailProducts.map((n) => JSON.parse(n));
  }
  /**
   * Get occupancy retail product count as string
   *
   * @return {string}
   */
  get occupancyRetailProductCountString() {
    return String(this.occupancyRetailProducts.length);
  }
  /**
   * Get occupancy seller full name
   *
   * @return {String}
   */
  get occupancySellerFullName() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_seller_full_name) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy seller id
   *
   * @return {Number | Null}
   */
  get occupancySellerId() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_seller_id) == null ? void 0 : e.raw) || null;
  }
  /**
   * Get occupancy start date time
   *
   * @return {String}
   */
  get occupancyStartDateTime() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_start_date_time) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy start date time as display time
   *
   * @return {String}
   */
  get occupancyStartDateTimeCustomTime() {
    return sl(this.occupancyStartDateTime);
  }
  /**
   * Get occupancy start date time with end date time
   *
   * @return {String}
   */
  get occupancyStartEndDateTimeCustom() {
    return `${this.occupancyStartDateTimeCustomTime} - ${this.occupancyEndDateTimeCustomTime}`;
  }
  /**
   * Get occupancy stock capacity
   *
   * @return {Number}
   */
  get occupancyStockCapacity() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_stock_capacity) == null ? void 0 : e.raw) || 0;
  }
  /**
   * Get occupancy stock id
   *
   * @return {Number | Null}
   */
  get occupancyStockId() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_stock_id) == null ? void 0 : e.raw) || null;
  }
  /**
   * Get occupancy stock name
   *
   * @return {String}
   */
  get occupancyStockName() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_stock_name) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy ticket id
   *
   * @return {Number || Null}
   */
  get occupancyTicketId() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_ticket_id) == null ? void 0 : e.raw) || null;
  }
  /**
   * Get occupancy ticket name
   *
   * @return {String}
   */
  get occupancyTicketName() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_ticket_name) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy ticket pos color
   *
   * @return {String}
   */
  get occupancyTicketPosColor() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_ticket_pos_color) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy booking custom fields
   *
   * @return {String}
   */
  get occupancyBookingCustomFields() {
    var n, e;
    return ((e = (n = this._rawData) == null ? void 0 : n.occupancy_booking_custom_fields) == null ? void 0 : e.raw) || "";
  }
  /**
   * Get occupancy count pss
   *
   * @return {number}
   */
  get occupancyCountPss() {
    var n, e, t;
    return (t = (e = (n = this._rawData) == null ? void 0 : n.occupancy_count_pss) == null ? void 0 : e.raw) != null ? t : 0;
  }
  /**
   * Get occupancy sum scans
   *
   * @return {number}
   */
  get occupancySumScans() {
    var n, e, t;
    return (t = (e = (n = this._rawData) == null ? void 0 : n.occupancy_sum_scans) == null ? void 0 : e.raw) != null ? t : 0;
  }
  /**
   * Get occupancy people inside tickets
   *
   * @return {String}
   */
  get occupancyPeopleInsideTicketsCustom() {
    return `${this.occupancySumScans}/${this.occupancyCountPss}`;
  }
  /**
   * Get occupancy booking custom field as string with answers
   *
   * @return {String}
   */
  get occupancyBookingCustomFieldAnswersCustom() {
    return this.occupancyBookingCustomFields ? Object.entries(JSON.parse(this.occupancyBookingCustomFields)).map(([, e]) => e).join(", ") : "";
  }
  /**
   * Get occupancy color code by scans
   *
   * @return {String}
   */
  get occupancyScansColorCodeCustom() {
    const n = this.occupancyCountPss, e = this.occupancySumScans, t = x.getters.getCalendarSettings.value.scanColor, a = x.getters.getCalendarSettings.value.fullScanColor;
    return e && e < n ? t : e && n && e >= n ? a : !e && !n ? "#767676" : "#c9c9c9";
  }
  /**
   * Get occupancy color for event card by scans or booking status
   *
   * @return {String}
   */
  get occupancyEventCardColorCodeCustom() {
    return this.occupancySumScans ? this.occupancyScansColorCodeCustom : this.occupancyBookingStatusColorCodeCustom;
  }
  /**
   * Get custom id for "count inside" feature
   *
   * @return {String}
   */
  get idCountInsideCustom() {
    return `${this.occupancyStockId}-${this.occupancyStartDateTime}-${this.occupancyEndDateTime}`;
  }
  /**
   * Get occupancy data splitted by time scale
   *
   * @return {Object[]}
   */
  get occupancySplittedByTimeScaleCustom() {
    const n = x.getters.getCalendarSettings.value.timeCellStep || 15;
    let e = [], t = !0, a = il(this.occupancyStartDateTime, n, "decrease");
    const i = il(this.occupancyEndDateTime, n, "increase");
    do {
      const r = po({ date: a, value: n, period: "minute" }), o = rl(r), l = rl(i), u = {
        id: `_${Math.random().toString(36).substr(2, 9)}`,
        start: a,
        end: o >= l ? i : r,
        color: this.occupancyBookingStatusColorCodeCustom,
        resource: this.occupancyStockId,
        editable: !1,
        occupancyStartEndDateTimeCustom: "",
        occupancyQuantity: this.occupancyQuantity,
        totalOccupancy: 1,
        totalOccupancyQuantity: this.occupancyQuantity,
        idCountInside: `${this.occupancyStockId}-${a}-${r}`
      };
      e.push(u), a = r, o >= l && (t = !1);
    } while (t);
    return e;
  }
}
class Xm {
  constructor(n) {
    this._rawData = n;
  }
  /**
   * Get id
   *
   * @return {Number | Null}
   */
  get id() {
    var n;
    return ((n = this._rawData) == null ? void 0 : n.id) || null;
  }
  /**
   * Get name
   *
   * @return {String}
   */
  get name() {
    var n;
    return ((n = this._rawData) == null ? void 0 : n.name) || "";
  }
  /**
   * Get capacity
   *
   * @return {Number}
   */
  get capacity() {
    var n;
    return ((n = this._rawData) == null ? void 0 : n.capacity) || 0;
  }
  /**
   * Get type
   *
   * @return {Number}
   */
  get type() {
    var n, e;
    return (e = (n = this._rawData) == null ? void 0 : n.type) != null ? e : 100;
  }
}
class Km {
  constructor(n) {
    this.opts = n, this._rawData = {};
  }
  /**
   * Fetch user graphql data
   *
   * @returns {Void}
   */
  fetch() {
    return Re(this, null, function* () {
      var e;
      const n = yield Wc(this.opts);
      this._rawData = ((e = n == null ? void 0 : n.data) == null ? void 0 : e.User) || {};
    });
  }
  /**
   * Get advanced settings
   *
   * @return {String}
   */
  get advancedSettings() {
    var n;
    return ((n = this._rawData) == null ? void 0 : n.AdvancedSettings) || "{}";
  }
  /**
   * Get advanced settings as object
   *
   * @returns {Object}
  */
  get advancedSettingsCustomObject() {
    return JSON.parse(this.advancedSettings);
  }
}
const ul = 1e3, Fe = Object.freeze({
  autocompleteHasValue: 1,
  // all: [{ field_name: "" }]
  autocompleteHasNotValue: 2,
  // none: [{ field_name: "" }]
  dateBefore: 14,
  // all: [{ field_name: { to: "" } }]
  dateAfter: 15,
  // all: [{ field_name: { from: "" } }]
  numberEqualTo: 6,
  // all: [{ field_name: "" }]
  numberNotEqual: 7,
  // none: [{ field_name: "" }]
  numberBetween: 8,
  // all: [{ field_name: { from: "", to: "" } }]
  numberNotBetween: 9,
  // none: [{ field_name: { from: "", to: "" } }]
  statusAnyOf: 10,
  // all: [{ field_name: "" }]
  statusNoneOf: 11,
  // none: [{ field_name: "" }]
  textContains: 12,
  // all: [{ field_name: "" }]
  textNotContain: 13,
  // none: [{ field_name: "" }]
  selectAutocompleteAnyOf: 16,
  // all: [{ field_name: "" }]
  selectAutocompleteNoneOf: 17,
  // none: [{ field_name: "" }]
  selectAutocompleteAnyValue: 23
  // any: [{ field_name: "" }]
}), Qm = () => Object.freeze({
  query: "",
  page: {
    size: 7,
    current: 1
  },
  filters: {
    all: [{ group_access: String(x.state.groupId) }]
  }
}), Jm = (s) => {
  const n = qc(s.calendarStartDate, s.calendarType), e = n.map((a) => a.key);
  let t = s.filter.filters.filter((a) => !e.includes(a.key));
  return t = t.concat(n), ct(ge({}, s.filter), {
    filters: t
  });
}, lr = (s) => {
  const n = rp(s.filters);
  return ct(ge({}, s), {
    filters: n
  });
}, $c = (s) => {
  const { propsFilters: n, backendFilters: e, calendarStartDate: t, calendarType: a } = s, i = ["occupancy_start_date_time", "occupancy_end_date_time"], r = n.map((d) => d.key);
  let o = e.filter((d) => !r.includes(d.key));
  o = o.concat(n);
  const l = o.filter((d) => !i.includes(d.key)), u = qc(t, a);
  return {
    filters: l.concat(u),
    page: {
      size: 25,
      current: 1
    },
    query: ""
  };
}, Pt = Object.freeze({
  all: "all",
  none: "none",
  any: "any"
}), $t = Object.freeze({
  text: "text",
  number: "number",
  date: "date",
  status: "status",
  autocomplete: "autocomplete",
  selectAutocomplete: "select-autocomplete"
}), Zm = [Fe.autocompleteHasValue, Fe.autocompleteHasNotValue], ep = [
  Fe.dateBefore,
  Fe.dateAfter
], tp = [
  Fe.numberEqualTo,
  Fe.numberNotEqual,
  Fe.numberBetween,
  Fe.numberNotBetween
], np = [Fe.statusAnyOf, Fe.statusNoneOf], sp = [Fe.textContains, Fe.textNotContain], ap = [
  Fe.selectAutocompleteAnyOf,
  Fe.selectAutocompleteNoneOf,
  Fe.selectAutocompleteAnyValue
], qc = (s, n) => {
  const [e] = s.split(" "), t = { key: "occupancy_start_date_time", option: Fe.dateAfter, value: "" }, a = { key: "occupancy_end_date_time", option: Fe.dateBefore, value: "" };
  return (n === Qe.daily || n === Qe.dailyCountInside) && (t.value = Sm({ date: s, value: 2, period: "day" }), a.value = po({ date: `${e} 23:59`, value: 2, period: "day" })), [t, a];
}, rp = (s) => s.reduce((n, e) => {
  const t = ip(e);
  let a = null;
  switch (t) {
    case $t.autocomplete:
      a = op(e);
      break;
    case $t.date:
      a = lp(e);
      break;
    case $t.number:
      a = cp(e);
      break;
    case $t.status:
      a = dp(e);
      break;
    case $t.text:
      a = up(e);
      break;
    case $t.selectAutocomplete:
      a = hp(e);
      break;
  }
  return a && (n[a.optionType] || (n[a.optionType] = []), n[a.optionType].push(a.value)), n;
}, {}), ip = (s) => Zm.includes(s.option) ? $t.autocomplete : ep.includes(s.option) ? $t.date : tp.includes(s.option) ? $t.number : np.includes(s.option) ? $t.status : sp.includes(s.option) ? $t.text : ap.includes(s.option) ? $t.selectAutocomplete : "", op = (s) => {
  const n = s.option === Fe.autocompleteHasValue ? Pt.all : Pt.none, e = { [s.key]: s.value };
  return { optionType: n, value: e };
}, lp = (s) => {
  const n = Pt.all;
  let e = null;
  s.option === Fe.dateBefore && (e = { to: po({ date: s.value, value: 1, period: "minute" }) }), s.option === Fe.dateAfter && (e = { from: Cm(s.value) });
  const t = { [s.key]: e };
  return { optionType: n, value: t };
}, cp = (s) => {
  let n = null, e = null;
  s.option === Fe.numberBetween || s.option === Fe.numberNotBetween ? (n = s.option === Fe.numberBetween ? Pt.all : Pt.none, e = {
    from: Number(s.value.from),
    // TODO - temporary hack, plus 0.001 for app search request
    to: Number(s.value.to) + 1e-3
  }) : (n = s.option === Fe.numberNotEqual ? Pt.none : Pt.all, e = Number(s.value));
  const t = { [s.key]: e };
  return { optionType: n, value: t };
}, dp = (s) => {
  const n = s.option === Fe.statusAnyOf ? Pt.all : Pt.none, e = { [s.key]: s.value };
  return { optionType: n, value: e };
}, up = (s) => {
  const n = s.option === Fe.textContains ? Pt.all : Pt.none, e = { [s.key]: s.value };
  return { optionType: n, value: e };
}, hp = (s) => {
  const n = { [s.key]: s.value };
  return s.option === Fe.selectAutocompleteAnyOf ? { value: n, optionType: Pt.all } : s.option === Fe.selectAutocompleteAnyValue ? { value: n, optionType: Pt.any } : { value: n, optionType: Pt.none };
};
class Us {
  constructor(n) {
    this.opts = n, this._rawData = [];
  }
  /**
   * Fetch occupancy data by filter
   *
   * @returns {Void}
   */
  fetch() {
    return Re(this, null, function* () {
      const { results: n = [] } = yield dl(this.opts);
      this._rawData = n;
    });
  }
  /**
   * Fetch occupancy data by filter and without paginations
   *
   * @returns {Void}
   */
  fetchAllPages() {
    return Re(this, null, function* () {
      const n = ct(ge({}, this.opts.filter), {
        page: { size: ul, current: 1 }
      });
      let e = [];
      do {
        const { results: t = [] } = yield dl(ct(ge({}, this.opts), { filter: n }));
        e = e.concat(t), n.page.current = n.page.current + 1;
      } while (e.length === ul);
      this._rawData = e;
    });
  }
  /**
   * Get occupancy items by occupancy model
   *
   * @return {Object[] | []}
   */
  get items() {
    return this._rawData.map((n) => new Gm(n));
  }
  /**
   * Get occupancy items as count inside
   *
   * @return {Object[] | []}
   */
  get itemsCountInside() {
    const e = this.items.reduce((t, a) => a.occupancyBookingIsCompletedCustom ? t.concat(a.occupancySplittedByTimeScaleCustom) : t, []).reduce((t, a) => (t[a.idCountInside] ? (t[a.idCountInside].children.push(a), t[a.idCountInside].totalOccupancy = t[a.idCountInside].totalOccupancy + 1, t[a.idCountInside].totalOccupancyQuantity = t[a.idCountInside].totalOccupancyQuantity + a.occupancyQuantity) : t[a.idCountInside] = ct(ge({}, a), {
      children: [a]
    }), t), {});
    return Object.values(e);
  }
}
class mp {
  constructor(n) {
    this.opts = n, this._rawData = [];
  }
  /**
   * Fetch stock data
   *
   * @returns {Void}
   */
  fetch() {
    return Re(this, null, function* () {
      this._rawData = yield Wm(this.opts);
    });
  }
  /**
   * Get stock items by stock model
   *
   * @return {Object[] | []}
   */
  get items() {
    var i, r, o, l, u, c, d;
    const n = ((r = (i = this._rawData) == null ? void 0 : i.data) == null ? void 0 : r.stocks) || ((o = this._rawData) == null ? void 0 : o.data) || [], e = ((u = (l = x.state.sorting) == null ? void 0 : l.resource) == null ? void 0 : u.type) || "", t = ((d = (c = x.state.sorting) == null ? void 0 : c.resource) == null ? void 0 : d.list) || [];
    let a = n.map((m) => new Xm(m));
    return (e === Nt.ascending || e === Nt.descending) && (a = Bc(a, e)), e === Nt.custom && (a = a.reduce((m, h) => t.includes(h.id) ? m.map((f) => f === h.id ? h : f) : (m.push(h), m), [...t]), a = a.filter((m) => m == null ? void 0 : m.name)), a;
  }
}
var Ei = function(s, n) {
  return Ei = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
    e.__proto__ = t;
  } || function(e, t) {
    for (var a in t)
      Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
  }, Ei(s, n);
};
function de(s, n) {
  if (typeof n != "function" && n !== null)
    throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
  function e() {
    this.constructor = s;
  }
  Ei(s, n), s.prototype = n === null ? Object.create(n) : (e.prototype = n.prototype, new e());
}
var K = function() {
  return K = Object.assign || function(s) {
    for (var n, e = 1, t = arguments.length; e < t; e++)
      for (var a in n = arguments[e])
        Object.prototype.hasOwnProperty.call(n, a) && (s[a] = n[a]);
    return s;
  }, K.apply(this, arguments);
};
function Bn(s, n) {
  var e = {};
  for (var t in s)
    Object.prototype.hasOwnProperty.call(s, t) && n.indexOf(t) < 0 && (e[t] = s[t]);
  if (s != null && typeof Object.getOwnPropertySymbols == "function") {
    var a = 0;
    for (t = Object.getOwnPropertySymbols(s); a < t.length; a++)
      n.indexOf(t[a]) < 0 && Object.prototype.propertyIsEnumerable.call(s, t[a]) && (e[t[a]] = s[t[a]]);
  }
  return e;
}
var sn, cs, Fn = /* @__PURE__ */ function() {
  function s() {
    this.nr = 0, this.keys = 1, this.subscribers = {};
  }
  return s.prototype.subscribe = function(n) {
    var e = this.keys++;
    return this.subscribers[e] = n, this.nr++, e;
  }, s.prototype.unsubscribe = function(n) {
    this.nr--, delete this.subscribers[n];
  }, s.prototype.next = function(n) {
    for (var e = this.subscribers, t = 0, a = Object.keys(e); t < a.length; t++) {
      var i = a[t];
      e[i] && e[i](n);
    }
  }, s;
}(), cr = [], Ds = !1, Mt = typeof window != "undefined", Gr = Mt && window.matchMedia && window.matchMedia("(prefers-color-scheme:dark)"), rs = Mt ? navigator.userAgent : "", hl = Mt ? navigator.platform : "", pp = Mt ? navigator.maxTouchPoints : 0, Ra = rs && rs.match(/Android|iPhone|iPad|iPod|Windows Phone|Windows|MSIE/i), fp = rs && /Safari/.test(rs);
/Android/i.test(Ra) ? (sn = "android", cs = rs.match(/Android\s+([\d.]+)/i), Ds = !0, cs && (cr = cs[0].replace("Android ", "").split("."))) : /iPhone|iPad|iPod/i.test(Ra) || /iPhone|iPad|iPod/i.test(hl) || hl === "MacIntel" && pp > 1 ? (sn = "ios", cs = rs.match(/OS\s+([\d_]+)/i), Ds = !0, cs && (cr = cs[0].replace(/_/g, ".").replace("OS ", "").split("."))) : /Windows Phone/i.test(Ra) ? (sn = "wp", Ds = !0) : /Windows|MSIE/i.test(Ra) && (sn = "windows");
var ki = +cr[0];
+cr[1];
var fs = {}, wn = {}, fo = {}, Mi = new Fn();
function Gc() {
  var s = "", n = "", e = "";
  for (var t in n = sn === "android" ? "material" : sn === "wp" || sn === "windows" ? "windows" : "ios", wn) {
    if (wn[t].baseTheme === n && wn[t].auto !== !1 && t !== n + "-dark") {
      s = t;
      break;
    }
    t === n ? s = t : e || (e = t);
  }
  return s || e;
}
function ml(s, n, e) {
  var t = wn[n];
  wn[s] = K({}, t, { auto: e, baseTheme: n }), fo.theme = Gc();
}
var pl = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M217.9 256L345 129c9.4-9.4 9.4-24.6 0-33.9-9.4-9.4-24.6-9.3-34 0L167 239c-9.1 9.1-9.3 23.7-.7 33.1L310.9 417c4.7 4.7 10.9 7 17 7s12.3-2.3 17-7c9.4-9.4 9.4-24.6 0-33.9L217.9 256z"/></svg>', Qa = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z"/></svg>', fl = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M294.1 256L167 129c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.3 34 0L345 239c9.1 9.1 9.3 23.7.7 33.1L201.1 417c-4.7 4.7-10.9 7-17 7s-12.3-2.3-17-7c-9.4-9.4-9.4-24.6 0-33.9l127-127.1z"/></svg>', _l = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 217.9L383 345c9.4 9.4 24.6 9.4 33.9 0 9.4-9.4 9.3-24.6 0-34L273 167c-9.1-9.1-23.7-9.3-33.1-.7L95 310.9c-4.7 4.7-7 10.9-7 17s2.3 12.3 7 17c9.4 9.4 24.6 9.4 33.9 0l127.1-127z"/></svg>', Ii = '<svg xmlns="http://www.w3.org/2000/svg" height="17" viewBox="0 0 17 17" width="17"><path d="M8.5 0a8.5 8.5 0 110 17 8.5 8.5 0 010-17zm3.364 5.005a.7.7 0 00-.99 0l-2.44 2.44-2.439-2.44-.087-.074a.7.7 0 00-.903 1.064l2.44 2.439-2.44 2.44-.074.087a.7.7 0 001.064.903l2.439-2.441 2.44 2.441.087.074a.7.7 0 00.903-1.064l-2.441-2.44 2.441-2.439.074-.087a.7.7 0 00-.074-.903z" fill="currentColor" fill-rule="evenodd"/></svg>', Xr = { clearIcon: Ii, labelStyle: "inline" };
wn.ios = { Calendar: { nextIconH: fl, nextIconV: Qa, prevIconH: pl, prevIconV: _l }, Checkbox: { position: "end" }, Datepicker: { clearIcon: Ii, display: "bottom" }, Dropdown: Xr, Eventcalendar: { chevronIconDown: Qa, nextIconH: fl, nextIconV: Qa, prevIconH: pl, prevIconV: _l }, Input: Xr, Radio: { position: "end" }, Scroller: { display: "bottom", itemHeight: 34, minWheelWidth: 55, rows: 5, scroll3d: !0 }, SegmentedGroup: { drag: !0 }, Select: { clearIcon: Ii }, Textarea: Xr }, ml("ios-dark", "ios"), fo.theme = Gc(), ml("smeetzz", "ios");
var vl = pa(3), gl = pa(4), Xc = pa(7);
function $e(s, n, e) {
  return Math.max(n, Math.min(s, e));
}
function _p(s, n) {
  return K({}, s, n);
}
function at(s) {
  return Array.isArray(s);
}
function Kc(s) {
  return s - parseFloat(s) >= 0;
}
function Qc(s) {
  return typeof s == "number";
}
function ye(s) {
  return typeof s == "string";
}
function Dt(s) {
  return s == null || s === "";
}
function yl(s) {
  return s === void 0;
}
function vp(s) {
  return typeof s == "object";
}
function Pa(s) {
  return s != null && "" + s != "false";
}
function pa(s) {
  return Array.apply(0, Array(Math.max(0, s)));
}
function On(s) {
  return s !== void 0 ? s + (Kc(s) ? "px" : "") : "";
}
function fa() {
}
function bl(s, n) {
  n === void 0 && (n = 2);
  for (var e = s + ""; e.length < n; )
    e = "0" + e;
  return e;
}
function bt(s) {
  return Math.round(s);
}
function Dl(s, n) {
  return Le(s / n) * n;
}
function Le(s) {
  return Math.floor(s);
}
function gp(s, n) {
  var e, t;
  return n === void 0 && (n = 100), function() {
    for (var a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    var r = +/* @__PURE__ */ new Date();
    e && r < e + n ? (clearTimeout(t), t = setTimeout(function() {
      e = r, s.apply(void 0, a);
    }, n)) : (e = r, s.apply(void 0, a));
  };
}
function yp(s, n) {
  var e;
  return n === void 0 && (n = 100), function() {
    for (var t = [], a = 0; a < arguments.length; a++)
      t[a] = arguments[a];
    clearTimeout(e), e = setTimeout(function() {
      s.apply(void 0, t);
    }, n);
  };
}
function bp(s, n) {
  if (s === n)
    return !0;
  if (s && !n || n && !s || s.length !== n.length)
    return !1;
  for (var e = 0; e < s.length; e++)
    if (s[e] !== n[e])
      return !1;
  return !0;
}
function es(s, n) {
  s._cdr ? setTimeout(n) : n();
}
function za(s, n) {
  return Jc(s, n);
}
function Dp(s, n) {
  return Jc(s, n, !0);
}
function Jc(s, n, e) {
  for (var t = s.length, a = 0; a < t; a++) {
    var i = s[a];
    if (n(i, a))
      return e ? a : i;
  }
  return e ? -1 : void 0;
}
function Kr(s) {
  var n = [];
  if (s)
    for (var e = 0, t = Object.keys(s); e < t.length; e++) {
      var a = t[e];
      n.push(s[a]);
    }
  return n;
}
pa(24);
var Je = Mt ? document : void 0, wt = Mt ? window : void 0, wp = ["Webkit", "Moz"], ts = Je && Je.createElement("div").style, Qr = Je && Je.createElement("canvas"), Ha = Qr && Qr.getContext && Qr.getContext("2d", { willReadFrequently: !0 }), wl = wt && wt.CSS, Xs = wl && wl.supports, Jr = {}, on = wt && wt.requestAnimationFrame || function(s) {
  return setTimeout(s, 20);
}, Bs = wt && wt.cancelAnimationFrame || function(s) {
  clearTimeout(s);
}, Ja = ts && ts.animationName !== void 0, Zc = sn === "ios" && !fp, xp = Zc && wt && wt.webkit && wt.webkit.messageHandlers, Cp = ts && ts.touchAction === void 0 || Zc && !xp, mn = function() {
  if (!ts || ts.transform !== void 0)
    return "";
  for (var s = 0, n = wp; s < n.length; s++) {
    var e = n[s];
    if (ts[e + "Transform"] !== void 0)
      return e;
  }
  return "";
}(), ra = mn ? "-" + mn.toLowerCase() + "-" : "", Sp = Xs && Xs("(transform-style: preserve-3d)"), gs = Xs && (Xs("position", "sticky") || Xs("position", "-webkit-sticky"));
function pe(s, n, e, t) {
  s && s.addEventListener(n, e, t);
}
function le(s, n, e, t) {
  s && s.removeEventListener(n, e, t);
}
function vn(s) {
  if (Mt)
    return s && s.ownerDocument ? s.ownerDocument : Je;
}
function Tp(s, n) {
  return parseFloat(getComputedStyle(s)[n] || "0");
}
function Ni(s) {
  return s.scrollLeft !== void 0 ? s.scrollLeft : s.pageXOffset;
}
function Oi(s) {
  return s.scrollTop !== void 0 ? s.scrollTop : s.pageYOffset;
}
function Ns(s) {
  if (Mt)
    return s && s.ownerDocument && s.ownerDocument.defaultView ? s.ownerDocument.defaultView : wt;
}
function xl(s, n) {
  var e = getComputedStyle(s), t = (mn ? e[mn + "Transform"] : e.transform).split(")")[0].split(", ");
  return +(n ? t[13] || t[5] : t[12] || t[4]) || 0;
}
function Ts(s) {
  if (!Ha || !s)
    return "#000";
  if (Jr[s])
    return Jr[s];
  Ha.fillStyle = s, Ha.fillRect(0, 0, 1, 1);
  var n = Ha.getImageData(0, 0, 1, 1), e = n ? n.data : [0, 0, 0], t = 0.299 * +e[0] + 0.587 * +e[1] + 0.114 * +e[2] < 130 ? "#fff" : "#000";
  return Jr[s] = t, t;
}
function ed(s, n, e, t, a, i, r) {
  var o, l, u = Math.min(1, (+/* @__PURE__ */ new Date() - n) / 468), c = 0.5 * (1 - Math.cos(Math.PI * u));
  a !== void 0 && (o = bt(e + (a - e) * c), s.scrollLeft = o), i !== void 0 && (l = bt(t + (i - t) * c), s.scrollTop = l), o !== a || l !== i ? on(function() {
    ed(s, n, e, t, a, i, r);
  }) : r && r();
}
function td(s, n, e, t, a, i) {
  n !== void 0 && (n = Math.max(0, bt(n))), e !== void 0 && (e = Math.max(0, bt(e))), a && n !== void 0 && (n = -n), t ? ed(s, +/* @__PURE__ */ new Date(), s.scrollLeft, s.scrollTop, n, e, i) : (n !== void 0 && (s.scrollLeft = n), e !== void 0 && (s.scrollTop = e), i && i());
}
function nd(s) {
  var n = s.getBoundingClientRect(), e = { left: n.left, top: n.top }, t = Ns(s);
  return t !== void 0 && (e.top += Oi(t), e.left += Ni(t)), e;
}
function Yn(s, n) {
  var e = s && (s.matches || s.msMatchesSelector);
  return e && e.call(s, n);
}
function _a(s, n, e) {
  for (; s && !Yn(s, n); ) {
    if (s === e || s.nodeType === s.DOCUMENT_NODE)
      return null;
    s = s.parentNode;
  }
  return s;
}
function dr(s, n, e) {
  var t;
  try {
    t = new CustomEvent(n, { bubbles: !0, cancelable: !0, detail: e });
  } catch (a) {
    (t = document.createEvent("Event")).initEvent(n, !0, !0), t.detail = e;
  }
  s.dispatchEvent(t);
}
function Ft(s, n) {
  for (var e = 0; e < s.length; e++)
    n(s[e], e);
}
var ur = {}, _o = [], Ep = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function Pn(s, n) {
  for (var e in n)
    s[e] = n[e];
  return s;
}
function sd(s) {
  var n = s.parentNode;
  n && n.removeChild(s);
}
var rt = { _catchError: function(s, n) {
  for (var e, t, a; n = n._parent; )
    if ((e = n._component) && !e._processingException)
      try {
        if ((t = e.constructor) && t.getDerivedStateFromError != null && (e.setState(t.getDerivedStateFromError(s)), a = e._dirty), e.componentDidCatch != null && (e.componentDidCatch(s), a = e._dirty), a)
          return e._pendingError = e;
      } catch (i) {
        s = i;
      }
  throw s;
}, _vnodeId: 0 };
function _(s, n, e) {
  var t, a, i, r = {};
  for (i in n)
    i == "key" ? t = n[i] : i == "ref" ? a = n[i] : r[i] = n[i];
  if (arguments.length > 3)
    for (e = [e], i = 3; i < arguments.length; i++)
      e.push(arguments[i]);
  if (e != null && (r.children = e), typeof s == "function" && s.defaultProps != null)
    for (i in s.defaultProps)
      r[i] === void 0 && (r[i] = s.defaultProps[i]);
  return Za(s, r, t, a, null);
}
function Za(s, n, e, t, a) {
  var i = { type: s, props: n, key: e, ref: t, _children: null, _parent: null, _depth: 0, _dom: null, _nextDom: void 0, _component: null, _hydrating: null, constructor: void 0, _original: a == null ? ++rt._vnodeId : a };
  return rt.vnode != null && rt.vnode(i), i;
}
function ut(s) {
  return s.children;
}
function ws(s, n) {
  this.props = s, this.context = n;
}
function ia(s, n) {
  if (n == null)
    return s._parent ? ia(s._parent, s._parent._children.indexOf(s) + 1) : null;
  for (var e; n < s._children.length; n++)
    if ((e = s._children[n]) != null && e._dom != null)
      return e._dom;
  return typeof s.type == "function" ? ia(s) : null;
}
function kp(s) {
  var n = s._vnode, e = n._dom, t = s._parentDom;
  if (t) {
    var a = [], i = Pn({}, n);
    i._original = n._original + 1, vo(t, n, i, s._globalContext, t.ownerSVGElement !== void 0, n._hydrating != null ? [e] : null, a, e == null ? ia(n) : e, n._hydrating), od(a, n), n._dom != e && ad(n);
  }
}
function ad(s) {
  if ((s = s._parent) != null && s._component != null) {
    s._dom = s._component.base = null;
    for (var n = 0; n < s._children.length; n++) {
      var e = s._children[n];
      if (e != null && e._dom != null) {
        s._dom = s._component.base = e._dom;
        break;
      }
    }
    return ad(s);
  }
}
ws.prototype.setState = function(s, n) {
  var e;
  e = this._nextState != null && this._nextState !== this.state ? this._nextState : this._nextState = Pn({}, this.state), typeof s == "function" && (s = s(Pn({}, e), this.props)), s && Pn(e, s), s != null && this._vnode && (n && this._renderCallbacks.push(n), Li(this));
}, ws.prototype.forceUpdate = function(s) {
  this._vnode && (this._force = !0, s && this._renderCallbacks.push(s), Li(this));
}, ws.prototype.render = ut;
var Cl, er = [], Mp = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout;
function Li(s) {
  (!s._dirty && (s._dirty = !0) && er.push(s) && !hr._rerenderCount++ || Cl !== rt.debounceRendering) && ((Cl = rt.debounceRendering) || Mp)(hr);
}
function hr() {
  for (var s; hr._rerenderCount = er.length; )
    s = er.sort(function(n, e) {
      return n._vnode._depth - e._vnode._depth;
    }), er = [], s.some(function(n) {
      n._dirty && kp(n);
    });
}
function Sl(s, n, e, t, a, i, r, o, l, u) {
  var c, d, m, h, f, p, g, v = t && t._children || _o, y = v.length;
  for (e._children = [], c = 0; c < n.length; c++)
    if ((h = (h = n[c]) == null || typeof h == "boolean" ? e._children[c] = null : typeof h == "string" || typeof h == "number" || typeof h == "bigint" ? e._children[c] = Za(null, h, null, null, h) : Array.isArray(h) ? e._children[c] = Za(ut, { children: h }, null, null, null) : h._depth > 0 ? e._children[c] = Za(h.type, h.props, h.key, null, h._original) : e._children[c] = h) != null) {
      if (h._parent = e, h._depth = e._depth + 1, (m = v[c]) === null || m && h.key == m.key && h.type === m.type)
        v[c] = void 0;
      else
        for (d = 0; d < y; d++) {
          if ((m = v[d]) && h.key == m.key && h.type === m.type) {
            v[d] = void 0;
            break;
          }
          m = null;
        }
      vo(s, h, m = m || ur, a, i, r, o, l, u), f = h._dom, (d = h.ref) && m.ref != d && (g || (g = []), m.ref && g.push(m.ref, null, h), g.push(d, h._component || f, h)), f != null ? (p == null && (p = f), typeof h.type == "function" && h._children != null && h._children === m._children ? h._nextDom = l = rd(h, l, s) : l = id(s, h, m, v, f, l), u || e.type !== "option" ? typeof e.type == "function" && (e._nextDom = l) : s.value = "") : l && m._dom == l && l.parentNode != s && (l = ia(m));
    }
  for (e._dom = p, c = y; c--; )
    v[c] != null && (typeof e.type == "function" && v[c]._dom != null && v[c]._dom == e._nextDom && (e._nextDom = ia(t, c + 1)), cd(v[c], v[c]));
  if (g)
    for (c = 0; c < g.length; c++)
      ld(g[c], g[++c], g[++c]);
}
function rd(s, n, e) {
  for (var t = 0; t < s._children.length; t++) {
    var a = s._children[t];
    a && (a._parent = s, n = typeof a.type == "function" ? rd(a, n, e) : id(e, a, a, s._children, a._dom, n));
  }
  return n;
}
function id(s, n, e, t, a, i) {
  var r;
  if (n._nextDom !== void 0)
    r = n._nextDom, n._nextDom = void 0;
  else if (e == null || a != i || a.parentNode == null)
    e:
      if (i == null || i.parentNode !== s)
        s.appendChild(a), r = null;
      else {
        for (var o = i, l = 0; (o = o.nextSibling) && l < t.length; l += 2)
          if (o == a)
            break e;
        s.insertBefore(a, i), r = i;
      }
  return i = r !== void 0 ? r : a.nextSibling;
}
function Tl(s, n, e) {
  n[0] === "-" ? s.setProperty(n, e) : e == null ? s[n] = "" : typeof e != "number" || Ep.test(n) ? s[n] = e : s[n] = e + "px";
}
function Fa(s, n, e, t, a) {
  var i;
  e:
    if (n === "style")
      if (typeof e == "string")
        s.style.cssText = e;
      else {
        if (typeof t == "string" && (s.style.cssText = t = ""), t)
          for (n in t)
            e && n in e || Tl(s.style, n, "");
        if (e)
          for (n in e)
            t && e[n] === t[n] || Tl(s.style, n, e[n]);
      }
    else if (n[0] === "o" && n[1] === "n")
      if (i = n !== (n = n.replace(/Capture$/, "")), n = n.toLowerCase() in s ? n.toLowerCase().slice(2) : n.slice(2), s._listeners || (s._listeners = {}), s._listeners[n + i] = e, e) {
        if (!t) {
          var r = i ? kl : El;
          s.addEventListener(n, r, i);
        }
      } else {
        var o = i ? kl : El;
        s.removeEventListener(n, o, i);
      }
    else if (n !== "dangerouslySetInnerHTML") {
      if (a)
        n = n.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
      else if (n !== "href" && n !== "list" && n !== "form" && n !== "tabIndex" && n !== "download" && n in s)
        try {
          s[n] = e == null ? "" : e;
          break e;
        } catch (l) {
        }
      typeof e == "function" || (e != null && (e !== !1 || n[0] === "a" && n[1] === "r") ? s.setAttribute(n, e) : s.removeAttribute(n));
    }
}
function El(s) {
  this._listeners[s.type + !1](rt.event ? rt.event(s) : s);
}
function kl(s) {
  this._listeners[s.type + !0](rt.event ? rt.event(s) : s);
}
function vo(s, n, e, t, a, i, r, o, l) {
  var u, c = n.type;
  if (n.constructor !== void 0)
    return null;
  e._hydrating != null && (l = e._hydrating, o = n._dom = e._dom, n._hydrating = null, i = [o]), (u = rt._diff) && u(n);
  try {
    e:
      if (typeof c == "function") {
        var d, m, h, f, p, g, v = n.props, y = (u = c.contextType) && t[u._id], b = u ? y ? y.props.value : u._defaultValue : t;
        if (e._component ? g = (d = n._component = e._component)._processingException = d._pendingError : ("prototype" in c && c.prototype.render ? n._component = d = new c(v, b) : (n._component = d = new ws(v, b), d.constructor = c, d.render = Ip), y && y.sub(d), d.props = v, d.state || (d.state = {}), d.context = b, d._globalContext = t, m = d._dirty = !0, d._renderCallbacks = []), d._nextState == null && (d._nextState = d.state), c.getDerivedStateFromProps != null && (d._nextState == d.state && (d._nextState = Pn({}, d._nextState)), Pn(d._nextState, c.getDerivedStateFromProps(v, d._nextState))), h = d.props, f = d.state, m)
          c.getDerivedStateFromProps == null && d.componentWillMount != null && d.componentWillMount(), d.componentDidMount != null && d._renderCallbacks.push(d.componentDidMount);
        else {
          if (c.getDerivedStateFromProps == null && v !== h && d.componentWillReceiveProps != null && d.componentWillReceiveProps(v, b), !d._force && d.shouldComponentUpdate != null && d.shouldComponentUpdate(v, d._nextState, b) === !1 || n._original === e._original) {
            d.props = v, d.state = d._nextState, n._original !== e._original && (d._dirty = !1), d._vnode = n, n._dom = e._dom, n._children = e._children, n._children.forEach(function(w) {
              w && (w._parent = n);
            }), d._renderCallbacks.length && r.push(d);
            break e;
          }
          d.componentWillUpdate != null && d.componentWillUpdate(v, d._nextState, b), d.componentDidUpdate != null && d._renderCallbacks.push(function() {
            d.componentDidUpdate(h, f, p);
          });
        }
        d.context = b, d.props = v, d.state = d._nextState, (u = rt._render) && u(n), d._dirty = !1, d._vnode = n, d._parentDom = s, u = d.render(d.props, d.state, d.context), d.state = d._nextState, d.getChildContext != null && (t = Pn(Pn({}, t), d.getChildContext())), m || d.getSnapshotBeforeUpdate == null || (p = d.getSnapshotBeforeUpdate(h, f));
        var D = u != null && u.type === ut && u.key == null ? u.props.children : u;
        Sl(s, Array.isArray(D) ? D : [D], n, e, t, a, i, r, o, l), d.base = n._dom, n._hydrating = null, d._renderCallbacks.length && r.push(d), g && (d._pendingError = d._processingException = null), d._force = !1;
      } else
        i == null && n._original === e._original ? (n._children = e._children, n._dom = e._dom) : n._dom = function(w, C, T, N, O, L, H, A) {
          var B = T.props, I = C.props, S = C.type, k = 0;
          if (S === "svg" && (O = !0), L != null)
            for (; k < L.length; k++) {
              var R = L[k];
              if (R && (R === w || (S ? R.localName == S : R.nodeType == 3))) {
                w = R, L[k] = null;
                break;
              }
            }
          if (w == null) {
            if (S === null)
              return document.createTextNode(I);
            w = O ? document.createElementNS("http://www.w3.org/2000/svg", S) : document.createElement(S, I.is && I), L = null, A = !1;
          }
          if (S === null)
            B === I || A && w.data === I || (w.data = I);
          else {
            L = L && _o.slice.call(w.childNodes);
            var z = (B = T.props || ur).dangerouslySetInnerHTML, W = I.dangerouslySetInnerHTML;
            if (A || (L != null && (B = {}), (W || z) && (W && (z && W.__html == z.__html || W.__html === w.innerHTML) || (w.innerHTML = W && W.__html || ""))), function(M, P, Y, q, U) {
              var j;
              for (j in Y)
                j === "children" || j === "key" || j in P || Fa(M, j, null, Y[j], q);
              for (j in P)
                U && typeof P[j] != "function" || j === "children" || j === "key" || j === "value" || j === "checked" || Y[j] === P[j] || Fa(M, j, P[j], Y[j], q);
            }(w, I, B, O, A), W)
              C._children = [];
            else if (k = C.props.children, Sl(w, Array.isArray(k) ? k : [k], C, T, N, O && S !== "foreignObject", L, H, w.firstChild, A), L != null)
              for (k = L.length; k--; )
                L[k] != null && sd(L[k]);
            A || ("value" in I && (k = I.value) !== void 0 && (k !== w.value || S === "progress" && !k) && Fa(w, "value", k, B.value, !1), "checked" in I && (k = I.checked) !== void 0 && k !== w.checked && Fa(w, "checked", k, B.checked, !1));
          }
          return w;
        }(e._dom, n, e, t, a, i, r, l);
    (u = rt.diffed) && u(n);
  } catch (w) {
    n._original = null, (l || i != null) && (n._dom = o, n._hydrating = !!l, i[i.indexOf(o)] = null), rt._catchError(w, n, e);
  }
}
function od(s, n) {
  rt._commit && rt._commit(n, s), s.some(function(e) {
    try {
      s = e._renderCallbacks, e._renderCallbacks = [], s.some(function(t) {
        t.call(e);
      });
    } catch (t) {
      rt._catchError(t, e._vnode);
    }
  });
}
function ld(s, n, e) {
  try {
    typeof s == "function" ? s(n) : s.current = n;
  } catch (t) {
    rt._catchError(t, e);
  }
}
function cd(s, n, e) {
  var t, a;
  if (rt.unmount && rt.unmount(s), (t = s.ref) && (t.current && t.current !== s._dom || ld(t, null, n)), e || typeof s.type == "function" || (e = (a = s._dom) != null), s._dom = s._nextDom = void 0, (t = s._component) != null) {
    if (t.componentWillUnmount)
      try {
        t.componentWillUnmount();
      } catch (r) {
        rt._catchError(r, n);
      }
    t.base = t._parentDom = null;
  }
  if (t = s._children)
    for (var i = 0; i < t.length; i++)
      t[i] && cd(t[i], n, e);
  a != null && sd(a);
}
function Ip(s, n, e) {
  return this.constructor(s, e);
}
function Es(s, n, e) {
  rt._root && rt._root(s, n);
  var t = typeof e == "function", a = t ? null : e && e._children || n._children, i = [];
  vo(n, s = (!t && e || n)._children = _(ut, null, [s]), a || ur, ur, n.ownerSVGElement !== void 0, !t && e ? [e] : a ? null : n.firstChild ? _o.slice.call(n.childNodes) : null, i, !t && e ? e : a ? a._dom : n.firstChild, t), od(i, s);
}
hr._rerenderCount = 0;
var Np = 0;
function dd(s, n) {
  var e = { _id: n = "__cC" + Np++, _defaultValue: s, Consumer: function(t, a) {
    return t.children(a);
  }, Provider: function(t) {
    if (!this.getChildContext) {
      var a = [], i = {};
      i[n] = this, this.getChildContext = function() {
        return i;
      }, this.shouldComponentUpdate = function(r) {
        this.props.value !== r.value && a.some(Li);
      }, this.sub = function(r) {
        a.push(r);
        var o = r.componentWillUnmount;
        r.componentWillUnmount = function() {
          a.splice(a.indexOf(r), 1), o && o.call(r);
        };
      };
    }
    return t.children;
  } };
  return e.Provider._contextRef = e.Consumer.contextType = e;
}
var ud = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype.render = function() {
  }, n.prototype.shouldComponentUpdate = function(e, t) {
    return Ml(e, this.props) || Ml(t, this.state);
  }, n;
}(ws);
function Ml(s, n) {
  for (var e in s)
    if (s[e] !== n[e])
      return !0;
  for (var e in n)
    if (!(e in s))
      return !0;
  return !1;
}
rt.vnode = function(s) {
  var n = s.props, e = {};
  if (ye(s.type)) {
    for (var t in n) {
      var a = n[t];
      /^onAni/.test(t) ? t = t.toLowerCase() : /ondoubleclick/i.test(t) && (t = "ondblclick"), e[t] = a;
    }
    s.props = e;
  }
};
var Ai = {}, Op = 0;
function Lp(s, n, e, t, a) {
  Yn(s, n) ? s.__mbscFormInst || mr(e, s, a, t, !0) : Ft(s.querySelectorAll(n), function(i) {
    i.__mbscFormInst || mr(e, i, a, t, !0);
  });
}
function mr(s, n, e, t, a) {
  var i, r, o = [], l = [], u = {}, c = t || {}, d = c.renderToParent ? n.parentNode : n, m = d.parentNode, h = c.useOwnChildren ? n : d, f = n.getAttribute("class"), p = n.value, g = K({ className: d.getAttribute("class") }, n.dataset, e, { ref: function(A) {
    r = A;
  } });
  c.readProps && c.readProps.forEach(function(A) {
    var B = n[A];
    B !== void 0 && (g[A] = B);
  }), c.readAttrs && c.readAttrs.forEach(function(A) {
    var B = n.getAttribute(A);
    B !== null && (g[A] = B);
  });
  var v = c.slots;
  if (v)
    for (var y = 0, b = Object.keys(v); y < b.length; y++) {
      var D = b[y], w = v[D], C = d.querySelector("[mbsc-" + w + "]");
      C && (u[D] = C, C.parentNode.removeChild(C), g[D] = _("span", { className: "mbsc-slot-" + w }));
    }
  if (c.hasChildren && (Ft(h.childNodes, function(A) {
    A !== n && A.nodeType !== 8 && (A.nodeType !== 3 || A.nodeType === 3 && /\S/.test(A.nodeValue)) && o.push(A), l.push(A);
  }), Ft(o, function(A) {
    h.removeChild(A);
  }), o.length && (g.hasChildren = !0)), n.id || (n.id = "mbsc-control-" + Op++), c.before && c.before(n, g, o), Es(_(s, g), m, d), f && c.renderToParent && (i = n.classList).add.apply(i, f.replace(/^\s+|\s+$/g, "").replace(/\s+|^\s|\s$/g, " ").split(" ")), c.hasChildren) {
    var T = "." + c.parentClass, N = Yn(d, T) ? d : d.querySelector(T);
    N && Ft(o, function(A) {
      N.appendChild(A);
    });
  }
  if (c.hasValue && (n.value = p), v)
    for (var O = function(A) {
      var B = v[A], I = u[A];
      Ft(d.querySelectorAll(".mbsc-slot-" + B), function(S, k) {
        var R = k > 0 ? I.cloneNode(!0) : I;
        S.appendChild(R);
      });
    }, L = 0, H = Object.keys(u); L < H.length; L++)
      O(D = H[L]);
  return r.destroy = function() {
    var A = d.parentNode, B = Je.createComment("");
    A.insertBefore(B, d), Es(null, d), delete n.__mbscInst, delete n.__mbscFormInst, delete d._listeners, d.innerHTML = "", d.setAttribute("class", g.className), A.replaceChild(d, B), c.hasChildren && Ft(l, function(I) {
      h.appendChild(I);
    }), c.renderToParent && n.setAttribute("class", f || "");
  }, a ? (n.__mbscInst || (n.__mbscInst = r), n.__mbscFormInst = r) : n.__mbscInst = r, r;
}
function Il(s, n) {
  return n ? s.__mbscFormInst : s.__mbscInst;
}
function In(s) {
  Ai[s._name] = s;
}
function ns(s, n) {
  if (s)
    for (var e = 0, t = Object.keys(Ai); e < t.length; e++) {
      var a = t[e], i = Ai[a];
      Lp(s, i._selector, i, i._renderOpt, n);
    }
}
function go(s, n) {
  return function(e, t) {
    var a = {};
    if (ye(e)) {
      var i, r = Je.querySelectorAll(e);
      return Ft(r, function(o) {
        var l = mr(s, o, t, n);
        a[o.id] = l, i || (i = l);
      }), r.length === 1 ? i : a;
    }
    return mr(s, e, t, n);
  };
}
Mt && (Je.addEventListener("DOMContentLoaded", function() {
  ns(Je);
}), Je.addEventListener("mbsc-enhance", function(s) {
  ns(s.target);
}));
var Ap = { setText: "OK", cancelText: "Abbrechen", clearText: "Löschen", closeText: "Schließen", selectedText: "{count} ausgewählt", dateFormat: "DD.MM.YYYY", dateFormatFull: "DDDD, D. MMMM YYYY", dateFormatLong: "DDD. D. MMM. YYYY", dateWheelFormat: "|DDD. D. MMM.|", dayNames: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"], dayNamesShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"], dayNamesMin: ["S", "M", "D", "M", "D", "F", "S"], fromText: "Von", monthNames: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"], monthNamesShort: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"], timeFormat: "HH:mm", nowText: "Jetzt", pmText: "pm", amText: "am", todayText: "Heute", toText: "Bis", firstDay: 1, dateText: "Datum", timeText: "Zeit", allDayText: "Ganztägig", noEventsText: "Keine Ereignisse", eventText: "Ereignis", eventsText: "Ereignisse", moreEventsText: "{count} weiteres Element", moreEventsPluralText: "{count} weitere Elemente", weekText: "Woche {count}", rangeStartLabel: "Von", rangeEndLabel: "Bis", rangeStartHelp: "Auswählen", rangeEndHelp: "Auswählen", filterEmptyText: "Keine Treffer", filterPlaceholderText: "Suchen" }, Rp = { setText: "Terminer", cancelText: "Annuler", clearText: "Effacer", closeText: "Fermer", selectedText: "{count} sélectionné", selectedPluralText: "{count} sélectionnés", dateFormat: "DD/MM/YYYY", dateFormatLong: "DDD D MMM YYYY", dateWheelFormat: "|DDD D MMM|", dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"], dayNamesShort: ["Dim.", "Lun.", "Mar.", "Mer.", "Jeu.", "Ven.", "Sam."], dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"], fromText: "Démarrer", monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"], monthNamesShort: ["Janv.", "Févr.", "Mars", "Avril", "Mai", "Juin", "Juil.", "Août", "Sept.", "Oct.", "Nov.", "Déc."], timeFormat: "HH:mm", toText: "Fin", nowText: "Maintenant", pmText: "pm", amText: "am", todayText: "Aujourd'hui", firstDay: 1, dateText: "Date", timeText: "Heure", allDayText: "Toute la journée", noEventsText: "Aucun événement", eventText: "Événement", eventsText: "Événements", moreEventsText: "{count} autre", moreEventsPluralText: "{count} autres", weekText: "Semaine {count}", rangeStartLabel: "Démarrer", rangeEndLabel: "Fin", rangeStartHelp: "Choisir", rangeEndHelp: "Choisir", filterEmptyText: "Aucun résultat", filterPlaceholderText: "Rechercher" }, Ri, Pp = {}, oa = { de: Ap, en: Pp, fr: Rp }, zp = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._newProps = {}, e._setEl = function(t) {
      e._el = t ? t._el || t : null;
    }, e;
  }
  return de(n, s), Object.defineProperty(n.prototype, "value", { get: function() {
    return this.__value;
  }, set: function(e) {
    this.__value = e;
  }, enumerable: !0, configurable: !0 }), n.prototype.componentDidMount = function() {
    this.__init(), this._init(), this._mounted(), this._updated(), this._enhance();
  }, n.prototype.componentDidUpdate = function() {
    this._updated(), this._enhance();
  }, n.prototype.componentWillUnmount = function() {
    this._destroy(), this.__destroy();
  }, n.prototype.render = function() {
    return this._willUpdate(), this._template(this.s, this.state);
  }, n.prototype.getInst = function() {
    return this;
  }, n.prototype.setOptions = function(e) {
    for (var t in e)
      this.props[t] = e[t];
    this.forceUpdate();
  }, n.prototype._safeHtml = function(e) {
    return { __html: e };
  }, n.prototype._init = function() {
  }, n.prototype.__init = function() {
  }, n.prototype._emit = function(e, t) {
  }, n.prototype._template = function(e, t) {
  }, n.prototype._mounted = function() {
  }, n.prototype._updated = function() {
  }, n.prototype._destroy = function() {
  }, n.prototype.__destroy = function() {
  }, n.prototype._willUpdate = function() {
  }, n.prototype._enhance = function() {
    var e = this._shouldEnhance;
    e && (ns(e === !0 ? this._el : e), this._shouldEnhance = !1);
  }, n;
}(ud), Hp = 0, Fp = { large: 992, medium: 768, small: 576, xlarge: 1200, xsmall: 0 };
Gr && (Ri = Gr.matches, Gr.addListener(function(s) {
  Ri = s.matches, Mi.next();
}));
var it = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e.s = {}, e.state = {}, e._mbsc = !0, e._v = { version: "5.29.1" }, e._uid = ++Hp, e._proxyHook = function(t) {
      e._hook(t.type, t);
    }, e;
  }
  return de(n, s), Object.defineProperty(n.prototype, "nativeElement", { get: function() {
    return this._el;
  }, enumerable: !0, configurable: !0 }), n.prototype.destroy = function() {
  }, n.prototype._hook = function(e, t) {
    var a = this.s;
    if (t.inst = this, t.type = e, a[e])
      return a[e](t, this);
    this._emit(e, t);
  }, n.prototype.__init = function() {
    var e = this;
    if (this.constructor.defaults) {
      this._optChange = Mi.subscribe(function() {
        e.forceUpdate();
      });
      var t = this.props.modules;
      if (t)
        for (var a = 0, i = t; a < i.length; a++) {
          var r = i[a];
          r.init && r.init(this);
        }
    }
    this._hook("onInit", {});
  }, n.prototype.__destroy = function() {
    this._optChange !== void 0 && Mi.unsubscribe(this._optChange), this._hook("onDestroy", {});
  }, n.prototype._render = function(e, t) {
  }, n.prototype._willUpdate = function() {
    this._merge(), this._render(this.s, this.state);
  }, n.prototype._resp = function(e) {
    var t, a = e.responsive, i = -1, r = this.state.width;
    if (r === void 0 && (r = 375), a && r)
      for (var o = 0, l = Object.keys(a); o < l.length; o++) {
        var u = l[o], c = a[u], d = c.breakpoint || Fp[u];
        r >= d && d > i && (t = c, i = d);
      }
    return t;
  }, n.prototype._merge = function() {
    var e, t, a = this.constructor, i = a.defaults, r = this._opt || {}, o = {};
    if (this._prevS = this.s || {}, i) {
      for (var l in this.props)
        this.props[l] !== void 0 && (o[l] = this.props[l]);
      var u = o.locale || r.locale || fs.locale || {}, c = o.calendarSystem || u.calendarSystem || r.calendarSystem || fs.calendarSystem, d = o.theme || r.theme || fs.theme, m = o.themeVariant || r.themeVariant || fs.themeVariant;
      d !== "auto" && d || (d = fo.theme || ""), m !== "dark" && (!Ri || m !== "auto" && m) || !wn[d + "-dark"] || (d += "-dark"), o.theme = d;
      var h = (t = wn[d]) && t[a._name];
      e = K({}, i, h, u, fs, r, c, o);
      var f = this._resp(e);
      this._respProps = f, f && (e = K({}, e, f));
    } else
      e = K({}, this.props), t = wn[e.theme];
    var p = t && t.baseTheme;
    e.baseTheme = p, this.s = e, this._className = e.cssClass || e.class || e.className || "", this._rtl = " mbsc-" + (e.rtl ? "rtl" : "ltr"), this._theme = " mbsc-" + e.theme + (p ? " mbsc-" + p : ""), this._touchUi = e.touchUi === "auto" || e.touchUi === void 0 ? Ds : e.touchUi, this._hb = sn !== "ios" || e.theme !== "ios" && p !== "ios" ? "" : " mbsc-hb";
  }, n.defaults = void 0, n._name = "", n;
}(zp), Pi, ds, tn = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return function(t, a) {
      return a._hasChildren ? _("span", { onClick: t.onClick, className: a._cssClass }, t.name) : _("span", { onClick: t.onClick, className: a._cssClass, dangerouslySetInnerHTML: a._svg, "v-html": void 0 });
    }(e, this);
  }, n;
}(/* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._render = function(e) {
    this._hasChildren = e.name !== void 0 && !ye(e.name), this._cssClass = this._className + " mbsc-icon" + this._theme + (e.name && !this._hasChildren ? e.name.indexOf(" ") !== -1 ? " " + e.name : " mbsc-font-icon mbsc-icon-" + e.name : ""), this._svg = e.svg ? this._safeHtml(e.svg) : void 0;
  }, n;
}(it)), Un = "change", Ut = "click", pt = "mousedown", gn = "mouseup", zi = "mouseenter", pr = 0;
function zn(s, n, e) {
  var t = (e ? "page" : "client") + n;
  return s.targetTouches && s.targetTouches[0] ? s.targetTouches[0][t] : s.changedTouches && s.changedTouches[0] ? s.changedTouches[0][t] : s[t];
}
function Yp(s, n) {
  if (!n.mbscClick) {
    var e = (s.originalEvent || s).changedTouches[0], t = document.createEvent("MouseEvents");
    t.initMouseEvent("click", !0, !0, window, 1, e.screenX, e.screenY, e.clientX, e.clientY, !1, !1, !1, !1, 0, null), t.isMbscTap = !0, t.isIonicTap = !0, Pi = !0, n.mbscChange = !0, n.mbscClick = !0, n.dispatchEvent(t), Pi = !1, pr++, setTimeout(function() {
      pr--;
    }, 500), setTimeout(function() {
      delete n.mbscClick;
    });
  }
}
function Up(s) {
  !pr || Pi || s.isMbscTap || s.target.nodeName === "TEXTAREA" && s.type === pt || (s.stopPropagation(), s.preventDefault());
}
function Nl(s) {
  Ns(s.target).__mbscFocusVisible = !1;
}
function Ol(s) {
  Ns(s.target).__mbscFocusVisible = !0;
}
function Zr(s) {
  s && setTimeout(function() {
    s.style.opacity = "0", s.style.transition = "opacity linear .4s", setTimeout(function() {
      s && s.parentNode && s.parentNode.removeChild(s);
    }, 400);
  }, 200);
}
function Kt(s, n) {
  var e, t, a, i, r, o, l, u, c, d, m, h, f, p, g, v = {}, y = Ns(s), b = vn(s);
  function D(M) {
    if (M.type === "touchstart")
      ds = !0;
    else if (ds)
      return M.type === pt && (ds = !1), !0;
    return !1;
  }
  function w() {
    l && (Zr(i), i = function(M, P, Y) {
      var q = M.getBoundingClientRect(), U = P - q.left, j = Y - q.top, ee = Math.max(U, M.offsetWidth - U), ne = Math.max(j, M.offsetHeight - j), G = 2 * Math.sqrt(Math.pow(ee, 2) + Math.pow(ne, 2)), te = Je.createElement("span");
      te.classList.add("mbsc-ripple");
      var Z = te.style;
      return Z.backgroundColor = getComputedStyle(M).color, Z.width = G + "px", Z.height = G + "px", Z.top = Y - q.top - G / 2 + "px", Z.left = P - q.left - G / 2 + "px", M.appendChild(te), setTimeout(function() {
        Z.opacity = ".2", Z.transform = "scale(1)", Z.transition = "opacity linear .1s, transform cubic-bezier(0, 0, 0.2, 1) .4s";
      }, 30), te;
    }(s, m, h)), n.onPress(), e = !0;
  }
  function C(M, P) {
    t = !1, Zr(M), clearTimeout(a), a = setTimeout(function() {
      e && (n.onRelease(), e = !1);
    }, P);
  }
  function T(M) {
    if (!D(M) && (M.type !== pt || M.button === 0 && !M.ctrlKey)) {
      if (c = zn(M, "X"), d = zn(M, "Y"), m = c, h = d, e = !1, t = !1, u = !1, g = !0, v.moved = u, v.startX = c, v.startY = d, v.endX = m, v.endY = h, v.deltaX = 0, v.deltaY = 0, v.domEvent = M, v.isTouch = ds, Zr(i), n.onStart) {
        var P = n.onStart(v);
        l = P && P.ripple;
      }
      n.onPress && (t = !0, clearTimeout(a), a = setTimeout(w, 50)), M.type === pt && (pe(b, "mousemove", N), pe(b, gn, O)), pe(b, "contextmenu", z);
    }
  }
  function N(M) {
    g && (m = zn(M, "X"), h = zn(M, "Y"), f = m - c, p = h - d, !u && (Math.abs(f) > 9 || Math.abs(p) > 9) && (u = !0, C(i)), v.moved = u, v.endX = m, v.endY = h, v.deltaX = f, v.deltaY = p, v.domEvent = M, v.isTouch = M.type === "touchmove", n.onMove && n.onMove(v));
  }
  function O(M) {
    g && (t && !e && (clearTimeout(a), w()), v.domEvent = M, v.isTouch = M.type === "touchend", n.onEnd && n.onEnd(v), C(i, 75), g = !1, M.type === "touchend" && n.click && Cp && !u && Yp(M, M.target), M.type === gn && (le(b, "mousemove", N), le(b, gn, O)), le(b, "contextmenu", z));
  }
  function L(M) {
    D(M) || (o = !0, n.onHoverIn(M));
  }
  function H(M) {
    o && n.onHoverOut(M), o = !1;
  }
  function A(M) {
    n.onKeyDown(M);
  }
  function B(M) {
    (n.keepFocus || y.__mbscFocusVisible) && (r = !0, n.onFocus(M));
  }
  function I(M) {
    r && n.onBlur(M), r = !1;
  }
  function S(M) {
    n.onChange(M);
  }
  function k(M) {
    n.onInput(M);
  }
  function R(M) {
    v.domEvent = M, ds || n.onDoubleClick(v);
  }
  function z(M) {
    ds && M.preventDefault();
  }
  if (pe(s, pt, T), pe(s, "touchstart", T, { passive: !0 }), pe(s, "touchmove", N, { passive: !1 }), pe(s, "touchend", O), pe(s, "touchcancel", O), n.onChange && pe(s, Un, S), n.onInput && pe(s, "input", k), n.onHoverIn && pe(s, zi, L), n.onHoverOut && pe(s, "mouseleave", H), n.onKeyDown && pe(s, "keydown", A), n.onFocus && y && (pe(s, "focus", B), !n.keepFocus)) {
    var W = y.__mbscFocusCount || 0;
    W === 0 && (pe(y, pt, Nl, !0), pe(y, "keydown", Ol, !0)), y.__mbscFocusCount = ++W;
  }
  return n.onBlur && pe(s, "blur", I), n.onDoubleClick && pe(s, "dblclick", R), function() {
    if (clearTimeout(a), n.onFocus && y && !n.keepFocus) {
      var M = y.__mbscFocusCount || 0;
      y.__mbscFocusCount = --M, M <= 0 && (le(y, pt, Nl), le(y, "keydown", Ol));
    }
    le(s, "input", k), le(s, pt, T), le(s, "touchstart", T, { passive: !0 }), le(s, "touchmove", N, { passive: !1 }), le(s, "touchend", O), le(s, "touchcancel", O), le(b, "mousemove", N), le(b, gn, O), le(b, "contextmenu", z), le(s, Un, S), le(s, zi, L), le(s, "mouseleave", H), le(s, "keydown", A), le(s, "focus", B), le(s, "blur", I), le(s, "dblclick", R);
  };
}
Mt && (["mousedown", zi, pt, gn, Ut].forEach(function(s) {
  Je.addEventListener(s, Up, !0);
}), sn === "android" && ki < 5 && Je.addEventListener(Un, function(s) {
  var n = s.target;
  pr && n.type === "checkbox" && !n.mbscChange && (s.stopPropagation(), s.preventDefault()), delete n.mbscChange;
}, !0));
var Ll, Hi = new Fn(), Ya = 0;
function Al() {
  clearTimeout(Ll), Ll = setTimeout(function() {
    Hi.next();
  }, 100);
}
function Rl(s) {
  try {
    return Yn(s, "*:-webkit-autofill");
  } catch (n) {
    return !1;
  }
}
var Bp = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._tag = "input", e._onClick = function() {
      e._hidePass = !e._hidePass;
    }, e._onMouseDown = function(t) {
      e.s.tags && (e._preventFocus = !0);
    }, e._onTagClear = function(t, a) {
      if (t.stopPropagation(), t.preventDefault(), !e.s.disabled) {
        var i = e.s.pickerValue.slice();
        i.splice(a, 1), dr(e._el, Un, i);
      }
    }, e._sizeTextArea = function() {
      var t, a, i, r = e._el, o = e.s.rows;
      r.offsetHeight && (r.style.height = "", i = r.scrollHeight - r.offsetHeight, t = r.offsetHeight + (i > 0 ? i : 0), (a = Math.round(t / 24)) > o ? (t = 24 * o + (t - 24 * a), r.style.overflow = "auto") : r.style.overflow = "", t && (r.style.height = t + "px"));
    }, e._onAutoFill = function() {
      e.s.labelStyle === "floating" && Rl(e._el) && e.setState({ isFloatingActive: !0 });
    }, e;
  }
  return de(n, s), n.prototype._change = function(e) {
  }, n.prototype._checkFloating = function() {
    var e = this, t = this._el, a = this.s, i = Rl(t), r = this.state.hasFocus || i || !Dt(this.value);
    if (t && a.labelStyle === "floating") {
      if (this._tag === "select") {
        var o = t, l = o.options[0];
        r = !!(r || o.multiple || o.value || o.selectedIndex > -1 && l && l.label);
      } else
        this.value === void 0 && (r = !(!r && !t.value));
      this._valueChecked = !0, es(this, function() {
        e.setState({ isFloatingActive: r });
      });
    }
  }, n.prototype._mounted = function() {
    var e, t = this, a = this.s, i = this._el;
    pe(i, "animationstart", this._onAutoFill), this._tag === "textarea" && (pe(i, "input", this._sizeTextArea), this._unsubscribe = (e = this._sizeTextArea, Ya || pe(wt, "resize", Al), Ya++, Hi.subscribe(e))), this._unlisten = Kt(i, { keepFocus: !0, onBlur: function() {
      t.setState({ hasFocus: !1, isFloatingActive: !!i.value });
    }, onChange: function(r) {
      if (a.type === "file") {
        for (var o = [], l = 0, u = r.target.files; l < u.length; l++) {
          var c = u[l];
          o.push(c.name);
        }
        t.setState({ files: o.join(", ") });
      }
      a.tags && a.value === void 0 && a.defaultValue === void 0 && t.setState({ value: r.target.value }), t._checkFloating(), t._change(r.target.value), t._emit("onChange", r);
    }, onFocus: function() {
      t._preventFocus || t.setState({ hasFocus: !0, isFloatingActive: !0 }), t._preventFocus = !1;
    }, onHoverIn: function() {
      t._disabled || t.setState({ hasHover: !0 });
    }, onHoverOut: function() {
      t.setState({ hasHover: !1 });
    }, onInput: function(r) {
      t._change(r.target.value);
    } });
  }, n.prototype._render = function(e, t) {
    var a = !(!e.endIconSvg && !e.endIcon), i = e.pickerValue, r = !(!e.startIconSvg && !e.startIcon), o = e.label !== void 0 || e.hasChildren, l = e.error, u = e.rtl ? "right" : "left", c = e.rtl ? "left" : "right", d = e.inputStyle, m = e.labelStyle, h = m === "floating", f = !(!h || !o || !t.isFloatingActive && Dt(e.value)), p = e.disabled === void 0 ? t.disabled : e.disabled, g = this._prevS, v = e.modelValue !== void 0 ? e.modelValue : e.value, y = v !== void 0 ? v : t.value !== void 0 ? t.value : e.defaultValue, b = this._theme + this._rtl + (l ? " mbsc-error" : "") + (p ? " mbsc-disabled" : "") + (t.hasHover ? " mbsc-hover" : "") + (t.hasFocus && !p ? " mbsc-focus" : "");
    e.type !== "file" || a || (e.endIconSvg = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0z" fill="none"/><path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/></svg>', a = !0), e.tags && (Dt(i) && (i = []), at(i) || (i = [i]), this._tagsArray = e.pickerMap ? i.map(function(D) {
      return e.pickerMap.get(D);
    }) : Dt(y) ? [] : y.split(", ")), e.passwordToggle && (a = !0, this._passIconClass = b + " mbsc-toggle-icon mbsc-textfield-icon mbsc-textfield-icon-" + d + " mbsc-textfield-icon-" + c + " mbsc-textfield-icon-" + d + "-" + c + (o ? " mbsc-textfield-icon-" + m : ""), this._hidePass = this._hidePass === void 0 ? e.type === "password" : this._hidePass), this._hasStartIcon = r, this._hasEndIcon = a, this._hasError = l, this._disabled = p, this._value = y, this._cssClass = this._className + this._hb + b + " mbsc-form-control-wrapper mbsc-textfield-wrapper mbsc-font mbsc-textfield-wrapper-" + d + (p ? " mbsc-disabled" : "") + (o ? " mbsc-textfield-wrapper-" + m : "") + (r ? " mbsc-textfield-wrapper-has-icon-" + u + " " : "") + (a ? " mbsc-textfield-wrapper-has-icon-" + c + " " : ""), o && (this._labelClass = b + " mbsc-label mbsc-label-" + m + " mbsc-label-" + d + "-" + m + (r ? " mbsc-label-" + d + "-" + m + "-has-icon-" + u + " " : "") + (a ? " mbsc-label-" + d + "-" + m + "-has-icon-" + c + " " : "") + (h && this._animateFloating ? " mbsc-label-floating-animate" : "") + (f ? " mbsc-label-floating-active" : "")), this._innerClass = b + " mbsc-textfield-inner mbsc-textfield-inner-" + d + (o ? " mbsc-textfield-inner-" + m : ""), r && (this._startIconClass = b + " mbsc-textfield-icon mbsc-textfield-icon-" + d + " mbsc-textfield-icon-" + u + " mbsc-textfield-icon-" + d + "-" + u + (o ? " mbsc-textfield-icon-" + m : "")), a && (this._endIconClass = b + " mbsc-textfield-icon mbsc-textfield-icon-" + d + " mbsc-textfield-icon-" + c + " mbsc-textfield-icon-" + d + "-" + c + (o ? " mbsc-textfield-icon-" + m : "")), this._nativeElmClass = b + " " + (e.inputClass || "") + " mbsc-textfield mbsc-textfield-" + d + (e.dropdown ? " mbsc-select" : "") + (o ? " mbsc-textfield-" + m + " mbsc-textfield-" + d + "-" + m : "") + (f ? " mbsc-textfield-floating-active" : "") + (r ? " mbsc-textfield-has-icon-" + u + " mbsc-textfield-" + d + "-has-icon-" + u + (o ? " mbsc-textfield-" + d + "-" + m + "-has-icon-" + u : "") : "") + (a ? " mbsc-textfield-has-icon-" + c + " mbsc-textfield-" + d + "-has-icon-" + c + (o ? " mbsc-textfield-" + d + "-" + m + "-has-icon-" + c : "") : ""), (this._tag === "select" || e.dropdown) && (this._selectIconClass = "mbsc-select-icon mbsc-select-icon-" + d + this._rtl + this._theme + (o ? " mbsc-select-icon-" + m : "") + (r ? " mbsc-select-icon-" + u : "") + (a ? " mbsc-select-icon-" + c : "")), (this._tag === "textarea" || e.tags) && (this._cssClass += " mbsc-textarea-wrapper", this._innerClass += " mbsc-textarea-inner", this._nativeElmClass += " mbsc-textarea", this._tag !== "textarea" || y === this._prevValue && e.inputStyle === g.inputStyle && e.labelStyle === g.labelStyle && e.rows === g.rows && e.theme === g.theme || (this._shouldSize = !0), this._prevValue = y), e.tags && (this._innerClass += " mbsc-textfield-tags-inner"), e.type === "file" && (this._dummyElmClass = this._nativeElmClass, this._nativeElmClass += " mbsc-textfield-file"), this._errorClass = this._theme + this._rtl + " mbsc-error-message mbsc-error-message-" + d + (o ? " mbsc-error-message-" + m : "") + (r ? " mbsc-error-message-has-icon-" + u : "") + (a ? " mbsc-error-message-has-icon-" + c : ""), e.notch && d === "outline" && (this._fieldSetClass = "mbsc-textfield-fieldset" + b + (r ? " mbsc-textfield-fieldset-has-icon-" + u : "") + (a ? " mbsc-textfield-fieldset-has-icon-" + c : ""), this._legendClass = "mbsc-textfield-legend" + this._theme + (f || o && m === "stacked" ? " mbsc-textfield-legend-active" : "")), e.ripple && e.inputStyle !== "outline" && (this._rippleClass = "mbsc-textfield-ripple" + this._theme + (l ? " mbsc-error" : "") + (t.hasFocus ? " mbsc-textfield-ripple-active" : "")), this._valueChecked && (this._animateFloating = !0);
  }, n.prototype._updated = function() {
    var e = this;
    this._shouldSize && (this._shouldSize = !1, es(this, function() {
      e._sizeTextArea();
    })), this._checkFloating();
  }, n.prototype._destroy = function() {
    le(this._el, "animationstart", this._onAutoFill), le(this._el, "input", this._sizeTextArea), this._unsubscribe && function(e) {
      Ya--, Hi.unsubscribe(e), Ya || le(wt, "resize", Al);
    }(this._unsubscribe), this._unlisten && this._unlisten();
  }, n.defaults = { dropdown: !1, dropdownIcon: Qa, hideIcon: "eye-blocked", inputStyle: "underline", labelStyle: "stacked", placeholder: "", ripple: !1, rows: 6, showIcon: "eye", type: "text" }, n._name = "Input", n;
}(it), us, rn, yo = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), Object.defineProperty(n.prototype, "value", { get: function() {
    return this._el && this._el.value;
  }, set: function(e) {
    this._el.value = e, this._checkFloating(), this._tag === "textarea" && this._sizeTextArea();
  }, enumerable: !0, configurable: !0 }), n.prototype._template = function(e, t) {
    return function(a, i, r, o, l) {
      var u, c = r.props;
      c.children;
      var d = c.dropdown;
      c.dropdownIcon, c.endIcon, c.endIconSrc, c.endIconSvg, c.error;
      var m = c.errorMessage, h = c.hasChildren;
      c.hideIcon, c.hideIconSvg, c.inputClass, c.inputStyle, c.label, c.labelStyle, c.modelValue, c.notch, c.passwordToggle, c.pickerMap, c.pickerValue, c.ripple, c.rows, c.rtl, c.showIcon, c.showIconSvg, c.startIcon, c.startIconSrc, c.startIconSvg;
      var f = c.tags;
      c.theme, c.themeVariant;
      var p = c.type, g = Bn(c, ["children", "dropdown", "dropdownIcon", "endIcon", "endIconSrc", "endIconSvg", "error", "errorMessage", "hasChildren", "hideIcon", "hideIconSvg", "inputClass", "inputStyle", "label", "labelStyle", "modelValue", "notch", "passwordToggle", "pickerMap", "pickerValue", "ripple", "rows", "rtl", "showIcon", "showIconSvg", "startIcon", "startIconSrc", "startIconSvg", "tags", "theme", "themeVariant", "type"]), v = a.label, y = ((u = {}).onMouseDown = r._onMouseDown, u), b = g;
      return _("label", K({ className: r._cssClass }, y), (v || h) && _("span", { className: r._labelClass }, h ? "" : v), _("span", { className: r._innerClass }, r._tag === "input" && _("input", K({}, b, { ref: r._setEl, className: r._nativeElmClass + (a.tags ? " mbsc-textfield-hidden" : ""), disabled: r._disabled, type: a.passwordToggle ? r._hidePass ? "password" : "text" : p })), p === "file" && _("input", { className: r._dummyElmClass, disabled: r._disabled, placeholder: a.placeholder, readOnly: !0, type: "text", value: i.files || "" }), r._tag === "select" && _("select", K({}, b, { ref: r._setEl, className: "mbsc-select" + r._nativeElmClass, disabled: r._disabled }), o), r._tag === "textarea" && _("textarea", K({}, b, { ref: r._setEl, className: r._nativeElmClass, disabled: r._disabled })), f && _("span", { className: "mbsc-textfield-tags" + r._nativeElmClass }, r._tagsArray.length ? r._tagsArray.map(function(D, w) {
        return D && _("span", { key: w, className: "mbsc-textfield-tag" + r._theme + r._rtl }, _("span", { className: "mbsc-textfield-tag-text" + r._theme }, D), _(tn, { className: "mbsc-textfield-tag-clear", onClick: function(C) {
          return r._onTagClear(C, w);
        }, svg: a.clearIcon, theme: a.theme }));
      }) : _("span", { className: "mbsc-textfield-tags-placeholder" + r._theme }, a.placeholder)), (r._tag === "select" || d) && _(tn, { className: r._selectIconClass, svg: a.dropdownIcon, theme: a.theme }), r._hasStartIcon && _(tn, { className: r._startIconClass, name: a.startIcon, svg: a.startIconSvg, theme: a.theme }), r._hasEndIcon && !a.passwordToggle && _(tn, { className: r._endIconClass, name: a.endIcon, svg: a.endIconSvg, theme: a.theme }), a.passwordToggle && _(tn, { onClick: r._onClick, className: r._passIconClass, name: r._hidePass ? a.showIcon : a.hideIcon, svg: r._hidePass ? a.showIconSvg : a.hideIconSvg, theme: a.theme }), r._hasError && _("span", { className: r._errorClass }, m), a.notch && a.inputStyle === "outline" && _("fieldset", { "aria-hidden": "true", className: r._fieldSetClass }, _("legend", { className: r._legendClass }, v && a.labelStyle !== "inline" ? v : "&nbsp;")), a.ripple && a.inputStyle !== "outline" && _("span", { className: r._rippleClass })));
    }(e, t, this, e.children);
  }, n;
}(Bp), bo = { hasChildren: !0, parentClass: "mbsc-label", readAttrs: ["placeholder", "rows"], readProps: ["disabled", "type"], renderToParent: !0, slots: { endIcon: "end-icon", label: "label", startIcon: "start-icon" }, before: function(s, n, e) {
  var t = s.parentNode, a = Je.createElement("span");
  if (t.insertBefore(a, s), a.appendChild(s), n.inputClass = s.getAttribute("class") || "", s.nodeName === "SELECT" && delete n.hasChildren, !n.label && n.hasChildren && (n.label = e[0].textContent), n.label) {
    var i = Je.createElement("span");
    t.insertBefore(i, a);
  }
} };
K({}, bo, { hasValue: !0, parentClass: "mbsc-select", useOwnChildren: !0 });
K({}, bo, { hasValue: !0 });
var ei = 0;
function Do(s, n, e) {
  var t, a, i, r, o, l, u, c = 0;
  function d() {
    a.style.width = "100000px", a.style.height = "100000px", t.scrollLeft = 1e5, t.scrollTop = 1e5, l.scrollLeft = 1e5, l.scrollTop = 1e5;
  }
  function m() {
    var p = +/* @__PURE__ */ new Date();
    r = 0, u || (p - c > 200 && !t.scrollTop && !t.scrollLeft && (c = p, d()), r || (r = on(m)));
  }
  function h() {
    o || (o = on(f));
  }
  function f() {
    o = 0, d(), n();
  }
  return wt && wt.ResizeObserver ? (us || (us = new wt.ResizeObserver(function(p) {
    o || (o = on(function() {
      for (var g = 0, v = p; g < v.length; g++) {
        var y = v[g];
        y.target.__mbscResize && y.target.__mbscResize();
      }
      o = 0;
    }));
  })), ei++, s.__mbscResize = function() {
    e ? e.run(n) : n();
  }, us.observe(s)) : i = Je && Je.createElement("div"), i && (i.innerHTML = '<div class="mbsc-resize"><div class="mbsc-resize-i mbsc-resize-x"></div></div><div class="mbsc-resize"><div class="mbsc-resize-i mbsc-resize-y"></div></div>', i.dir = "ltr", l = i.childNodes[1], t = i.childNodes[0], a = t.childNodes[0], s.appendChild(i), pe(t, "scroll", h), pe(l, "scroll", h), e ? e.runOutsideAngular(function() {
    on(m);
  }) : on(m)), { detach: function() {
    us ? (ei--, delete s.__mbscResize, us.unobserve(s), ei || (us = void 0)) : (i && (le(t, "scroll", h), le(l, "scroll", h), s.removeChild(i), Bs(o), i = void 0), u = !0);
  } };
}
var hd = "input,select,textarea,button", Vp = 'textarea,button,input[type="button"],input[type="submit"]', jp = hd + ',[tabindex="0"]', Wp = { enter: 13, esc: 27, space: 32 }, $p = Mt && /(iphone|ipod)/i.test(rs) && ki >= 7 && ki < 15;
function md(s, n) {
  var e = s.s, t = [], a = { cancel: { cssClass: "mbsc-popup-button-close", name: "cancel", text: e.cancelText }, close: { cssClass: "mbsc-popup-button-close", name: "close", text: e.closeText }, ok: { cssClass: "mbsc-popup-button-primary", keyCode: 13, name: "ok", text: e.okText }, set: { cssClass: "mbsc-popup-button-primary", keyCode: 13, name: "set", text: e.setText } };
  if (n && n.length)
    return n.forEach(function(i) {
      var r = ye(i) ? a[i] || { text: i } : i;
      r.handler && !ye(r.handler) || (ye(r.handler) && (r.name = r.handler), r.handler = function(o) {
        s._onButtonClick({ domEvent: o, button: r });
      }), t.push(r);
    }), t;
}
function Fi(s, n) {
  n === void 0 && (n = 0);
  var e = s._prevModal;
  if (e && e !== s && n < 10)
    return e.isVisible() ? e : Fi(e, n + 1);
}
var qp = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._lastFocus = +/* @__PURE__ */ new Date(), e._setActive = function(t) {
      e._active = t;
    }, e._setContent = function(t) {
      e._content = t;
    }, e._setLimitator = function(t) {
      e._limitator = t;
    }, e._setPopup = function(t) {
      e._popup = t;
    }, e._setWrapper = function(t) {
      e._wrapper = t;
    }, e._onOverlayClick = function() {
      e._isOpen && e.s.closeOnOverlayClick && !e._preventClose && e._close("overlay"), e._preventClose = !1;
    }, e._onDocClick = function(t) {
      e.s.showOverlay || t.target === e.s.focusElm || rn !== e || e._onOverlayClick();
    }, e._onMouseDown = function(t) {
      e.s.showOverlay || (e._target = t.target);
    }, e._onMouseUp = function(t) {
      e._target && e._popup && e._popup.contains(e._target) && !e._popup.contains(t.target) && (e._preventClose = !0), e._target = !1;
    }, e._onPopupClick = function() {
      e.s.showOverlay || (e._preventClose = !0);
    }, e._onAnimationEnd = function(t) {
      t.target === e._popup && (e._isClosing && (e._onClosed(), e._isClosing = !1, e.state.isReady ? e.setState({ isReady: !1 }) : e.forceUpdate()), e._isOpening && (e._onOpened(), e._isOpening = !1, e.forceUpdate()));
    }, e._onButtonClick = function(t) {
      var a = t.domEvent, i = t.button;
      e._hook("onButtonClick", { domEvent: a, button: i }), /cancel|close|ok|set/.test(i.name) && e._close(i.name);
    }, e._onFocus = function(t) {
      var a = +/* @__PURE__ */ new Date();
      rn === e && t.target.nodeType && e._ctx.contains(t.target) && e._popup && !e._popup.contains(t.target) && a - e._lastFocus > 100 && t.target !== e.s.focusElm && (e._lastFocus = a, e._active.focus());
    }, e._onKeyDown = function(t) {
      var a = e.s, i = t.keyCode, r = a.focusElm && !a.focusOnOpen ? a.focusElm : void 0;
      if ((i === 32 && !Yn(t.target, hd) || e._lock && (i === 38 || i === 40)) && t.preventDefault(), a.focusTrap && i === 9) {
        var o = e._popup.querySelectorAll(jp), l = [], u = -1, c = 0, d = -1, m = void 0;
        Ft(o, function(h) {
          h.disabled || !h.offsetHeight && !h.offsetWidth || (l.push(h), u++, h === e._doc.activeElement && (d = u));
        }), t.shiftKey && (c = u, u = 0), d === u ? m = r || l[c] : t.target === r && (m = l[c]), m && (m.focus(), t.preventDefault());
      }
    }, e._onContentScroll = function(t) {
      !e._lock || t.type === "touchmove" && t.touches[0].touchType === "stylus" || t.preventDefault();
    }, e._onScroll = function(t) {
      var a = e.s;
      a.closeOnScroll ? e._close("scroll") : (e._hasContext || a.display === "anchored") && e.position();
    }, e._onWndKeyDown = function(t) {
      var a = e.s, i = t.keyCode;
      if (rn === e && i !== void 0) {
        if (e._hook("onKeyDown", { keyCode: i }), a.closeOnEsc && i === 27 && e._close("esc"), i === 13 && Yn(t.target, Vp) && !t.shiftKey)
          return;
        if (e._buttons)
          for (var r = 0, o = e._buttons; r < o.length; r++)
            for (var l = o[r], u = 0, c = at(l.keyCode) ? l.keyCode : [l.keyCode]; u < c.length; u++) {
              var d = c[u];
              if (!l.disabled && d !== void 0 && (d === i || Wp[d] === i))
                return void l.handler(t);
            }
      }
    }, e._onResize = function() {
      var t = e._wrapper, a = e._hasContext;
      if (t) {
        e._vpWidth = Math.min(t.clientWidth, a ? 1 / 0 : e._win.innerWidth), e._vpHeight = Math.min(t.clientHeight, a ? 1 / 0 : e._win.innerHeight), e._maxWidth = e._limitator.offsetWidth, e._maxHeight = e.s.maxHeight !== void 0 || e._vpWidth < 768 || e._vpHeight < 650 ? e._limitator.offsetHeight : 600, e._round = e.s.touchUi === !1 || e._popup.offsetWidth < e._vpWidth && e._vpWidth > e._maxWidth;
        var i = { isLarge: e._round, maxPopupHeight: e._maxHeight, maxPopupWidth: e._maxWidth, target: t, windowHeight: e._vpHeight, windowWidth: e._vpWidth };
        e._hook("onResize", i) === !1 || i.cancel || e.position();
      }
    }, e;
  }
  return de(n, s), n.prototype.open = function() {
    this._isOpen || this.setState({ isOpen: !0 });
  }, n.prototype.close = function() {
    this._close();
  }, n.prototype.isVisible = function() {
    return !!this._isOpen;
  }, n.prototype.position = function() {
    if (this._isOpen) {
      var e = this.s, t = this.state, a = this._wrapper, i = this._popup, r = this._hasContext, o = e.anchor, l = e.anchorAlign, u = e.rtl, c = Oi(this._scrollCont), d = Ni(this._scrollCont), m = this._vpWidth, h = this._vpHeight, f = this._maxWidth, p = this._maxHeight, g = Math.min(i.offsetWidth, f), v = Math.min(i.offsetHeight, p), y = e.showArrow;
      this._lock = e.scrollLock && this._content.scrollHeight <= this._content.clientHeight, r && (a.style.top = c + "px", a.style.left = d + "px");
      var b = this._hook("onPosition", { isLarge: this._round, maxPopupHeight: p, maxPopupWidth: f, target: this._wrapper, windowHeight: h, windowWidth: m }) === !1;
      if (e.display !== "anchored" || b)
        this.setState({ height: h, isReady: !0, showArrow: y, width: m });
      else {
        var D = 0, w = 0, C = $e(t.modalLeft || 0, 8, m - g - 8), T = t.modalTop || 8, N = "bottom", O = {}, L = y ? 16 : 4, H = (a.offsetWidth - m) / 2, A = (a.offsetHeight - h) / 2;
        if (r) {
          var B = this._ctx.getBoundingClientRect();
          w = B.top, D = B.left;
        }
        if (o && this._ctx.contains(o)) {
          var I = o.getBoundingClientRect(), S = I.top - w, k = I.left - D, R = o.offsetWidth, z = o.offsetHeight;
          if (C = $e(C = l === "start" && !u || l === "end" && u ? k : l === "end" && !u || l === "start" && u ? k + R - g : k - (g - R) / 2, 8, m - g - 8), T = S + z + L, O = { left: $e(k + R / 2 - C - H, 30, g - 30) + "px" }, T + v + L > h) {
            if (S - v - L > 0)
              N = "top", T = S - v - L;
            else if (!e.disableLeftRight) {
              var W = k - g - 8 > 0;
              (W || k + R + g + 8 <= m) && ((T = $e(S - (v - z) / 2, 8, h - v - 8)) + v + 8 > h && (T = Math.max(h - v - 8, 0)), O = { top: $e(S + z / 2 - T - A, 30, v - 30) + "px" }, N = W ? "left" : "right", C = W ? k - g : k + R);
            }
          }
        }
        N !== "top" && N !== "bottom" || T + v + L > h && (T = Math.max(h - v - L, 0), y = !1), this.setState({ arrowPos: O, bubblePos: N, height: h, isReady: !0, modalLeft: C, modalTop: T, showArrow: y, width: m });
      }
    }
  }, n.prototype._render = function(e, t) {
    e.display === "bubble" && (e.display = "anchored");
    var a = e.animation, i = e.display, r = this._prevS, o = i === "anchored", l = i !== "inline", u = e.fullScreen && l, c = !!l && (e.isOpen === void 0 ? t.isOpen : e.isOpen);
    if (c && (e.windowWidth !== r.windowWidth || e.display !== r.display || e.showArrow !== r.showArrow || e.anchor !== r.anchor && e.display === "anchored") && (this._shouldPosition = !0), this._limits = { maxHeight: On(e.maxHeight), maxWidth: On(e.maxWidth) }, this._style = { height: u ? "100%" : On(e.height), left: o && t.modalLeft ? t.modalLeft + "px" : "", maxHeight: On(this._maxHeight || e.maxHeight), maxWidth: On(this._maxWidth || e.maxWidth), top: o && t.modalTop ? t.modalTop + "px" : "", width: u ? "100%" : On(e.width) }, this._hasContext = e.context !== "body" && e.context !== void 0, this._needsLock = $p && !this._hasContext && i !== "anchored" && e.scrollLock, this._isModal = l, this._flexButtons = i === "center" || !this._touchUi && !u && (i === "top" || i === "bottom"), a !== void 0 && a !== !0)
      this._animation = ye(a) ? a : "";
    else
      switch (i) {
        case "bottom":
          this._animation = "slide-up";
          break;
        case "top":
          this._animation = "slide-down";
          break;
        default:
          this._animation = "pop";
      }
    e.buttons ? e.buttons !== r.buttons && (this._buttons = md(this, e.buttons)) : this._buttons = void 0, e.headerText !== r.headerText && (this._headerText = e.headerText ? this._safeHtml(e.headerText) : void 0), e.context !== r.context && (this._contextChanged = !0), c && !this._isOpen && this._onOpen(), !c && this._isOpen && this._onClose(), this._isOpen = c, this._isVisible = c || this._isClosing;
  }, n.prototype._updated = function() {
    var e = this, t = this.s, a = this._wrapper;
    if (Je && (this._contextChanged || !this._ctx) && ((i = ye(t.context) ? Je.querySelector(t.context) : t.context) || (i = Je.body), this._ctx = i, this._contextChanged = !1, this._justOpened))
      return void es(this, function() {
        e.forceUpdate();
      });
    if (a) {
      if (this._justOpened) {
        var i = this._ctx, r = this._hasContext, o = this._doc = vn(a), l = this._win = Ns(a), u = o.activeElement;
        if (!this._hasWidth && t.responsive) {
          var c = Math.min(a.clientWidth, r ? 1 / 0 : l.innerWidth), d = Math.min(a.clientHeight, r ? 1 / 0 : l.innerHeight);
          if (this._hasWidth = !0, c !== this.state.width || d !== this.state.height)
            return void es(this, function() {
              e.setState({ height: d, width: c });
            });
        }
        if (this._scrollCont = r ? i : l, this._observer = Do(a, this._onResize, this._zone), this._prevFocus = t.focusElm || u, i.__mbscModals = (i.__mbscModals || 0) + 1, this._needsLock) {
          if (!i.__mbscIOSLock) {
            var m = Oi(this._scrollCont), h = Ni(this._scrollCont);
            i.style.left = -h + "px", i.style.top = -m + "px", i.__mbscScrollLeft = h, i.__mbscScrollTop = m, i.classList.add("mbsc-popup-open-ios"), i.parentElement.classList.add("mbsc-popup-open-ios");
          }
          i.__mbscIOSLock = (i.__mbscIOSLock || 0) + 1;
        }
        r && i.classList.add("mbsc-popup-ctx"), t.focusTrap && pe(l, "focusin", this._onFocus), t.focusElm && !t.focusOnOpen && pe(t.focusElm, "keydown", this._onKeyDown), pe(this._scrollCont, "touchmove", this._onContentScroll, { passive: !1 }), pe(this._scrollCont, "wheel", this._onContentScroll, { passive: !1 }), pe(this._scrollCont, "mousewheel", this._onContentScroll, { passive: !1 }), setTimeout(function() {
          t.focusOnOpen && u && u.blur(), Ja && e._animation || e._onOpened(), pe(o, pt, e._onMouseDown), pe(o, gn, e._onMouseUp), pe(o, Ut, e._onDocClick);
        }), this._hook("onOpen", { target: this._wrapper });
      }
      this._shouldPosition && es(this, function() {
        e._onResize();
      }), this._justOpened = !1, this._justClosed = !1, this._shouldPosition = !1;
    }
  }, n.prototype._destroy = function() {
    this._isOpen && (this._onClosed(), this._unlisten(), rn === this && (rn = Fi(this)));
  }, n.prototype._onOpen = function() {
    var e = this;
    Ja && this._animation && (this._isOpening = !0, this._isClosing = !1), this._justOpened = !0, this._preventClose = !1, this.s.setActive && rn !== this && setTimeout(function() {
      e._prevModal = rn, rn = e;
    });
  }, n.prototype._onClose = function() {
    var e = this;
    Ja && this._animation ? (this._isClosing = !0, this._isOpening = !1) : setTimeout(function() {
      e._onClosed(), e.setState({ isReady: !1 });
    }), this._hasWidth = !1, this._unlisten();
  }, n.prototype._onOpened = function() {
    var e = this.s;
    if (e.focusOnOpen) {
      var t = e.activeElm, a = t ? ye(t) ? this._popup.querySelector(t) || this._active : t : this._active;
      a && a.focus && a.focus();
    }
    pe(this._win, "keydown", this._onWndKeyDown), pe(this._scrollCont, "scroll", this._onScroll);
  }, n.prototype._onClosed = function() {
    var e, t, a = this, i = this._ctx, r = this._prevFocus, o = this.s.focusOnClose && r && r.focus && r !== this._doc.activeElement;
    i.__mbscModals && i.__mbscModals--, this._justClosed = !0, this._needsLock && (i.__mbscIOSLock && i.__mbscIOSLock--, i.__mbscIOSLock || (i.classList.remove("mbsc-popup-open-ios"), i.parentElement.classList.remove("mbsc-popup-open-ios"), i.style.left = "", i.style.top = "", e = this._scrollCont, t = i.__mbscScrollLeft || 0, e.scrollTo ? e.scrollTo(t, e.scrollY) : e.scrollLeft = t, function(l, u) {
      l.scrollTo ? l.scrollTo(l.scrollX, u) : l.scrollTop = u;
    }(this._scrollCont, i.__mbscScrollTop || 0))), this._hasContext && !i.__mbscModals && i.classList.remove("mbsc-popup-ctx"), this._hook("onClosed", { focus: o }), o && r.focus(), setTimeout(function() {
      rn === a && (rn = Fi(a));
    });
  }, n.prototype._unlisten = function() {
    le(this._win, "keydown", this._onWndKeyDown), le(this._scrollCont, "scroll", this._onScroll), le(this._scrollCont, "touchmove", this._onContentScroll, { passive: !1 }), le(this._scrollCont, "wheel", this._onContentScroll, { passive: !1 }), le(this._scrollCont, "mousewheel", this._onContentScroll, { passive: !1 }), le(this._doc, pt, this._onMouseDown), le(this._doc, gn, this._onMouseUp), le(this._doc, Ut, this._onDocClick), this.s.focusTrap && le(this._win, "focusin", this._onFocus), this.s.focusElm && le(this.s.focusElm, "keydown", this._onKeyDown), this._observer && (this._observer.detach(), this._observer = null);
  }, n.prototype._close = function(e) {
    this._isOpen && (this.s.isOpen === void 0 && this.setState({ isOpen: !1 }), this._hook("onClose", { source: e }));
  }, n.defaults = { buttonVariant: "flat", cancelText: "Cancel", closeOnEsc: !0, closeOnOverlayClick: !0, closeText: "Close", contentPadding: !0, display: "center", focusOnClose: !0, focusOnOpen: !0, focusTrap: !0, maxWidth: 600, okText: "Ok", scrollLock: !0, setActive: !0, setText: "Set", showArrow: !0, showOverlay: !0 }, n;
}(it);
function Yi(s, n, e) {
  e === void 0 && (e = 0), e > 10 ? (delete s.__mbscTimer, n(s)) : (clearTimeout(s.__mbscTimer), s.__mbscTimer = setTimeout(function() {
    s.getInputElement ? s.getInputElement().then(function(t) {
      t ? (delete s.__mbscTimer, n(t)) : Yi(s, n, e + 1);
    }) : Yi(s, n, e + 1);
  }, 10));
}
function Gp(s, n) {
  if (s) {
    if ((t = s).getInputElement || t.tagName && t.tagName.toLowerCase() === "ion-input")
      Yi(s, n);
    else if (s.vInput)
      n(s.vInput.nativeElement);
    else if (s._el)
      n(s._el);
    else if (s.instance && s.instance._el)
      n(s.instance._el);
    else if (s.nodeType === 1)
      n(s);
    else if (ye(s)) {
      var e = Je.querySelector(s);
      e && n(e);
    }
  }
  var t;
}
function Xp(s, n, e, t) {
  if (!s || s.nodeType !== 1)
    return fa;
  var a, i = function() {
    (n.s.showOnClick || n.s.showOnFocus) && f && !n._allowTyping && (p.readOnly = !0);
  }, r = function(g) {
    var v = n.s;
    i(), t && t(g), !v.showOnClick || v.disabled || n._popup._isVisible && s === n._popup._prevFocus || setTimeout(function() {
      n._focusElm = s, n._anchor = v.anchor || s, n.open();
    });
  }, o = function(g) {
    n.s.showOnClick && (n.s.showOnFocus && (n._preventShow = !0), n._allowTyping || g.preventDefault());
  }, l = function(g) {
    n.s.showOnClick && (n._isOpen ? g.keyCode === 13 && n._allowTyping && g.stopPropagation() : (g.keyCode === 32 && g.preventDefault(), g.keyCode !== 13 && g.keyCode !== 32 || r(g)));
  }, u = function(g) {
    i(), n.s.showOnFocus && (n._preventShow ? n._preventShow = !1 : r(g));
  }, c = function() {
    f && (p.readOnly = a);
  }, d = function(g) {
    e && e(g);
  }, m = function() {
    h.document.activeElement === s && (i(), n._preventShow = !0);
  }, h = Ns(s), f = Yn(s, "input,select"), p = s;
  return f && (p.autocomplete = "off", a = p.readOnly), pe(s, Ut, r), pe(s, pt, o), pe(s, "keydown", l), pe(s, "focus", u), pe(s, "blur", c), pe(s, Un, d), pe(h, "focus", m), function() {
    f && (p.readOnly = a), le(s, Ut, r), le(s, pt, o), le(s, "keydown", l), le(s, "focus", u), le(s, "blur", c), le(s, Un, d), le(h, "focus", m);
  };
}
var pd = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._nullSupport = !0, e._onInputChange = function(t, a) {
      var i = t.detail || (a !== void 0 ? a : t.target.value);
      if (i !== e._tempValueText && !e._preventChange) {
        e._readValue(i, !0), e._valueTextChange = i !== e._tempValueText;
        var r = Dt(i) ? null : e._get(e._tempValueRep);
        e.value = r, e._valueChange(r);
      }
      e._preventChange = !1;
    }, e._onResize = function(t) {
      e._hook("onResize", t);
    }, e._onWrapperResize = function() {
      e._wrapper && e._onResize({ windowWidth: e._wrapper.offsetWidth });
    }, e._onPopupClose = function(t) {
      /cancel|esc|overlay|scroll/.test(t.source) && e._hook("onCancel", { value: e.value, valueText: e._valueText }), e.close();
    }, e._onPopupClosed = function(t) {
      t.focus && (e._preventShow = !0), e._hook("onClosed", t), e._onClosed();
    }, e._onPopupKey = function(t) {
      t.keyCode === 13 && e._onEnterKey(t);
    }, e._onPopupOpen = function(t) {
      t.value = e.value, t.valueText = e._valueText, e._hook("onOpen", t);
    }, e._onButtonClick = function(t) {
      var a = t.domEvent, i = t.button;
      i.name === "set" && e.set(), e._popup && e._popup._onButtonClick({ domEvent: a, button: i });
    }, e._setInput = function(t) {
      e._el = t && t.nativeElement ? t.nativeElement : t;
    }, e._setPopup = function(t) {
      e._popup = t;
    }, e._setWrapper = function(t) {
      e._wrapper = t;
    }, e;
  }
  return de(n, s), n.prototype.open = function() {
    this._inst ? this._inst.open() : this.s.isOpen === void 0 && this.setState({ isOpen: !0 });
  }, n.prototype.close = function() {
    if (this.s.display !== "inline")
      if (this._inst)
        this._inst.close();
      else {
        var e = { value: this.value, valueText: this._valueText };
        this.s.isOpen === void 0 && this.setState({ isOpen: !1 }), this._hook("onClose", e);
      }
  }, n.prototype.set = function() {
    this._valueRep = this._copy(this._tempValueRep), this._valueText = this._tempValueText, this._value = this.value = this._get(this._valueRep), this._valueChange(this.value);
  }, n.prototype.position = function() {
    this._inst ? this._inst.position() : this._popup && this._popup.position();
  }, n.prototype.isVisible = function() {
    return this._inst ? this._inst.isVisible() : !!this._popup && this._popup.isVisible();
  }, n.prototype.getVal = function() {
    return this._nullSupport && Dt(this._value) ? this.s.selectMultiple ? [] : null : this._get(this._valueRep);
  }, n.prototype.setVal = function(e) {
    this.value = e, this.setState({ value: e });
  }, n.prototype.getTempVal = function() {
    return this._get(this._tempValueRep);
  }, n.prototype.setTempVal = function(e) {
    this._tempValueSet = !0, this._tempValueRep = this._parse(e), this._setOrUpdate(!0);
  }, n.prototype._shouldValidate = function(e, t) {
    return !1;
  }, n.prototype._valueEquals = function(e, t) {
    return e === t;
  }, n.prototype._change = function(e) {
  }, n.prototype._render = function(e, t) {
    var a = this, i = this.props || {}, r = this._respProps || {}, o = this._prevS;
    this._touchUi || (e.display = r.display || i.display || fs.display || "anchored", e.showArrow = r.showArrow || i.showArrow || !1), e.display === "bubble" && (e.display = "anchored"), this._scrollLock = e.scrollLock;
    var l = e.isOpen !== void 0 ? e.isOpen : t.isOpen, u = e.modelValue !== void 0 ? e.modelValue : e.value, c = u !== void 0 ? u : t.value === void 0 ? e.defaultValue : t.value;
    if (this._showInput = e.showInput !== void 0 ? e.showInput : e.display !== "inline" && e.element === void 0, (!this._buttons || e.buttons !== o.buttons || e.display !== o.display || e.setText !== o.setText || e.cancelText !== o.cancelText || e.closeText !== o.closeText || e.touchUi !== o.touchUi) && (this._buttons = md(this, e.buttons || (e.display === "inline" || e.display === "anchored" && !this._touchUi ? [] : ["cancel", "set"])), this._live = !0, this._buttons && this._buttons.length))
      for (var d = 0, m = this._buttons; d < m.length; d++) {
        var h = m[d];
        h.name !== "ok" && h.name !== "set" || (this._live = !1);
      }
    if (!this._valueEquals(c, this._value) || this._tempValueRep === void 0 || this._shouldValidate(e, o) || e.defaultSelection !== o.defaultSelection || e.invalid !== o.invalid || e.valid !== o.valid) {
      this._readValue(c);
      var f = this._get(this._tempValueRep), p = !(this._valueEquals(c, f) || this._nullSupport && Dt(c));
      this._setHeader(), clearTimeout(this._handler), this._handler = setTimeout(function() {
        a.value = c, p && a._valueChange(f), a._valueEquals(a._tempValue, f) || a._inst !== void 0 || a._hook("onTempChange", { value: f });
      });
    }
    if (e.headerText !== o.headerText && this._setHeader(), l && !this._isOpen) {
      if (!this._tempValueSet || this._live) {
        var g = this._get(this._tempValueRep), v = this._get(this._valueRep);
        this._tempValueRep = this._copy(this._valueRep), this._tempValueText = this._format(this._tempValueRep), this._tempValue = g, this._setHeader(), this._valueEquals(g, v) || setTimeout(function() {
          a._hook("onTempChange", { value: v });
        });
      }
      this._onOpen();
    }
    this._allowTyping = e.inputTyping && !Ds && !this._touchUi, this._anchorAlign = e.anchorAlign || (this._touchUi ? "center" : "start"), this._cssClass = "mbsc-picker " + (e.cssClass || ""), this._isOpen = l, this._maxWidth = e.maxWidth, this._valueTextChange = this._valueTextChange || this._oldValueText !== this._valueText, this._oldValueText = this._valueText, this._value = c, this._shouldInitInput = this._shouldInitInput || o.display === void 0 || e.display === "inline" && o.display !== "inline" || e.display !== "inline" && o.display === "inline" || e.element !== o.element;
  }, n.prototype._updated = function() {
    var e = this, t = this.s, a = this._input;
    this._shouldInitInput && !this._inst && (this._unlisten(), this._wrapper && t.display === "inline" && (this._observer = Do(this._wrapper, this._onWrapperResize, this._zone)), Gp(t.element || this._el, function(i) {
      e._el = i, t.display !== "inline" && (e._resetEl = Xp(i, e, e._onInputChange)), Yn(i, "input,select") && (e._input = i, e._write(i));
    })), this._valueTextChange && a && this._write(a), setTimeout(function() {
      t.responsive && t.display !== "inline" && wt && e.state.width === void 0 && e._onResize({ windowWidth: wt.innerWidth });
    }), this._shouldInitInput = !1, this._valueTextChange = !1, this._anchor = t.anchor || this._focusElm || t.element || this._el;
  }, n.prototype._writeValue = function(e, t, a) {
    var i = e.value;
    return e.value = t, i !== t;
  }, n.prototype._destroy = function() {
    this._unlisten(), this._shouldInitInput = !0;
  }, n.prototype._setHeader = function() {
    var e = this.s.headerText;
    this._headerText = e ? e.replace(/\{value\}/i, this._tempValueText || "&nbsp;") : void 0;
  }, n.prototype._setOrUpdate = function(e) {
    var t = this._get(this._tempValueRep);
    this._tempValue = t, this._tempValueText = this._format(this._tempValueRep), this._setHeader(), e || this._hook("onTempChange", { value: t }), this._live ? this.set() : this.forceUpdate();
  }, n.prototype._copy = function(e) {
    return e;
  }, n.prototype._format = function(e) {
    return e;
  }, n.prototype._get = function(e) {
    return e;
  }, n.prototype._parse = function(e, t) {
    return e;
  }, n.prototype._validate = function() {
  }, n.prototype._onClosed = function() {
  }, n.prototype._onOpen = function() {
  }, n.prototype._onParse = function() {
  }, n.prototype._onEnterKey = function(e) {
    this.set(), this.close();
  }, n.prototype._valueChange = function(e) {
    this.s.value === void 0 && this.setState({ value: e }), this._change(e), this._hook("onChange", { value: e, valueText: this._tempValueText });
  }, n.prototype._readValue = function(e, t) {
    this._tempValueRep = this._parse(e, t), this._onParse(), this._validate(), this._tempValueText = this._format(this._tempValueRep), this._valueRep = this._copy(this._tempValueRep), this._valueText = Dt(e) ? "" : this._tempValueText;
  }, n.prototype._unlisten = function() {
    this._resetEl && (this._resetEl(), this._resetEl = void 0), this._observer && (this._observer.detach(), this._observer = void 0);
  }, n.prototype._write = function(e) {
    var t = this, a = this._value;
    this._writeValue(e, this._valueText || "", a) && setTimeout(function() {
      t._preventChange = !0, dr(e, "input"), dr(e, Un);
    });
    var i = e.__mbscFormInst;
    i && i.setOptions({ pickerMap: this.s.valueMap, pickerValue: a });
  }, n.defaults = { cancelText: "Cancel", closeText: "Close", focusOnClose: sn !== "android", okText: "Ok", setText: "Set", showOnFocus: Ds }, n;
}(it);
function Ui(s, n, e, t) {
  var a = s.min === void 0 ? -1 / 0 : s.min, i = s.max === void 0 ? 1 / 0 : s.max, r = js(s, n), o = tr(s, r), l = o, u = o, c = 0, d = 0;
  if (e && e.get(o)) {
    for (; r - c >= a && e.get(l) && c < 100; )
      l = tr(s, r - ++c);
    for (; r + d < i && e.get(u) && d < 100; )
      u = tr(s, r + ++d);
    if (e.get(l) && e.get(u))
      return o;
    o = (d < c && d && t !== -1 || !c || r - c < 0 || t === 1) && !e.get(u) ? u : l;
  }
  return o;
}
function Vs(s) {
  return s !== void 0 ? s.value !== void 0 ? s.value : s.display !== void 0 ? s.display : s : s;
}
function fd(s, n) {
  if (s.getItem)
    return s.getItem(n);
  var e = s.data || [], t = e.length, a = n % t;
  return s._circular ? e[a >= 0 ? a : a + t] : e[$e(n, 0, t - 1)];
}
function js(s, n) {
  var e = s.multiple ? n && n.length && n[0] || void 0 : n;
  return (s.getIndex ? +s.getIndex(n) : s._map.get(e)) || 0;
}
function tr(s, n) {
  return Vs(fd(s, n));
}
var Kp = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._indexes = [], e._activeIndexes = [], e._wheels = [], e._batches = [], e._lastIndexes = [], e._onSet = function() {
      e._setOrUpdate();
    }, e._onActiveChange = function(t) {
      var a = t.wheel, i = t.index, r = a._key;
      e._activeIndexes[r] = i;
      var o = e._indexes, l = o[r];
      e._scroll3d ? l = i : i - l >= e._rows ? l++ : i < l && l--, o[r] = l, e.forceUpdate();
    }, e._onWheelIndexChange = function(t) {
      var a = e.s, i = t.wheel, r = i._key, o = i.multiple, l = tr(i, t.index), u = e._disabled && e._disabled[r] && e._disabled[r].get(l), c = [], d = a.selectOnScroll;
      (d || !t.click) && (e._lastIndexes[r] = e._indexes[r] = t.index, e._indexes.forEach(function(b, D) {
        var w = e._wheelMap[D], C = w.data ? w.data.length : 0;
        e._batches[D] = C ? Le(b / C) : 0, c[D] = C;
      })), e._activeIndexes[r] = t.index;
      var m = e._get(e._tempValueRep), h = !!t.click && !u, f = d || h;
      if (o) {
        if (h) {
          var p = (e._tempValueRep[r] || []).slice();
          t.selected === !1 ? p.push(l) : t.selected === !0 && p.splice(p.indexOf(l), 1), e._tempValueRep[r] = p;
        }
      } else
        f && (e._tempValueRep[r] = l);
      if (a.onWheelMove && t.index !== void 0) {
        var g = a.onWheelMove({ dataItem: fd(i, t.index), selection: f, wheelIndex: r });
        g && g.forEach(function(b, D) {
          if (b !== void 0 && (e._tempValueRep[D] = b), !f) {
            var w = e._wheelMap[D], C = js(w, b);
            e._constrainIndex(C, w);
          }
        });
      }
      f && e._validate(r, t.diff > 0 ? 1 : -1), d && e._tempValueRep.forEach(function(b, D) {
        var w = e._wheelMap[D], C = w.data ? w.data.length : 0, T = e._indexes[D], N = js(w, b) + e._batches[D] * C;
        e._activeIndexes[D] = e._lastIndexes[D] = e._indexes[D] = N, w._offset = C !== c[D] ? N - T : 0;
      });
      var v = e._get(e._tempValueRep), y = !e._valueEquals(m, v);
      y || t.click && e._live && !e._valueEquals(e.value, v) ? e._setOrUpdate(!y) : e.forceUpdate(), e._live && h && i.closeOnTap && e.close();
    }, e;
  }
  return de(n, s), n.prototype._initWheels = function() {
    var e = this, t = 0, a = this.s.wheels || [];
    this._wheelMap = [], a.forEach(function(i) {
      i.forEach(function(r) {
        e._initWheel(r, t), e._wheelMap[t] = r, t++;
      });
    }), this._wheels = a;
  }, n.prototype._shouldValidate = function(e, t) {
    return !!e.shouldValidate && e.shouldValidate(e, t);
  }, n.prototype._valueEquals = function(e, t) {
    return this.s.valueEquality ? this.s.valueEquality(e, t) : e === t;
  }, n.prototype._render = function(e, t) {
    var a = this, i = this.props || {}, r = this._respProps || {}, o = this._prevS, l = !!this._touchUi && e.circular, u = this._touchUi ? e.rows : r.rows || i.rows || 7;
    if (this._displayStyle = e.displayStyle || e.display, this._scroll3d = e.scroll3d && this._touchUi && Sp, (e.itemHeight !== o.itemHeight || u !== this._rows) && (this._rows = u, this._lineStyle = { height: e.itemHeight + "px" }, this._scroll3d)) {
      var c = "translateZ(" + (e.itemHeight * u / 2 + 3) + "px";
      this._overlayStyle = {}, this._overlayStyle[ra + "transform"] = c, this._lineStyle[ra + "transform"] = "translateY(-50%) " + c;
    }
    e.wheels === o.wheels && l === this._circular || (this._batches = [], this._shouldSetIndex = !0, this._circular = l, this._initWheels()), s.prototype._render.call(this, e, t), this._shouldSetIndex && (this._setIndexes(), this._shouldSetIndex = this._indexFromValue = !1), e.wheels !== o.wheels && o.wheels !== void 0 && setTimeout(function() {
      for (var d = 0, m = a._wheelMap; d < m.length; d++) {
        var h = m[d];
        a._onWheelIndexChange({ diff: 0, index: a._indexes[h._key], wheel: h });
      }
    });
  }, n.prototype._writeValue = function(e, t, a) {
    return this.s.writeValue ? this.s.writeValue(e, t, a) : s.prototype._writeValue.call(this, e, t, a);
  }, n.prototype._copy = function(e) {
    return e.slice(0);
  }, n.prototype._format = function(e) {
    return this.s.formatValue ? this.s.formatValue(e) : e.join(" ");
  }, n.prototype._get = function(e) {
    return this.s.getValue ? this.s.getValue(e) : e;
  }, n.prototype._parse = function(e) {
    if (this.s.parseValue)
      return this.s.parseValue(e);
    var t = [], a = [], i = 0;
    return e != null && (a = (e + "").split(" ")), this._wheels.forEach(function(r) {
      r.forEach(function(o) {
        for (var l = o.data || [], u = l.length, c = Vs(l[0]), d = 0; c != a[i] && d < u; )
          c = Vs(l[d]), d++;
        t.push(c), i++;
      });
    }), t;
  }, n.prototype._validate = function(e, t) {
    var a = this;
    if (this.s.validate) {
      var i = this.s.validate.call(this._el, { direction: t, index: e, values: this._tempValueRep.slice(0), wheels: this._wheelMap });
      this._disabled = i.disabled, i.init && this._initWheels(), i.indexes && i.indexes.forEach(function(r, o) {
        if (r !== void 0) {
          var l = a._wheelMap[o], u = js(l, r);
          a._constrainIndex(u, l);
        }
      }), i.valid ? this._tempValueRep = i.valid.slice(0) : this._wheelMap.forEach(function(r, o) {
        a._tempValueRep[o] = Ui(r, a._tempValueRep[o], a._disabled && a._disabled[o], t);
      });
    }
  }, n.prototype._onOpen = function() {
    this._batches = [], this._shouldSetIndex = !0, this._indexFromValue = !0;
  }, n.prototype._onParse = function() {
    this._shouldSetIndex = !0;
  }, n.prototype._initWheel = function(e, t) {
    var a = this._circular;
    e._key = t, e._map = /* @__PURE__ */ new Map(), e._circular = a === void 0 ? e.circular === void 0 ? e.data && e.data.length > this._rows : e.circular : at(a) ? a[t] : a, e.data && (e.min = e._circular ? void 0 : 0, e.max = e._circular ? void 0 : e.data.length - 1, e.data.forEach(function(i, r) {
      e._map.set(Vs(i), r);
    }));
  }, n.prototype._setIndexes = function() {
    var e = this, t = this._indexes || [];
    this._indexes = [], this._activeIndexes = [], this._tempValueRep.forEach(function(a, i) {
      var r = e._wheelMap[i], o = r.data ? r.data.length : 0, l = js(r, a);
      if (e.s.selectOnScroll)
        e._activeIndexes[i] = e._indexes[i] = l + (e._batches[i] || 0) * o;
      else {
        var u = l;
        e._indexFromValue || (u = e._prevS.wheels !== e.s.wheels ? 0 : t[i]) !== void 0 && (u = function(c, d) {
          if (c.getItem && c.getIndex)
            return c.getIndex(Vs(c.getItem(d)));
          var m = (c.data || []).length, h = d % m;
          return m ? h >= 0 ? h : h + m : 0;
        }(r, u) + (e._batches[i] || 0) * o), e._constrainIndex(u, r);
      }
    });
  }, n.prototype._constrainIndex = function(e, t) {
    var a = t._key;
    e !== void 0 && t.data ? (t.spaceAround || (e = $e(e, 0, Math.max(t.data.length - this._rows, 0))), this._activeIndexes[a] = this._indexes[a] = e) : this._activeIndexes[a] = this._indexes[a] = this._lastIndexes[a] || 0;
  }, n.defaults = { itemHeight: 40, rows: 5, selectOnScroll: !0, showOnClick: !0 }, n._name = "Scroller", n;
}(pd);
function Pl(s, n, e, t) {
  var a;
  if (!(n < e || n > t)) {
    if (at(s)) {
      var i = s.length, r = n % i;
      a = s[r >= 0 ? r : r + i];
    } else
      a = s(n);
    return a;
  }
}
var Qp = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._currPos = 0, e._delta = 0, e._endPos = 0, e._lastRaf = 0, e._maxSnapScroll = 0, e._margin = 0, e._scrollEnd = yp(function() {
      Bs(e._raf), e._raf = !1, e._onEnd(), e._hasScrolled = !1;
    }, 200), e._setInnerEl = function(t) {
      e._innerEl = t;
    }, e._setScrollEl = function(t) {
      e._scrollEl = t;
    }, e._setScrollEl3d = function(t) {
      e._scrollEl3d = t;
    }, e._setScrollbarEl = function(t) {
      e._scrollbarEl = t;
    }, e._setScrollbarContEl = function(t) {
      e._scrollbarContEl = t;
    }, e._onStart = function(t) {
      var a = e.s;
      e._hook("onStart", {}), a.changeOnEnd && e._isScrolling || !a.mouseSwipe && !t.isTouch || !a.swipe || (e._started = !0, e._hasScrolled = e._isScrolling, e._currX = t.startX, e._currY = t.startY, e._delta = 0, e._velocityX = 0, e._velocityY = 0, e._startPos = xl(e._scrollEl, e._isVertical), e._timestamp = +/* @__PURE__ */ new Date(), e._isScrolling && (Bs(e._raf), e._raf = !1, e._scroll(e._startPos)));
    }, e._onMove = function(t) {
      var a = t.domEvent, i = e.s;
      e._isVertical || i.scrollLock || e._hasScrolled ? a.cancelable && a.preventDefault() : a.type === "touchmove" && (Math.abs(t.deltaY) > 7 || !i.swipe) && (e._started = !1), e._started && (e._delta = e._isVertical ? t.deltaY : t.deltaX, (e._hasScrolled || Math.abs(e._delta) > e._threshold) && (e._hasScrolled || e._hook("onGestureStart", {}), e._hasScrolled = !0, e._isScrolling = !0, e._raf || (e._raf = on(function() {
        return e._move(t);
      }))));
    }, e._onEnd = function() {
      if (e._started = !1, e._hasScrolled) {
        var t, a = e.s, i = 17 * (e._isVertical ? e._velocityY : e._velocityX), r = e._maxSnapScroll, o = e._delta;
        o += i * i * 0.5 * (i < 0 ? -1 : 1), r && (o = $e(o, -e._round * r, e._round * r));
        var l = $e(bt((e._startPos + o) / e._round) * e._round, e._min, e._max), u = bt(-l * e._rtlNr / a.itemSize) + e._offset, c = o > 0 ? e._isVertical ? 270 : 360 : e._isVertical ? 90 : 180, d = u - a.selectedIndex;
        t = a.time || Math.max(1e3, 3 * Math.abs(l - e._currPos)), e._hook("onGestureEnd", { direction: c, index: u }), e._delta = 0, e._scroll(l, t), d && !a.changeOnEnd && (e._hook("onIndexChange", { index: u, diff: d }), a.selectedIndex === e._prevIndex && a.selectedIndex !== u && e.forceUpdate());
      }
    }, e._onClick = function(t) {
      e._hasScrolled && (e._hasScrolled = !1, t.stopPropagation(), t.preventDefault());
    }, e._onScroll = function(t) {
      t.target.scrollTop = 0, t.target.scrollLeft = 0;
    }, e._onMouseWheel = function(t) {
      var a = e._isVertical ? t.deltaY === void 0 ? t.wheelDelta || t.detail : t.deltaY : t.deltaX;
      if (a && e.s.mousewheel) {
        if (t.preventDefault(), e._hook("onStart", {}), e._started || (e._delta = 0, e._velocityX = 0, e._velocityY = 0, e._startPos = e._currPos, e._hook("onGestureStart", {})), t.deltaMode && t.deltaMode === 1 && (a *= 15), a = $e(-a, -e._scrollSnap, e._scrollSnap), e._delta += a, e._maxSnapScroll && Math.abs(e._delta) > e._round * e._maxSnapScroll && (a = 0), e._startPos + e._delta < e._min && (e._startPos = e._min, e._delta = 0, a = 0), e._startPos + e._delta > e._max && (e._startPos = e._max, e._delta = 0, a = 0), e._raf || (e._raf = on(function() {
          return e._move();
        })), !a && e._started)
          return;
        e._hasScrolled = !0, e._isScrolling = !0, e._started = !0, e._scrollEnd();
      }
    }, e._onTrackStart = function(t) {
      t.stopPropagation();
      var a = { domEvent: t, startX: zn(t, "X", !0), startY: zn(t, "Y", !0) };
      if (e._onStart(a), e._trackStartX = a.startX, e._trackStartY = a.startY, t.target === e._scrollbarEl)
        pe(e._doc, gn, e._onTrackEnd), pe(e._doc, "mousemove", e._onTrackMove);
      else {
        var i = nd(e._scrollbarContEl).top, r = (a.startY - i) / e._barContSize;
        e._startPos = e._currPos = e._max + (e._min - e._max) * r, e._hasScrolled = !0, e._onEnd();
      }
    }, e._onTrackMove = function(t) {
      var a = e._barContSize, i = zn(t, "X", !0), r = zn(t, "Y", !0), o = (e._isVertical ? r - e._trackStartY : i - e._trackStartX) / a;
      e._isInfinite ? e._delta = -(e._maxSnapScroll * e._round * 2 + a) * o : e._delta = (e._min - e._max - a) * o, (e._hasScrolled || Math.abs(e._delta) > e._threshold) && (e._hasScrolled || e._hook("onGestureStart", {}), e._hasScrolled = !0, e._isScrolling = !0, e._raf || (e._raf = on(function() {
        return e._move({ endX: i, endY: r }, !e._isInfinite);
      })));
    }, e._onTrackEnd = function() {
      e._delta = 0, e._startPos = e._currPos, e._onEnd(), le(e._doc, gn, e._onTrackEnd), le(e._doc, "mousemove", e._onTrackMove);
    }, e._onTrackClick = function(t) {
      t.stopPropagation();
    }, e;
  }
  return de(n, s), n.prototype._render = function(e, t) {
    var a = this._prevS, i = e.batchSize, r = e.batchSize3d, o = e.itemNr || 1, l = e.itemSize, u = e.selectedIndex, c = a.selectedIndex, d = t.index === void 0 ? u : t.index, m = [], h = [], f = u - c, p = d - this._currIndex, g = e.minIndex, v = e.maxIndex, y = e.items, b = e.offset;
    this._currIndex = d, this._isVertical = e.axis === "Y", this._threshold = this._isVertical ? e.thresholdY : e.thresholdX, this._rtlNr = !this._isVertical && e.rtl ? -1 : 1, this._round = e.snap ? l : 1;
    for (var D = this._round; D > 44; )
      D /= 2;
    if (this._scrollSnap = bt(44 / D) * D, y) {
      for (var w = d - i; w < d + o + i; w++)
        m.push({ key: w, data: Pl(y, w, g, v) });
      if (e.scroll3d)
        for (w = d - r; w < d + o + r; w++)
          h.push({ key: w, data: Pl(y, w, g, v) });
      this.visibleItems = m, this.visible3dItems = h, this._maxSnapScroll = i, this._isInfinite = typeof y == "function";
    }
    this._offset === void 0 && (this._offset = u);
    var C = -(u - this._offset) * l * this._rtlNr;
    if (Math.abs(f) > i && C !== this._endPos) {
      var T = f + i * (f > 0 ? -1 : 1);
      this._offset += T, this._margin -= T;
    }
    if (b && b !== a.offset && (this._offset += b, this._margin -= b), p && (this._margin += p), this._max = g !== void 0 ? -(g - this._offset) * l * this._rtlNr : 1 / 0, this._min = v !== void 0 ? -(v - this._offset - (e.spaceAround ? 0 : o - 1)) * l * this._rtlNr : -1 / 0, this._rtlNr === -1) {
      var N = this._min;
      this._min = this._max, this._max = N;
    }
    this._min > this._max && (this._min = this._max);
    var O = e.visibleSize * l;
    this._barContSize = O, this._barSize = Math.max(20, O * O / (this._max - this._min + O)), this._cssClass = this._className + " mbsc-ltr";
  }, n.prototype._mounted = function() {
    var e = this._el, t = this._scrollbarContEl;
    this._doc = vn(e), pe(this.s.scroll3d ? this._innerEl : e, "scroll", this._onScroll), pe(e, Ut, this._onClick, !0), pe(e, "mousewheel", this._onMouseWheel, { passive: !1 }), pe(e, "wheel", this._onMouseWheel, { passive: !1 }), pe(t, pt, this._onTrackStart), pe(t, Ut, this._onTrackClick), this._unlisten = Kt(e, { onEnd: this._onEnd, onHoverIn: function() {
      t.classList.add("mbsc-scroller-bar-hover");
    }, onHoverOut: function() {
      t.classList.remove("mbsc-scroller-bar-hover");
    }, onMove: this._onMove, onStart: this._onStart, prevDef: !0 });
  }, n.prototype._updated = function() {
    var e = this.s, t = e.batchSize, a = e.itemSize, i = e.selectedIndex, r = this._prevIndex, o = !e.prevAnim && (r !== void 0 && r !== i || this._isAnimating), l = -(i - this._offset) * a * this._rtlNr;
    e.margin && (this._scrollEl.style.marginTop = this._isVertical ? (this._margin - t) * a + "px" : ""), this._started || this._scroll(l, o ? this._isAnimating || e.time || 1e3 : 0), this._prevIndex = i;
  }, n.prototype._destroy = function() {
    le(this.s.scroll3d ? this._innerEl : this._el, "scroll", this._onScroll), le(this._el, Ut, this._onClick, !0), le(this._el, "mousewheel", this._onMouseWheel, { passive: !1 }), le(this._el, "wheel", this._onMouseWheel, { passive: !1 }), le(this._scrollbarContEl, pt, this._onTrackStart), le(this._scrollbarContEl, Ut, this._onTrackClick), Bs(this._raf), this._raf = !1, this._scroll(0), this._unlisten();
  }, n.prototype._anim = function(e) {
    var t = this;
    return this._raf = on(function() {
      var a = t.s, i = +/* @__PURE__ */ new Date();
      if (t._raf) {
        if ((t._currPos - t._endPos) * -e < 4)
          return t._currPos = t._endPos, t._raf = !1, t._isAnimating = 0, t._isScrolling = !1, t._infinite(t._currPos), t._hook("onAnimationEnd", {}), void t._scrollbarContEl.classList.remove("mbsc-scroller-bar-started");
        i - t._lastRaf > 100 && (t._lastRaf = i, t._currPos = xl(t._scrollEl, t._isVertical), a.changeOnEnd || t._infinite(t._currPos)), t._raf = t._anim(e);
      }
    });
  }, n.prototype._infinite = function(e) {
    var t = this.s;
    if (t.itemSize) {
      var a = bt(-e * this._rtlNr / t.itemSize) + this._offset, i = a - this._currIndex;
      i && (t.changeOnEnd ? this._hook("onIndexChange", { index: a, diff: i }) : this.setState({ index: a }));
    }
  }, n.prototype._scroll = function(e, t) {
    var a = this.s, i = a.itemSize, r = this._isVertical, o = this._scrollEl.style, l = mn ? mn + "T" : "t", u = t ? ra + "transform " + bt(t) + "ms " + a.easing : "";
    if (o[l + "ransform"] = "translate3d(" + (r ? "0," + e + "px," : e + "px,0,") + "0)", o[l + "ransition"] = u, this._endPos = e, a.scroll3d) {
      var c = this._scrollEl3d.style, d = 360 / (2 * a.batchSize3d);
      c[l + "ransform"] = "translateY(-50%) rotateX(" + -e / i * d + "deg)", c[l + "ransition"] = u;
    }
    if (this._scrollbarEl) {
      var m = this._scrollbarEl.style, h = this._isInfinite ? (this._maxSnapScroll * this._round - this._delta) / (this._maxSnapScroll * this._round * 2) : (e - this._max) / (this._min - this._max), f = $e((this._barContSize - this._barSize) * h, 0, this._barContSize - this._barSize);
      m[l + "ransform"] = "translate3d(" + (r ? "0," + f + "px," : f + "px,0,") + "0)", m[l + "ransition"] = u;
    }
    t ? (Bs(this._raf), this._isAnimating = t, this._scrollbarContEl.classList.add("mbsc-scroller-bar-started"), this._raf = this._anim(e > this._currPos ? 1 : -1)) : (this._currPos = e, a.changeOnEnd || this._infinite(e));
  }, n.prototype._move = function(e, t) {
    var a = this._currX, i = this._currY, r = this._timestamp, o = this._maxSnapScroll;
    if (e) {
      this._currX = e.endX, this._currY = e.endY, this._timestamp = +/* @__PURE__ */ new Date();
      var l = this._timestamp - r;
      if (l > 0 && l < 100) {
        var u = (this._currX - a) / l, c = (this._currY - i) / l;
        this._velocityX = 0.7 * u + 0.3 * this._velocityX, this._velocityY = 0.7 * c + 0.3 * this._velocityY;
      }
    }
    o && !t && (this._delta = $e(this._delta, -this._round * o, this._round * o)), this._scroll($e(this._startPos + this._delta, this._min - this.s.itemSize, this._max + this.s.itemSize)), this._raf = !1;
  }, n.defaults = { axis: "Y", batchSize: 40, easing: "cubic-bezier(0.190, 1.000, 0.220, 1.000)", mouseSwipe: !0, mousewheel: !0, prevDef: !0, selectedIndex: 0, spaceAround: !0, stopProp: !0, swipe: !0, thresholdX: 10, thresholdY: 5 }, n;
}(it), Ws = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return function(t, a, i) {
      var r;
      return t.itemRenderer && (i = a.visibleItems.map(function(o) {
        return t.itemRenderer(o, a._offset);
      }), t.scroll3d && (r = a.visible3dItems.map(function(o) {
        return t.itemRenderer(o, a._offset, !0);
      }))), _("div", { ref: a._setEl, className: a._cssClass, style: t.styles }, _("div", { ref: a._setInnerEl, className: t.innerClass, style: t.innerStyles }, _("div", { ref: a._setScrollEl, className: "mbsc-scrollview-scroll" + a._rtl }, i)), t.scroll3d && _("div", { ref: a._setScrollEl3d, style: { height: t.itemSize + "px" }, className: "mbsc-scroller-items-3d" }, r), _("div", { ref: a._setScrollbarContEl, className: "mbsc-scroller-bar-cont " + a._rtl + (t.scrollBar && a._barSize !== a._barContSize ? "" : " mbsc-scroller-bar-hidden") + (a._started ? " mbsc-scroller-bar-started" : "") }, _("div", { className: "mbsc-scroller-bar" + a._theme, ref: a._setScrollbarEl, style: { height: a._barSize + "px" } })));
    }(e, this, e.children);
  }, n;
}(Qp), Jp = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return function(t, a) {
      var i;
      if (t.renderItem && t.data !== void 0) {
        var r = t.renderItem(t.data), o = ye(r) ? { __html: r } : void 0;
        i = o ? _("div", { dangerouslySetInnerHTML: o }) : _("div", null, r);
      } else
        i = t.text;
      return _("div", { "aria-disabled": t.disabled ? "true" : void 0, "aria-hidden": i === void 0 || t.is3d ? "true" : void 0, "aria-selected": t.selected ? "true" : void 0, ref: a._setEl, tabIndex: t.active ? 0 : void 0, className: a._cssClass, role: "option", style: a._style, onClick: a._onClick }, t.checkmark && _("span", { className: a._checkmarkClass }), i);
    }(e, this);
  }, n;
}(/* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._onClick = function() {
      var t = e.s;
      t.text === void 0 || t.isGroup || e._hook("onClick", { index: t.index, selected: t.selected, disabled: t.disabled });
    }, e;
  }
  return de(n, s), n.prototype._mounted = function() {
    var e = this;
    this._unlisten = Kt(this._el, { click: !0, keepFocus: !1, onBlur: function() {
      e.setState({ hasFocus: !1 });
    }, onFocus: function() {
      e.setState({ hasFocus: !0 });
    }, onHoverIn: function() {
      e.s.text !== void 0 && e.setState({ hasHover: !0 });
    }, onHoverOut: function() {
      e.s.text !== void 0 && e.setState({ hasHover: !1 });
    }, onKeyDown: function(t) {
      (t.keyCode === 32 || !e.s.multiple && t.keyCode === 13) && e._onClick();
    }, onPress: function() {
      e.s.text !== void 0 && e.setState({ isActive: !0 });
    }, onRelease: function() {
      e.s.text !== void 0 && e.setState({ isActive: !1 });
    } });
  }, n.prototype._destroy = function() {
    this._unlisten();
  }, n.prototype._render = function(e, t) {
    var a = e.height;
    this._cssClass = "mbsc-scroller-wheel-" + (e.isGroup ? "header" : "item") + this._theme + this._rtl + (e.checkmark && !e.isGroup ? " mbsc-wheel-item-checkmark" : "") + (e.is3d ? " mbsc-scroller-wheel-item-3d" : "") + (e.scroll3d && !e.is3d ? " mbsc-scroller-wheel-item-2d" : "") + (e.selected && !e.is3d ? " mbsc-selected" : "") + (e.selected && e.is3d ? " mbsc-selected-3d" : "") + (e.disabled ? " mbsc-disabled" : "") + (e.multiple && !e.isGroup ? " mbsc-wheel-item-multi" : "") + (t.hasHover ? " mbsc-hover" : "") + (t.hasFocus ? " mbsc-focus" : "") + (t.isActive ? " mbsc-active" : ""), this._style = { height: a + "px", lineHeight: a + "px" }, this._checkmarkClass = this._theme + this._rtl + " mbsc-wheel-checkmark" + (e.selected ? " mbsc-selected" : ""), e.is3d && (this._transform = "rotateX(" + (e.offset - e.index) * e.angle3d % 360 + "deg) translateZ(" + a * e.rows / 2 + "px)", this._style[ra + "transform"] = this._transform);
  }, n;
}(it)), Zp = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return function(t, a) {
      var i, r = ((i = {}).onKeyDown = a._onKeyDown, i);
      return _("div", K({ "aria-multiselectable": t.multiple ? "true" : void 0, className: "mbsc-scroller-wheel-wrapper mbsc-scroller-wheel-wrapper-" + t.wheel._key + " " + (t.wheel.cssClass || "") + (t.scroll3d ? " mbsc-scroller-wheel-wrapper-3d" : "") + a._theme + a._rtl, ref: a._setEl, role: "listbox", style: a._wheelStyle }, r), _(Ws, { batchSize3d: a._batchSize3d, className: "mbsc-scroller-wheel" + (t.scroll3d ? " mbsc-scroller-wheel-3d" : "") + a._theme, innerClass: "mbsc-scroller-wheel-cont mbsc-scroller-wheel-cont-" + t.display + (t.scroll3d ? " mbsc-scroller-wheel-cont-3d" : "") + (t.multiple ? " mbsc-scroller-wheel-multi" : "") + a._theme, innerStyles: a._innerStyle, items: a._items, itemSize: t.itemHeight, itemRenderer: function(o, l, u) {
        if (o !== void 0) {
          var c = a._getText(o.data);
          return _(Jp, { active: a._isActive(o, c, u), angle3d: a._angle3d, data: o.data, disabled: a._isDisabled(o.data), height: t.itemHeight, index: o.key, is3d: u, isGroup: o.data && o.data.isGroup, key: o.key, multiple: t.multiple, onClick: a._onItemClick, offset: l, checkmark: t.wheel.checkmark, renderItem: t.renderItem, rows: t.rows, rtl: t.rtl, scroll3d: t.scroll3d, selected: a._isSelected(o), text: c, theme: t.theme });
        }
        return null;
      }, itemNr: a._itemNr, margin: !0, maxIndex: t.maxIndex, minIndex: t.minIndex, onIndexChange: a._onIndexChange, offset: t.wheel._offset, rtl: t.rtl, scroll3d: t.scroll3d, scrollBar: !a._touchUi, selectedIndex: t.selectedIndex, snap: !0, spaceAround: t.wheel.spaceAround, styles: a._style, visibleSize: t.rows }));
    }(e, this);
  }, n;
}(/* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._onIndexChange = function(t) {
      t.wheel = e.s.wheel, e._hook("onIndexChange", t);
    }, e._onItemClick = function(t) {
      e._hook("onIndexChange", { click: !0, index: t.index, wheel: e.s.wheel, selected: t.selected });
    }, e._onKeyDown = function(t) {
      var a = 0;
      t.keyCode === 38 ? a = -1 : t.keyCode === 40 && (a = 1);
      var i = e.s, r = i.activeIndex + a, o = !(r < i.minIndex || r > i.maxIndex);
      if (a && t.preventDefault(), a && o) {
        var l = i.selectOnScroll ? "onIndexChange" : "onActiveChange";
        e._shouldFocus = !0, e._hook(l, { diff: a, index: r, wheel: i.wheel });
      } else
        t.keyCode === 13 && i.multiple && e._hook("onSet", {});
    }, e;
  }
  return de(n, s), n.prototype._getText = function(e) {
    return e !== void 0 ? e.display !== void 0 ? e.display : e : void 0;
  }, n.prototype._getValue = function(e) {
    return e && (e.value !== void 0 ? e.value : e.display !== void 0 ? e.display : e);
  }, n.prototype._isActive = function(e, t, a) {
    var i = this.s, r = i.scroll3d && i.multiple ? a : !a;
    return i.activeIndex === e.key && t && r;
  }, n.prototype._isSelected = function(e) {
    var t = this.s, a = t.selectedValues, i = this._getValue(e.data);
    return t.multiple ? !(!a || !a.indexOf) && a.indexOf(i) >= 0 : t.selectOnScroll ? e.key === t.selectedIndex : i !== void 0 && i === a;
  }, n.prototype._isDisabled = function(e) {
    var t = this.s.disabled, a = e && e.disabled, i = this._getValue(e);
    return !!(a || t && t.get(i));
  }, n.prototype._render = function(e) {
    var t = e.rows, a = e.itemHeight, i = e.wheel._key, r = 2 * bt((a - 0.03 * (a * t / 2 + 3)) / 2);
    this._items = e.wheel.getItem || e.wheel.data || [], this._batchSize3d = bt(1.8 * t), this._angle3d = 360 / (2 * this._batchSize3d), this._style = { height: 2 * bt(t * a * (e.scroll3d ? 1.1 : 1) / 2) + "px" }, this._itemNr = e.wheel.spaceAround ? 1 : t, this._innerStyle = { height: (e.scroll3d ? r : e.wheel.spaceAround ? a : a * t) + "px" }, this._wheelStyle = e.wheelWidth ? { width: (at(e.wheelWidth) ? e.wheelWidth[i] : e.wheelWidth) + "px" } : { maxWidth: (at(e.maxWheelWidth) ? e.maxWheelWidth[i] : e.maxWheelWidth) + "px", minWidth: (at(e.minWheelWidth) ? e.minWheelWidth[i] : e.minWheelWidth) + "px" }, e.scroll3d && (this._innerStyle[ra + "transform"] = "translateY(-50%) translateZ(" + (a * t / 2 + 3) + "px");
  }, n.prototype._updated = function() {
    if (this._shouldFocus) {
      var e = this._el.querySelector('[tabindex="0"]');
      e && setTimeout(function() {
        e.focus();
      }), this._shouldFocus = !1;
    }
  }, n;
}(it)), dn = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return function(t, a, i) {
      var r = a.props, o = r.ariaLabel;
      r.children, r.className, r.color;
      var l = r.endIcon;
      r.endIconSrc;
      var u = r.endIconSvg;
      r.hasChildren;
      var c = r.icon;
      r.iconSrc;
      var d = r.iconSvg;
      r.ripple, r.rtl;
      var m = r.role, h = r.startIcon;
      r.startIconSrc;
      var f = r.startIconSvg;
      r.tag, r.tabIndex, r.theme, r.themeVariant, r.variant;
      var p = Bn(r, ["ariaLabel", "children", "className", "color", "endIcon", "endIconSrc", "endIconSvg", "hasChildren", "icon", "iconSrc", "iconSvg", "ripple", "rtl", "role", "startIcon", "startIconSrc", "startIconSvg", "tag", "tabIndex", "theme", "themeVariant", "variant"]), g = K({ "aria-label": o, className: a._cssClass, ref: a._setEl }, p), v = _(ut, null, a._isIconOnly && _(tn, { className: a._iconClass, name: c, svg: d, theme: t.theme }), a._hasStartIcon && _(tn, { className: a._startIconClass, name: h, svg: f, theme: t.theme }), i, a._hasEndIcon && _(tn, { className: a._endIconClass, name: l, svg: u, theme: t.theme }));
      return t.tag === "span" ? _("span", K({ role: m, "aria-disabled": t.disabled, tabIndex: a._tabIndex }, g), v) : t.tag === "a" ? _("a", K({ "aria-disabled": t.disabled, tabIndex: a._tabIndex }, g), v) : _("button", K({ role: m, tabIndex: a._tabIndex }, g), v);
    }(e, this, e.children);
  }, n;
}(/* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._mounted = function() {
    var e = this;
    this._unlisten = Kt(this._el, { click: !0, onBlur: function() {
      e.setState({ hasFocus: !1 });
    }, onFocus: function() {
      e.setState({ hasFocus: !0 });
    }, onHoverIn: function() {
      e.s.disabled || e.setState({ hasHover: !0 });
    }, onHoverOut: function() {
      e.setState({ hasHover: !1 });
    }, onKeyDown: function(t) {
      switch (t.keyCode) {
        case 13:
        case 32:
          e._el.click(), t.preventDefault();
      }
    }, onPress: function() {
      e.setState({ isActive: !0 });
    }, onRelease: function() {
      e.setState({ isActive: !1 });
    }, onStart: function() {
      return { ripple: e.s.ripple && !e.s.disabled };
    } });
  }, n.prototype._render = function(e, t) {
    var a = this, i = e.disabled;
    this._isIconOnly = !(!e.icon && !e.iconSvg), this._hasStartIcon = !(!e.startIcon && !e.startIconSvg), this._hasEndIcon = !(!e.endIcon && !e.endIconSvg), this._tabIndex = i ? void 0 : e.tabIndex || 0, this._cssClass = this._className + " mbsc-reset mbsc-font mbsc-button" + this._theme + this._rtl + " mbsc-button-" + e.variant + (this._isIconOnly ? " mbsc-icon-button" : "") + (i ? " mbsc-disabled" : "") + (e.color ? " mbsc-button-" + e.color : "") + (t.hasFocus && !i ? " mbsc-focus" : "") + (t.isActive && !i ? " mbsc-active" : "") + (t.hasHover && !i ? " mbsc-hover" : ""), this._iconClass = "mbsc-button-icon" + this._rtl, this._startIconClass = this._iconClass + " mbsc-button-icon-start", this._endIconClass = this._iconClass + " mbsc-button-icon-end", e.disabled && t.hasHover && setTimeout(function() {
      a.setState({ hasHover: !1 });
    });
  }, n.prototype._destroy = function() {
    this._unlisten && this._unlisten();
  }, n.defaults = { ripple: !1, role: "button", tag: "button", variant: "standard" }, n._name = "Button", n;
}(it)), ef = { before: function(s, n) {
  n.tag = s.nodeName.toLowerCase();
}, hasChildren: !0, parentClass: "mbsc-button", readProps: ["disabled"], slots: { endIcon: "end-icon", icon: "icon", startIcon: "start-icon" } };
function tf(s) {
  return this.getChildContext = function() {
    return s.context;
  }, s.children;
}
function nf(s) {
  var n = this, e = s._container;
  n.componentWillUnmount = function() {
    Es(null, n._temp), n._temp = null, n._container = null;
  }, n._container && n._container !== e && n.componentWillUnmount(), s._vnode ? (n._temp || (n._container = e, n._temp = { nodeType: 1, parentNode: e, childNodes: [], appendChild: function(t) {
    this.childNodes.push(t), n._container.appendChild(t);
  }, insertBefore: function(t, a) {
    this.childNodes.push(t), n._container.appendChild(t);
  }, removeChild: function(t) {
    this.childNodes.splice(this.childNodes.indexOf(t) >>> 1, 1), n._container.removeChild(t);
  } }), Es(_(tf, { context: n.context }, s._vnode), n._temp)) : n._temp && n.componentWillUnmount();
}
function sf(s, n) {
  return _(nf, { _vnode: s, _container: n });
}
var af = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype.render = function() {
    var e = this.props.context;
    return e ? sf(this.props.children, e) : null;
  }, n;
}(ws), rf = af, va = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e, t) {
    return function(a, i, r, o) {
      var l, u, c = r._hb, d = r._rtl, m = r._theme, h = a.display, f = ((l = {}).onKeyDown = r._onKeyDown, l), p = ((u = {}).onAnimationEnd = r._onAnimationEnd, u);
      return r._isModal ? r._isVisible ? _(rf, { context: r._ctx }, _("div", K({ className: "mbsc-font mbsc-flex mbsc-popup-wrapper mbsc-popup-wrapper-" + h + m + d + " " + r._className + (a.fullScreen ? " mbsc-popup-wrapper-" + h + "-full" : "") + (r._touchUi ? "" : " mbsc-popup-pointer") + (r._round ? " mbsc-popup-round" : "") + (r._hasContext ? " mbsc-popup-wrapper-ctx" : "") + (i.isReady ? "" : " mbsc-popup-hidden"), ref: r._setWrapper }, f), a.showOverlay && _("div", { className: "mbsc-popup-overlay mbsc-popup-overlay-" + h + m + (r._isClosing ? " mbsc-popup-overlay-out" : "") + (r._isOpening && i.isReady ? " mbsc-popup-overlay-in" : ""), onClick: r._onOverlayClick }), _("div", { className: "mbsc-popup-limits mbsc-popup-limits-" + h, ref: r._setLimitator, style: r._limits }), _("div", K({ className: "mbsc-flex-col mbsc-popup mbsc-popup-" + h + m + c + (a.fullScreen ? "-full" : "") + (i.bubblePos && i.showArrow && h === "anchored" ? " mbsc-popup-anchored-" + i.bubblePos : "") + (r._isClosing ? " mbsc-popup-" + r._animation + "-out" : "") + (r._isOpening && i.isReady ? " mbsc-popup-" + r._animation + "-in" : ""), role: "dialog", "aria-modal": "true", ref: r._setPopup, style: r._style, onClick: r._onPopupClick }, p), h === "anchored" && i.showArrow && _("div", { className: "mbsc-popup-arrow-wrapper mbsc-popup-arrow-wrapper-" + i.bubblePos + m }, _("div", { className: "mbsc-popup-arrow mbsc-popup-arrow-" + i.bubblePos + m, style: i.arrowPos })), _("div", { className: "mbsc-popup-focus", tabIndex: -1, ref: r._setActive }), _("div", { className: "mbsc-flex-col mbsc-flex-1-1 mbsc-popup-body mbsc-popup-body-" + h + m + c + (a.fullScreen ? " mbsc-popup-body-" + h + "-full" : "") + (r._round ? " mbsc-popup-body-round" : "") }, r._headerText && _("div", { className: "mbsc-flex-none mbsc-popup-header mbsc-popup-header-" + h + m + c + (r._buttons ? "" : " mbsc-popup-header-no-buttons"), dangerouslySetInnerHTML: r._headerText, "v-html": void 0 }), _("div", { className: "mbsc-flex-1-1 mbsc-popup-content" + (a.contentPadding ? " mbsc-popup-padding" : ""), ref: r._setContent }, o), r._buttons && _("div", { className: "mbsc-flex-none mbsc-popup-buttons mbsc-popup-buttons-" + h + m + d + c + (r._flexButtons ? " mbsc-flex" : "") + (a.fullScreen ? " mbsc-popup-buttons-" + h + "-full" : "") }, r._buttons.map(function(g, v) {
        return _(dn, { color: g.color, className: "mbsc-popup-button mbsc-popup-button-" + h + d + c + (r._flexButtons ? " mbsc-popup-button-flex" : "") + " " + (g.cssClass || ""), icon: g.icon, disabled: g.disabled, key: v, theme: a.theme, themeVariant: a.themeVariant, variant: g.variant || a.buttonVariant, onClick: g.handler }, g.text);
      })))))) : null : _(ut, null, o);
    }(e, t, this, e.children);
  }, n;
}(qp), of = { before: function(s, n) {
  var e, t, a = this;
  n.onOpen && (e = n.onOpen), n.onClosed && (t = n.onClosed);
  var i = vn(s), r = i && i.createComment("popup");
  r && s.parentNode && s.parentNode.insertBefore(r, s), s.style.display = "none", n.onOpen = function(o, l) {
    s.style.display = "", o.target.querySelector(".mbsc-popup-content").appendChild(s), e && e.call(a, o, l);
  }, n.onClosed = function(o, l) {
    s.style.display = "none", r && r.parentNode && r.parentNode.insertBefore(s, r), t && t.call(a, o, l);
  };
} };
function lf(s, n, e) {
  var t = n.inputComponent, a = K({ defaultValue: s._value && s._valueText || "", placeholder: n.placeholder, ref: s._setInput }, n.inputProps);
  n.inputComponent || (t = yo, a = K({ "aria-expanded": !!s._isOpen, "aria-haspopup": "dialog", "aria-label": n.ariaLabel, disabled: n.disabled, dropdown: n.dropdown, endIcon: n.endIcon, endIconSrc: n.endIconSrc, endIconSvg: n.endIconSvg, error: n.error, errorMessage: n.errorMessage, inputStyle: n.inputStyle, label: n.label, labelStyle: n.labelStyle, name: n.name, pickerMap: n.valueMap, pickerValue: s._value, placeholder: n.placeholder, role: "combobox", rtl: n.rtl, startIcon: n.startIcon, startIconSrc: n.startIconSrc, startIconSvg: n.startIconSvg, tags: n.tagInput === void 0 ? n.selectMultiple : n.tagInput, theme: n.theme, themeVariant: n.themeVariant }, a));
  var i = _(t, a);
  return _(ut, null, s._showInput && i, _(va, { activeElm: n.activeElm, anchor: s._anchor, anchorAlign: s._anchorAlign, animation: n.animation, buttons: s._buttons, cancelText: n.cancelText, closeOnEsc: n.closeOnEsc, closeOnOverlayClick: n.closeOnOverlayClick, closeOnScroll: n.closeOnScroll, closeText: n.closeText, contentPadding: !1, context: n.context, cssClass: s._cssClass, disableLeftRight: !0, display: n.display, focusElm: s._focusElm, focusOnClose: n.focusOnClose, focusOnOpen: !s._allowTyping, focusTrap: n.focusTrap, fullScreen: n.fullScreen, headerText: s._headerText, height: n.height, isOpen: s._isOpen, maxHeight: n.maxHeight, maxWidth: s._maxWidth, onClose: s._onPopupClose, onClosed: s._onPopupClosed, onKeyDown: s._onPopupKey, onOpen: s._onPopupOpen, onResize: s._onResize, setText: n.setText, showArrow: n.showArrow, showOverlay: !s._allowTyping && n.showOverlay, ref: s._setPopup, rtl: n.rtl, scrollLock: s._scrollLock, theme: n.theme, themeVariant: n.themeVariant, touchUi: s._touchUi, windowWidth: s.state.width, width: n.width }, e));
}
var cf = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return lf(this, e, function(t, a) {
      var i = t.renderPreContent ? t.renderPreContent(t.preContentData) : "", r = t.renderInContent ? t.renderInContent(t.preContentData) : "";
      return _(ut, null, i, _("div", { className: "mbsc-scroller mbsc-scroller-" + a._displayStyle + a._theme + a._rtl + (a._touchUi ? " mbsc-scroller-touch" : " mbsc-scroller-pointer") + (t.display === "inline" ? " mbsc-font " : " ") + a._className }, r, a._wheels.map(function(o, l) {
        return _("div", { key: l, className: "mbsc-scroller-wheel-group-cont" + (t.scroll3d ? " mbsc-scroller-wheel-group-cont-3d" : "") + a._theme }, t.selectOnScroll && _("div", { className: "mbsc-scroller-wheel-line" + a._theme, style: a._lineStyle }), _("div", { className: "mbsc-flex mbsc-scroller-wheel-group" + (t.scroll3d ? " mbsc-scroller-wheel-group-3d" : "") + a._theme }, _("div", { className: "mbsc-scroller-wheel-overlay mbsc-scroller-wheel-overlay-" + a._displayStyle + a._theme, style: a._overlayStyle }), o.map(function(u, c) {
          return _(Zp, { activeIndex: a._activeIndexes[u._key], disabled: a._disabled && a._disabled[u._key], display: a._displayStyle, key: c, itemHeight: t.itemHeight, onActiveChange: a._onActiveChange, onIndexChange: a._onWheelIndexChange, onSet: a._onSet, maxIndex: u.max, maxWheelWidth: t.maxWheelWidth, minIndex: u.min, minWheelWidth: t.minWheelWidth, multiple: u.multiple, renderItem: t.renderItem, rows: a._rows, scroll3d: a._scroll3d, selectedIndex: a._indexes[u._key], selectedValues: a._tempValueRep[u._key], selectOnScroll: t.selectOnScroll, theme: t.theme, touchUi: t.touchUi, rtl: t.rtl, wheel: u, wheelWidth: t.wheelWidth });
        })));
      })));
    }(e, this));
  }, n;
}(Kp), df = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._options = [], e._selectMap = /* @__PURE__ */ new Map(), e._onFilterChange = function(t) {
      var a = t.target.value;
      clearTimeout(e._debounce), e._filterInput.value = a, e._debounce = setTimeout(function() {
        e._filter(a);
      }, 300);
    }, e._onFilterClear = function() {
      var t = e._filterInput;
      t && (t.value = ""), e._filter("");
    }, e._onResize = function(t) {
      e.setState({ width: t.windowWidth });
    }, e._onChange = function(t) {
      var a = t.value;
      e._parsedValue = a, e._saveSelected(a), e._change(a), e._hook("onChange", t);
    }, e._onClose = function(t) {
      e._hook("onClose", t), e._filterText && setTimeout(function() {
        return e._onFilterClear();
      }, 100);
    }, e._onWheelMove = function(t) {
      var a = t.wheelIndex, i = t.selection, r = t.dataItem;
      if (!e._selectOnScroll && !i && a === 1) {
        var o = za(e._options, function(l) {
          return l.value === r.value;
        });
        return [r.isGroup ? r.value : o.group];
      }
    }, e._shouldValidate = function(t, a) {
      var i = t.selectMultiple !== a.selectMultiple || !t.filter && t.data !== a.data || e._groupChanged;
      return e._groupChanged = !1, i;
    }, e._writeValue = function(t, a, i) {
      var r = t.value;
      if (t.value = a, e._isSelect) {
        at(i) || (i = [i]);
        for (var o = e.s.selectElement, l = o.options, u = !1, c = 0; c < l.length; c++) {
          var d = l[c], m = d.selected;
          d.selected = i.indexOf(d.value) > -1, m !== d.selected && (u = !0);
        }
        return u && dr(o, Un), u;
      }
      return r !== a;
    }, e._format = function(t) {
      var a = t[e.s.showGroupWheel ? 1 : 0], i = e.s.selectMultiple ? a : [a];
      return (i.map && i.map(function(r) {
        if (e._map)
          return e._map.get(r);
      }) || []).join(", ");
    }, e._parse = function(t) {
      var a, i = e._map, r = e._reMap, o = e.s.selectMultiple, l = e.s.defaultSelection, u = o ? l ? l.length !== void 0 ? l : l.slice() : [] : l !== void 0 ? l : null;
      if (e._parsedValue = t, i)
        if (o && !Dt(t)) {
          var c = [];
          if (t.length === void 0)
            c.push(t);
          else if (ye(t))
            for (var d = 0, m = t.split(", "); d < m.length; d++) {
              var h = m[d], f = r.get(h);
              f !== void 0 && c.push(f);
            }
          else
            for (var p = 0, g = t; p < g.length; p++) {
              var v = g[p];
              i.has(v) && c.push(v);
            }
          a = c;
        } else
          i.has(t) ? a = t : ye(t) && r.has(t) && (a = r.get(t));
      if (a === void 0 && (a = u), e.s.showGroupWheel) {
        var y = o ? a[0] : a, b = za(e._options, function(D) {
          return D.value === y;
        });
        return [b && b.group, a];
      }
      return [a];
    }, e._get = function(t) {
      var a = t[e.s.showGroupWheel ? 1 : 0];
      return e.s.selectMultiple ? a || [] : a;
    }, e._valueEquals = function(t, a) {
      return e.s.selectMultiple ? bp(t || [], a || []) : t === a;
    }, e._validate = function(t) {
      var a = t.values, i = t.direction, r = t.wheels, o = t.index, l = e._disabled, u = e._selectOnScroll, c = e.s.selectMultiple, d = e.s.showGroupWheel, m = d ? [e._disabledGroups, l] : [l], h = d ? 1 : 0, f = e._get(a), p = { disabled: m };
      if (o === h || o === void 0)
        if (c) {
          var g = [];
          f.forEach(function(N) {
            l.get(N) || g.push(N);
          }), p.valid = e._parse(g), o !== void 0 && (p.valid[0] = a[0]);
        } else {
          if (Dt(f) && !u)
            return p.valid = d ? [null, null] : [null], p;
          var v = Ui(r[h], a[h], l, i);
          if (d) {
            var y = za(e._options, function(N) {
              return N.value === v;
            });
            p.valid = [y.group, v];
          } else
            p.valid = [v];
        }
      else {
        var b = Ui(r[0], a[0], m[0], i), D = za(e._options, function(N) {
          return !(N.group !== b || u && l.get(N.value));
        }), w = e._touchUi || D.group === void 0 ? D.value : D.group;
        if (u)
          p.valid = [b, w];
        else {
          p.valid = [b, a[1]];
          var C = c ? [w] : w, T = e._touchUi ? b : void 0;
          p.indexes = [T, C];
        }
      }
      return p;
    }, e._setScroller = function(t) {
      e._scroller = t;
    }, e._setInput = function(t) {
      e._filterInput = t && t.nativeElement;
    }, e._saveSelected = function(t) {
      if (e.s.selectMultiple) {
        var a = /* @__PURE__ */ new Map();
        Ft(t, function(i) {
          var r = e._map.get(i);
          a.set(i, r);
        }), e._selectMap = a;
      }
    }, e;
  }
  return de(n, s), n.prototype._change = function(e) {
  }, n.prototype.reloadOptionElements = function() {
    var e = this;
    this._optionsReloaded = !0, this._setOptionsFromElm(), setTimeout(function() {
      e.forceUpdate();
    });
  }, n.prototype.setVal = function(e) {
    this._proxy("setVal", [e]);
  }, n.prototype.getVal = function() {
    return Dt(this._parsedValue) ? this._parsedValue : this._proxy("getVal");
  }, n.prototype.setTempVal = function(e) {
    this._proxy("setTempVal", [e]);
  }, n.prototype.getTempVal = function() {
    return this._proxy("getTempVal");
  }, n.prototype.open = function() {
    this._proxy("open");
  }, n.prototype.close = function() {
    this._proxy("close");
  }, n.prototype._render = function(e) {
    var t = this._prevS, a = this._touchUi && (!e.selectMultiple || (e.baseTheme || e.theme) === "ios"), i = this._touchUi && !e.selectMultiple, r = e.element !== t.element || e.selectElement !== t.selectElement, o = e.data !== t.data, l = o || this._optionsReloaded, u = e.placeholder, c = e.display !== t.display || u !== t.placeholder || i !== this._selectOnScroll, d = l || r || e.invalid !== t.invalid || this._selectOnScroll !== i;
    if (this._selectOnScroll = i, e.showGroupWheel !== t.showGroupWheel && (this._groupChanged = !0), (r || c) && (this._isSelect = e.selectElement !== void 0, this._isSelect ? this._setOptionsFromElm() : e.element || (this._options = [])), (o || c) && e.data && this._createOptionList(e.data), d && (this._disabled = function(g, v) {
      var y = /* @__PURE__ */ new Map();
      return g && g.forEach(function(b) {
        b.disabled && y.set(b.value, !0);
      }), v && v.forEach(function(b) {
        y.set(b, !0);
      }), y;
    }(this._options, e.invalid), this._disabledGroups = function(g, v) {
      var y = /* @__PURE__ */ new Map();
      return v && v.forEach(function(b) {
        var D = b.group, w = b.value;
        D && (y.has(D) || y.set(D, !0), g.get(w) || y.set(D, !1));
      }), y;
    }(this._disabled, i ? this._options : void 0)), (d || a !== this._spaceAround || this._groupChanged || e.filter !== t.filter || e.selectMultiple !== t.selectMultiple) && this._createWheels(this._filterText, a), l || e.filter !== t.filter || e.touchUi !== t.touchUi || e.rows !== t.rows) {
      var m = e.filter ? 1 / 0 : this._wheels[0][e.showGroupWheel ? 1 : 0].data.length, h = (this._respProps || {}).rows, f = this.props.rows, p = this._touchUi ? e.rows : Math.min(h || f || 7, m);
      this._rows = f || p;
    }
    (this._groupChanged || e.wheelWidth !== t.wheelWidth || e.filter !== t.filter) && (this._wheelWidth = e.wheelWidth || (e.filter ? e.showGroupWheel ? [150, 250] : 400 : void 0)), this._spaceAround = a, this._optionsReloaded = !1;
  }, n.prototype._createOptionList = function(e) {
    var t = this.s, a = t.placeholder, i = [], r = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
    this._selectMap.forEach(function(c, d) {
      r.set(d, c);
    });
    var l = !1, u = function(c, d) {
      c && c.value !== void 0 || (c = { text: c, value: c }), Dt(c.value) && (l = !0), t.showGroupWheel && c.group === void 0 && (c.group = "group_0"), r.set(c.value, c.text), o.set(c.text, c.value), i.splice(d, 0, c);
    };
    e.forEach(u), t.display === "inline" && this._selectOnScroll && a && !l && u({ value: "", text: a }, 0), this._map = r, this._reMap = o, this._options = i;
  }, n.prototype._proxy = function(e, t) {
    var a = this._inst || this._scroller;
    if (a)
      return a[e].apply(a, t);
  }, n.prototype._createWheels = function(e, t) {
    var a = this, i = this.s, r = i.selectMultiple, o = i.filter && e ? function(f, p) {
      if (!p)
        return f;
      var g = p.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), v = new RegExp(g, "i");
      return f.filter(function(y) {
        return v.test(y.text);
      });
    }(this._options, e) : this._options, l = [], u = [], c = /* @__PURE__ */ new Map();
    o.forEach(function(f) {
      var p = f.group, g = p && p !== "group_0" ? p : "", v = c.get(g), y = { display: f.text, value: f.value, data: f, disabled: a._disabled.get(f.value) };
      v ? v.push(y) : c.set(g, [y]);
    });
    var d = c.get("");
    d && (l.push.apply(l, d), this._selectOnScroll && u.push({ display: "", value: "group_0" })), c.forEach(function(f, p) {
      p && (l.push({ display: p, isGroup: !0, value: p }), l.push.apply(l, f), u.push({ display: p, value: p }), a._disabled.set(p, !0));
    });
    var m = { checkmark: !0, circular: !1, closeOnTap: !r, data: l, multiple: r, spaceAround: t }, h = { checkmark: !1, circular: !1, cssClass: "mbsc-select-group-wheel" + (r ? " mbsc-select-group-wheel-multi" : ""), data: u, multiple: !1, spaceAround: t };
    this._noResults = i.filter && !o.length, this._wheels = i.showGroupWheel ? [[h, m]] : [[m]];
  }, n.prototype._setOptionsFromElm = function() {
    for (var e = this.s.selectElement, t = vn(e), a = e.options, i = [], r = !1, o = !1, l = 0; l < a.length; l++) {
      var u = a[l], c = u.parentElement, d = c.nodeName.toLowerCase() === "optgroup" ? c.label : void 0;
      u.value !== "" ? i.push({ disabled: u.disabled, group: d, text: u.text, value: u.value }) : r = !0, u.defaultSelected && (o = !0);
    }
    !r && t && (e.insertBefore(t.createElement("option"), e.childNodes[0] || null), o || (e.value = "")), this._createOptionList(i);
  }, n.prototype._filter = function(e) {
    this._hook("onFilter", { filterText: e }) !== !1 && (this._filterText = e, this._createWheels(e, this._spaceAround)), this.forceUpdate();
  }, n.defaults = K({}, pd.defaults, { dropdown: !0, filterEmptyText: "No results", filterPlaceholderText: "Search", rows: 5 }), n._name = "Select", n;
}(it);
function uf(s) {
  var n = s.s;
  return _("div", { className: "mbsc-select-filter-cont" + s._theme + s._rtl }, _(yo, { ref: s._setInput, autoComplete: "off", className: "mbsc-select-filter", inputClass: "mbsc-select-filter-input", placeholder: n.filterPlaceholderText, onInput: s._onFilterChange, theme: n.theme, themeVariant: n.themeVariant, rtl: n.rtl, inputStyle: "box" }), s._filterText ? _(tn, { className: "mbsc-select-filter-clear" + s._rtl, onClick: s._onFilterClear, svg: n.clearIcon, theme: n.theme }) : null);
}
function hf(s) {
  return s._noResults ? _("div", { className: "mbsc-select-empty-text mbsc-flex" + s._theme }, s.s.filterEmptyText) : null;
}
var mf = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._filterRenderer = function() {
      return uf(e);
    }, e._filterEmptyRenderer = function() {
      return hf(e);
    }, e;
  }
  return de(n, s), n.prototype._template = function(e) {
    return function(t, a, i, r) {
      return _(cf, { ariaLabel: t.ariaLabel, activeElm: t.filter ? ".mbsc-select-filter-input" : void 0, anchor: t.anchor, animation: t.animation, buttons: t.buttons, cancelText: t.cancelText, circular: t.circular, className: (t.cssClass || "") + (a._noResults ? " mbsc-select-empty" : "") + " mbsc-select-scroller mbsc-select-scroller-" + t.display, clearText: t.clearText, closeOnEsc: t.closeOnEsc, closeOnOverlayClick: t.closeOnOverlayClick, closeText: t.closeText, context: t.context, defaultValue: t.defaultValue, disabled: t.disabled, display: t.display, dropdown: t.dropdown, element: t.element, endIcon: t.endIcon, endIconSrc: t.endIconSrc, endIconSvg: t.endIconSvg, error: t.error, errorMessage: t.errorMessage, focusOnClose: t.focusOnClose, focusOnOpen: t.focusOnOpen, focusTrap: t.focusTrap, formatValue: a._format, getValue: a._get, headerText: t.headerText, height: t.height, inputComponent: t.inputComponent, inputProps: t.inputProps, inputStyle: t.inputStyle, invalid: t.invalid, itemHeight: t.itemHeight, isOpen: t.isOpen, label: t.label, labelStyle: t.labelStyle, maxHeight: t.maxHeight, maxWheelWidth: t.maxWheelWidth, maxWidth: t.maxWidth, minWheelWidth: t.minWheelWidth, modelValue: t.modelValue, name: t.name, onCancel: a._proxyHook, onChange: a._onChange, onClose: a._onClose, onOpen: a._proxyHook, onResize: a._onResize, onTempChange: a._proxyHook, onWheelMove: a._onWheelMove, parseValue: a._parse, placeholder: t.placeholder, ref: a._setScroller, renderInContent: a._filterEmptyRenderer, renderItem: r ? r.item : t.renderItem, renderPreContent: t.filter ? a._filterRenderer : void 0, rows: a._rows, rtl: t.rtl, selectMultiple: t.selectMultiple, selectOnScroll: a._selectOnScroll, setText: t.setText, shouldValidate: a._shouldValidate, showArrow: t.showArrow, showInput: t.showInput, showOnClick: t.showOnClick, showOnFocus: t.showOnFocus, showOverlay: t.showOverlay, startIcon: t.startIcon, startIconSrc: t.startIconSrc, startIconSvg: t.startIconSvg, tagInput: t.tagInput, theme: t.theme, themeVariant: t.themeVariant, touchUi: a._touchUi, validate: a._validate, value: t.value, valueEquality: a._valueEquals, valueMap: a._map, wheelWidth: a._wheelWidth, wheels: a._wheels, width: t.width, writeValue: a._writeValue }, i);
    }(e, this, e.children);
  }, n;
}(df), pf = { before: function(s, n) {
  if (s.nodeName.toLowerCase() === "select") {
    var e = s;
    s.style.display = "none", n.inputElement || n.display === "inline" ? n.element = n.inputElement || s : (n.inputComponent = "input", n.showInput = !0), n.selectElement = e, n.selectMultiple !== void 0 ? e.multiple = n.selectMultiple : n.selectMultiple = e.multiple;
    for (var t = [], a = e.options, i = 0; i < a.length; i++) {
      var r = a[i];
      r.defaultSelected && t.push(r.value);
    }
    t.length && (n.defaultValue = n.selectMultiple ? t : t[0]);
  } else
    n.element = s, n.defaultValue = s.value;
} }, fr = /* @__PURE__ */ go(mf, pf), ff = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n._selector = "[mbsc-button]", n._renderOpt = ef, n;
}(dn), _f = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n._selector = "[mbsc-input]", n._renderOpt = bo, n;
}(yo), Bi = [], la = [], vf = Mt && !!wt.Promise;
function gf(s, n, e, t, a) {
  return K({ closeOnOverlayClick: !1, context: n.context, cssClass: "mbsc-alert", display: n.display || "center", onClose: function() {
    s.shift();
  }, onClosed: function() {
    bf(n, t, a);
  }, theme: n.theme, themeVariant: n.themeVariant }, e);
}
function yf(s, n, e, t) {
  return gf(la, s, { animation: s.animation || (t ? "pop" : void 0), buttons: [], closeOnOverlayClick: !1, contentPadding: t, cssClass: "mbsc-" + (t ? "toast" : "snackbar") + " mbsc-" + (s.color ? s.color : "color-none") + " " + (s.cssClass || ""), display: s.display || "bottom", focusOnClose: !1, focusOnOpen: !1, focusTrap: !1, onOpen: function(a, i) {
    (function(r, o) {
      r.duration !== !1 && setTimeout(function() {
        o.close();
      }, r.duration || 3e3);
    })(s, i);
  }, scrollLock: !1, setActive: !1, showOverlay: !1, touchUi: !0 }, n, e);
}
function bf(s, n, e, t) {
  e && e(t), s.callback && s.callback(t), s.onClose && s.onClose(t), Bi.length ? Bi[0].open() : la.length && la[0].open(), n && n();
}
function Df(s, n, e) {
  return yf(s, n, e, !0);
}
function wf(s) {
  var n = la[0];
  la.push(s), Bi.length || (n ? n.close() : s.open());
}
function xf(s, n) {
  var e;
  return vf ? e = new Promise(function(t) {
    s(n, t);
  }) : s(n, fa), e;
}
function Cf(s, n, e, t, a, i, r) {
  if (Je) {
    var o = Je.createElement("div"), l = e(n, function() {
      setTimeout(function() {
        var u;
        (u = o)._children && Es(null, u);
      });
    }, a, r);
    Es(_(va, K({ onInit: function(u, c) {
      i && i(c), t(c);
    } }, l), s), o);
  }
}
function Sf(s, n) {
  Cf(function(e) {
    return _("div", { className: "mbsc-toast-background mbsc-toast-message" }, e.message || "");
  }(s), s, Df, wf, n);
}
function jt(s) {
  return xf(Sf, s);
}
var _d = dd({}), un = {};
function Tf(s, n) {
  return un[s] || (un[s] = { change: new Fn(), selectedIndex: -1 }), un[s].change.subscribe(n);
}
function Ef(s, n) {
  var e = un[s];
  e && (e.change.unsubscribe(n), e.change.nr || delete un[s]);
}
function vd(s, n, e) {
  var t = un[s];
  t && (e !== void 0 && (t.selectedIndex = e), n !== void 0 && (t.value = n), t.change.next(t.value));
}
function gd(s) {
  return un[s] && un[s].selectedIndex;
}
var kf = 1, Mf = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._id = "mbsc-segmented-group" + kf++, e._onChange = function(t, a) {
      var i = e.s, r = i.modelValue !== void 0 ? i.modelValue : e.value;
      if (i.select === "multiple") {
        if (r !== void 0) {
          var o = (r = r || []).indexOf(a);
          o !== -1 ? r.splice(o, 1) : r.push(a), e.value = r.slice();
        }
      } else
        e.value = a;
      e._change(e.value), i.onChange && i.onChange(t);
    }, e;
  }
  return de(n, s), n.prototype._change = function(e) {
  }, n.prototype._render = function(e) {
    this._name = e.name === void 0 ? this._id : e.name, this._groupClass = "mbsc-segmented mbsc-flex " + this._className + this._theme + this._rtl + (e.color ? " mbsc-segmented-" + e.color : "") + (this.state.dragging ? " mbsc-segmented-dragging" : ""), this._groupOpt = { color: e.color, disabled: e.disabled, name: this._name, onChange: this._onChange, select: e.select, value: e.modelValue !== void 0 ? e.modelValue : e.value };
  }, n.prototype._updated = function() {
    this.s.drag && this.s.select !== "multiple" ? this._unlisten || this._setupDrag() : this._cleanupDrag();
  }, n.prototype._destroy = function() {
    this._cleanupDrag();
  }, n.prototype._setupDrag = function() {
    var e, t, a, i, r, o, l = this, u = [], c = [];
    this._unlisten = Kt(this._el, { onEnd: function() {
      a && i !== r && !u[i] && l._el.querySelectorAll(".mbsc-segmented-input")[i].click(), a = !1, l.setState({ dragging: !1 });
    }, onMove: function(d) {
      if (a) {
        for (var m = Math.min(Math.max(d.endX - t, 0), e), h = 0, f = c[0]; m > f && c.length > h + 1; )
          h++, f += c[h];
        (h = l.s.rtl ? c.length - 1 - h : h) === i || u[h] || vd(o, void 0, i = h);
      }
    }, onStart: function(d) {
      var m = _a(d.domEvent.target, ".mbsc-segmented-item", l._el);
      if (m) {
        var h = m.querySelector(".mbsc-segmented-input");
        h.classList.contains("mbsc-selected") && (u = [], Ft(l._el.querySelectorAll(".mbsc-segmented-button"), function(f) {
          u.push(f.classList.contains("mbsc-disabled"));
        }), c = [], Ft(l._el.querySelectorAll(".mbsc-segmented-item"), function(f) {
          c.push(f.clientWidth);
        }), e = l._el.clientWidth - 30, t = nd(l._el).left + 15, o = h.name, i = gd(o), r = i, c.length && h.type === "radio" && (a = !0, l.setState({ dragging: !0 })));
      }
    } });
  }, n.prototype._cleanupDrag = function() {
    this._unlisten && (this._unlisten(), this._unlisten = null);
  }, n.defaults = { select: "single" }, n._name = "SegmentedGroup", n;
}(it), If = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return _(_d.Provider, { children: (t = this, a = e.children, _("div", { className: t._groupClass, ref: t._setEl }, a)), value: this._groupOpt });
    var t, a;
  }, n;
}(Mf), Nf = 1, Of = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._onChange = function(t) {
      var a = e.s, i = t.target.checked;
      i !== e._checked && (e._change(i), e._onGroupChange && e._onGroupChange(t, e._value), e._toggle(i), a.onChange && a.onChange(t));
    }, e._onValueChange = function(t) {
      var a = e.s, i = e._isMultiple ? at(t) && t.indexOf(e._value) !== -1 : t === e._value;
      a.checked === void 0 && i !== e.state.selected ? e.setState({ selected: i }) : e.forceUpdate(), e._change(i);
    }, e._setBox = function(t) {
      e._box = t;
    }, e;
  }
  return de(n, s), n.prototype._change = function(e) {
  }, n.prototype._groupOptions = function(e) {
    var t = this, a = e.color, i = e.disabled, r = e.name, o = e.onChange, l = e.select, u = e.value, c = this.s, d = this.state, m = this._checked, h = c.modelValue !== void 0 ? c.modelValue === c.value : c.checked, f = h !== void 0 ? Pa(h) : d.selected === void 0 ? Pa(c.defaultChecked) : d.selected;
    this._id = c.id === void 0 ? this._id || "mbsc-segmented-" + Nf++ : c.id, this._value = c.value === void 0 ? this._id : c.value, this._onGroupChange = o, this._isMultiple = (l || c.select) === "multiple", this._name = r === void 0 ? c.name : r, this._disabled = i === void 0 ? c.disabled === void 0 ? d.disabled : Pa(c.disabled) : Pa(i), this._color = a === void 0 ? c.color : a, this._checked = u === void 0 ? f : this._isMultiple ? u && u.indexOf(this._value) !== -1 : u === this._value, this._isMultiple || m || !this._checked || setTimeout(function() {
      t._checked && vd(t._name, t._value, t._index);
    }), this._selectedIndex = gd(this._name), this._cssClass = "mbsc-segmented-item " + this._className + this._theme + this._rtl + (this._checked ? " mbsc-segmented-item-checked" : "") + (d.hasFocus ? " mbsc-focus" : "") + (this._index === this._selectedIndex || this._index === void 0 && this._checked || this._isMultiple && this._checked ? " mbsc-segmented-item-selected" : "");
  }, n.prototype._toggle = function(e) {
    this.s.checked === void 0 && this.setState({ selected: e });
  }, n.prototype._mounted = function() {
    var e = this;
    pe(this._el, Ut, this._onChange), this._unlisten = Kt(this._el, { onBlur: function() {
      e.setState({ hasFocus: !1 });
    }, onFocus: function() {
      e.setState({ hasFocus: !0 });
    } });
  }, n.prototype._updated = function() {
    if (this._name && !this._unsubscribe && (this._unsubscribe = Tf(this._name, this._onValueChange)), !this._isMultiple) {
      var e = _a(this._el, ".mbsc-segmented"), t = -1, a = -1;
      if (e)
        for (var i = e.querySelectorAll('.mbsc-segmented-input[name="' + this._name + '"]'), r = 0; r < i.length; r++)
          i[r] === this._el && (t = r), i[r].checked && (a = r);
      this._index !== t && a !== -1 && function(o, l) {
        un[o] && (un[o].selectedIndex = l);
      }(this._name, a), this._selectedIndex !== -1 && (this._box.style.transform = "translateX(" + (this.s.rtl ? -1 : 1) * (this._selectedIndex - t) * 100 + "%)", this._animate = !0), t !== -1 && (this._index = t);
    }
  }, n.prototype._destroy = function() {
    le(this._el, Ut, this._onChange), this._unsubscribe && (Ef(this._name, this._unsubscribe), this._unsubscribe = void 0), this._unlisten && this._unlisten();
  }, n.defaults = { select: "single" }, n._name = "Segmented", n;
}(it), Lf = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), Object.defineProperty(n.prototype, "checked", { get: function() {
    return this._checked;
  }, set: function(e) {
    this._toggle(e);
  }, enumerable: !0, configurable: !0 }), n.prototype._template = function(e, t) {
    var a = this;
    return _(_d.Consumer, null, function(i) {
      return function(r, o, l, u, c) {
        return l._groupOptions(c), _("label", { className: l._cssClass }, _("input", { ref: l._setEl, "aria-labelledby": l._id, checked: l._checked, className: "mbsc-segmented-input mbsc-reset " + (r.inputClass || "") + l._theme + (l._checked ? " mbsc-selected" : ""), disabled: l._disabled, name: l._isMultiple ? r.name : l._name, onChange: fa, type: l._isMultiple ? "checkbox" : "radio", value: l._value }), _("div", { ref: l._setBox, className: "mbsc-segmented-selectbox" + l._theme + (l._animate ? " mbsc-segmented-selectbox-animate" : "") + (l._checked ? " mbsc-selected" : "") }, _("div", { className: "mbsc-segmented-selectbox-inner" + l._theme + (l._index === l._selectedIndex || l._checked ? " mbsc-segmented-selectbox-inner-visible" : "") + (l._checked ? " mbsc-selected" : "") })), _(dn, { "aria-hidden": !0, ariaLabel: r.ariaLabel, className: "mbsc-segmented-button" + (l._checked ? " mbsc-selected" : "") + (o.hasFocus ? " mbsc-focus" : ""), color: l._color, disabled: l._disabled, endIcon: r.endIcon, endIconSrc: r.endIconSrc, endIconSvg: r.endIconSvg, icon: r.icon, iconSrc: r.iconSrc, iconSvg: r.iconSvg, id: l._id, ripple: r.ripple, rtl: r.rtl, startIcon: r.startIcon, startIconSrc: r.startIconSrc, startIconSvg: r.startIconSvg, tag: "span", tabIndex: -1, theme: r.theme, themeVariant: r.themeVariant }, u));
      }(e, t, a, e.children, i);
    });
  }, n;
}(Of), Af = { hasChildren: !0, parentClass: "mbsc-segmented-button", readAttrs: ["value"], readProps: ["disabled", "name"], renderToParent: !0, before: function(s, n) {
  n.select = s.type === "checkbox" ? "multiple" : "single", n.defaultChecked = s.checked, n.inputClass = s.getAttribute("class") || "";
  var e = s.parentNode, t = e.parentNode;
  if (t.getAttribute("mbsc-segmented-group") === null) {
    var a = Je.createElement("div");
    a.setAttribute("mbsc-segmented-group", ""), t.insertBefore(a, e), a.appendChild(e), Ft(t.querySelectorAll('input[name="' + s.name + '"]'), function(i) {
      a.appendChild(i.parentNode);
    });
  }
} }, Rf = { hasChildren: !0, parentClass: "mbsc-segmented" }, Pf = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n._selector = "[mbsc-segmented]", n._renderOpt = Af, n;
}(Lf), zf = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n._selector = "[mbsc-segmented-group]", n._renderOpt = Rf, n;
}(If), Bt = new Date(1970, 0, 1);
function Vn(s) {
  return !!s._mbsc;
}
function Ua(s, n, e) {
  var t = e || n.dataTimezone || n.displayTimezone, a = n.timezonePlugin;
  if (t && a && Vn(s)) {
    var i = s.clone();
    return i.setTimezone(t), i.toISOString();
  }
  return s;
}
var yd = { amText: "am", dateFormat: "MM/DD/YYYY", dateFormatFull: "DDDD, MMMM D, YYYY", dateFormatLong: "D DDD MMM YYYY", dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"], dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], daySuffix: "", firstDay: 0, fromText: "Start", getDate: wd, monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], monthSuffix: "", pmText: "pm", quarterText: "Q{count}", separator: " ", shortYearCutoff: "+10", timeFormat: "h:mm A", toText: "End", todayText: "Today", weekText: "Week {count}", yearSuffix: "", getMonth: function(s) {
  return s.getMonth();
}, getDay: function(s) {
  return s.getDate();
}, getYear: function(s) {
  return s.getFullYear();
}, getMaxDayOfMonth: function(s, n) {
  return 32 - new Date(s, n, 32, 12).getDate();
}, getWeekNumber: function(s) {
  var n = /* @__PURE__ */ new Date(+s);
  n.setHours(0, 0, 0), n.setDate(n.getDate() + 4 - (n.getDay() || 7));
  var e = new Date(n.getFullYear(), 0, 1);
  return Math.ceil(((n - e) / 864e5 + 1) / 7);
} }, Hf = /^(\d{4}|[+-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[T\s](\d{2}):?(\d{2})(?::?(\d{2})(?:\.(\d{3}))?)?((Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/, bd = /^((\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{3}))?)?(?:(Z)|([+-])(\d{2})(?::?(\d{2}))?)?)?$/;
function zl(s, n, e) {
  var t, a, i = { y: 1, m: 2, d: 3, h: 4, i: 5, s: 6, u: 7, tz: 8 };
  if (e)
    for (var r = 0, o = Object.keys(i); r < o.length; r++)
      (a = s[i[t = o[r]] - n]) && (e[t] = t === "tz" ? a : 1);
}
function nt(s) {
  return +new Date(1970, 0, 1, s.getHours(), s.getMinutes(), s.getSeconds(), s.getMilliseconds()) - +Bt;
}
function ss(s, n, e, t, a) {
  var i = +s, r = +e;
  return i < (a && r === +t ? +t + 1 : +t) && (a && i === +n ? +n + 1 : +n) > r;
}
function Ff(s, n) {
  var e = me(s, n);
  return e.setHours(0, 0, 0, 0), e;
}
function Yf(s, n) {
  var e = me(s, n);
  return e.setHours(23, 59, 59, 999), e;
}
function Xt(s, n, e, t, a) {
  return (!n && !a || s.exclusiveEndDates) && e && t && e < t ? me(n ? void 0 : s, +t - 1) : t;
}
function Pe(s) {
  return s.getFullYear() + "-" + bl(s.getMonth() + 1) + "-" + bl(s.getDate());
}
function Ce(s, n) {
  return Vn(s) && !n ? s.createDate(s.getFullYear(), s.getMonth(), s.getDate()) : wd(s.getFullYear(), s.getMonth(), s.getDate());
}
function Hl(s) {
  return Date.UTC(s.getFullYear(), s.getMonth(), s.getDate());
}
function an(s, n) {
  return bt((Hl(n) - Hl(s)) / 864e5);
}
function Dd(s, n, e, t) {
  for (var a = -1, i = Ce(s); i <= Ce(n); i.setDate(i.getDate() + 1))
    nn(i.getDay(), e, t) && a++;
  return a;
}
function Et(s, n, e) {
  var t = s.getFullYear(), a = s.getMonth(), i = s.getDay(), r = e === void 0 ? n.firstDay : e;
  return new Date(t, a, r - (r - i > 0 ? 7 : 0) - i + s.getDate());
}
function Ke(s, n) {
  return s.getFullYear() === n.getFullYear() && s.getMonth() === n.getMonth() && s.getDate() === n.getDate();
}
function Fl(s, n, e) {
  return e.getYear(s) === e.getYear(n) && e.getMonth(s) === e.getMonth(n);
}
function wd(s, n, e, t, a, i, r) {
  var o = new Date(s, n, e, t || 0, a || 0, i || 0, r || 0);
  return o.getHours() === 23 && (t || 0) === 0 && o.setHours(o.getHours() + 2), o;
}
function xd(s) {
  return s.getTime;
}
function yn(s, n) {
  return me(s, n.getFullYear(), n.getMonth(), n.getDate(), n.getHours(), n.getMinutes(), n.getSeconds(), n.getMilliseconds());
}
function wo(s) {
  return s && new Date(s.getFullYear(), s.getMonth(), s.getDate(), s.getHours(), s.getMinutes(), s.getSeconds(), s.getMilliseconds());
}
function me(s, n, e, t, a, i, r, o) {
  return n === null ? null : n && (Qc(n) || ye(n)) && yl(e) ? ue(n, s) : s && s.timezonePlugin ? s.timezonePlugin.createDate(s, n, e, t, a, i, r, o) : vp(n) ? new Date(n) : yl(n) ? /* @__PURE__ */ new Date() : new Date(n, e || 0, t || 1, a || 0, i || 0, r || 0, o || 0);
}
function ue(s, n, e, t, a) {
  var i;
  if (ye(s) && (s = s.trim()), !s)
    return null;
  var r = n && n.timezonePlugin;
  if (r && !a) {
    var o = Vn(s) ? s : r.parse(s, n);
    return o.setTimezone(n.displayTimezone), o;
  }
  if (xd(s))
    return s;
  if (s._isAMomentObject)
    return s.toDate();
  if (Qc(s))
    return new Date(s);
  i = bd.exec(s);
  var l = n && n.defaultValue, u = ue((at(l) ? l[0] : l) || /* @__PURE__ */ new Date()), c = u.getFullYear(), d = u.getMonth(), m = u.getDate();
  return i ? (zl(i, 2, t), new Date(c, d, m, i[2] ? +i[2] : 0, i[3] ? +i[3] : 0, i[4] ? +i[4] : 0, i[5] ? +i[5] : 0)) : (i = Hf.exec(s)) ? (zl(i, 0, t), new Date(i[1] ? +i[1] : c, i[2] ? i[2] - 1 : d, i[3] ? +i[3] : m, i[4] ? +i[4] : 0, i[5] ? +i[5] : 0, i[6] ? +i[6] : 0, i[7] ? +i[7] : 0)) : Uf(e, s, n);
}
function Xe(s, n, e) {
  var t, a, i = "", r = !1, o = function(m) {
    for (var h = 0, f = t; f + 1 < s.length && s.charAt(f + 1) === m; )
      h++, f++;
    return h;
  }, l = function(m) {
    var h = o(m);
    return t += h, h;
  }, u = function(m, h, f) {
    var p = "" + h;
    if (l(m))
      for (; p.length < f; )
        p = "0" + p;
    return p;
  }, c = function(m, h, f, p) {
    return l(m) === 3 ? p[h] : f[h];
  };
  for (t = 0; t < s.length; t++)
    if (r)
      s.charAt(t) !== "'" || l("'") ? i += s.charAt(t) : r = !1;
    else
      switch (s.charAt(t)) {
        case "D":
          i += o("D") > 1 ? c("D", n.getDay(), e.dayNamesShort, e.dayNames) : u("D", e.getDay(n), 2);
          break;
        case "M":
          i += o("M") > 1 ? c("M", e.getMonth(n), e.monthNamesShort, e.monthNames) : u("M", e.getMonth(n) + 1, 2);
          break;
        case "Y":
          a = e.getYear(n), i += l("Y") === 3 ? a : (a % 100 < 10 ? "0" : "") + a % 100;
          break;
        case "h":
          var d = n.getHours();
          i += u("h", d > 12 ? d - 12 : d === 0 ? 12 : d, 2);
          break;
        case "H":
          i += u("H", n.getHours(), 2);
          break;
        case "m":
          i += u("m", n.getMinutes(), 2);
          break;
        case "s":
          i += u("s", n.getSeconds(), 2);
          break;
        case "a":
          i += n.getHours() > 11 ? e.pmText : e.amText;
          break;
        case "A":
          i += n.getHours() > 11 ? e.pmText.toUpperCase() : e.amText.toUpperCase();
          break;
        case "'":
          l("'") ? i += "'" : r = !0;
          break;
        default:
          i += s.charAt(t);
      }
  return i;
}
function Uf(s, n, e) {
  var t = K({}, yd, e), a = ue(t.defaultValue || /* @__PURE__ */ new Date());
  if (!n)
    return a;
  s || (s = t.dateFormat + t.separator + t.timeFormat);
  var i, r = t.shortYearCutoff, o = t.getYear(a), l = t.getMonth(a) + 1, u = t.getDay(a), c = a.getHours(), d = a.getMinutes(), m = 0, h = -1, f = !1, p = 0, g = function(T) {
    for (var N = 0, O = i; O + 1 < s.length && s.charAt(O + 1) === T; )
      N++, O++;
    return N;
  }, v = function(T) {
    var N = g(T);
    return i += N, N;
  }, y = function(T) {
    var N = v(T), O = new RegExp("^\\d{1," + (N >= 2 ? 4 : 2) + "}"), L = n.substr(p).match(O);
    return L ? (p += L[0].length, parseInt(L[0], 10)) : 0;
  }, b = function(T, N, O) {
    for (var L = v(T) === 3 ? O : N, H = 0; H < L.length; H++)
      if (n.substr(p, L[H].length).toLowerCase() === L[H].toLowerCase())
        return p += L[H].length, H + 1;
    return 0;
  }, D = function() {
    p++;
  };
  for (i = 0; i < s.length; i++)
    if (f)
      s.charAt(i) !== "'" || v("'") ? D() : f = !1;
    else
      switch (s.charAt(i)) {
        case "Y":
          o = y("Y");
          break;
        case "M":
          l = g("M") < 2 ? y("M") : b("M", t.monthNamesShort, t.monthNames);
          break;
        case "D":
          g("D") < 2 ? u = y("D") : b("D", t.dayNamesShort, t.dayNames);
          break;
        case "H":
          c = y("H");
          break;
        case "h":
          c = y("h");
          break;
        case "m":
          d = y("m");
          break;
        case "s":
          m = y("s");
          break;
        case "a":
          h = b("a", [t.amText, t.pmText], [t.amText, t.pmText]) - 1;
          break;
        case "A":
          h = b("A", [t.amText, t.pmText], [t.amText, t.pmText]) - 1;
          break;
        case "'":
          v("'") ? D() : f = !0;
          break;
        default:
          D();
      }
  if (o < 100) {
    var w = void 0;
    w = o <= (ye(r) ? (/* @__PURE__ */ new Date()).getFullYear() % 100 + parseInt(r, 10) : +r) ? 0 : -100, o += (/* @__PURE__ */ new Date()).getFullYear() - (/* @__PURE__ */ new Date()).getFullYear() % 100 + w;
  }
  c = h === -1 ? c : h && c < 12 ? c + 12 : h || c !== 12 ? c : 0;
  var C = t.getDate(o, l - 1, u, c, d, m);
  return t.getYear(C) !== o || t.getMonth(C) + 1 !== l || t.getDay(C) !== u ? a : C;
}
function Cd(s) {
  return Vn(s) ? s.clone() : new Date(s);
}
function ce(s, n) {
  var e = Cd(s);
  return e.setDate(e.getDate() + n), e;
}
function Xn(s, n, e) {
  var t = e.getYear(s), a = e.getMonth(s) + n, i = e.getMaxDayOfMonth(t, a);
  return yn(e, e.getDate(t, a, Math.min(e.getDay(s), i), s.getHours(), s.getMinutes(), s.getSeconds(), s.getMilliseconds()));
}
function nn(s, n, e) {
  return n > e ? s <= e || s >= n : s >= n && s <= e;
}
function Nn(s, n) {
  var e = 6e4 * n, t = Cd(s).setHours(0, 0, 0, 0), a = t + Math.round((+s - +t) / e) * e;
  return Vn(s) ? s.createDate(a) : new Date(a);
}
Mt && typeof Symbol == "undefined" && (window.Symbol = { toPrimitive: "toPrimitive" });
var Bf = { 0: "SU", 1: "MO", 2: "TU", 3: "WE", 4: "TH", 5: "FR", 6: "SA" }, Yl = { SU: 0, MO: 1, TU: 2, WE: 3, TH: 4, FR: 5, SA: 6 }, Vf = { byday: "weekDays", bymonth: "month", bymonthday: "day", bysetpos: "pos", dtstart: "from", freq: "repeat", wkst: "weekStart" };
function Ul(s, n, e, t) {
  var a = ue(n.start, n.allDay ? void 0 : e), i = ue(n.end, n.allDay ? void 0 : e), r = i - a;
  for (t && (n.start = a, n.end = i), a = Ce(a), i = e.exclusiveEndDates ? i : Ce(ce(i, 1)); a < i || !r; )
    Vi(s, a, n), a = ce(a, 1), r = 1;
}
function Vi(s, n, e) {
  var t = Pe(n);
  s[t] || (s[t] = [], s[t].date = Ce(n, !0)), s[t].push(e);
}
function Bl(s, n, e, t, a, i) {
  var r = {};
  if (a)
    for (var o = 0, l = ji(a); o < l.length; o++)
      r[Pe(ue(l[o]))] = !0;
  if (i)
    for (var u = 0, c = Sd(i, s, s, n, e, t); u < c.length; u++)
      r[Pe(c[u].d)] = !0;
  return r;
}
function jf(s) {
  return ye(s) || s.getTime || s.toDate ? s : s.start || s.date;
}
function ca(s, n, e) {
  var t = n.original ? n.original.start : n.start, a = n.allDay || !t, i = s.timezonePlugin, r = n.timezone || s.dataTimezone || s.displayTimezone;
  return i && !a ? { dataTimezone: r, displayTimezone: e ? r : s.displayTimezone, timezonePlugin: i } : void 0;
}
function Wf(s) {
  for (var n = {}, e = 0, t = s.split(";"); e < t.length; e++) {
    var a = t[e].split("="), i = a[0].trim().toLowerCase(), r = a[1].trim();
    n[Vf[i] || i] = r;
  }
  return n;
}
function ji(s) {
  return s ? at(s) ? s : ye(s) ? s.split(",") : [s] : [];
}
function Sd(s, n, e, t, a, i, r, o, l) {
  ye(s) && (s = Wf(s));
  for (var u, c, d = i.getYear, m = i.getMonth, h = i.getDay, f = i.getDate, p = i.getMaxDayOfMonth, g = (s.repeat || "").toLowerCase(), v = s.interval || 1, y = s.count, b = s.from ? ue(s.from) : n || (v !== 1 || y !== void 0 || g === "monthly" || g === "yearly" ? /* @__PURE__ */ new Date() : t), D = Ce(b), w = d(b), C = m(b), T = h(b), N = e ? e.getHours() : 0, O = e ? e.getMinutes() : 0, L = e ? e.getSeconds() : 0, H = s.until ? ue(s.until) : 1 / 0, A = b < t, B = A ? t : Ce(b), I = l === "first", S = l === "last", k = I || S || !a || H < a ? H : a, R = y === void 0 ? 1 / 0 : y, z = (s.weekDays || Bf[b.getDay()]).split(","), W = Yl[(s.weekStart || "MO").trim().toUpperCase()], M = s.day, P = s.month, Y = at(M) ? M.length ? M : [T] : ((M || T) + "").split(","), q = at(P) ? P.length ? P : [C] : ((P || C + 1) + "").split(","), U = [], j = s.pos !== void 0, ee = j ? +s.pos : 1, ne = [], G = a ? Bl(n, t, a, i, r, o) : {}, te = !0, Z = 0, re = 0, fe = null, he = t, oe = 0, Ee = z; oe < Ee.length; oe++) {
    var Ie = Ee[oe];
    ne.push(Yl[Ie.trim().toUpperCase()]);
  }
  var Se = function() {
    if (a || (G = Bl(c, c, ce(c, 1), i, r, o)), !G[Pe(c)] && c >= B)
      if (I)
        fe = !fe || c < fe ? c : fe, te = !1;
      else if (S) {
        var ze = an(he, c);
        he = c > he && ze <= 1 ? c : he, te = ze <= 1;
      } else
        U.push({ d: c, i: re });
    re++;
  }, Ve = function(ze, Te) {
    for (var Ae = [], Ot = 0, ot = ne; Ot < ot.length; Ot++)
      for (var lt = Et(ze, { firstDay: ot[Ot] }); lt < Te; lt.setDate(lt.getDate() + 7))
        lt.getMonth() === ze.getMonth() && Ae.push(+lt);
    Ae.sort();
    var Qt = Ae[ee < 0 ? Ae.length + ee : ee - 1];
    c = Qt ? new Date(Qt) : Te, (c = f(d(c), m(c), h(c), N, O, L)) >= b && (c <= k && re < R ? Qt && Se() : te = !1);
  };
  switch (g) {
    case "daily":
      for (re = y && A ? Le(an(b, t) / v) : 0; te; )
        (c = f(w, C, T + re * v, N, O, L)) <= k && re < R ? Se() : te = !1;
      break;
    case "weekly":
      var je = ne, Ne = Et(b, { firstDay: W }), E = Ne.getDay();
      for (je.sort(function(ze, Te) {
        return (ze = (ze -= E) < 0 ? ze + 7 : ze) - (Te = (Te -= E) < 0 ? Te + 7 : Te);
      }); te; ) {
        for (var F = 0, V = je; F < V.length; F++)
          u = ce(Ne, (Ie = V[F]) < W ? Ie - W + 7 : Ie - W), (c = f(d(u), m(u), h(u) + 7 * Z * v, N, O, L)) <= k && re < R ? c >= D && Se() : te = !1;
        Z++;
      }
      break;
    case "monthly":
      for (; te; ) {
        var J = p(w, C + Z * v);
        if (j)
          Ve(f(w, C + Z * v, 1), f(w, C + Z * v + 1, 1));
        else
          for (var ie = 0, _e = Y; ie < _e.length; ie++) {
            var ve = _e[ie];
            (c = f(w, C + Z * v, (ke = +ve) < 0 ? J + ke + 1 : ke, N, O, L)) <= k && re < R ? J >= ke && c >= D && Se() : te = !1;
          }
        Z++;
      }
      break;
    case "yearly":
      for (; te; ) {
        for (var Oe = 0, we = q; Oe < we.length; Oe++) {
          var Ue = +we[Oe];
          if (J = p(w + Z * v, Ue - 1), j)
            Ve(f(w + Z * v, Ue - 1, 1), f(w + Z * v, Ue, 1));
          else
            for (var et = 0, Be = Y; et < Be.length; et++) {
              var ke;
              ve = Be[et], (c = f(w + Z * v, Ue - 1, (ke = +ve) < 0 ? J + ke + 1 : ke, N, O, L)) <= k && re < R ? J >= ke && c >= D && Se() : te = !1;
            }
        }
        Z++;
      }
  }
  return I ? fe : S ? he : U;
}
function qt(s, n, e, t, a) {
  var i = {};
  if (s) {
    for (var r = 0, o = s; r < o.length; r++) {
      var l = o[r], u = ca(t, l, !0), c = ca(t, l), d = jf(l), m = ue(d, c);
      if (l.recurring)
        for (var h = bd.test(d) ? null : ue(d), f = me(u, m), p = l.end ? ue(l.end, u) : f, g = l.end === "00:00" ? ce(p, 1) : p, v = +g - +f, y = ce(n, -1), b = ce(e, 1), D = 0, w = Sd(l.recurring, h, f, y, b, t, l.recurringException, l.recurringExceptionRule); D < w.length; D++) {
          var C = w[D], T = C.d, N = K({}, l);
          if (l.start ? N.start = me(u, T.getFullYear(), T.getMonth(), T.getDate(), f.getHours(), f.getMinutes(), f.getSeconds()) : (N.allDay = !0, N.start = me(void 0, T.getFullYear(), T.getMonth(), T.getDate())), l.end)
            if (l.allDay) {
              var O = ce(T, an(f, g));
              N.end = new Date(O.getFullYear(), O.getMonth(), O.getDate(), g.getHours(), g.getMinutes(), g.getSeconds());
            } else
              N.end = me(u, +N.start + v);
          N.nr = C.i, N.occurrenceId = N.id + "_" + Pe(N.start), N.original = l, N.start && N.end ? Ul(i, N, t, a) : Vi(i, T, N);
        }
      else
        l.start && l.end ? Ul(i, l, t, a) : m && Vi(i, m, l);
    }
    return i;
  }
}
var $f = 1, qf = /* @__PURE__ */ _p(yd, { dateText: "Date", eventText: "event", eventsText: "events", moreEventsText: "{count} more", nextPageText: "Next page", prevPageText: "Previous page", showEventTooltip: !0, showToday: !0, timeText: "Time" });
function _s(s, n) {
  var e = n.refDate ? ue(n.refDate) : Bt, t = n.showCalendar ? n.calendarType : n.eventRange, a = (n.showCalendar ? t === "year" ? 1 : t === "week" ? n.weeks : n.size : n.eventRangeSize) || 1, i = n.getDate, r = t === "week" ? Et(e, n) : e, o = n.getYear(r), l = n.getMonth(r), u = n.getDay(r);
  switch (t) {
    case "year":
      return i(o + s * a, 0, 1);
    case "week":
      return i(o, l, u + 7 * a * s);
    case "day":
      return i(o, l, u + a * s);
    default:
      return i(o, l + s * a, 1);
  }
}
function Jn(s, n) {
  var e, t = n.refDate ? ue(n.refDate) : Bt, a = n.getYear, i = n.getMonth, r = n.showCalendar ? n.calendarType : n.eventRange, o = (n.showCalendar ? r === "year" ? 1 : r === "week" ? n.weeks : n.size : n.eventRangeSize) || 1;
  switch (r) {
    case "year":
      e = a(s) - a(t);
      break;
    case "week":
      e = an(Et(t, n), Et(s, n)) / 7;
      break;
    case "day":
      e = an(t, s);
      break;
    case "month":
      e = i(s) - i(t) + 12 * (a(s) - a(t));
      break;
    default:
      return;
  }
  return Le(e / o);
}
function ti(s, n) {
  var e = n.refDate ? ue(n.refDate) : Bt;
  return Le((n.getYear(s) - n.getYear(e)) / 12);
}
function ni(s, n) {
  var e = n.refDate ? ue(n.refDate) : Bt;
  return n.getYear(s) - n.getYear(e);
}
function si(s, n) {
  var e = n.refDate ? ue(n.refDate) : Bt;
  return n.getMonth(s) - n.getMonth(e) + 12 * (n.getYear(s) - n.getYear(e));
}
function Gf(s, n) {
  var e = ue(s.start || s.date), t = ue(n.start || s.date), a = s.title || s.text, i = n.title || n.text, r = e ? +e * (s.allDay ? 1 : 10) : 0, o = t ? +t * (n.allDay ? 1 : 10) : 0;
  return r === o ? a > i ? 1 : -1 : r - o;
}
function Td(s, n) {
  return s === "auto" ? Math.max(1, Math.min(3, Math.floor(n ? n / 296 : 1))) : s ? +s : 1;
}
function Ed(s, n, e, t, a, i, r, o, l, u, c, d, m, h) {
  n = n || {};
  for (var f = {}, p = /* @__PURE__ */ new Map(), g = {}, v = e, y = 0, b = a, D = t; v < t; ) {
    var w = Pe(v), C = v.getDay(), T = s.getDay(v), N = c && s.getDate(s.getYear(v), s.getMonth(v) + 1, 0), O = l && (C === o || T === 1 && c) || +v == +e, L = Et(v, s), H = Ks(n[w] || [], u), A = void 0, B = void 0, I = void 0, S = 0, k = 0, R = 0;
    O && (g = {}, D = l ? ce(L, i) : t), r && (H = H.filter(function(Se) {
      return Se.allDay;
    })), a === -1 && (b = H.length + 1);
    var z = H.length, W = [];
    for (d && (W.push({ id: "count_" + +v, count: z, placeholder: z === 0 }), S = b); z && S < b; ) {
      A = null;
      for (var M = 0; M < H.length; M++)
        g[S] === H[M] && (A = H[M], I = M);
      if (B = A && p.get(A) || [], S === b - 1 && (k < z - 1 || R === z && !A) && a !== -1) {
        var P = z - k, Y = m || "", q = (P > 1 && h || Y).replace(/{count}/, P);
        if (P && W.push({ id: "more_" + ++y, more: q, label: q }), A) {
          g[S] = null;
          for (var U = 0, j = B; U < j.length; U++) {
            var ee = j[U], ne = Y.replace(/{count}/, "1");
            f[Pe(ee)].data[S] = { id: "more_" + ++y, more: ne, label: ne };
          }
        }
        k++, S++;
      } else if (A)
        I === R && R++, Ke(v, ue(A.end, ca(s, A))) && (g[S] = null), W.push({ id: A.occurrenceId || A.id, event: A }), S++, k++, B.push(v);
      else if (R < z) {
        var G = H[R], te = G.allDay, Z = ca(s, G), re = G.start && ue(G.start, Z);
        if (!re || Ke(v, re) || O) {
          var fe = Xt(s, te, re, G.end && ue(G.end, Z), !0), he = fe && !Ke(re, fe), oe = N && N < fe ? N : fe, Ee = re ? ", " + s.fromText + ": " + Xe("DDDD, MMMM D, YYYY", re, s) : "", Ie = fe ? ", " + s.toText + ": " + Xe("DDDD, MMMM D, YYYY", fe, s) : "";
          G.id === void 0 && (G.id = "mbsc_" + $f++), he && (g[S] = G), p.set(G, [v]), W.push({ event: G, id: G.occurrenceId || G.id, label: (G.title || G.text || "") + Ee + Ie, lastDay: N ? ce(N, 1) : void 0, multiDay: he, showText: !0, width: he ? 100 * Math.min(an(v, oe) + 1, an(v, D)) : 100 }), S++, k++;
        }
        R++;
      } else
        k < z && W.push({ id: "ph_" + ++y, placeholder: !0 }), S++;
    }
    f[w] = { data: W, events: H }, v = Ce(ce(v, 1));
  }
  return f;
}
function Ks(s, n) {
  return s && s.slice(0).sort(n || Gf);
}
function da(s, n, e) {
  return !(s === !1 || e === !1 || !n);
}
function Wi(s, n, e) {
  return s !== !1 && n !== !1 && e !== !1;
}
function Xf(s, n, e) {
  return s !== !1 && n !== !1 && e !== !1;
}
function Kf(s, n, e, t) {
  return s !== !1 && n !== !1 && e !== !1 && t !== !1;
}
var Qf = /* @__PURE__ */ function() {
  function s() {
    this.pageSize = 0, this._prevS = {}, this._s = {};
  }
  return s.prototype.options = function(n, e) {
    var t = this._s = K({}, this._s, n), a = this._prevS, i = t.getDate, r = t.getYear, o = t.getMonth, l = t.showCalendar, u = t.calendarType, c = t.startDay, d = t.endDay, m = t.firstDay, h = u === "week", f = l ? h ? t.weeks : 6 : 0, p = t.min === a.min && this.minDate ? this.minDate : Dt(t.min) ? -1 / 0 : ue(t.min), g = t.max === a.max && this.maxDate ? this.maxDate : Dt(t.max) ? 1 / 0 : ue(t.max), v = t.activeDate || +/* @__PURE__ */ new Date(), y = $e(v, +p, +g), b = this.forcePageChange || y !== v, D = new Date(y), w = y !== a.activeDate, C = t.calendarType !== a.calendarType || t.eventRange !== a.eventRange || t.firstDay !== a.firstDay || t.eventRangeSize !== a.eventRangeSize || t.refDate !== a.refDate || l !== a.showCalendar || t.size !== a.size || t.weeks !== a.weeks, T = b || this.pageIndex === void 0 || C || !this.preventPageChange && w && (y < +this.firstDay || y >= +this.lastDay) ? Jn(D, t) : this.pageIndex, N = u === "year" ? 12 : t.size || 1, O = N > 1 && !h, L = O ? 1 : Td(t.pages, this.pageSize), H = t.calendarScroll === "vertical" && t.pages !== "auto" && (t.pages === void 0 || t.pages === 1), A = t.showOuterDays !== void 0 ? t.showOuterDays : !H && L < 2 && (h || !N || N < 2), B = O ? 0 : 1, I = _s(T, t), S = _s(T + L, t);
    l || t.eventRange !== "week" || c === void 0 || d === void 0 || (I = ce(I, c - m + (c < m ? 7 : 0)), S = ce(I, 7 * t.eventRangeSize + d - c + 1 - (d < c ? 0 : 7)));
    var k = l && A ? Et(I, t) : I, R = O ? i(r(S), o(S) - 1, 1) : _s(T + L - 1, t), z = l && A ? ce(Et(R, t), 7 * f) : S, W = l ? Et(_s(T - B, t), t) : I, M = l ? Et(_s(T + L + B - 1, t), t) : S, P = l ? ce(O ? Et(R, t) : M, 7 * f) : S, Y = this.pageIndex === void 0, q = W, U = P;
    if (!l && t.resolution === "week" && (t.eventRange === "year" || t.eventRange === "month")) {
      var j = d - c + 1 + (d < c ? 7 : 0);
      if (I.getDay() !== c && (q = (ne = ce(ee = Et(I, t, c), j)) <= I ? ce(ee, 7) : ee), S.getDay() !== c) {
        var ee, ne = ce(ee = Et(S, t, c), j);
        U = ee > S ? ce(ne, -7) : ne;
      }
    }
    var G = !1;
    T !== void 0 && (G = +q != +this.viewStart || +U != +this.viewEnd, this.pageIndex = T), this.firstDay = I, this.lastDay = S, this.firstPageDay = k, this.lastPageDay = z, this.viewStart = q, this.viewEnd = U, this.forcePageChange = !1, this.preventPageChange = !1, this.minDate = p, this.maxDate = g, this._prevS = t, T !== void 0 && (G || e) && (G && !Y && this.pageChange(), this.pageLoading(G));
  }, s.prototype.pageChange = function() {
    this._s.onPageChange && this._s.onPageChange({ firstDay: this.firstPageDay, lastDay: this.lastPageDay, month: this._s.calendarType === "month" ? this.firstDay : void 0, type: "onPageChange", viewEnd: this.viewEnd, viewStart: this.viewStart });
  }, s.prototype.pageLoading = function(n) {
    this._s.onPageLoading && this._s.onPageLoading({ firstDay: this.firstPageDay, lastDay: this.lastPageDay, month: this._s.calendarType === "month" ? this.firstDay : void 0, type: "onPageLoading", viewChanged: n, viewEnd: this.viewEnd, viewStart: this.viewStart });
  }, s;
}();
function as(s, n, e, t, a, i) {
  var r = Pe(n);
  if (a && +n < a || i && +n > i)
    return !0;
  if (t && t[r])
    return !1;
  var o = e && e[r];
  if (o)
    for (var l = 0, u = o; l < u.length; l++) {
      var c = u[l], d = c.start, m = c.end, h = c.allDay;
      if (!d || !m || h)
        return c;
      var f = Xt(s, h, d, m), p = Ff(s, n), g = Yf(s, f);
      if (!Ke(d, m) && (+d == +p || +f == +g || !Ke(n, d) && !Ke(n, m) && n > d && n < m))
        return c;
    }
  return !1;
}
function Jf(s, n, e, t, a, i, r) {
  var o, l, u = !0, c = !0, d = 0, m = 0;
  +s < e && (s = me(n, e)), +s > t && (s = me(n, t));
  var h = n.getYear(s), f = n.getMonth(s), p = n.getDate(h, f - 1, 1), g = n.getDate(h, f + 2, 1), v = +p > e ? +p : e, y = +g < t ? +g : t;
  if (a || (i = qt(n.valid, p, g, n, !0), a = qt(n.invalid, p, g, n, !0)), !as(n, s, a, i, e, t))
    return s;
  for (o = s, l = s; u && +o < y && d < 100; )
    u = as(n, o = ce(o, 1), a, i, e, t), d++;
  for (; c && +l > v && m < 100; )
    c = as(n, l = ce(l, -1), a, i, e, t), m++;
  return u && c ? s : r !== 1 || u ? r !== -1 || c ? Fl(s, o, n) && !u ? o : Fl(s, l, n) && !c ? l : c || m >= d && !u ? o : l : l : o;
}
var bn = new Fn();
function kd(s) {
  return bn.subscribe(s);
}
function Md(s) {
  bn.unsubscribe(s);
}
function Id(s, n) {
  n.style.left = s.endX + "px", n.style.top = s.endY + "px";
}
var Zf = 1;
function Vl(s, n, e, t, a, i) {
  var r = e, o = t, l = /* @__PURE__ */ new Map(), u = [];
  a && (r = ue(a, n)), i ? o = ue(i, n) : a && (o = ce(r, 1));
  var c = qt(s, r, o, n);
  for (var d in c)
    if (d)
      for (var m = 0, h = c[d]; m < h.length; m++) {
        var f = h[m];
        if (f.start) {
          if (!l.has(f)) {
            var p = ue(f.start, n), g = ue(f.end, n) || p;
            if (f.allDay && (p = me(n, p.getFullYear(), p.getMonth(), p.getDate()), g = me(n, (g = Xt(n, !0, p, g)).getFullYear(), g.getMonth(), g.getDate(), 23, 59, 59, 999)), ss(r, o, p, g)) {
              var v = K({}, f);
              (n.dataTimezone || n.displayTimezone) && (v.start = p.toISOString(), v.end = g.toISOString()), l.set(f, !0), u.push(v);
            }
          }
        } else
          u.push(f);
      }
  return u;
}
function _r() {
  return "mbsc_" + Zf++;
}
function Nd(s, n, e, t, a, i, r, o, l, u) {
  var c = n.color || a && a.color, d = n.start || n.date, m = n.recurring ? n.original.start : n.start, h = n.allDay || !m, f = ca(s, n), p = d ? ue(d, f) : null, g = n.end ? ue(n.end, f) : null, v = Xt(s, n.allDay, p, g, i), y = n.bufferBefore ? ue(+p - 6e4 * n.bufferBefore, f) : null, b = n.bufferAfter ? ue(+v + 6e4 * n.bufferAfter, f) : null, D = p && v && !Ke(p, v), w = !D || Ke(p, e), C = !D || Ke(v, e), T = !u && (h || r && D && !w && !C), N = "", O = "";
  if (!l)
    if (u) {
      var L = s.dateFormat + (h ? "" : s.separator + s.timeFormat);
      N = p ? Xe(L, p, s) : "", O = g ? Xe(L, h ? v : g, s) : "";
    } else
      r || o ? h || (N = p ? Xe(s.timeFormat, p, s) : "", O = g ? Xe(s.timeFormat, g, s) : "") : (N = p ? Xe(s.dateFormat, p, s) : "", O = g ? Xe(s.dateFormat, v, s) : "");
  var H = T || !w && r && !u ? "" : N, A = T || !C && r && !u ? "" : O, B = n.title || n.text || "", I = B, S = I + (T ? "" : ", " + H + " - " + A), k = s.dateFormatFull, R = !l && p ? ", " + s.fromText + ": " + Xe(k, p, s) + (h ? "" : ", " + N) : "", z = !l && g ? ", " + s.toText + ": " + Xe(k, g, s) + (h ? "" : ", " + O) : "", W = a && a.name ? ", " + a.name : "";
  return { allDay: h, allDayText: T ? s.allDayText : "", ariaLabel: I + W + R + z, bufferEnd: b, bufferStart: y, color: c, currentResource: a, date: +e, end: A, endDate: g || (p ? new Date(p) : null), html: B, id: n.id, isMultiDay: D, lastDay: !T && D && C ? s.toText : "", original: n, position: {}, resource: n.resource, slot: n.slot, start: H, startDate: p, style: { background: c, color: t && c ? Ts(c) : "" }, title: I, tooltip: s.showEventTooltip ? n.tooltip || S : void 0, uid: n.occurrenceId ? n.occurrenceId : n.id };
}
function ai(s) {
  var n = [];
  if (s)
    for (var e = 0, t = s; e < t.length; e++) {
      var a = t[e];
      a.id === void 0 && (a.id = _r()), n.push(a);
    }
  return n;
}
function e_(s, n, e, t, a, i, r, o, l) {
  if (o === "start-end") {
    var u = as(s, t, n, e, i, r), c = as(s, a, n, e, i, r);
    if (u)
      return u;
    if (c)
      return c;
  } else
    for (var d = l ? a : Ce(ce(a, 1)), m = Ce(t); m < d; m.setDate(m.getDate() + 1)) {
      var h = as(s, m, n, e, i, r);
      if (h)
        return h;
    }
  return !1;
}
function t_(s, n, e, t, a) {
  for (var i = a.exclusiveEndDates ? e : Ce(ce(e, 1)), r = Ce(n); r < i; r.setDate(r.getDate() + 1)) {
    var o = (t[Pe(r)] || []).filter(function(d) {
      return d.id !== s.id;
    });
    if (o.length) {
      if (a.eventOverlap === !1 || s.overlap === !1)
        return o[0];
      for (var l = 0, u = o; l < u.length; l++) {
        var c = u[l];
        if (c.overlap === !1)
          return c;
      }
    }
  }
  return !1;
}
var n_ = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e.print = fa, e._checkSize = 0, e._navService = new Qf(), e._pageLoad = 0, e._selectedDates = {}, e._shouldScrollSchedule = 0, e._update = 0, e._onScroll = gp(function() {
      if (!e._isListScrolling && !e._viewChanged) {
        for (var t in e._listDays)
          if (e._listDays[t]) {
            var a = e._listDays[t];
            if (a.offsetTop + a.offsetHeight - e._list.scrollTop > 0) {
              +t !== e._selected && (e._shouldSkipScroll = !0, e._selectedChange(+t));
              break;
            }
          }
      }
    }), e._isListScrolling = 0, e._onWeekDayClick = function(t) {
      t !== e._selected && (e._skipScheduleScroll = !0, e._selectedChange(t));
    }, e._onDayClick = function(t) {
      var a = t.date, i = +a, r = Pe(a), o = Ks(e._eventMap[r], e.s.eventOrder), l = e._showEventPopover, u = l === void 0 ? !e._showEventLabels && !e._showEventList && !e._showSchedule : l, c = l !== !1 && e._moreLabelClicked, d = (u || c) && o && o.length > 0;
      t.events = o, e._isEventClick || e._resetSelection(), e._hook("onCellClick", t), e._moreLabelClicked = !1, t.disabled || i === e._selected || (e._navService.preventPageChange = !e._showEventList, e._skipScheduleScroll = !0, e._selectedChange(i)), d && e._showPopover(i, i, o.map(function(m) {
        return e._getEventData(m, a);
      }), t.target), e._isEventClick = !1;
    }, e._onActiveChange = function(t) {
      if (t.scroll)
        e._viewDate = +t.date;
      else {
        var a = e._getValidDay(t.date, t.dir), i = { activeDate: a };
        e._active = a, e._viewDate = a, e._update++, e._skipScheduleScroll = t.pageChange && !t.nav, (t.pageChange || t.today) && (i.selectedDate = a, e._selectedChange(a, !0), e._navService.forcePageChange = !0), e.setState(i);
      }
    }, e._onGestureStart = function(t) {
      e._hidePopover();
    }, e._onDayDoubleClick = function(t) {
      e._dayClick("onCellDoubleClick", t);
    }, e._onDayRightClick = function(t) {
      e._dayClick("onCellRightClick", t);
    }, e._onCellHoverIn = function(t) {
      t.events = e._eventMap[Pe(t.date)], e._hook("onCellHoverIn", t);
    }, e._onCellHoverOut = function(t) {
      t.events = e._eventMap[Pe(t.date)], e._hook("onCellHoverOut", t);
    }, e._onEventHoverIn = function(t) {
      e._hoverTimer = setTimeout(function() {
        e._isHover = !0, e._eventClick("onEventHoverIn", t);
      }, 150);
    }, e._onEventHoverOut = function(t) {
      clearTimeout(e._hoverTimer), e._isHover && (e._isHover = !1, e._eventClick("onEventHoverOut", t));
    }, e._onEventClick = function(t) {
      var a = e.s;
      e._handleMultipleSelect(t), e._eventClick("onEventClick", t) === !1 || a.selectMultipleEvents || a.eventDelete || (a.dragToCreate || a.clickToCreate) && a.eventDelete !== !1 || e._hidePopover();
    }, e._onEventDoubleClick = function(t) {
      e._eventClick("onEventDoubleClick", t);
    }, e._onEventRightClick = function(t) {
      e._eventClick("onEventRightClick", t);
    }, e._onEventDragEnd = function(t) {
      e._hook("onEventDragEnd", t);
    }, e._onEventDragStart = function(t) {
      e._hook("onEventDragStart", t);
    }, e._onEventDragEnter = function(t) {
      e._hook("onEventDragEnter", t);
    }, e._onEventDragLeave = function(t) {
      e._hook("onEventDragLeave", t);
    }, e._onLabelHoverIn = function(t) {
      e._hoverTimer = setTimeout(function() {
        e._isHover = !0, e._labelClick("onEventHoverIn", t);
      }, 150);
    }, e._onLabelHoverOut = function(t) {
      clearTimeout(e._hoverTimer), e._isHover && (e._isHover = !1, e._labelClick("onEventHoverOut", t));
    }, e._onLabelClick = function(t) {
      e._handleMultipleSelect(t), e._hook("onLabelClick", t), e._labelClick("onEventClick", t), e._isEventClick = !0, t.label || (e._moreLabelClicked = !0);
    }, e._onLabelDoubleClick = function(t) {
      e._labelClick("onEventDoubleClick", t);
    }, e._onLabelRightClick = function(t) {
      e._labelClick("onEventRightClick", t);
    }, e._onCellClick = function(t) {
      e._resetSelection(), e._cellClick("onCellClick", t);
    }, e._onCellDoubleClick = function(t) {
      e._cellClick("onCellDoubleClick", t);
    }, e._onCellRightClick = function(t) {
      e._cellClick("onCellRightClick", t);
    }, e._proxy = function(t) {
      e._hook(t.type, t);
    }, e._onPageChange = function(t) {
      setTimeout(function() {
        e._hidePopover();
      }), e._isPageChange = !0, e._hook("onPageChange", t);
    }, e._onPageLoading = function(t) {
      var a = e.s, i = qt(e._events, t.viewStart, t.viewEnd, a);
      e._colorsMap = qt(a.colors, t.viewStart, t.viewEnd, a), e._invalidsMap = qt(a.invalid, t.viewStart, t.viewEnd, a, !0), e._validsMap = qt(a.valid, t.viewStart, t.viewEnd, a, !0), e._eventMap = i, e._firstDay = Et(t.firstDay, a, e._firstWeekDay), e._lastDay = t.lastDay, e._labelsMap = e._marksMap = void 0, a.labels || !e._showEventLabels && !e._showEventCount ? a.marked || (e._marksMap = i) : e._labelsMap = i, t.viewChanged && e._hook("onPageLoading", t);
    }, e._onPageLoaded = function(t) {
      e._shouldAnimateScroll = e._isPageChange, e._isPageChange = !1;
      var a = e._eventListType;
      if (e._showEventList && (!e._showCalendar || a !== "day")) {
        var i = e.s, r = t.month, o = e._showEventList && r && a === "month", l = o ? r : t.firstDay, u = o ? i.getDate(i.getYear(r), i.getMonth(r) + e._eventListSize, 1) : t.lastDay;
        e._setEventList(l, u);
      }
      e._hook("onPageLoaded", t);
    }, e._onMoreClick = function(t) {
      e._showPopover(t.key, +t.date, t.list.map(function(a) {
        return e._getEventData(a.original, new Date(t.date), a.currentResource, !0);
      }), t.target, t.context, t.inst);
    }, e._onPopoverClose = function(t) {
      var a = e.state;
      a.popoverHost && t.source === "dragStart" ? e.setState({ popoverDrag: !0, popoverHidden: !0 }) : a.popoverHost && t.source === "scroll" && a.popoverDrag || e._hidePopover();
    }, e._onResize = function(t) {
      var a;
      if (e._showEventList && Mt) {
        var i = t.target, r = i.offsetHeight, o = i.getBoundingClientRect().top;
        a = r - e._list.getBoundingClientRect().top + o > 170;
      }
      e.setState({ height: t.height, isListScrollable: a, width: t.width });
    }, e._onSelectedEventsChange = function(t) {
      e._emit("selectedEventsChange", t), e._hook("onSelectedEventsChange", { events: t });
    }, e._getDragDates = function(t, a, i) {
      for (var r = {}, o = e._firstWeekDay, l = Xt(e.s, i.allDay, t, a, !0), u = Ce(ce(l, 1)), c = Ce(t); c < u; c.setDate(c.getDate() + 1)) {
        var d = c.getDay(), m = o - d > 0 ? 7 : 0;
        Ke(t, c) || d === o ? r[Pe(c)] = { event: i, width: 100 * Math.min(an(c, l) + 1, 7 + o - d - m) } : r[Pe(c)] = {};
      }
      return r;
    }, e._onLabelUpdateModeOn = function(t) {
      var a = t.create ? e._tempEvent : t.event, i = ue(a.start), r = ue(a.end || i);
      e.setState({ isTouchDrag: !0, labelDragData: { draggedEvent: a, originDates: t.external ? void 0 : e._getDragDates(i, r, a) } });
    }, e._onLabelUpdateModeOff = function(t) {
      e._hook("onEventDragEnd", { domEvent: t.domEvent, event: t.create ? e._tempEvent : t.event, source: "calendar" }), e.setState({ isTouchDrag: !1, labelDragData: void 0 });
    }, e._onLabelUpdateStart = function(t) {
      var a = e.s, i = e._el;
      if (a.externalDrag && t.drag && !t.create) {
        var r = i.querySelector(".mbsc-calendar-label[data-id='" + t.event.id + "']") || _a(t.domEvent.target, ".mbsc-list-item");
        if (r) {
          var o = r.cloneNode(!0), l = o.classList;
          o.style.display = "none", l.add("mbsc-drag-clone", "mbsc-schedule-drag-clone", "mbsc-font"), l.remove("mbsc-calendar-label-hover", "mbsc-hover", "mbsc-focus", "mbsc-active"), e._clone = o, e._body = vn(i).body, e._body.appendChild(o), e._eventDropped = !1, bn.next(K({}, t, { create: !0, dragData: t.event, eventName: "onDragStart", external: !0, from: e }));
        }
      }
      var u = e._showWeekNumbers ? i.querySelector(".mbsc-calendar-week-nr").getBoundingClientRect().width : 0, c = i.querySelectorAll(".mbsc-calendar-slide-active")[0], d = c.getBoundingClientRect(), m = i.querySelector(".mbsc-calendar-week-days"), h = c.querySelectorAll(".mbsc-calendar-row"), f = /click/.test(t.domEvent.type);
      if (e._areaTop = 0, m) {
        var p = m.getBoundingClientRect();
        e._areaTop = p.top + p.height;
      }
      e._areaLeft = d.left + (a.rtl ? 0 : u), e._areaBottom = d.top + d.height, e._areaRight = e._areaLeft + d.width - (a.rtl ? u : 0), e._calCellWidth = (e._areaRight - e._areaLeft) / 7;
      var g = 0;
      if (e._rowTops = [], h.forEach(function(T, N) {
        var O = T.getBoundingClientRect().top - e._areaTop;
        e._rowTops.push(O), t.endY - e._areaTop > O && (g = N);
      }), t.create) {
        var v = Le((a.rtl ? e._areaRight - t.endX : t.endX - e._areaLeft) / e._calCellWidth), y = ce(e._firstDay, 7 * g + v), b = new Date(y.getFullYear(), y.getMonth(), y.getDate()), D = ce(b, 1), w = a.exclusiveEndDates ? D : new Date(+D - 1), C = a.extendDefaultEvent ? a.extendDefaultEvent({ start: b }) : void 0;
        e._tempEvent = K({ allDay: !0, end: w, id: _r(), start: b, title: a.newEventText }, t.dragData, C);
      }
      f || e._hook("onEventDragStart", { action: t.create ? "create" : t.resize ? "resize" : "move", domEvent: t.domEvent, event: t.create ? e._tempEvent : t.event, source: "calendar" });
    }, e._onLabelUpdateMove = function(t) {
      var a = e.s, i = t.create ? e._tempEvent : t.event, r = K({}, i), o = e.state.labelDragData, l = i.allDay ? void 0 : a;
      if (a.externalDrag && t.drag && !t.create && e._clone && (bn.next(K({}, t, { clone: e._clone, create: !0, dragData: t.event, eventName: "onDragMove", external: !0, from: e })), !e._onCalendar))
        return Id(t, e._clone), void (o && o.draggedEvent || e.setState({ labelDragData: { draggedEvent: r } }));
      if (t.endY > e._areaTop && t.endY < e._areaBottom && t.endX > e._areaLeft && t.endX < e._areaRight) {
        var u = Le((a.rtl ? e._areaRight - t.endX : t.endX - e._areaLeft) / e._calCellWidth), c = Le((a.rtl ? e._areaRight - t.startX : t.startX - e._areaLeft) / e._calCellWidth), d = 0, m = 0;
        e._rowTops.forEach(function(N, O) {
          t.startY - e._areaTop > N && (m = O), t.endY - e._areaTop > N && (d = O);
        });
        var h = 7 * (d - m) + (u - c);
        if (u !== e._tempDay || d !== e._tempWeek) {
          var f = ue(i.start, l), p = ue(i.end, l) || f, g = Wi(i.dragInTime, void 0, a.dragInTime), v = f, y = p;
          if (t.external) {
            var b = nt(f), D = +p - +f;
            g && (v = me(a, +ce(e._firstDay, 7 * d + u) + b), y = me(a, +v + D));
          } else if (t.drag) {
            if (!g)
              return;
            v = ce(f, h), y = ce(p, h);
          } else {
            var w = a.rtl ? -1 : 1, C = t.create ? d === m ? t.deltaX * w > 0 : h > 0 : t.direction === "end", T = an(f, p);
            C ? y = ce(p, Math.max(-T, h)) : v = ce(f, Math.min(T, h)), y < v && (C ? y = me(l, v) : v = me(l, y));
          }
          r.start = v, r.end = y, e.setState({ labelDragData: { draggedDates: e._getDragDates(v, y, r), draggedEvent: r, originDates: o && o.originDates }, popoverHidden: !0 }), e._tempDay = u, e._tempWeek = d;
        }
      }
    }, e._onLabelUpdateEnd = function(t) {
      var a = e.s, i = e.state, r = t.create, o = i.labelDragData || {}, l = r ? e._tempEvent : t.event, u = o.draggedEvent || l, c = ue(l.start), d = ue(l.end), m = ue(u.start), h = ue(u.end), f = r || +c != +m || +d != +h, p = { allDay: l.allDay, endDate: h, original: l, startDate: m }, g = !1;
      a.externalDrag && t.drag && !t.create && e._clone && (bn.next(K({}, t, { action: "externalDrop", create: !0, dragData: t.event, eventName: "onDragEnd", external: !0, from: e })), e._body.removeChild(e._clone), e._clone = void 0, e._onCalendar || (g = !0, e._eventDropped && e._onEventDelete(t)));
      var v = t.action || (o.draggedEvent ? "drag" : "click"), y = !g && (!f || e._onEventDragStop({ action: v, collision: e_(a, e._invalidsMap, e._validsMap, m, h, e._minDate, e._maxDate, a.invalidateEvent, a.exclusiveEndDates), create: r, domEvent: t.domEvent, event: p, external: t.external, from: t.from, overlap: t_(l, m, h, e._eventMap, a), source: "calendar" })), b = i.isTouchDrag && !g && (!r || y);
      b || v === "click" || e._hook("onEventDragEnd", { domEvent: t.domEvent, event: l, source: "calendar" }), e.setState({ isTouchDrag: b, labelDragData: b ? { draggedEvent: y ? u : K({}, l), originDates: y ? e._getDragDates(m, h, p.original) : o.originDates } : {} }), t.drag && e._hidePopover(), e._tempWeek = -1, e._tempDay = -1;
    }, e._onEventDragStop = function(t) {
      var a = e.s, i = t.action, r = t.resource, o = t.slot, l = t.collision, u = t.overlap, c = t.create, d = t.source, m = t.event, h = m.original, f = h.recurring ? h.original : h, p = a.immutableData ? K({}, f) : f, g = K({}, p), v = K({}, p), y = h.timezone, b = Ua(h.start, a, y), D = Ua(m.startDate, a, y), w = Ua(m.endDate, a, y), C = m.allDay, T = v.recurring;
      T ? v.recurringException = ji(v.recurringException).concat([b]) : (v.allDay = C, v.start = D, v.end = w, r !== void 0 && (v.resource = r), o !== void 0 && (v.slot = o));
      var N = !1, O = T ? K({}, p) : p;
      return (c || T) && (T && delete O.recurring, (T || O.id === void 0) && (O.id = _r()), r !== void 0 && (O.resource = r), o !== void 0 && (O.slot = o), O.start = D, O.end = w, O.allDay = C, N = e._hook("onEventCreate", K({ action: i, domEvent: t.domEvent, event: O, source: d }, T && { originEvent: h })) !== !1, l === !1 && u === !1 || (N = !1, e._hook("onEventCreateFailed", K({ action: i, event: O, invalid: l, overlap: u, source: d }, T && { originEvent: h })))), c && !T || t.external || (N = e._hook("onEventUpdate", K({ domEvent: t.domEvent, event: v, oldEvent: g, oldResource: t.oldResource, oldSlot: t.oldSlot, resource: t.newResource, slot: t.newSlot, source: d }, T && { newEvent: O, oldEventOccurrence: h })) !== !1, l === !1 && u === !1 || (N = !1, e._hook("onEventUpdateFailed", K({ event: v, invalid: l, oldEvent: g, overlap: u, source: d }, T && { newEvent: O, oldEventOccurrence: h })))), N ? (t.from && (t.from._eventDropped = !0), (c || T) && (e._events.push(O), e._triggerCreated = { action: i, event: O, source: d }), c && !T || (T ? (m.id = O.id, m.original = O, p.recurringException = v.recurringException) : (p.start = D, p.end = w, p.allDay = C, r !== void 0 && (p.resource = r), o !== void 0 && (p.slot = o)), e._triggerUpdated = { event: p, oldEvent: g, source: d }), e._refresh = !0, d !== "calendar" && e.forceUpdate()) : e._hidePopover(), N;
    }, e._onExternalDrag = function(t) {
      var a = e.s, i = t.clone, r = t.from === e, o = !r && a.externalDrop, l = r && a.externalDrag && !a.dragToMove, u = e.state.labelDragData;
      if (e._showCalendar && (o || a.externalDrag)) {
        var c = !l && t.endY > e._areaTop && t.endY < e._areaBottom && t.endX > e._areaLeft && t.endX < e._areaRight;
        switch (t.eventName) {
          case "onDragModeOff":
            o && e._onLabelUpdateModeOff(t);
            break;
          case "onDragModeOn":
            o && e._onLabelUpdateModeOn(t);
            break;
          case "onDragStart":
            o ? e._onLabelUpdateStart(t) : r && (e._onCalendar = !0);
            break;
          case "onDragMove":
            if (!r && !o)
              return;
            c ? (e._onCalendar || e._hook("onEventDragEnter", { domEvent: t.domEvent, event: t.dragData, source: "calendar" }), (r || o) && (i.style.display = "none"), o && e._onLabelUpdateMove(t), e._onCalendar = !0) : e._onCalendar && (e._hook("onEventDragLeave", { domEvent: t.domEvent, event: t.dragData, source: "calendar" }), i.style.display = "table", (!r || u && u.draggedEvent) && e.setState({ labelDragData: { draggedDates: {}, draggedEvent: r ? u && u.draggedEvent : void 0, originDates: r ? u && u.originDates : void 0 } }), e._tempWeek = -1, e._tempDay = -1, e._onCalendar = !1);
            break;
          case "onDragEnd":
            o && (c ? e._onLabelUpdateEnd(t) : (e.setState({ labelDragData: void 0 }), e._hook("onEventDragEnd", { domEvent: t.domEvent, event: t.dragData, source: "calendar" })));
        }
      }
    }, e._onEventDelete = function(t) {
      var a, i = e.s;
      if ((i.eventDelete !== void 0 || i.dragToCreate || i.clickToCreate) && i.eventDelete !== !1) {
        for (var r, o, l, u = !1, c = !1, d = !1, m = t.event, h = m, f = i.selectMultipleEvents, p = f ? e._selectedEventsMap : ((a = {})[m.id] = m, a), g = [], v = [], y = [], b = {}, D = [], w = 0, C = Kr(p); w < C.length; w++) {
          var T = C[w];
          if (T.recurring) {
            h = T, c = !0;
            var N = (r = T.original).id;
            b[N] ? l = b[N] : (o = K({}, r), l = K({}, r), v.push(r), g.push(o), y.push(l), b[N] = l);
            var O = Ua(T.start, i);
            l.recurringException = ji(l.recurringException).concat([O]);
          } else
            d = !0, m = T, D.push(T);
        }
        if (c && e._hook("onEventUpdate", { domEvent: t.domEvent, event: l, events: f ? y : void 0, isDelete: !0, oldEvent: f ? void 0 : o, oldEventOccurrence: h, oldEvents: f ? g : void 0, oldResource: t.resource, oldSlot: t.slot, resource: t.resource, slot: t.slot, source: t.source }) !== !1) {
          u = !0;
          for (var L = 0, H = v; L < H.length; L++) {
            var A = H[L], B = b[A.id];
            A.recurringException = B.recurringException;
          }
          e._triggerUpdated = { event: r, events: f ? v : void 0, oldEvent: f ? void 0 : o, oldEvents: f ? g : void 0, source: t.source };
        }
        d && e._hook("onEventDelete", { domEvent: t.domEvent, event: m, events: f ? D : void 0, source: t.source }) !== !1 && (u = !0, e._events = e._events.filter(function(I) {
          return !p[I.id];
        }), e._selectedEventsMap = {}, e._triggerDeleted = { event: m, events: f ? D : void 0, source: t.source }), u && (e._hidePopover(), e.refresh());
      }
    }, e._setEl = function(t) {
      e._el = t ? t._el || t : null, e._calendarView = t;
    }, e._setList = function(t) {
      e._list = t;
    }, e._setPopoverList = function(t) {
      e._popoverList = t && t._el;
    }, e._onKeyDown = function(t) {
      t.keyCode === 9 && e._resetSelection();
    }, e;
  }
  return de(n, s), n.prototype.addEvent = function(e) {
    for (var t = [], a = 0, i = ai(at(e) ? e : [e]); a < i.length; a++) {
      var r = i[a];
      t.push("" + r.id), this._events.push(r);
    }
    return this.refresh(), t;
  }, n.prototype.getEvents = function(e, t) {
    return Vl(this._events, this.s, this._firstDay, this._lastDay, e, t);
  }, n.prototype.getInvalids = function(e, t) {
    return Vl(this.s.invalid, this.s, this._firstDay, this._lastDay, e, t);
  }, n.prototype.getSelectedEvents = function() {
    return Kr(this._selectedEventsMap);
  }, n.prototype.setEvents = function(e) {
    for (var t = [], a = ai(e), i = 0, r = a; i < r.length; i++) {
      var o = r[i];
      t.push("" + o.id);
    }
    return this._events = a, this.refresh(), t;
  }, n.prototype.setSelectedEvents = function(e) {
    this._selectedEventsMap = (e || []).reduce(function(t, a) {
      return a.occurrenceId ? t[a.occurrenceId] = a : t[a.id] = a, t;
    }, {}), this.forceUpdate();
  }, n.prototype.removeEvent = function(e) {
    for (var t = at(e) ? e : [e], a = this._events, i = a.length, r = 0, o = t; r < o.length; r++)
      for (var l = o[r], u = !1, c = 0; !u && c < i; ) {
        var d = a[c];
        d.id !== l && d.id !== l.id || (u = !0, a.splice(c, 1)), c++;
      }
    this.refresh();
  }, n.prototype.navigateToEvent = function(e) {
    this._navigateToEvent = e, this._shouldScrollSchedule++, this.navigate(e.start, !0);
  }, n.prototype.navigate = function(e, t) {
    var a = +ue(e), i = this._navigateToEvent !== void 0, r = a !== this._selectedDateTime;
    (r || i) && (this._shouldAnimateScroll = !!t), this.s.selectedDate === void 0 ? !this._showSchedule && !this._showTimeline || r ? this.setState({ selectedDate: a }) : (this._shouldScrollSchedule++, this.forceUpdate()) : (r || i) && this._selectedChange(a);
  }, n.prototype.updateEvent = function(e) {
    for (var t = at(e) ? e : [e], a = this._events, i = a.length, r = 0, o = t; r < o.length; r++)
      for (var l = o[r], u = !1, c = 0; !u && c < i; )
        a[c].id === l.id && (u = !0, a.splice(c, 1, K({}, l))), c++;
    this.refresh();
  }, n.prototype.refresh = function() {
    this._refresh = !0, this.forceUpdate();
  }, n.prototype._render = function(e, t) {
    var a, i = this, r = this._prevS, o = this._showDate, l = e.displayTimezone !== r.displayTimezone || e.dataTimezone !== r.dataTimezone, u = !1, c = !1, d = !1;
    if (this._colorEventList = e.eventTemplate === void 0 && e.renderEvent === void 0 && e.colorEventList, e.exclusiveEndDates === void 0 && (e.exclusiveEndDates = !!e.displayTimezone), Dt(e.min) ? this._minDate = -1 / 0 : r.min !== e.min && (this._minDate = +ue(e.min)), Dt(e.max) ? this._maxDate = 1 / 0 : r.max !== e.max && (this._maxDate = +ue(e.max)), e.selectedDate !== void 0 ? a = +ue(e.selectedDate) : (this._defaultDate || (this._defaultDate = +(e.defaultSelectedDate !== void 0 ? ue(e.defaultSelectedDate) : wo(me(e)))), a = t.selectedDate || this._selectedDateTime || this._defaultDate), this.eventList = t.eventList || [], e.data !== r.data && (this._events = e.immutableData ? (e.data || []).slice() : ai(e.data), this._refresh = !0), (e.invalid !== r.invalid || e.colors !== r.colors || l) && (this._refresh = !0), e.view !== r.view || e.firstDay !== r.firstDay) {
      var m = e.firstDay, h = e.view || {}, f = h.agenda || {}, p = h.calendar || {}, g = h.schedule || {}, v = h.timeline || {}, y = +(f.size || 1), b = f.type || "month", D = +(g.size || 1), w = g.type || "week", C = g.startDay !== void 0 ? g.startDay : m, T = g.endDay !== void 0 ? g.endDay : (m + 6) % 7, N = g.startTime, O = g.endTime, L = g.maxEventStack || "all", H = g.minEventWidth, A = g.timeCellStep || 60, B = g.timeLabelStep || 60, I = g.timezones, S = !!h.calendar, k = p.count, R = !!h.agenda, z = !!h.schedule, W = g.days !== void 0 ? g.days : !S && z && !(w === "day" && e.resources && e.resources.length > 0 && D < 2), M = !!h.timeline, P = v.weekNumbers, Y = M && !!e.slots && e.slots.length > 0, q = M ? v.currentTimeIndicator : g.currentTimeIndicator, U = v.type || "week", j = v.resolutionHorizontal || v.resolution, ee = j || "hour", ne = v.resolutionVertical, G = ne !== "day" || /hour|day/.test(ee) ? ee : "hour", te = v.startDay !== void 0 && /hour|day|week/.test(G) ? v.startDay : m, Z = v.endDay !== void 0 && /hour|day|week/.test(G) ? v.endDay : (m + 6) % 7, re = v.startTime, fe = v.endTime, he = v.maxEventStack || "all", oe = v.eventList || Y, Ee = +(v.size || 1), Ie = /month|year/.test(U) && !j && ne !== "day" || G === "day" || oe ? 1440 : 60, Se = Y || G === "day" ? Ie : v.timeCellStep || Ie, Ve = Y || G === "day" ? Ie : v.timeLabelStep || Ie, je = v.virtualScroll === void 0 || v.virtualScroll, Ne = p.type || "month", E = p.labels !== void 0 ? !!p.labels : !(R || z || M || e.marked || Ne === "year" || Ne === "month" && p.size);
      this._calendarScroll = p.scroll, this._calendarSize = p.size || 1, this._calendarLabelList = p.labels, this._calendarType = Ne, this._dragTimeStep = e.dragTimeStep !== void 0 ? e.dragTimeStep : /hour|day/.test(G) ? 15 : 1440, this._showEventPopover = p.popover, this._showOuterDays = p.outerDays, this._showWeekNumbers = p.weekNumbers, this._popoverClass = p.popoverClass || "", this._showScheduleAllDay = g.allDay === void 0 || g.allDay, this._navView = G === "year" || Ne === "year" ? "multi-year" : G === "quarter" || G === "month" || S && Ne === "month" ? "year" : "month", y === this._eventListSize && b === this._eventListType && S === this._showCalendar && k === this._showEventCount && E === this._showEventLabels && R === this._showEventList && D === this._scheduleSize && w === this._scheduleType && z === this._showSchedule && W === this._showScheduleDays && C === this._scheduleStartDay && T === this._scheduleEndDay && N === this._scheduleStartTime && O === this._scheduleEndTime && A === this._scheduleTimeCellStep && B === this._scheduleTimeLabelStep && M === this._showTimeline && te === this._timelineStartDay && Z === this._timelineEndDay && re === this._timelineStartTime && fe === this._timelineEndTime && Ee === this._timelineSize && U === this._timelineType && Se === this._timelineTimeCellStep && Ve === this._timelineTimeLabelStep && oe === this._timelineListing && G === this._timelineResolution && ne === this._timelineResolutionVertical || (this._refresh = !0, this._viewChanged = d = !0), this._currentTimeIndicator = q, this._eventListSize = y, this._eventListType = b, this._scheduleType = w, this._showCalendar = S, this._showEventCount = k, this._showEventLabels = E, this._showEventList = R, this._showSchedule = z, this._showScheduleDays = W, this._scheduleStartDay = C, this._scheduleEndDay = T, this._scheduleStartTime = N, this._scheduleEndTime = O, this._scheduleSize = D, this._scheduleTimeCellStep = A, this._scheduleTimeLabelStep = B, this._scheduleTimezones = I, this._scheduleMaxEventStack = L, this._scheduleMinEventWidth = H, this._showTimeline = M, this._showTimelineWeekNumbers = P, this._timelineSize = Ee, this._timelineType = U, this._timelineStartDay = te, this._timelineEndDay = Z, this._timelineListing = oe, this._timelineStartTime = re, this._timelineEndTime = fe, this._timelineTimeCellStep = Se, this._timelineTimeLabelStep = Ve, this._timelineMaxEventStack = he, this._timelineRowHeight = v.rowHeight, this._timelineResolution = G, this._timelineResolutionVertical = ne, this._timelineVirtualScroll = je, this._rangeType = z ? w : M ? U : b, this._rangeStartDay = z ? C : M ? te : void 0, this._rangeEndDay = z ? T : M ? Z : void 0, this._firstWeekDay = z ? C : M ? te : m;
    }
    this._showDate = !this._showScheduleDays && (this._showSchedule && this._scheduleType === "day" || this._showEventList && this._eventListType === "day" && this._eventListSize < 2);
    var F = this._pageLoad;
    if ((this._refresh || e.locale !== r.locale || e.theme !== r.theme) && (u = !0, this._pageLoad++), e.resources !== r.resources && (this._resourcesMap = (e.resources || []).reduce(function(_e, ve) {
      return _e[ve.id] = ve, _e;
    }, {})), e.selectMultipleEvents && e.selectedEvents !== r.selectedEvents && (this._selectedEventsMap = (e.selectedEvents || []).reduce(function(_e, ve) {
      return ve.occurrenceId ? _e[ve.occurrenceId] = ve : _e[ve.id] = ve, _e;
    }, {})), this._selectedEventsMap === void 0 && (this._selectedEventsMap = {}), e.refDate !== r.refDate && (this._refDate = ue(e.refDate)), this._refDate || this._showCalendar || !this._showSchedule && !this._showTimeline || (this._refDate = Ce(/* @__PURE__ */ new Date())), a !== this._selectedDateTime && (this._viewDate = a), e.cssClass === r.cssClass && e.className === r.className && e.class === r.class || (this._checkSize++, this._viewChanged = d = !0), d && this._viewDate && a !== this._viewDate && (c = !0, a = this._viewDate), a !== this._selectedDateTime || d) {
      var V = this._showCalendar && (this._showSchedule || this._showTimeline || this._showEventList) ? +Jf(new Date(a), e, this._minDate, this._maxDate, void 0, void 0, 1) : $e(a, this._minDate, this._maxDate);
      V = this._getValidDay(V), (a !== V || c) && (a = V, setTimeout(function() {
        i._selectedChange(a);
      })), this._skipScheduleScroll || this._shouldScrollSchedule++, this._selectedDateTime = a;
    }
    var J = Ce(new Date(a)), ie = +J;
    ie === this._selected && o === this._showDate && e.locale === r.locale && r.dateFormatLong === e.dateFormatLong || (this._selectedDateHeader = this._showDate ? Xe(e.dateFormatLong, J, e) : ""), ie === this._selected && e.dataTimezone === r.dataTimezone && e.displayTimezone === r.displayTimezone || (this._shouldAnimateScroll = this._shouldAnimateScroll !== void 0 ? this._shouldAnimateScroll : this._selected !== void 0, this._selected = ie, this._selectedDates = {}, this._selectedDates[+yn(e, new Date(ie))] = !0, this._active = ie, u = !0, c = !0), u && this._showCalendar && (this._eventListType === "day" || this._scheduleType === "day" || this._timelineType === "day") && this._setEventList(J, ce(J, 1)), this._refresh && t.showPopover && setTimeout(function() {
      i._hidePopover();
    }), this._refresh = !1, this._cssClass = this._className + " mbsc-eventcalendar" + (this._showEventList ? " mbsc-eventcalendar-agenda" : "") + (this._showSchedule ? " mbsc-eventcalendar-schedule" : "") + (this._showTimeline ? " mbsc-eventcalendar-timeline" : ""), this._navService.options({ activeDate: this._active, calendarType: this._calendarType, endDay: this._showSchedule ? this._scheduleEndDay : this._showTimeline ? this._timelineEndDay : this._rangeEndDay, eventRange: this._rangeType, eventRangeSize: this._showSchedule ? this._scheduleSize : this._showTimeline ? this._timelineSize : this._eventListSize, firstDay: e.firstDay, getDate: e.getDate, getDay: e.getDay, getMonth: e.getMonth, getYear: e.getYear, max: e.max, min: e.min, onPageChange: this._onPageChange, onPageLoading: this._onPageLoading, refDate: this._refDate, resolution: this._timelineResolution, showCalendar: this._showCalendar, showOuterDays: this._showOuterDays, size: this._calendarSize, startDay: this._rangeStartDay, weeks: this._calendarSize }, this._pageLoad !== F), c && (this._shouldScroll = !this._isPageChange && !this._shouldSkipScroll);
  }, n.prototype._mounted = function() {
    this._unsubscribe = kd(this._onExternalDrag), pe(this._el, "keydown", this._onKeyDown);
  }, n.prototype._updated = function() {
    var e = this;
    if (this._shouldScroll && this.state.eventList && this.state.isListScrollable && (es(this, function() {
      e._scrollToDay(), e._shouldAnimateScroll = void 0;
    }), this._shouldScroll = !1), this._shouldLoadDays && (this._shouldLoadDays = !1, Ft(this._list.querySelectorAll("[mbsc-timestamp]"), function(r) {
      e._listDays[r.getAttribute("mbsc-timestamp")] = r;
    })), this._shouldEnhance && (this._shouldEnhance = this._shouldEnhance === "popover" ? this._popoverList : this._list), this._triggerCreated) {
      var t = this._triggerCreated, a = t.source === "calendar" ? this._calendarView._body.querySelector('.mbsc-calendar-table-active .mbsc-calendar-text[data-id="' + t.event.id + '"]') : this._el.querySelector('.mbsc-schedule-event[data-id="' + t.event.id + '"]');
      this._hook("onEventCreated", K({}, this._triggerCreated, { target: a })), this._triggerCreated = null;
    }
    if (this._triggerUpdated) {
      var i = this._triggerUpdated;
      a = i.source === "calendar" ? this._calendarView._body.querySelector('.mbsc-calendar-table-active .mbsc-calendar-text[data-id="' + i.event.id + '"]') : this._el.querySelector('.mbsc-schedule-event[data-id="' + i.event.id + '"]'), this._hook("onEventUpdated", K({}, this._triggerUpdated, { target: a })), this._triggerUpdated = null;
    }
    this._triggerDeleted && (this._hook("onEventDeleted", K({}, this._triggerDeleted)), this._triggerDeleted = null), this._viewChanged && setTimeout(function() {
      e._viewChanged = !1;
    }, 10), this._shouldSkipScroll && setTimeout(function() {
      e._shouldSkipScroll = !1;
    }), this._navigateToEvent && setTimeout(function() {
      e._navigateToEvent = void 0;
    }), this._skipScheduleScroll = !1;
  }, n.prototype._destroy = function() {
    this._unsubscribe && Md(this._unsubscribe), le(this._el, "keydown", this._onKeyDown);
  }, n.prototype._resetSelection = function() {
    this.s.selectMultipleEvents && Object.keys(this._selectedEventsMap).length > 0 && (this._selectedEventsMap = {}, this._onSelectedEventsChange([]), this.forceUpdate());
  }, n.prototype._getAgendaEvents = function(e, t, a) {
    var i = this, r = [], o = this.s;
    if (a && this._showEventList)
      for (var l = function(c) {
        var d = a[Pe(c)];
        if (d && d.length) {
          var m = Ks(d, o.eventOrder);
          r.push({ date: Xe(o.dateFormatLong, c, o), events: m.map(function(h) {
            return i._getEventData(h, c);
          }), timestamp: +c });
        }
      }, u = Ce(e); u < t; u.setDate(u.getDate() + 1))
        l(u);
    return r;
  }, n.prototype._getEventData = function(e, t, a, i) {
    var r = this.s;
    return !e.color && e.resource && a === void 0 && (a = (this._resourcesMap || {})[at(e.resource) ? e.resource[0] : e.resource]), Nd(r, e, t, this._colorEventList, a, !0, !0, !1, !1, i);
  }, n.prototype._getValidDay = function(e, t) {
    t === void 0 && (t = 1);
    var a = this._rangeStartDay, i = this._rangeEndDay;
    if (!this._showCalendar && this._rangeType === "day" && a !== void 0 && i !== void 0) {
      var r = new Date(e), o = r.getDay(), l = 0;
      if ((i < a ? o > i && o < a : o > i || o < a) && (l = t < 0 ? i - o : a - o), l)
        return +ce(r, l += t < 0 ? l > 0 ? -7 : 0 : l < 0 ? 7 : 0);
    }
    return e;
  }, n.prototype._setEventList = function(e, t) {
    var a = this;
    setTimeout(function() {
      a._eventListHTML = void 0, a._shouldScroll = !0, a._listDays = null, a._scrollToDay(0), a.setState({ eventList: a._getAgendaEvents(e, t, a._eventMap) });
    });
  }, n.prototype._showPopover = function(e, t, a, i, r, o) {
    var l = this;
    this.state.showPopover && e === this.state.popoverKey || setTimeout(function() {
      l._anchor = i, l.setState({ popoverContext: r, popoverDate: t, popoverHidden: !1, popoverHost: o, popoverKey: e, popoverList: a, showPopover: !0 });
    });
  }, n.prototype._hidePopover = function() {
    this.state.showPopover && this.setState({ popoverDrag: !1, showPopover: !1 });
  }, n.prototype._scrollToDay = function(e) {
    var t = this;
    if (this._list) {
      var a = e, i = void 0;
      if (e === void 0 && this._listDays) {
        var r = this._listDays[this._selected], o = this._navigateToEvent && this._navigateToEvent.id;
        if (r && (a = r.offsetTop, o !== void 0)) {
          var l = r.querySelector('.mbsc-event[data-id="' + o + '"]'), u = r.querySelector(".mbsc-event-day");
          l && (a = l.offsetTop - (u ? u.offsetHeight : 0) + 1);
        }
        a !== void 0 && (i = this._shouldAnimateScroll);
      }
      a !== void 0 && (this._isListScrolling++, td(this._list, void 0, a, i, !1, function() {
        setTimeout(function() {
          t._isListScrolling--;
        }, 150);
      }));
    }
  }, n.prototype._selectedChange = function(e, t) {
    var a = new Date(e);
    this.s.selectedDate !== void 0 || t || this.setState({ selectedDate: +e }), this._emit("selectedDateChange", a), this._hook("onSelectedDateChange", { date: a });
  }, n.prototype._cellClick = function(e, t) {
    this._hook(e, K({ target: t.domEvent.currentTarget }, t));
  }, n.prototype._dayClick = function(e, t) {
    var a = Pe(t.date), i = Ks(this._eventMap[a], this.s.eventOrder);
    t.events = i, this._hook(e, t);
  }, n.prototype._labelClick = function(e, t) {
    t.label && this._hook(e, { date: t.date, domEvent: t.domEvent, event: t.label, source: "calendar" });
  }, n.prototype._eventClick = function(e, t) {
    return t.date = new Date(t.date), this._hook(e, t);
  }, n.prototype._handleMultipleSelect = function(e) {
    var t = e.label || e.event;
    if (t && this.s.selectMultipleEvents) {
      var a = e.domEvent, i = a.shiftKey || a.ctrlKey || a.metaKey ? this._selectedEventsMap : {}, r = t.occurrenceId || t.id;
      i[r] ? delete i[r] : i[r] = t, this._selectedEventsMap = K({}, i), this._onSelectedEventsChange(Kr(i)), this.s.selectedEvents === void 0 && this.forceUpdate();
    }
  }, n.defaults = K({}, qf, { actionableEvents: !0, allDayText: "All-day", data: [], newEventText: "New event", noEventsText: "No events", showControls: !0, showEventTooltip: !0, view: { calendar: { type: "month" } } }), n._name = "Eventcalendar", n;
}(it), s_ = /* @__PURE__ */ function() {
  function s() {
    this.onInstanceReady = new Fn(), this.onComponentChange = new Fn();
  }
  return Object.defineProperty(s.prototype, "instance", { get: function() {
    return this.inst;
  }, set: function(n) {
    this.inst = n, this.onInstanceReady.next(n);
  }, enumerable: !0, configurable: !0 }), s;
}(), jl = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return t = this, a = e.children, _("div", { ref: t._setEl, className: t._cssClass }, a);
    var t, a;
  }, n;
}(/* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._render = function(e) {
    this._cssClass = this._className + this._rtl + " mbsc-font mbsc-list" + this._theme;
  }, n;
}(it)), a_ = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return t = this, a = e.children, _("div", { ref: t._setEl, className: t._cssClass }, a);
    var t, a;
  }, n;
}(/* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._render = function(e) {
    this._cssClass = this._className + " mbsc-list-header" + this._theme + this._hb;
  }, n;
}(it)), r_ = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return function(t, a, i) {
      var r = a.props;
      r.actionable, r.children, r.className, r.drag, r.event, r.eventData, r.ripple, r.rtl;
      var o = r.theme;
      r.themeVariant, r.onHoverIn, r.onHoverOut, r.onDragEnd, r.onDragMove, r.onDragStart, r.onDragModeOn, r.onDragModeOff, r.onDelete, r.onClick;
      var l = Bn(r, ["actionable", "children", "className", "drag", "event", "eventData", "ripple", "rtl", "theme", "themeVariant", "onHoverIn", "onHoverOut", "onDragEnd", "onDragMove", "onDragStart", "onDragModeOn", "onDragModeOff", "onDelete", "onClick"]);
      return _("div", K({ tabIndex: 0, ref: a._setEl, onClick: a._onClick, className: a._cssClass }, l), i, _("div", { className: "mbsc-list-item-background mbsc-" + o }));
    }(0, this, e.children);
  }, n;
}(/* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._onClick = function(t) {
      e._hook("onClick", { domEvent: t }), e.s.selected && e.setState({ hasFocus: !1 });
    }, e;
  }
  return de(n, s), n.prototype._mounted = function() {
    var e, t, a = this;
    this._unlisten = Kt(this._el, { click: !0, keepFocus: !0, onBlur: function() {
      a.setState({ hasFocus: !1 });
    }, onEnd: function(i) {
      if (e) {
        var r = a.s, o = K({}, i), l = r.eventData;
        o.domEvent.preventDefault(), o.drag = !0, o.event = r.event, o.eventData = l, o.resource = l && l.currentResource && l.currentResource.id, a._hook("onDragEnd", o), e = !1;
      }
      clearTimeout(t);
    }, onFocus: function() {
      a.setState({ hasFocus: !0 });
    }, onHoverIn: function(i) {
      a.s.actionable && a.setState({ hasHover: !0 }), a._hook("onHoverIn", { domEvent: i });
    }, onHoverOut: function(i) {
      a.setState({ hasHover: !1 }), a._hook("onHoverOut", { domEvent: i });
    }, onKeyDown: function(i) {
      var r = a.s.event;
      switch (i.keyCode) {
        case 13:
        case 32:
          a._el.click(), i.preventDefault();
          break;
        case 8:
        case 46:
          r && r.editable !== !1 && a._hook("onDelete", { domEvent: i, event: r, source: "agenda" });
      }
    }, onMove: function(i) {
      var r = a.s, o = K({}, i), l = r.eventData;
      o.drag = !0, o.event = r.event, o.eventData = l, o.external = !0, o.resource = l && l.currentResource && l.currentResource.id, !e && o.isTouch || o.domEvent.preventDefault(), e ? a._hook("onDragMove", o) : (Math.abs(o.deltaX) > 7 || Math.abs(o.deltaY) > 7) && (clearTimeout(t), !o.isTouch && r.drag && r.event.editable !== !1 && (e = !0, a._hook("onDragStart", o)));
    }, onPress: function() {
      a.s.actionable && a.setState({ isActive: !0 });
    }, onRelease: function() {
      a.setState({ isActive: !1 });
    }, onStart: function(i) {
      var r = a.s;
      return i.isTouch && r.drag && r.event.editable !== !1 && !e && (t = setTimeout(function() {
        var o = K({}, i), l = r.eventData;
        o.drag = !0, o.event = r.event, o.eventData = l, o.resource = l && l.currentResource && l.currentResource.id, a._hook("onDragModeOn", o), a._hook("onDragStart", o), e = !0;
      }, 350)), { ripple: r.actionable && r.ripple };
    } });
  }, n.prototype._render = function(e, t) {
    this._cssClass = this._className + " mbsc-list-item" + this._theme + this._hb + this._rtl + (e.actionable ? " mbsc-list-item-actionable" : "") + (t.hasFocus ? " mbsc-focus" : "") + (t.hasHover ? " mbsc-hover" : "") + (t.isActive ? " mbsc-active" : "") + (e.selected ? " mbsc-selected" : "");
  }, n.prototype._destroy = function() {
    this._unlisten && this._unlisten();
  }, n.defaults = { actionable: !0, ripple: !1 }, n._name = "ListItem", n;
}(it)), qe = "mbsc-def";
function Wl(s, n, e, t, a, i, r) {
  for (var o = r.showEventBuffer !== !1, l = i === "start-end", u = r.exclusiveEndDates ? e : Ce(ce(e, 1)), c = 0, d = Object.keys(s); c < d.length; c++)
    for (var m = s[d[c]], h = Ce(n); h < u; h.setDate(h.getDate() + 1)) {
      var f = m[Pe(h)];
      if (f) {
        if ((t || a) && f.allDay[0] && (!l || Ke(h, n) || Ke(h, e)))
          return f.allDay[0].original;
        if (!t)
          for (var p = 0, g = f.data; p < g.length; p++) {
            var v = g[p], y = v.original, b = o && v.bufferStart ? v.bufferStart : v.startDate, D = o && v.bufferEnd ? v.bufferEnd : v.endDate;
            if (l) {
              if (ss(b, D, n, n, !0) || ss(b, D, e, e))
                return y;
            } else if (ss(b, D, n, e))
              return y;
          }
      }
    }
  return !1;
}
function $i(s, n, e, t, a, i, r, o, l) {
  var u = s.allDay || e, c = l && s.bufferStart ? s.bufferStart : s.startDate;
  if (t && e && !a) {
    var d = o[Pe(c)];
    return c < i ? i : r[d + (nn(c.getDay(), n.startDay, n.endDay) ? 0 : 1)].date;
  }
  return u ? me(n, c.getFullYear(), c.getMonth(), c.getDate()) : c;
}
function qi(s, n, e, t, a, i, r, o, l) {
  var u = s.allDay || e, c = l && s.bufferEnd ? s.bufferEnd : s.endDate;
  if (t && e && !a) {
    var d = o[Pe(Xt(n, s.allDay, s.startDate, c))], m = c >= i || d >= r.length - 1 ? i : r[d + 1].date;
    return Xt(n, !1, s.startDate, m);
  }
  var h = u ? Xt(n, s.allDay, s.startDate, c) : c;
  return u ? me(n, h.getFullYear(), h.getMonth(), h.getDate(), 23, 59, 59, 999) : h;
}
function i_(s, n, e, t, a, i, r, o, l, u, c, d, m, h) {
  for (var f = s.showEventBuffer !== !1, p = e.allDay ? l : u, g = e.allDay ? c : d, v = $i(e, s, i, r, o, p, m, h, f), y = qi(e, s, i, r, o, g, m, h, f), b = !1, D = 0, w = n; D < w.length; D++) {
    for (var C = w[D], T = 0, N = !1, O = void 0, L = 0, H = C.stacks; L < H.length; L++) {
      for (var A = H[L], B = !1, I = 0, S = A; I < S.length; I++) {
        var k = S[I], R = k.allDay ? l : u, z = k.allDay ? c : d;
        ss($i(k, s, i, r, o, R, m, h, f), qi(k, s, i, r, o, z, m, h, f), v, y, !0) && (B = !0, N = !0, O ? t[e.uid] = t[e.uid] || T : t[k.uid] = T + 1);
      }
      B || O || (O = A), T++;
    }
    N && (O ? O.push(e) : a === "all" || C.stacks.length < +a ? C.stacks.push([e]) : (e.position = void 0, C.more.push(e)), b = !0);
  }
  b || (t[e.uid] = 0, n.push({ stacks: [[e]], more: [] }));
}
function $l(s) {
  return (s = Math.abs(bt(s))) > 60 ? 60 * bt(s / 60) : 60 % s == 0 ? s : [6, 10, 12, 15, 20, 30].reduce(function(n, e) {
    return Math.abs(e - s) < Math.abs(n - s) ? e : n;
  });
}
function ri(s, n, e, t) {
  var a = nt(s), i = nt(n);
  return e > a && (a = e), t < i && (i = t), i - a;
}
function ii(s, n, e, t, a, i, r, o, l) {
  var u = i - a + 1, c = s, d = n, m = ce(Ce(d), 1);
  c < e && (c = e), d > t && (d = m = t);
  var h = nt(c), f = nt(d);
  a > h && (h = a), i < f && (f = i), Ke(c, d) || (h > i && (h = i), f < a && (f = a));
  var p = 0;
  if (Ke(c, d))
    p = l ? u : f - h;
  else
    for (var g = Ce(c); g < m; g.setDate(g.getDate() + 1))
      nn(g.getDay(), r, o) && (!l && Ke(g, c) ? p += u - h + a : !l && Ke(g, d) ? p += f - a : p += u);
  return p;
}
function oi(s, n, e, t, a, i) {
  t && t > s && (s = t);
  var r = nt(s);
  return (n > r || a !== void 0 && i !== void 0 && !nn(s.getDay(), a, i)) && (r = n), 100 * (r - n) / e;
}
function li(s, n, e, t, a) {
  s = s || {};
  var i = Object.keys(s), r = {}, o = n.map(function(m) {
    return m.id;
  }), l = e.map(function(m) {
    return m.id;
  });
  o.forEach(function(m) {
    r[m] = {}, l.forEach(function(h) {
      r[m][h] = {};
    });
  });
  for (var u = function(m) {
    for (var h = function(g) {
      var v = g.resource, y = g.slot, b = v !== void 0 && t ? at(v) ? v : [v] : o, D = y !== void 0 && a ? [y] : l;
      b.forEach(function(w) {
        var C = r[w];
        C && D.forEach(function(T) {
          var N = C[T];
          N && (N[m] || (N[m] = []), N[m].push(g));
        });
      });
    }, f = 0, p = s[m]; f < p.length; f++)
      h(p[f]);
  }, c = 0, d = i; c < d.length; c++)
    u(d[c]);
  return r;
}
function Od(s, n) {
  var e = new Date(s), t = new Date(+Bt + n);
  return new Date(e.getFullYear(), e.getMonth(), e.getDate(), t.getHours(), t.getMinutes());
}
var Fs = {}, o_ = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._onClick = function(t) {
      e._triggerClick("onClick", t);
      var a = e.s, i = Fs[a.event.uid];
      i && a.selected && i.next({ hasFocus: !1 });
    }, e._onRightClick = function(t) {
      e._triggerClick("onRightClick", t);
    }, e._onDocTouch = function(t) {
      le(e._doc, "touchstart", e._onDocTouch), le(e._doc, pt, e._onDocTouch), e._isDrag = !1, e._hook("onDragModeOff", { domEvent: t, event: e.s.event.original });
    }, e._updateState = function(t) {
      e.setState(t);
    }, e;
  }
  return de(n, s), n.prototype._render = function(e, t) {
    var a = e.event, i = new Date(a.date), r = a.position, o = a.startDate, l = Xt(e, a.allDay, o, a.endDate), u = e.isTimeline, c = e.isListing, d = a.original.more, m = d && u || c || a.allDay, h = !Ke(o, l), f = h && Ke(o, i), p = h && Ke(l, i), g = m && (!u || c || d), v = u ? "timeline" : "schedule", y = e.gridStartTime, b = e.gridEndTime, D = nt(o), w = nt(l), C = u && e.slot !== qe, T = nn(l.getDay(), e.startDay, e.endDay), N = e.singleDay ? ce(i, 1) : new Date(e.lastDay);
    a.allDay || (N = yn(e, N)), this._isStart = C || !h || f, this._isEnd = C || !h || (m || u && !e.hasResY ? l < N && T : p), C || m || !(y > D || b < D) || (this._isStart = !1), C || m || !(b < w || y > w) || (this._isEnd = !1), this._isMore = d, this._isDrag = this._isDrag || e.isDrag, this._content = void 0, this._rangeText = a.start + " - " + a.end, this._isAllDay = g, this._host = v, !a.allDay && (u && !e.hasResY || !h || f || p) || (this._rangeText = a.allDayText || " "), a.bufferBefore && (this._bufferStyleStart = u ? { width: a.bufferBefore } : { height: a.bufferBefore }), a.bufferAfter && (this._bufferStyleEnd = u ? { width: a.bufferAfter } : { height: a.bufferAfter }), this._cssClass = "mbsc-schedule-event" + this._theme + this._rtl + (e.render || e.template ? " mbsc-schedule-event-custom" : "") + (u ? " mbsc-timeline-event" : "") + (c || d ? " mbsc-timeline-event-listing" : "") + (this._isStart ? " mbsc-" + v + "-event-start" : "") + (this._isEnd ? " mbsc-" + v + "-event-end" : "") + (g ? " mbsc-schedule-event-all-day" : "") + (C ? " mbsc-timeline-event-slot" : "") + (t.hasFocus && !e.inactive && !e.selected || e.selected ? " mbsc-schedule-event-active" : "") + (!t.hasHover || e.inactive || this._isDrag ? "" : " mbsc-schedule-event-hover") + (e.isDrag ? " mbsc-schedule-event-dragging" + (u ? " mbsc-timeline-event-dragging" : "") : "") + (e.hidden ? " mbsc-schedule-event-hidden" : "") + (e.inactive ? " mbsc-schedule-event-inactive" : "") + (a.original.editable === !1 ? " mbsc-readonly-event" : "") + (a.original.cssClass ? " " + a.original.cssClass : ""), this._style = K({}, r, { color: a.color, top: e.eventHeight && r.top !== void 0 ? r.top * e.eventHeight + "px" : r.top });
    var O, L = e.render || e.renderContent;
    if (L && !d) {
      var H = L(a);
      ye(H) ? O = H : this._content = H;
    } else
      e.contentTemplate && !d || (O = a.html);
    O !== this._text && (this._text = O, this._html = O ? this._safeHtml(O) : void 0, this._shouldEnhance = O && !!L);
  }, n.prototype._mounted = function() {
    var e, t, a, i = this, r = this.s.event.uid, o = this._el, l = Fs[r];
    l || (l = new Fn(), Fs[r] = l), this._unsubscribe = l.subscribe(this._updateState), this._doc = vn(o), this._unlisten = Kt(o, { keepFocus: !0, onBlur: function() {
      l.next({ hasFocus: !1 });
    }, onDoubleClick: function(u) {
      u.domEvent.stopPropagation(), i._triggerClick("onDoubleClick", u.domEvent);
    }, onEnd: function(u) {
      if (i._isDrag) {
        var c = i.s, d = K({}, u);
        d.domEvent.preventDefault(), d.eventData = c.event, d.resource = c.resource, d.slot = c.slot, c.resize && e ? (d.resize = !0, d.direction = e) : c.drag && (d.drag = !0), i._hook("onDragEnd", d), c.isDrag || (i._isDrag = !1), o && d.moved && o.blur();
      }
      clearTimeout(a), e = void 0;
    }, onFocus: function() {
      l.next({ hasFocus: !0 });
    }, onHoverIn: function(u) {
      l.next({ hasHover: !0 }), i._triggerClick("onHoverIn", u);
    }, onHoverOut: function(u) {
      l.next({ hasHover: !1 }), i._triggerClick("onHoverOut", u);
    }, onKeyDown: function(u) {
      var c = i.s.event.original;
      switch (u.keyCode) {
        case 13:
        case 32:
          o.click(), u.preventDefault();
          break;
        case 8:
        case 46:
          c.editable !== !1 && i._hook("onDelete", { domEvent: u, event: c, resource: i.s.resource, slot: i.s.slot, source: i._host });
      }
    }, onMove: function(u) {
      var c = i.s, d = K({}, u);
      if (d.eventData = c.event, d.resource = c.resource, d.slot = c.slot, e)
        d.resize = !0, d.direction = e;
      else {
        if (!c.drag)
          return;
        d.drag = !0;
      }
      c.event.original.editable !== !1 && (!i._isDrag && d.isTouch || d.domEvent.preventDefault(), i._isDrag ? i._hook("onDragMove", d) : (Math.abs(d.deltaX) > 7 || Math.abs(d.deltaY) > 7) && (clearTimeout(a), d.isTouch || (d.domEvent = t, i._isDrag = !0, i._hook("onDragStart", d))));
    }, onStart: function(u) {
      t = u.domEvent;
      var c = i.s, d = K({}, u), m = t.target;
      if (d.eventData = c.event, d.resource = c.resource, d.slot = c.slot, c.resize && m.classList.contains("mbsc-schedule-event-resize"))
        e = m.classList.contains("mbsc-schedule-event-resize-start") ? "start" : "end", d.resize = !0, d.direction = e;
      else {
        if (!c.drag)
          return;
        d.drag = !0;
      }
      c.event.original.editable !== !1 && (i._isDrag ? (t.stopPropagation(), i._hook("onDragStart", d)) : d.isTouch && (a = setTimeout(function() {
        i._hook("onDragModeOn", d), i._hook("onDragStart", d), i._isDrag = !0;
      }, 350)));
    } }), this._isDrag && (pe(this._doc, "touchstart", this._onDocTouch), pe(this._doc, pt, this._onDocTouch));
  }, n.prototype._destroy = function() {
    if (this._el && this._el.blur(), this._unsubscribe) {
      var e = this.s.event.uid, t = Fs[e];
      t && (t.unsubscribe(this._unsubscribe), t.nr || delete Fs[e]);
    }
    this._unlisten && this._unlisten(), le(this._doc, "touchstart", this._onDocTouch), le(this._doc, pt, this._onDocTouch);
  }, n.prototype._triggerClick = function(e, t) {
    var a = this.s;
    this._hook(e, { date: a.event.date, domEvent: t, event: a.event.original, resource: a.resource, slot: a.slot, source: this._host });
  }, n;
}(it), xs = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return function(t, a) {
      var i, r, o, l = t.event, u = a._isAllDay, c = t.isTimeline, d = a._rtl, m = a._theme, h = t.resize && l.original.editable !== !1, f = ((i = {}).onContextMenu = a._onRightClick, i);
      return _("div", K({ tabIndex: 0, className: a._cssClass, "data-id": l.id, style: a._style, ref: a._setEl, title: l.tooltip, onClick: a._onClick }, f), a._isStart && l.bufferBefore && (t.renderBufferBefore && ye(r = t.renderBufferBefore(l)) && (o = a._safeHtml(r), a._shouldEnhance = !0), _("div", { className: "mbsc-" + a._host + "-event-buffer mbsc-" + a._host + "-event-buffer-before" + (r ? "" : " mbsc-schedule-event-buffer-background") + m + d, style: a._bufferStyleStart, dangerouslySetInnerHTML: o }, r)), a._isEnd && l.bufferAfter && function() {
        var p, g;
        return t.renderBufferAfter && ye(p = t.renderBufferAfter(l)) && (g = a._safeHtml(p), a._shouldEnhance = !0), _("div", { className: "mbsc-" + a._host + "-event-buffer mbsc-" + a._host + "-event-buffer-after" + (p ? "" : " mbsc-schedule-event-buffer-background") + m + d, style: a._bufferStyleEnd, dangerouslySetInnerHTML: g }, p);
      }(), a._isStart && h && _("div", { className: "mbsc-schedule-event-resize mbsc-schedule-event-resize-start" + (c ? " mbsc-timeline-event-resize" : "") + (t.isDrag ? " mbsc-schedule-event-resize-start-touch" : "") + d }), a._isEnd && h && _("div", { className: "mbsc-schedule-event-resize mbsc-schedule-event-resize-end" + (c ? " mbsc-timeline-event-resize" : "") + (t.isDrag ? " mbsc-schedule-event-resize-end-touch" : "") + d }), t.render && !a._isMore ? a._html ? _("div", { style: { height: "100%" }, dangerouslySetInnerHTML: a._html }) : a._content : _(ut, null, !u && !c && !a._isMore && _("div", { className: "mbsc-schedule-event-bar" + m + d }), _("div", { className: "mbsc-schedule-event-background" + (c ? " mbsc-timeline-event-background" : "") + (u ? " mbsc-schedule-event-all-day-background" : "") + m, style: { background: l.style.background } }), _("div", { "aria-hidden": "true", className: "mbsc-schedule-event-inner" + m + (u ? " mbsc-schedule-event-all-day-inner" : "") + (l.cssClass || ""), style: { color: l.style.color } }, _("div", { className: "mbsc-schedule-event-title" + (u ? " mbsc-schedule-event-all-day-title" : "") + m, dangerouslySetInnerHTML: a._html }, a._content), !u && !a._isMore && _("div", { className: "mbsc-schedule-event-range" + m }, a._rangeText)), l.ariaLabel && _("div", { className: "mbsc-hidden-content" }, l.ariaLabel)));
    }(e, this);
  }, n;
}(o_), Ld = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return function(t, a) {
      var i = t.timezones;
      return _("div", { "aria-hidden": "true", className: a._cssClass, style: a._pos }, _("div", { className: (i ? "mbsc-flex " : "") + "mbsc-schedule-time-indicator-time mbsc-schedule-time-indicator-time-" + t.orientation + a._theme + a._rtl }, i ? i.map(function(r, o) {
        return _("div", { key: o, className: "mbsc-schedule-time-indicator-tz" + a._theme + a._rtl }, a._times[o]);
      }) : a._time), t.showDayIndicator && _("div", { className: "mbsc-schedule-time-indicator-day" + a._theme + a._rtl, style: a._dayPos }));
    }(e, this);
  }, n;
}(/* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._mounted = function() {
    var e = this;
    clearInterval(this._timer), this._timer = setInterval(function() {
      e._zone ? e._zone.runOutsideAngular(function() {
        e.forceUpdate();
      }) : e.forceUpdate();
    }, 1e4);
  }, n.prototype._destroy = function() {
    clearInterval(this._timer);
  }, n.prototype._render = function(e) {
    var t = me(e), a = e.rtl, i = e.displayedDays, r = e.displayedTime, o = e.startTime, l = 6e4 * Le(nt(t) / 6e4), u = e.timezones, c = { amText: e.amText, pmText: e.pmText };
    if (u && Vn(t)) {
      this._times = [];
      for (var d = 0, m = u; d < m.length; d++) {
        var h = m[d], f = t.clone();
        f.setTimezone(h.timezone), this._times.push(Xe(e.timeFormat, f, c));
      }
    } else
      this._time = Xe(e.timeFormat, t, c);
    this._cssClass = "mbsc-schedule-time-indicator mbsc-schedule-time-indicator-" + e.orientation + this._theme + this._rtl + " " + (l < o || l > o + r || !nn(t.getDay(), e.startDay, e.endDay) ? " mbsc-hidden" : "");
    var p = e.hasResY ? 0 : Dd(e.firstDay, t, e.startDay, e.endDay);
    if (e.orientation === "x") {
      var g = 100 * p / i + "%", v = u && 4.25 * u.length + "em";
      this._pos = { left: u && !a ? v : void 0, right: u && a ? v : void 0, top: 100 * (l - o) / r + "%" }, this._dayPos = { left: a ? "" : g, right: a ? g : "", width: 100 / i + "%" };
    } else {
      var y = 100 * (p * r + l - o) / (i * r) + "%";
      this._pos = { left: a ? "" : y, right: a ? y : "" };
    }
  }, n;
}(it)), ci = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e, t) {
    return function(a, i, r) {
      var o;
      return a.renderDay && (o = a.renderDay(r._data)), a.renderDayContent && (o = a.renderDayContent(r._data)), ye(o) && (o = _("div", { dangerouslySetInnerHTML: r._safeHtml(o) }), r._shouldEnhance = !0), _("div", { ref: r._setEl, className: r._cssClass, onClick: r._onClick, style: { background: a.background } }, a.renderDay ? o : _(ut, null, _("div", { "aria-hidden": "true", className: "mbsc-schedule-header-dayname" + r._theme + (a.selected ? " mbsc-selected" : "") + (a.isToday ? " mbsc-schedule-header-dayname-curr" : "") }, a.dayNames[r._day]), _("div", { "aria-hidden": "true", className: "mbsc-schedule-header-day" + r._theme + r._rtl + (a.selected ? " mbsc-selected" : "") + (a.isToday ? " mbsc-schedule-header-day-today" : "") + (i.hasHover ? " mbsc-hover" : "") }, a.day), a.label && _("div", { className: "mbsc-hidden-content", "aria-pressed": a.selectable ? a.selected ? "true" : "false" : void 0, role: a.selectable ? "button" : void 0 }, a.label), a.renderDayContent && o));
    }(e, t, this);
  }, n;
}(/* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._onClick = function() {
      var t = e.s;
      t.selectable && t.onClick(t.timestamp);
    }, e;
  }
  return de(n, s), n.prototype._render = function(e, t) {
    var a = new Date(e.timestamp);
    this._cssClass = "mbsc-schedule-header-item " + this._className + this._theme + this._rtl + this._hb + (e.largeNames ? " mbsc-schedule-header-item-large" : "") + (e.selected ? " mbsc-selected" : "") + (t.hasHover ? " mbsc-hover" : ""), this._data = { date: a, events: e.events || [], resource: e.resource, selected: e.selected }, this._day = a.getDay();
  }, n.prototype._mounted = function() {
    var e = this;
    this._unlisten = Kt(this._el, { onHoverIn: function() {
      e.s.selectable && e.setState({ hasHover: !0 });
    }, onHoverOut: function() {
      e.s.selectable && e.setState({ hasHover: !1 });
    } });
  }, n.prototype._destroy = function() {
    this._unlisten && this._unlisten();
  }, n;
}(it)), Ad = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._isScrolling = 0, e._onScroll = function() {
    }, e._onMouseLeave = function(t, a) {
      !e._cursorTimeCont || e.state.dragData && !a || (e._cursorTimeCont.style.visibility = "hidden", e._isCursorTimeVisible = !1);
    }, e._onMouseMove = function(t) {
      if (e._showCursorTime) {
        var a = e.s, i = a.rtl, r = e._isTimeline, o = e._cursorTimeCont;
        if (!e._isTouch || e._tempStart ? !e._isCursorTimeVisible && t && (o.style.visibility = "visible", e._isCursorTimeVisible = !0) : (o.style.visibility = "hidden", e._isCursorTimeVisible = !1), e._isCursorTimeVisible && e._colWidth) {
          var l = e._gridCont.getBoundingClientRect(), u = t ? t.clientX : e._cursorX || 0, c = t ? t.clientY : e._cursorY || 0, d = i ? l.right - u : u - l.left, m = $e(c - l.top, 8, e._colHeight), h = void 0, f = void 0, p = void 0;
          if (e._dragDelta !== void 0)
            f = me(a, e._dragDelta < 0 ? e._tempStart : e._tempEnd), h = r && !e._hasResY ? e._dayIndexMap[Pe(f)] : 0, p = (p = nt(f)) === 0 ? e._dragDelta < 0 ? p : 864e5 : p;
          else {
            h = r && !e._hasResY ? $e(Le(d / e._colWidth), 0, e._daysNr - 1) : 0, p = e._startTime + Dl(Le(r ? e._time * (d - h * e._colWidth) / e._colWidth : e._time * (m - 8) / (e._colHeight - 16)), 6e4 * a.dragTimeStep);
            var g = e._days[h].date, v = new Date(+Bt + p);
            f = me(a, g.getFullYear(), g.getMonth(), g.getDate(), v.getHours(), v.getMinutes());
          }
          var y = e._time * (r ? e._daysNr : 1), b = r ? i ? "right" : "left" : "top", D = o.style;
          D[b] = 100 * (h * e._time + p - e._startTime) / y + "%", D[i ? "left" : "right"] = "", o.textContent = Xe(a.timeFormat, f, a), e._cursorX = u, e._cursorY = c;
        }
      }
    }, e._onEventClick = function(t) {
      var a = t.event.more;
      a ? e._hook("onMoreClick", { context: e._scrollCont, date: t.date, key: t.event.id, list: a, target: t.domEvent.target }) : e._hook("onEventClick", t);
    }, e._onEventDragModeOn = function(t) {
      e.s.externalDrag && t.drag && !t.create && bn.next(K({}, t, { create: !0, eventName: "onDragModeOn", external: !0, from: e }));
      var a = t.create ? e._tempEvent : t.eventData, i = t.create ? e._tempResource : t.resource, r = t.create ? e._tempSlot : t.slot;
      e.setState({ dragData: { draggedEvent: a, originDates: t.external ? void 0 : e._getDragDates(a, i, r), resource: i }, isTouchDrag: !0 });
    }, e._onEventDragModeOff = function(t) {
      e._hook("onEventDragEnd", { domEvent: t.domEvent, event: t.create ? e._tempEvent.original : t.event, resource: e._tempResource !== qe ? e._tempResource : void 0, slot: e._tempSlot !== qe ? e._tempSlot : void 0, source: e._isTimeline ? "timeline" : "schedule" }), e.setState({ dragData: void 0, isTouchDrag: !1 });
    }, e._onEventDragStart = function(t) {
      var a = e.s, i = t.click, r = a.eventList, o = e._isTimeline, l = e._visibleResources, u = e._slots, c = a.dragTimeStep, d = t.startX, m = t.startY;
      e._isTouch = t.isTouch, e._scrollY = 0, e._scrollX = 0, e._calcGridSizes();
      var h = a.rtl ? e._gridRight - d : d - e._gridLeft, f = $e(m - e._gridTop, 8, e._colHeight - 9), p = r ? e._cols : e._days, g = p.length, v = e._colWidth, y = v ? Le(h / v) : 1, b = e._resourceTops, D = e._scrollCont.scrollTop, w = 0, C = y, T = 0;
      if (a.externalDrag && t.drag && !t.create) {
        var N = _a(t.domEvent.target, ".mbsc-schedule-event", e._el).cloneNode(!0), O = N.classList;
        N.style.display = "none", O.add("mbsc-drag-clone", "mbsc-schedule-drag-clone", "mbsc-font"), O.remove("mbsc-schedule-event-hover"), e._clone = N, e._body = vn(e._el).body, e._body.appendChild(N), e._eventDropped = !1, bn.next(K({}, t, { create: !0, dragData: t.eventData.original, eventName: "onDragStart", external: !0, from: e }));
      }
      if (o) {
        if (T = v ? Le(h / (v / u.length)) % u.length : 0, e._hasResY)
          p.forEach(function(fe, he) {
            l.forEach(function(oe, Ee) {
              f > b[fe.dateKey + "-" + oe.id] && (C = he, w = Ee);
            });
          });
        else {
          l.forEach(function(fe, he) {
            f > b[fe.id] && (w = he);
          });
          var L = f - D + e.state.headerHeight;
          if (D && L < e._fixedHeight && f - D > 0)
            for (var H = 0, A = e._fixedResources; H < A.length; H++) {
              var B = A[H];
              L > e._fixedResourceTops[B.key] && (w = B.index);
            }
        }
        e._startSlotIndex = T;
      } else {
        var I = e._groupByResource, S = I ? g : e._hasSlots ? e._slots.length : l.length;
        w = I ? Le(y / S) : y % S, C = I ? y % S : Le(y / S);
      }
      var k = t.external ? void 0 : l[w], R = k ? k.id : void 0, z = t.external ? void 0 : u[T], W = z ? z.id : void 0;
      if (k && k.eventCreation === !1)
        return !1;
      if (t.create) {
        C = $e(C, 0, g - 1);
        var M = !o && a.showAllDay && t.endY < e._gridContTop, P = a.type === "day" && a.size === 1 ? e._firstDay : p[C].date, Y = r || !t.external && !i ? 6e4 * c : e._stepCell, q = e._getGridTime(P, h, f, C, i ? e._stepCell / 6e4 : c), U = !e._isDailyResolution || M || r ? M ? P : yn(a, P) : q, j = a.resolution === "year" ? Xn(U, 12, a) : a.resolution === "quarter" ? Xn(U, 3, a) : a.resolution === "month" ? Xn(U, 1, a) : a.resolution === "week" ? ce(U, a.endDay - a.startDay + 1 + (a.endDay < a.startDay ? 7 : 0)) : ce(U, 1), ee = a.exclusiveEndDates ? j : new Date(+j - 1), ne = M || r ? ee : Nn(me(a, +U + Y), i ? 1 : c), G = a.extendDefaultEvent ? a.extendDefaultEvent({ resource: R, slot: W, start: U }) : void 0, te = K({ allDay: M, end: ne, id: _r(), resource: k && R !== qe ? R : void 0, slot: z && W !== qe ? W : void 0, start: U, title: a.newEventText }, G, t.dragData), Z = e._getEventData(te, P, k);
        if (o && R !== void 0 && e._setRowHeight && (Z.position.top = $e(Le((f - (e._fixedResourceTops[R] ? D : 0) - b[R]) / e._eventHeight), 0, e._eventRows[R] - 1)), t.dragData) {
          var re = +Z.endDate - +Z.startDate;
          Wi(t.dragData.dragInTime, void 0, a.dragInTime) && (Z.startDate = P, Z.endDate = new Date(+P + re));
        }
        e._tempEvent = Z, e._tempResource = R, e._tempSlot = W;
      }
      return e._hook("onPopoverClose", { source: "dragStart" }), i || e._hook("onEventDragStart", { action: t.create ? "create" : t.resize ? "resize" : "move", domEvent: t.domEvent, event: (t.create ? e._tempEvent : t.eventData).original, resource: R !== qe ? R : void 0, slot: W !== qe ? W : void 0, source: o ? "timeline" : "schedule" }), !0;
    }, e._onEventDragMove = function(t) {
      clearTimeout(e._scrollTimer);
      var a = e.s, i = a.rtl, r = i ? -1 : 1, o = e._isTimeline, l = a.eventList, u = a.resolution === "month" || a.resolution === "year", c = l ? e._cols : e._days, d = e._colWidth, m = c.length, h = e._slots, f = e._groupByResource, p = e._visibleResources, g = e.state.dragData, v = a.dragTimeStep, y = a.timeFormat, b = t.startX, D = $e(t.endX, e._gridContLeft, e._gridContRight - 1), w = $e(t.endY, e._gridContTop, e._gridContBottom - 1), C = w - t.startY + e._scrollY, T = i ? b - D + e._scrollX : D - b + e._scrollX, N = o ? T : C, O = o ? d : e._colHeight - 16, L = e._gridRight - e._gridLeft - 1, H = $e(t.startY - e._gridTop, 8, e._colHeight - 9), A = $e(i ? e._gridRight + e._scrollX - D : D - e._gridLeft + e._scrollX, 0, L), B = $e(w - e._gridTop + e._scrollY, 8, e._colHeight - 9), I = Le((i ? e._gridRight - b : b - e._gridLeft) / d), S = Le(A / d), k = a.showAllDay && t.endY < e._gridContTop, R = e._resourceTops, z = e._hasResY, W = e._scrollCont, M = W.scrollTop, P = t.create ? e._tempEvent : t.eventData, Y = P.original, q = K({}, P), U = I, j = S, ee = 0, ne = 0, G = !1, te = e._gridContBottom - t.endY, Z = t.endY - e._gridContTop, re = t.endX - e._gridContLeft, fe = e._gridContRight - t.endX, he = (W.scrollWidth - W.clientWidth) * r, oe = i ? 0 : he, Ee = i ? he : 0;
      if (a.externalDrag && t.drag && !t.create && (bn.next(K({}, t, { clone: e._clone, create: !0, dragData: Y, eventName: "onDragMove", external: !0, from: e })), !e._onCalendar))
        return Id(t, e._clone), void (g || e.setState({ dragData: { draggedEvent: q } }));
      if (te < 30 && M < W.scrollHeight - W.clientHeight && (W.scrollTop += 5, e._scrollY += 5, G = !0), Z < 30 && !k && M > 0 && (W.scrollTop -= 5, e._scrollY -= 5, G = !0), re < 30 && W.scrollLeft > Ee && (W.scrollLeft -= 5, e._scrollX -= 5 * r, G = !0), fe < 30 && W.scrollLeft < oe && (W.scrollLeft += 5, e._scrollX += 5 * r, G = !0), G && (e._scrollTimer = setTimeout(function() {
        e._onEventDragMove(t);
      }, 20)), o)
        if (ne = Le(A / (d / h.length)) % h.length, z)
          c.forEach(function(qn, Tn) {
            p.forEach(function(ba, Rr) {
              H > R[qn.dateKey + "-" + ba.id] && (U = Tn), B > R[qn.dateKey + "-" + ba.id] && (j = Tn, ee = Rr);
            });
          });
        else {
          p.forEach(function(qn, Tn) {
            B > R[qn.id] && (ee = Tn);
          });
          var Ie = B - M + e.state.headerHeight;
          if (M && Ie < e._fixedHeight && B - M > 0)
            for (var Se = 0, Ve = e._fixedResources; Se < Ve.length; Se++) {
              var je = Ve[Se];
              Ie > e._fixedResourceTops[je.key] && (ee = je.index);
            }
        }
      else {
        var Ne = f ? m : e._resources.length;
        U = f ? I % Ne : Le(I / Ne), j = f ? S % Ne : Le(S / Ne), ee = f ? Le(S / Ne) : S % Ne;
      }
      U = $e(U, 0, m - 1), j = $e(j, 0, m - 1);
      var E = P.startDate, F = P.endDate, V = +F - +E, J = e._time, ie = Le(J * N / O), _e = p[ee], ve = t.create ? e._tempResource : t.resource, Oe = t.create ? e._tempSlot : t.slot;
      if (_e.eventCreation === !1 && e._tempResource === void 0)
        return !1;
      var we, Ue = h[ne].id, et = _e.eventCreation !== !1 ? _e.id : e._tempResource, Be = P.allDay, ke = Be ? void 0 : a, ze = Be || l, Te = E, Ae = F, Ot = !0, ot = !0, lt = !0, Qt = c[U].date, Lt = c[j].date, ht = a.type === "day" && a.size === 1 ? 0 : an(Qt, Lt), Vt = j - U, xt = a.resolution === "year" ? 12 : 1, Os = ht - Vt;
      if ((t.drag && !t.create || t.external) && (t.external || (Ot = Xf(Y.dragBetweenResources, e._resourcesMap[ve].eventDragBetweenResources, a.dragBetweenResources), ot = Kf(Y.dragBetweenSlots, e._resourcesMap[ve].eventDragBetweenSlots, h[e._startSlotIndex || 0].eventDragBetweenSlots, a.dragBetweenSlots)), lt = Wi(Y.dragInTime, t.external || e._resourcesMap[ve].eventDragInTime, a.dragInTime)), t.drag || t.external)
        if (o || Ot || ve === et || (ht = e._dragDayDelta), o && l && u)
          Te = Xn(E, Vt * xt, a), Ae = Xn(F, Vt * xt, a);
        else {
          if (ze = (Be = k || o && P.allDay) || l, ke = Be ? void 0 : a, !o && !k && (P.allDay || t.external) || o && t.external && !P.allDay && !l) {
            var Ar = Ce(ce(E, ht));
            Te = e._getGridTime(Ar, A, B, j, v);
          } else
            !o || ze || z ? (we = ce(E, ht), Te = ze ? we : Nn(me(ke, +we + ie), v)) : Te = Nn(me(a, +E + ie + (864e5 - J) * ht + J * Os), v);
          _e.eventCreation !== !1 || o || (Te = me(a, e._tempStart)), Ae = me(ke, +Te + V);
        }
      else {
        var Ls = o ? Vt : S - I, jn = t.create ? Ls ? Ls > 0 : N > 0 : t.direction === "end", os = an(E, F);
        !o && f && ve !== et && (ht = e._dragDayDelta), jn ? o && l && u ? Ae = Xn(F, Vt * xt, a) : !o || ze || z ? (we = ce(F, Math.max(-os, ht)), Ae = ze ? we : Nn(me(ke, +we + ie), v), !ze && (nt(Ae) > e._endTime + 1 || Ae >= ce(Ce(we), 1)) && (Ae = me(a, +Ce(we) + e._endTime + 1))) : Ae = Nn(me(a, +F + ie + ht * (864e5 - J) + J * Os), v) : o && l && u ? Te = Xn(E, Vt * xt, a) : !o || ze || z ? (we = ce(E, Math.min(os, ht)), Te = ze ? we : Nn(me(ke, +we + ie), v), !ze && (nt(Te) < e._startTime || Te < Ce(we)) && (Te = me(a, +Ce(we) + e._startTime))) : Te = Nn(me(a, +E + ie + ht * (864e5 - J) + J * Os), v), et = ve, ze && Ae < Te && (jn ? Ae = me(a, Te) : Te = me(a, Ae)), !ze && (Ae < Te || Math.abs(+Ae - +Te) < 6e4 * v) && (jn ? Ae = me(a, +Te + 6e4 * v) : Te = me(a, +Ae - 6e4 * v));
      }
      if ((t.drag || t.external) && (lt || (Te = E, Ae = F, Be = e._tempAllDay), Ot || (et = ve), ot || (Ue = Oe)), e._tempStart !== +Te || e._tempEnd !== +Ae || e._tempAllDay !== Be || e._tempResource !== et || e._tempSlot !== Ue) {
        var Wn = void 0, $n = void 0;
        e._isDailyResolution ? (Wn = Xe(y, Te, a), $n = Xe(y, Ae, a)) : (Wn = Xe(a.dateFormat, Te, a), $n = Xe(a.dateFormat, Xt(a, Be, Te, Ae), a)), q.startDate = Te, q.endDate = Ae, q.start = Wn, q.end = $n, q.allDay = Be, q.date = +Lt, Y.bufferAfter && (q.bufferEnd = ue(+Ae + 6e4 * Y.bufferAfter, ke)), Y.bufferBefore && (q.bufferStart = ue(+Te - 6e4 * Y.bufferBefore, ke)), e._tempStart = +Te, e._tempEnd = +Ae, e._tempAllDay = Be, e._tempResource = et, e._tempSlot = Ue, e._dragDelta = t.drag || t.external ? -1 : t.direction ? t.direction === "end" ? 1 : -1 : N, e._dragDayDelta = ht, Be || e._onMouseMove(t.domEvent), e.setState({ dragData: { draggedDates: e._getDragDates(q, et, Ue), draggedEvent: q, originDate: P.date, originDates: g && g.originDates, originResource: t.external ? void 0 : ve, resource: et, slot: Ue } });
      }
      return !0;
    }, e._onEventDragEnd = function(t) {
      clearTimeout(e._scrollTimer);
      var a = e.s, i = t.create, r = e.state, o = r.dragData, l = !1;
      if (a.externalDrag && t.drag && !t.create && (bn.next(K({}, t, { action: "externalDrop", create: !0, dragData: t.eventData.original, eventName: "onDragEnd", external: !0, from: e })), e._body.removeChild(e._clone), e._onCalendar || (l = !0, e._eventDropped && (t.event = t.eventData.original, a.onEventDelete(t)))), i && !o && ((o = {}).draggedEvent = e._tempEvent), o && o.draggedEvent) {
        var u = a.showEventBuffer !== !1, c = t.eventData, d = o.draggedEvent, m = d.original, h = d.startDate, f = d.endDate, p = u && d.bufferStart || h, g = u && d.bufferEnd || f, v = d.allDay, y = i && !t.external ? e._tempResource : t.resource, b = o.resource === void 0 ? y : o.resource, D = m.resource === void 0 ? b : m.resource, w = i ? e._tempSlot : t.slot, C = o.slot === void 0 ? w : o.slot, T = {}, N = {}, O = e._isTimeline, L = O ? "timeline" : "schedule", H = i || +h != +c.startDate || +f != +c.endDate || v !== c.allDay || y !== b || w !== C, A = D, B = void 0;
        if (y !== b && (!i || t.external) && !e._isSingleResource)
          if (at(D) && D.length && b !== void 0) {
            var I = D.indexOf(y);
            D.indexOf(b) === -1 && (A = D.slice()).splice(I, 1, b);
          } else
            A = b;
        B = A && a.resources ? at(A) ? A : [A] : e._resources.map(function(Z) {
          return Z.id;
        });
        for (var S = e._resourcesMap[b], k = m.overlap !== !1 && S.eventOverlap !== !1 && a.eventOverlap !== !1, R = 0, z = B; R < z.length; R++) {
          var W = z[R];
          if (e._invalids[W] && (T[W] = e._invalids[W][C]), e._events[W]) {
            for (var M = {}, P = e._events[W][C], Y = 0, q = Object.keys(P); Y < q.length; Y++) {
              var U = q[Y], j = P[U];
              M[U] = { allDay: j.allDay.filter(function(Z) {
                return Z.id !== d.id && (!k || Z.original.overlap === !1);
              }), data: j.data.filter(function(Z) {
                return Z.id !== d.id && (!k || Z.original.overlap === !1);
              }) };
            }
            N[W] = M;
          }
        }
        var ee = t.action || (r.dragData ? "drag" : "click"), ne = !l && (!H || a.eventDragEnd({ action: ee, collision: Wl(T, p, g, v, O, a.invalidateEvent, a), create: i, domEvent: t.domEvent, event: d, external: t.external, from: t.from, newResource: b, newSlot: C, oldResource: y, oldSlot: w, overlap: Wl(N, p, g, v, O, "strict", a), resource: A !== qe ? A : void 0, slot: C !== qe ? C : void 0, source: L })), G = r.isTouchDrag && !l && (!i || ne);
        if (ne && G && y !== b && !m.color) {
          var te = S && S.color;
          te ? (d.color = te, d.style.background = te, d.style.color = Ts(te)) : (d.color = void 0, d.style = {});
        }
        G || ee === "click" || e._hook("onEventDragEnd", { domEvent: t.domEvent, event: (i ? e._tempEvent : c).original, resource: b !== qe ? b : void 0, slot: C !== qe ? C : void 0, source: L }), e.setState({ dragData: G ? { draggedEvent: ne ? d : K({}, c), originDate: ne ? d.date : c.date, originDates: ne ? e._getDragDates(d, b, C) : o.originDates, originResource: ne ? b : o.originResource } : void 0, isTouchDrag: G }), e._tempStart = 0, e._tempEnd = 0, e._tempAllDay = void 0, e._dragDelta = void 0, e._onMouseMove(t.domEvent), e._isTouch = !1;
      }
    }, e._onExternalDrag = function(t) {
      var a = e.s, i = t.clone, r = t.from === e, o = !r && a.externalDrop, l = r && a.externalDrag && !a.dragToMove, u = e.state.dragData;
      if (o || a.externalDrag) {
        var c = !l && t.endY < e._gridContBottom && t.endY > e._allDayTop && t.endX > e._gridContLeft && t.endX < e._gridContRight;
        switch (t.eventName) {
          case "onDragModeOff":
            o && e._onEventDragModeOff(t);
            break;
          case "onDragModeOn":
            o && e._onEventDragModeOn(t);
            break;
          case "onDragStart":
            o ? e._onEventDragStart(t) : r && (e._onCalendar = !0);
            break;
          case "onDragMove":
            if (!r && !o)
              return;
            c ? (e._onCalendar || e._hook("onEventDragEnter", { domEvent: t.domEvent, event: t.dragData, source: e._isTimeline ? "timeline" : "schedule" }), (r || o && e._onEventDragMove(t) !== !1) && (i.style.display = "none"), e._onCalendar = !0) : e._onCalendar && (e._hook("onEventDragLeave", { domEvent: t.domEvent, event: t.dragData, source: e._isTimeline ? "timeline" : "schedule" }), clearTimeout(e._scrollTimer), i.style.display = "table", r && !u || e.setState({ dragData: { draggedDates: {}, draggedEvent: r ? u && u.draggedEvent : void 0, originDates: r ? u && u.originDates : void 0 } }), e._tempStart = 0, e._tempEnd = 0, e._tempAllDay = void 0, e._tempResource = void 0, e._dragDelta = void 0, e._onCalendar = !1, e._onMouseLeave(void 0, !0));
            break;
          case "onDragEnd":
            o && (c && e._tempResource !== void 0 ? e._onEventDragEnd(t) : (e.setState({ dragData: void 0, isTouchDrag: !1 }), e._hook("onEventDragEnd", { domEvent: t.domEvent, event: t.dragData, resource: t.resource, slot: t.slot, source: t.source })));
        }
      }
    }, e;
  }
  return de(n, s), n.prototype._isToday = function(e) {
    return Ke(new Date(e), me(this.s));
  }, n.prototype._formatTime = function(e, t) {
    var a = this.s, i = a.timeFormat, r = /a/i.test(i) && this._stepLabel === 36e5 && e % 36e5 == 0 ? i.replace(/.[m]+/i, "") : i, o = new Date(+Bt + e), l = me(a, o.getFullYear(), o.getMonth(), o.getDate(), o.getHours(), o.getMinutes());
    return Vn(l) && t && l.setTimezone(t), Xe(r, l, a);
  }, n.prototype._getEventPos = function(e, t, a, i) {
    var r = this.s, o = e.allDay ? void 0 : r, l = me(o, t.getFullYear(), t.getMonth(), t.getDate()), u = Ce(ce(l, 1)), c = o ? this._firstDayTz : this._firstDay, d = o ? this._lastDayTz : this._lastDay, m = this._isTimeline, h = !m && !this._groupByResource, f = e.allDay, p = e.original, g = this._startTime, v = this._endTime + 1, y = this._time, b = this._hasSlots, D = this._hasResY, w = this._isDailyResolution, C = r.eventList, T = "", N = "", O = e.bufferStart, L = e.bufferEnd, H = D ? 0 : this._dayIndexMap[a], A = e.start, B = e.end, I = $i(e, r, C, m, w, c, this._cols, this._colIndexMap), S = qi(e, r, C, m, w, d, this._cols, this._colIndexMap), k = +I == +S ? 1 : 0, R = r.showEventBuffer !== !1 && !C && !f;
    if ((!f && !m || D && !b) && (I < l && (A = "", I = me(r, l)), S >= u && (B = "", S = me(r, +u - 1)), S >= u && (S = me(r, +u - 1))), f || m) {
      if (!i.get(p) || b || D || h) {
        var z = r.startDay, W = r.endDay, M = f || C, P = !Ke(I, S), Y = this._daysNr;
        m && P && nt(I) >= v && (I = me(r, +Ce(I) + v));
        var q = ii(I, S, c, d, g, v, z, W, M), U = oi(I, g, y, c, z, W), j = 100 * q / y;
        if (R && O) {
          var ee = ii(O, I, c, d, g, v, z, W, M);
          N = Math.max(0, 100 * ee / q) + "%";
        }
        if (R && L && (ee = ii(S, L, c, d, g, v, z, W, M), T = Math.max(0, 100 * ee / q) + "%"), m) {
          var ne = 0;
          if (C && !w && (H = this._dayIndexMap[Pe(I)]), r.resolution === "month" || r.resolution === "quarter") {
            var G = this._days[H].dayDiff, te = Pe(S >= d ? ce(d, -1) : S), Z = this._dayIndexMap[te];
            ne = this._days[Z].dayDiff - G;
          }
          j = (j + 100 * ne) / Y, U = (U + 100 * H) / Y;
        }
        var re = m ? M ? { left: r.rtl ? "" : (b ? "" : 100 * H / Y) + "%", right: r.rtl ? (b ? "" : 100 * H / Y) + "%" : "", width: (b ? "" : j) + "%" } : { height: this._setRowHeight ? "" : "100%", left: r.rtl ? "" : U + "%", right: r.rtl ? U + "%" : "", top: "0", width: j + "%" } : { width: (P && !h ? j : 100) + "%" }, fe = nt(I) < v && S > c, he = nt(S) + k > g;
        if (M || P && j > 0 || fe && he)
          return i.set(p, !0), { bufferAfter: T, bufferBefore: N, end: B, endDate: S, position: re, start: A, startDate: I };
      }
    } else if (nt(I) < v && nt(S) + k > g && S >= I) {
      var oe = 100 * (q = ri(I, S, g, v)) / y;
      return R && O && (Ke(O, I) || (O = me(r, +Ce(I) + g)), N = 100 * ri(O, I, g, v) / q + "%"), R && L && (Ke(L, I) || (L = me(r, +Ce(I) + v - 1)), T = 100 * ri(S, L, g, v) / q + "%"), { bufferAfter: T, bufferBefore: N, cssClass: oe < 2 ? " mbsc-schedule-event-small-height" : "", end: B, endDate: S, position: { height: oe + "%", top: oi(I, g, y) + "%", width: "100%" }, start: A, startDate: I };
    }
  }, n.prototype._getEventData = function(e, t, a, i) {
    var r = this.s, o = Nd(r, e, t, !0, a, !1, !this._isTimeline || this._hasResY, this._isDailyResolution, i);
    return e.allDay && r.exclusiveEndDates && +o.endDate == +o.startDate && (o.endDate = Ce(ce(o.startDate, 1))), o;
  }, n.prototype._getEvents = function(e) {
    var t = this, a = this.s, i = this._resources, r = this._slots, o = this._hasSlots, l = this._hasResY, u = this._isTimeline, c = !u, d = {}, m = li(e, i, r, !!a.resources, !!a.slots), h = {}, f = this._firstDay, p = this._lastDay, g = this._setRowHeight, v = {}, y = this._cols, b = this._createEventMaps || a.renderHour || a.renderHourFooter || a.renderDay || a.renderDayFooter || a.renderWeek || a.renderWeekFooter || a.renderMonth || a.renderMonthFooter || a.renderQuarter || a.renderQuarterFooter || a.renderYear || a.renderYearFooter;
    if (b && y.forEach(function(H) {
      return H.eventMap = { all: [] };
    }), a.connections)
      for (var D = 0, w = a.connections; D < w.length; D++) {
        var C = w[D];
        v[C.from] = !0, v[C.to] = !0;
      }
    for (var T = function(H) {
      var A = H.id, B = /* @__PURE__ */ new Map(), I = 0, S = [], k = {}, R = function(P, Y) {
        for (var q = 0; q < S.length; q++) {
          var U = S[q], j = U.stacks.length, ee = U.more.length;
          if (g && j > I && (I = j), !o)
            for (var ne = 0; ne < j; ne++)
              for (var G = 0, te = U.stacks[ne]; G < te.length; G++) {
                var Z = te[G], re = u && ee && !g ? 1 : 0, fe = ((k[Z.uid] || j + re) - ne) / (j + re) * 100;
                c ? (Z.position.width = fe + "%", Z.position[a.rtl ? "right" : "left"] = 100 * ne / j + "%", Z.position[a.rtl ? "left" : "right"] = "auto") : (Z.position.height = g ? "" : fe + "%", Z.position.top = g ? ne : 100 * ne / (j + re) + "%");
              }
          if (ee) {
            for (var he = void 0, oe = void 0, Ee = 0, Ie = U.more; Ee < Ie.length; Ee++) {
              var Se = Ie[Ee];
              (!he || Se.startDate < he) && (he = Se.startDate), (!oe || Se.endDate > oe) && (oe = Se.endDate);
            }
            var Ve = Y || new Date(U.more[0].date), je = Pe(Ve), Ne = "more-" + (c || l ? je + "-" : "") + A, E = a.moreEventsText || "", F = (ee > 1 && a.moreEventsPluralText || E).replace(/{count}/, ee), V = t._getEventData({ color: "#ddd", cssClass: "mbsc-schedule-event-more", editable: !1, end: oe, id: Ne + (o ? (l ? "" : "-" + je) + "-" + P : "") + "-" + q, more: U.more, start: he, text: (c ? "+" : "") + (u ? F : ee) }, Ve, H), J = t._getEventPos(V, Ve, je, B);
            J && (V.position = J.position, u ? (V.position.height = g ? "" : 100 / (j + 1) + "%", V.position.top = o ? "" : g ? j : 100 * j / (j + 1) + "%", d[A][P][l || o ? je : "all"].data.push(V)) : (V.showText = !0, V.position.width = "24px", V.position[a.rtl ? "right" : "left"] = "auto", V.position[a.rtl ? "left" : "right"] = "-24px", d[A][P][je].hasMore = !0, d[A][P][je].data.push(V))), t._eventRows[Ne] = 1;
          }
        }
      };
      d[A] = {};
      for (var z = function(P) {
        var Y = P.id, q = m[A][Y], U = Object.keys(q).sort();
        d[A][Y] = { all: { allDay: [], data: [] } }, c && (h[Y] = Ed(a, q, f, p, -1, N._daysNr, !0, a.startDay, !1, a.eventOrder));
        for (var j = function(G) {
          var te = e[G].date;
          if (N._dayIndexMap[G] !== void 0 && nn(te.getDay(), a.startDay, a.endDay)) {
            var Z = Ks(q[G]) || [];
            (c || l || o) && (S = [], k = {}), d[A][Y][G] = { allDay: [], data: [] }, l && (I = N._eventRows[G + "-" + A] || 0);
            for (var re = 0, fe = Z; re < fe.length; re++) {
              var he = fe[re];
              if (!he.allDay || u) {
                var oe = N._getEventData(he, te, H), Ee = N._getEventPos(oe, te, G, B);
                if (oe.position = void 0, Ee && (oe.cssClass = Ee.cssClass, oe.position = Ee.position, oe.bufferAfter = Ee.bufferAfter, oe.bufferBefore = Ee.bufferBefore, (c || l) && (oe.showText = !0), i_(a, S, oe, k, N._maxEventStack || 1, a.eventList, u, N._isDailyResolution, f, N._firstDayTz, p, N._lastDayTz, N._cols, N._colIndexMap), d[A][Y].all.data.push(oe), N._eventMap[oe.id] = oe, b))
                  for (var Ie = N._stepCell, Se = N._isDailyResolution && Ie < 864e5, Ve = he.allDay ? f : yn(a, f), je = oe.startDate > Ve ? oe.startDate : Ve, Ne = N._colIndexMap[Pe(je)], E = !0; E && Ne < y.length; ) {
                    for (var F = y[Ne], V = F.date, J = Ne < y.length - 1 ? y[Ne + 1].date : p, ie = V, _e = !1; ie < J; ) {
                      var ve = +ie, Oe = Se ? new Date(ve + Ie) : J, we = he.allDay ? V : yn(a, ie), Ue = he.allDay ? J : yn(a, Oe);
                      ss(oe.startDate, oe.endDate, we, Ue, !0) ? (F.eventMap[ve] || (F.eventMap[ve] = []), _e || (F.eventMap.all.push(oe.original), _e = !0), F.eventMap[ve].push(oe.original), E = !0) : E = !1, ie = Oe;
                    }
                    Ne++;
                  }
                d[A][Y][G].data.push(oe), u && he.allDay && d[A][Y][G].allDay.push(oe);
              }
            }
            c && h[Y][G] && h[Y][G].data.forEach(function(Te) {
              var Ae = Te.event, Ot = Te.width;
              if (Ae) {
                var ot = t._getEventData(Ae, te, H), lt = t._getEventPos(ot, te, G, B);
                lt && (ot.bufferAfter = lt.bufferAfter, ot.bufferBefore = lt.bufferBefore), ot.position = { width: lt ? lt.position.width : Ot }, ot.showText = !!lt, d[A][Y][G].allDay.push(ot);
              }
            }), (c || l || o) && R(Y, te), l && (N._eventRows[G + "-" + A] = I || 1);
          } else if (a.connections)
            for (var et = 0, Be = Z = q[G] || []; et < Be.length; et++) {
              var ke = Be[et], ze = ke.id;
              !N._eventMap[ze] && v[ze] && (N._eventMap[ze] = N._getEventData(ke, te, H));
            }
        }, ee = 0, ne = U; ee < ne.length; ee++)
          j(ne[ee]);
      }, W = 0, M = r; W < M.length; W++)
        z(M[W]);
      !u || o || l || R(qe), l || (N._eventRows[A] = I || 1);
    }, N = this, O = 0, L = i; O < L.length; O++)
      T(L[O]);
    return d;
  }, n.prototype._getInvalids = function(e) {
    var t, a = this.s, i = a.eventList, r = e || {}, o = {}, l = i ? Ce(new Date(a.minDate)) : new Date(a.minDate), u = i ? Ce(ce(new Date(a.maxDate), 1)) : new Date(a.maxDate), c = this._isTimeline;
    if (a.minDate)
      for (var d = Ce(this._firstDay); d < l; d.setDate(d.getDate() + 1))
        (L = r[O = Pe(d)] || []).push({ end: l, start: new Date(d) }), r[O] = L;
    if (a.maxDate)
      for (d = Ce(u); d < this._lastDay; d.setDate(d.getDate() + 1))
        (L = r[O = Pe(d)] || []).push({ end: new Date(this._lastDay), start: u }), r[O] = L;
    for (var m = li(r, this._resources, this._slots, !!a.resources, !!a.slots), h = Object.keys(r).sort(), f = 0, p = this._resources; f < p.length; f++) {
      var g = p[f], v = g.id, y = /* @__PURE__ */ new Map();
      o[v] = {};
      for (var b = 0, D = this._slots; b < D.length; b++) {
        var w = D[b].id, C = { allDay: [], data: [] };
        o[v][w] = { all: C };
        for (var T = 0, N = h; T < N.length; T++) {
          var O;
          if (d = ue(O = N[T]), this._dayIndexMap[O] !== void 0 && nn(d.getDay(), a.startDay, a.endDay)) {
            var L = m[v][w][O] || [], H = { allDay: [], data: [] }, A = [];
            o[v][w][O] = H;
            for (var B = 0, I = L; B < I.length; B++) {
              var S = I[B];
              if (ye(S) || xd(S)) {
                var k = ue(S);
                S = { allDay: !0, end: new Date(k), start: k };
              }
              var R = this._getEventData(S, d, g, !0);
              R.cssClass = S.cssClass ? " " + S.cssClass : "", R.position = void 0;
              var z = this._getEventPos(R, d, O, y);
              if (z && (!c && nt(z.startDate) === 0 && /* @__PURE__ */ new Date(+z.endDate + 1) >= ce(d, 1) ? R.allDay = !0 : (R.position = z.position, nt(z.startDate) <= this._startTime && (R.cssClass += " mbsc-schedule-invalid-start"), nt(z.endDate) >= this._endTime && (R.cssClass += " mbsc-schedule-invalid-end")), A.push(R)), H.data.push(R), R.allDay) {
                c || (R.position = {}, z && +R.startDate == +R.endDate && (R.endDate = z.endDate)), H.allDay = [R], H.data = [R], A = [R];
                break;
              }
            }
            (t = C.data).push.apply(t, A);
          }
        }
      }
    }
    return o;
  }, n.prototype._getColors = function(e) {
    for (var t = this.s, a = {}, i = li(e, this._resources, this._slots, !!t.resources, !!t.slots), r = Object.keys(e || {}).sort(), o = this._hasSlots, l = this._isTimeline, u = this._hasResY, c = 0, d = this._resources; c < d.length; c++) {
      var m = d[c], h = m.id, f = /* @__PURE__ */ new Map();
      a[h] = {};
      for (var p = 0, g = this._slots; p < g.length; p++) {
        var v = g[p].id;
        a[h][v] = { all: { allDay: [], data: [] } };
        for (var y = 0, b = r; y < b.length; y++) {
          var D = b[y], w = ue(D);
          if (this._dayIndexMap[D] !== void 0 && nn(w.getDay(), t.startDay, t.endDay)) {
            var C = i[h][v][D] || [], T = u || o || !l ? D : "all";
            (!l || o || u) && (a[h][v][T] = { allDay: [], data: [] });
            for (var N = a[h][v][T], O = 0, L = C; O < L.length; O++) {
              var H = L[O], A = this._getEventData(H, w, m, !0);
              if (A.cssClass = H.cssClass ? " " + H.cssClass : "", A.allDay && !l)
                N.allDay = [A];
              else {
                var B = this._getEventPos(A, w, D, f);
                B && (A.position = B.position, nt(B.startDate) <= this._startTime && (A.cssClass += " mbsc-schedule-color-start"), nt(B.endDate) >= this._endTime && (A.cssClass += " mbsc-schedule-color-end"), N.data.push(A));
              }
              A.position.background = H.background, A.position.color = H.textColor ? H.textColor : Ts(H.background);
            }
          }
        }
      }
    }
    return a;
  }, n.prototype._flattenResources = function(e, t, a, i, r) {
    for (var o = e && e.length ? e : [{ id: qe }], l = this.s.immutableData, u = 0, c = o; u < c.length; u++) {
      var d = c[u], m = i && l ? K({}, d) : d, h = m.children;
      l && (m.original = d), m.depth = a, m.isParent = !(!h || !h.length), m.fixed = m.fixed || r, t.push(m), this._resourcesMap[m.id] = m, !i || !l && a || i.push(m), m.isParent && (this._hasHierarchy = !0, m.collapsed && !i || (i && l && (m.children = []), this._flattenResources(h, t, a + 1, i && m.children, m.fixed)));
    }
    return t;
  }, n.prototype._render = function(e, t) {
    var a = this, i = this._prevS, r = this._isTimeline, o = new Date(e.selected), l = +e.size, u = $l(e.timeLabelStep), c = $l(e.timeCellStep), d = e.firstDay, m = e.startDay, h = e.endDay, f = e.resources, p = e.slots, g = e.virtualScroll === !1, v = e.resolution, y = v === "day" || v === "hour" || !r, b = e.resolutionVertical === "day", D = !1, w = !1, C = this._startTime, T = this._endTime;
    if (m === i.startDay && h === i.endDay && e.checkSize === i.checkSize && e.eventList === i.eventList && e.refDate === i.refDate && e.size === i.size && e.type === i.type && e.resolution === i.resolution && e.resolutionVertical === i.resolutionVertical && e.displayTimezone === i.displayTimezone && e.weekNumbers === i.weekNumbers || (D = !0, this._viewChanged = !0), (D || e.rtl !== i.rtl || e.dateFormat !== i.dateFormat || e.getDay !== i.getDay || e.rowHeight !== i.rowHeight || e.maxEventStack !== i.maxEventStack) && (w = !0), e.startTime !== i.startTime || e.endTime !== i.endTime || e.timeLabelStep !== i.timeLabelStep || e.timeCellStep !== i.timeCellStep || e.timeFormat !== i.timeFormat || this._startTime === void 0 || this._endTime === void 0) {
      var N = ue(e.startTime || "00:00"), O = new Date(+ue(e.endTime || "00:00") - 1);
      this._startTime = C = nt(N), this._endTime = T = nt(O), this._time = T - C + 1, this._timesBetween = pa(Le(c / u) - 1), this._times = [], this._timeLabels = {}, this._viewChanged = !0;
      for (var L = 6e4 * c, H = Le(C / L) * L, A = function(En) {
        if (B._times.push(En), r) {
          var Rs = En === H;
          B._timeLabels[En] = Rs || En % (6e4 * u) == 0 ? B._formatTime(Rs ? C : En) : "", B._timesBetween.forEach(function(kn, Ma) {
            var Jt = En + (Ma + 1) * u * 6e4;
            a._timeLabels[Jt] = a._formatTime(Jt);
          });
        }
      }, B = this, I = H; I <= T; I += L)
        A(I);
      w = !0;
    }
    if (e.slots === i.slots && this._slots !== void 0 || (this._hasSlots = r && !!p && p.length > 0, this._slots = p && p.length ? p : [{ id: qe }], w = !0), f === i.resources && this._resources !== void 0 || (this._hasResources = !!f && f.length > 0, this._hasHierarchy = !1, this._resourcesMap = {}, this._resourcesCopy = [], this._resources = this._flattenResources(f, [], 0, this._resourcesCopy), this._visibleResources = this._flattenResources(this._resourcesCopy, [], 0), this._isSingleResource = this._resources.length === 1, w = !0), D || e.selected !== i.selected || e.getDay !== i.getDay || e.monthNames !== i.monthNames || e.dateFormat !== i.dateFormat || e.currentTimeIndicator !== i.currentTimeIndicator) {
      var S = wo(me(e)), k = e.type === "day", R = e.type === "month", z = e.type === "year", W = k && l < 2, M = e.navService, P = e.dateFormat.search(/m/i), Y = e.dateFormat.search(/y/i) < P, q = e.dateFormat.search(/d/i) < P, U = void 0, j = void 0, ee = void 0, ne = void 0;
      if (l > 1 || z || R ? (ee = U = M.firstDay, ne = j = M.lastDay) : (ee = ce(Et(o, e), m - d + (m < d ? 7 : 0)), k && (o < ee && (ee = ce(ee, -7)), o >= ce(ee, 7) && (ee = ce(ee, 7))), ne = ce(ee, h - m + 1 + (h < m ? 7 : 0)), U = k ? Ce(o) : ee, j = k ? ce(U, 1) : ne), r && v === "week" && (z || R) && (U = M.viewStart, j = M.viewEnd), e.selected !== i.selected && k && l < 2 && (w = !0), this._isMulti = l > 1 || z, this._isDailyResolution = y, this._hasResY = b, this._firstDayTz = me(e, U.getFullYear(), U.getMonth(), U.getDate()), this._lastDayTz = me(e, j.getFullYear(), j.getMonth(), j.getDate()), this._selectedDay = +Ce(o), this._shouldAnimateScroll = i.selected !== void 0 && e.selected !== i.selected && !this._viewChanged, this._showTimeIndicator = !e.eventList && (e.currentTimeIndicator === void 0 ? !r || y && c < 1440 : e.currentTimeIndicator) && (k && l < 2 ? Ke(S, o) : U <= S && j >= S), w || +U != +this._firstDay || +j != +this._lastDay) {
        this._firstDay = U, this._lastDay = j, this._colIndexMap = {}, this._cols = [], this._dayIndexMap = {}, this._days = [], this._headerDays = [];
        var G = 0, te = -1, Z = 0, re = 0, fe = -1, he = "", oe = -1, Ee = -1, Ie = "", Se = -1, Ve = -1, je = "", Ne = U, E = j, F = 0, V = void 0, J = 0;
        for (!r && W && (Ne = ee, E = ne), I = Ce(Ne); I < Ce(E); I.setDate(I.getDate() + 1)) {
          var ie = Pe(I), _e = I.getDay();
          if (this._dayIndexMap[ie] = G, nn(_e, m, h)) {
            var ve = void 0, Oe = "", we = "", Ue = y;
            if (r && !b) {
              J = e.getWeekNumber(ce(I, (7 - d + 1) % 7));
              var et = e.getDay(I), Be = e.getMonth(I), ke = e.getYear(I), ze = e.monthNames[Be];
              if (fe !== ke && (fe = ke, v === "year" && (Ue = !0, he = "" + fe)), oe !== Be) {
                if (v === "month")
                  he = z && l < 2 ? ze : Y ? ke + " " + ze : ze + " " + ke, Ue = !0;
                else if (v === "quarter" && Be % 3 == 0) {
                  var Te = Be / 3 + 1, Ae = e.quarterText.replace("{count}", "" + Te);
                  he = z && l < 2 ? Ae : Y ? ke + " " + Ae : Ae + " " + ke, Ue = !0;
                } else
                  y && (Oe = Ie = Y ? ke + " " + ze : ze + " " + ke);
                Ee = G, oe = Be, re = e.getMaxDayOfMonth(fe, oe);
              }
              if (Se !== J && (Ve = G, Se = J, we = je = e.weekText.replace(/{count}/, Se), G > 0 && (this._days[G - 1].lastOfWeek = !0)), (_e === m || !G) && v === "week") {
                var Ot = q ? "D MMM" : "MMM D";
                V = ce(I, h - m + (h < m ? 7 : 0)), he = Xe(Ot, I, e) + " - " + Xe(Ot, V, e), Ue = !0;
              }
              !(ve = et === re || _e === h && (m - h - 1 + 7) % 7 >= re - et) || v !== "month" && v !== "quarter" || (Z += 31 - re);
            }
            var ot = { columnTitle: he, date: new Date(I), dateIndex: G, dateKey: ie, dateText: Xe(b ? R && !this._isMulti ? "D DDD" : f ? e.dateFormatLong : e.dateFormat : R || this._isMulti ? "D DDD" : e.dateFormatLong, I, e), day: e.getDay(I), dayDiff: Z, endDate: V, eventMap: { all: [] }, label: Xe("DDDD, MMMM D, YYYY", I, e), lastOfMonth: ve, monthIndex: Ee, monthText: Ie, monthTitle: Oe, timestamp: +Ce(I), weekIndex: Ve, weekNr: J, weekText: je, weekTitle: we };
            if (Ue && (ot.isActive = I <= S && S < E, F && (this._cols[te].isActive = F <= +S && S < I), F = +I, this._cols.push(ot), te++), W && this._headerDays.push(ot), W && this._selectedDay !== +I || this._days.push(ot), ve && (v === "month" || v === "quarter"))
              for (var lt = re; lt < 31; lt++)
                this._days.push(ot), G++;
            G++;
          }
          this._colIndexMap[ie] = te < 0 ? 0 : te;
        }
        this._colsNr = b ? 1 : te + 1, this._daysNr = b || W ? 1 : G;
      }
    }
    this._groupByResource = e.groupBy !== "date" && !(e.type === "day" && l < 2) || this._isSingleResource, this._stepCell = 6e4 * c, this._stepLabel = 6e4 * u, this._dayNames = t.dayNameWidth > 49 ? e.dayNamesShort : e.dayNamesMin, this._displayTime = u < 1440 && y, this._eventHeight = t.eventHeight || (e.eventList ? 24 : 46), this._showCursorTime = this._displayTime && !!(e.dragToCreate || e.dragToMove || e.dragToResize), this._setRowHeight = e.eventList || e.rowHeight !== "equal", e.maxEventStack !== "auto" && (this._maxEventStack = e.maxEventStack || "all"), (e.colorsMap !== i.colorsMap || w) && (this._colors = this._getColors(e.colorsMap)), (e.eventMap !== i.eventMap || e.showEventBuffer !== i.showEventBuffer || w || !this._events || this._reloadEvents) && (this._eventMap = {}, this._eventRows = {}, this._events = this._getEvents(e.eventMap), this._reloadEvents = !1), (e.invalidsMap !== i.invalidsMap || w) && (this._invalids = this._getInvalids(e.invalidsMap));
    var Qt = r && e.eventMap !== i.eventMap;
    if ((e.height !== i.height || e.width !== i.width || Qt || w) && (this._shouldCheckSize = Mt && !!e.height && !!e.width), e.scroll !== i.scroll && (this._shouldScroll = !0), e.height !== void 0 && (this._hasSideSticky = gs && !e.rtl, this._hasSticky = gs), r) {
      var Lt = this._cols, ht = this._colsNr, Vt = [], xt = this._daysBatchNr === void 0 ? $e(Le(this._stepCell / (this._time / 30)), 1, 30) : this._daysBatchNr, Os = this._dayIndexMap[Pe(o)] || 0, Ar = t.batchIndexX !== void 0 ? t.batchIndexX : bt(Os / xt), Ls = Math.min(Ar * xt, ht - 1), jn = g ? 0 : Math.max(0, Ls - Le(3 * xt / 2)), os = g ? ht : Math.min(jn + 3 * xt, ht), Wn = Lt[jn].date, $n = os < ht ? Lt[os].date : this._lastDay, qn = {};
      for (G = jn; G < os; G++)
        qn[Lt[G].dateKey] = !0, Vt.push(Lt[G]);
      this._batchStart = me(e, Wn.getFullYear(), Wn.getMonth(), Wn.getDate()), this._batchEnd = me(e, $n.getFullYear(), $n.getMonth(), $n.getDate()), this._daysBatch = Vt, this._daysBatchNr = xt, this._placeholderSizeX = g ? 0 : t.dayWidth * bt(Math.max(0, Ls - 3 * xt / 2)) || 0, this._rowHeights = {}, this._dragCol = "", this._dragRow = "", this._fixedResources = [], this._fixedResourceTops = {}, this._fixedHeight = t.headerHeight || 0;
      var Tn = (t.scrollContHeight || 0) - (t.headerHeight || 0) - (t.footerHeight || 0), ba = t.rowHeight || 52, Rr = t.parentRowHeight || 52, Zd = t.gutterHeight !== void 0 ? t.gutterHeight : 16, To = t.batchIndexY || 0, Pr = this._visibleResources, Eo = b ? this._days : [{}], ko = Pr.length * Eo.length, zr = [], As = [], Mo = {}, Da = {}, Io = {}, wa = [], Gn = 0, Hr = 0;
      t.hasScrollY && (this._resourceTops = {}), Eo.forEach(function(En, Rs) {
        Pr.forEach(function(kn, Ma) {
          var Jt = (b ? En.dateKey + "-" : "") + kn.id;
          if (Io[Jt] = kn, Tn) {
            var Ur = kn.children ? Rr : ba, tu = a._eventRows["more-" + Jt] ? 24 : 0, Ps = a._setRowHeight ? kn.eventCreation === !1 ? Ur : Math.max((a._eventRows[Jt] || 1) * a._eventHeight + Zd + tu, Ur) : Ur;
            a._rowHeights[Jt] = a._setRowHeight ? Ps + "px" : void 0, !b && kn.fixed && (a._fixedResourceTops[Jt] = a._fixedHeight, a._fixedHeight += Ps, a._fixedResources.push({ height: Ps, index: Ma, key: Jt, resource: kn })), t.hasScrollY && (a._resourceTops[Jt] = Gn), Hr || wa.push({ startIndex: Rs * Pr.length + Ma, top: Gn }), Gn += Ps, (Hr += Ps) > Tn && (Hr = 0);
          }
          zr.push({ dayIndex: Rs, key: Jt, resource: kn });
        });
      });
      var xa = wa[To - 1], No = wa[To + 2], Oo = xa ? xa.startIndex : 0, Lo = No ? No.startIndex : Gn ? ko : 30;
      (g || Gn && Gn <= Tn) && (Oo = 0, Lo = ko);
      var Ca = [], Ao = -1;
      for (G = Oo; G < Lo; G++) {
        var Sa = zr[G];
        if (Sa) {
          var Ta = Sa.dayIndex;
          Ao !== Ta && (Ca = [], As.push({ day: b ? this._days[Ta] : void 0, rows: Ca }), Ao = Ta, Mo[Ta] = As[As.length - 1]), Da[Sa.key] = !0, Ca.push(Sa.resource);
        }
      }
      for (var Ro = 0, Fr = 0, Po = this._fixedResources; Fr < Po.length; Fr++) {
        var Ea = Po[Fr];
        Da[Ea.key] || (Ca.unshift(Ea.resource), Da[Ea.key] = !0, Ro += Ea.height);
      }
      if (t.dragData && t.dragData.originResource !== void 0) {
        var eu = t.dragData.originResource, Yr = (ie = Pe(new Date(t.dragData.originDate)), (b ? ie + "-" : "") + eu), zo = b ? this._dayIndexMap[ie] : 0, Ho = b ? this._colIndexMap[ie] : 0, Fo = Lt[Ho].dateKey;
        if (!Da[Yr]) {
          var ka = Mo[zo];
          ka || (ka = { day: b ? this._days[zo] : void 0, hidden: !0, rows: [] }, As.push(ka)), ka.rows.push(Io[Yr]), this._dragRow = Yr;
        }
        b || qn[Fo] || (this._dragCol = Fo, Vt.push(Lt[Ho]));
      }
      this._gridHeight = Gn, this._virtualPagesY = wa, this._colClass = f || !b ? "mbsc-timeline-resource-col" : "mbsc-timeline-date-col", this._hasRows = this._hasResources || b, this._rows = zr, this._rowBatch = As, this._placeholderSizeY = xa && !g ? xa.top - Ro : 0;
    }
  }, n.prototype._mounted = function() {
    var e, t, a, i = this;
    this._unlisten = Kt(this._el, { onDoubleClick: function(r) {
      var o = i.s;
      a && o.clickToCreate && o.clickToCreate !== "single" && (r.click = !0, i._onEventDragStart(r) && i._onEventDragEnd(r));
    }, onEnd: function(r) {
      !e && t && i.s.clickToCreate === "single" && (r.click = !0, i._onEventDragStart(r) && (e = !0)), e && (r.domEvent.preventDefault(), i._onEventDragEnd(r)), clearTimeout(i._touchTimer), e = !1, t = !1;
    }, onMove: function(r) {
      var o = i.s;
      e && o.dragToCreate ? (r.domEvent.preventDefault(), i._onEventDragMove(r)) : t && o.dragToCreate && (Math.abs(r.deltaX) > 7 || Math.abs(r.deltaY) > 7) ? i._onEventDragStart(r) ? e = !0 : t = !1 : clearTimeout(i._touchTimer);
    }, onStart: function(r) {
      var o = i.s;
      if (r.create = !0, r.click = !1, i._isTouch = r.isTouch, !e && (o.dragToCreate || o.clickToCreate)) {
        var l = r.domEvent.target && r.domEvent.target.classList;
        (a = l && (l.contains("mbsc-schedule-item") || l.contains("mbsc-schedule-all-day-item") || l.contains("mbsc-timeline-column"))) && (r.isTouch && o.dragToCreate ? i._touchTimer = setTimeout(function() {
          i._onEventDragStart(r) && (i._onEventDragModeOn(r), e = !0);
        }, 350) : t = !r.isTouch);
      }
    } }), this._unsubscribe = kd(this._onExternalDrag);
  }, n.prototype._updated = function() {
    var e = this, t = this.s, a = this.state;
    this._scrollAfterResize && (this._onScroll(), this._scrollAfterResize = !1), this._shouldCheckSize && es(this, function() {
      var i, r, o, l, u, c, d, m, h = e._resCont, f = e._headerCont, p = e._footerCont, g = e._sidebarCont, v = e._stickyFooter, y = f.offsetHeight, b = h ? h.offsetWidth : 0, D = g ? g.offsetWidth : 0, w = p ? p.offsetHeight : 0, C = e._scrollCont, T = C.offsetWidth, N = C.offsetHeight, O = C.clientWidth, L = C.clientHeight, H = O - b - D, A = L - y - w, B = e._gridHeight, I = T - O, S = N - L, k = C.scrollHeight > L, R = C.scrollWidth > O, z = a.eventHeight;
      if (e._isTimeline) {
        var W = C.querySelector(".mbsc-timeline-day"), M = C.querySelector(".mbsc-timeline-empty-row"), P = C.querySelector(".mbsc-timeline-empty-parent"), Y = C.querySelector(".mbsc-timeline-row-gutter"), q = e._colsNr;
        if (o = W ? W.offsetWidth : 64, c = M ? M.offsetHeight : 52, d = P ? P.offsetHeight : 52, m = Y ? Y.offsetHeight : 16, o * q < H && (R = !1, S = 0), B && B < A && (k = !1, I = 0), o = R ? o : bt(H / q), u = R ? o * q : H, r = e._stepCell * o / e._time, e._gridWidth = u, e._daysBatchNr = Math.max(1, Math.ceil(H / (o || 1))), e._hasSticky || (f.style[t.rtl ? "left" : "right"] = I + "px", p && (p.style[t.rtl ? "left" : "right"] = I + "px", p.style.bottom = S + "px")), e._hasSideSticky || (h && (h.style.bottom = S + "px"), g && (g.style[t.rtl ? "left" : "right"] = I + "px")), v && (v.style.bottom = S + "px"), e._setRowHeight) {
          var U = C.querySelector(".mbsc-schedule-event");
          z = U ? U.clientHeight : z || (t.eventList ? 24 : 46);
        }
        if (!k && a.rowHeight) {
          e._resourceTops = {};
          var j = e._gridCont, ee = j.getBoundingClientRect();
          j.querySelectorAll(".mbsc-timeline-row").forEach(function(Z, re) {
            e._resourceTops[e._rows[re].key] = Z.getBoundingClientRect().top - ee.top;
          });
        }
      } else {
        var ne = e._el.querySelector(".mbsc-schedule-column-inner"), G = e._el.querySelector(".mbsc-schedule-header-item");
        if (i = ne ? e._stepCell * ne.offsetHeight / e._time : 0, l = G ? G.offsetWidth : 0, t.maxEventStack === "auto") {
          var te = Le(ne.offsetWidth / (t.minEventWidth || 50));
          e._reloadEvents = e._maxEventStack !== te, e._maxEventStack = te;
        }
      }
      C.scrollTop > B - A ? C.scrollTop = B - A : e._onScroll(), e._calcConnections = !!t.connections && (e._isParentClick || e._calcConnections || !k), e._shouldCheckSize = c !== a.rowHeight || z !== a.eventHeight || k !== a.hasScrollY, e._scrollAfterResize = t.virtualScroll && !e._shouldCheckSize, e._isCursorTimeVisible = !1, e._calcGridSizes(), e.setState({ cellHeight: i, cellWidth: r, dayNameWidth: l, dayWidth: o, eventHeight: z, footerHeight: w, gridContWidth: H, gridWidth: u, gutterHeight: m, hasScrollX: R, hasScrollY: k, headerHeight: y, parentRowHeight: d, rowHeight: c, scrollContHeight: R ? L : N, update: e._calcConnections || e._reloadEvents ? (a.update || 0) + 1 : a.update });
    }), !this._shouldScroll || !a.dayWidth && this._isTimeline || (setTimeout(function() {
      e._scrollToTime(e._shouldAnimateScroll), e._shouldAnimateScroll = !1;
    }), this._shouldScroll = !1), this._viewChanged && setTimeout(function() {
      e._viewChanged = !1;
    }, 10);
  }, n.prototype._destroy = function() {
    this._unlisten && this._unlisten(), this._unsubscribe && Md(this._unsubscribe);
  }, n.prototype._calcGridSizes = function() {
    var e = this.s, t = this._resources, a = this._isTimeline, i = this._daysNr * (a ? 1 : t.length), r = this._gridCont, o = this._scrollCont, l = !a && this._el.querySelector(".mbsc-schedule-all-day-wrapper"), u = l && l.getBoundingClientRect(), c = r.getBoundingClientRect(), d = o.getBoundingClientRect(), m = a ? this._gridWidth : r.scrollWidth, h = this._resCont ? this._resCont.offsetWidth : 0;
    this._gridLeft = e.rtl ? c.right - m : c.left, this._gridRight = e.rtl ? c.right : c.left + m, this._gridTop = c.top, this._gridContTop = d.top, this._gridContBottom = d.bottom, this._gridContLeft = d.left + (e.rtl ? 0 : h), this._gridContRight = d.right - (e.rtl ? h : 0), this._allDayTop = u ? u.top : this._gridContTop, this._colWidth = m / (e.eventList ? this._colsNr : i), this._colHeight = c.height;
  }, n.prototype._getDragDates = function(e, t, a) {
    var i = this.s, r = {}, o = /* @__PURE__ */ new Map(), l = e.allDay ? this._firstDay : this._firstDayTz, u = e.startDate, c = e.endDate;
    for (u = (u = Ce(u)) < l ? l : u, c = Xt(i, e.allDay || i.eventList, u, c); u <= c; ) {
      var d = K({}, e), m = Pe(u), h = nn(u.getDay(), i.startDay, i.endDay) && this._getEventPos(e, u, m, o);
      if (h) {
        var f = d.resource;
        this._isTimeline && this._setRowHeight && (at(f) ? f : [f]).indexOf(this._tempResource) !== -1 && (h.position.top = d.position.top);
        var p = !this._isTimeline || this._hasSlots || this._hasResY ? m : "all";
        d.date = +Ce(u, !0), d.cssClass = h.cssClass, d.start = h.start, d.end = h.end, d.position = h.position, d.bufferAfter = h.bufferAfter, d.bufferBefore = h.bufferBefore, r[t + "__" + (this._isTimeline ? a + "__" : "") + p] = d;
      }
      u = ce(u, 1);
    }
    return r;
  }, n.prototype._getGridTime = function(e, t, a, i, r) {
    var o = this._hasResY ? 0 : i, l = Dl(this._isTimeline ? Le(this._time * (t - o * this._colWidth) / this._colWidth) : Le(this._time * (a - 8) / (this._colHeight - 16)), 6e4 * r), u = new Date(+Bt + this._startTime + l);
    return me(this.s, e.getFullYear(), e.getMonth(), e.getDate(), u.getHours(), u.getMinutes());
  }, n.prototype._scrollToTime = function(e) {
    var t = this, a = this._scrollCont, i = this._gridCont, r = this._isTimeline;
    if (a) {
      var o = this.s, l = this._hasResY, u = o.navigateToEvent, c = u && u.start ? Nn(new Date(+ue(u.start, o) - this._stepCell), this._stepCell / 6e4) : new Date(o.selected), d = this._colIndexMap[Pe(c)];
      d === void 0 || !r || l || o.resolution === "hour" && this._stepCell !== 864e5 && !o.eventList ? c.setHours(o.eventList ? 0 : c.getHours(), 0) : c = this._cols[d].date;
      var m = oi(c, this._startTime, this._time * (r ? this._daysNr : 1)), h = l ? 0 : Dd(this._firstDay, c, o.startDay, o.endDay), f = (r ? i.offsetWidth : i.scrollWidth) * (100 * h / this._daysNr + (r ? m : 0)) / 100 + 1, p = void 0;
      if (u || l) {
        var g = this._visibleResources, v = u ? u.resource : g[0].id, y = at(v) ? v[0] : v;
        if (y)
          if (r) {
            var b = (l ? Pe(c) + "-" : "") + y;
            p = this._resourceTops && this._resourceTops[b];
          } else {
            var D = this._colWidth, w = Dp(g, function(T) {
              return T.id === y;
            }) || 0;
            f = this._groupByResource && !this._isSingleResource ? this._daysNr * D * w + D * h : g.length * h * D + w * D;
          }
      }
      if (!r) {
        var C = a.querySelector(".mbsc-schedule-column-inner");
        p = C ? C.offsetHeight * m / 100 : 0, !this._groupByResource || this._isSingleResource || u || (f = void 0);
      }
      this._isScrolling++, td(a, f, p, e, o.rtl, function() {
        setTimeout(function() {
          t._isScrolling--;
        }, 150);
      });
    }
  }, n;
}(it), l_ = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e, t) {
    return function(a, i, r) {
      var o, l = r._colors, u = i.dragData, c = u && u.draggedEvent && u.draggedEvent.id, d = r._events, m = r._invalids, h = r._hb, f = r._rtl, p = r._times, g = r._startTime, v = r._endTime, y = r._startCellStyle, b = r._endCellStyle, D = r._stepLabel, w = r._theme, C = r._isSingleResource, T = a.eventMap || {}, N = "schedule", O = " mbsc-flex-1-0 mbsc-schedule-resource-group" + w + f, L = r._timezones, H = r._groupByResource, A = r._days, B = r._resources, I = ((o = {}).onMouseMove = r._onMouseMove, o.onMouseLeave = r._onMouseLeave, o), S = { dayNames: r._dayNames, largeNames: r._largeDayNames, onClick: a.onWeekDayClick, renderDay: a.renderDay, renderDayContent: a.renderDayContent, rtl: a.rtl, theme: a.theme }, k = function(P) {
        var Y, q = P.name;
        return a.renderResource && ye(q = a.renderResource(P)) && (Y = r._safeHtml(q), r._shouldEnhance = !0), q && _("div", { key: P.id, className: "mbsc-schedule-resource " + (P.cssClass || "") + w + f + h + (!H || a.type === "day" && a.size === 1 ? " mbsc-flex-1-0 mbsc-schedule-col-width" : ""), style: { background: P.background } }, _("div", { dangerouslySetInnerHTML: Y, className: "mbsc-schedule-resource-title" }, q));
      }, R = function(P, Y, q, U) {
        var j = r._resourcesMap[q].eventResize, ee = q + "__" + Y, ne = da(u && u.draggedEvent && u.draggedEvent.original.resize, a.dragToResize, j), G = { displayTimezone: a.displayTimezone, drag: a.dragToMove || a.externalDrag, endDay: a.endDay, exclusiveEndDates: a.exclusiveEndDates, gridEndTime: v, gridStartTime: g, lastDay: +r._lastDay, render: a.renderEvent, renderBufferAfter: a.renderBufferAfter, renderBufferBefore: a.renderBufferBefore, renderContent: a.renderEventContent, resource: q, rtl: a.rtl, singleDay: !H, slot: qe, startDay: a.startDay, theme: a.theme, timezonePlugin: a.timezonePlugin };
        return _(ut, null, P.map(function(te) {
          return te.showText ? te.position && _(xs, K({}, G, { event: te, key: te.uid, inactive: c === te.id, resize: da(te.original.resize, a.dragToResize, j), selected: !(!a.selectedEventsMap[te.uid] && !a.selectedEventsMap[te.id]), onClick: r._onEventClick, onDoubleClick: a.onEventDoubleClick, onRightClick: a.onEventRightClick, onDelete: a.onEventDelete, onHoverIn: a.onEventHoverIn, onHoverOut: a.onEventHoverOut, onDragStart: r._onEventDragStart, onDragMove: r._onEventDragMove, onDragEnd: r._onEventDragEnd, onDragModeOn: r._onEventDragModeOn, onDragModeOff: r._onEventDragModeOff })) : _("div", { key: te.uid, className: "mbsc-schedule-event mbsc-schedule-event-all-day mbsc-schedule-event-all-day-placeholder" }, _("div", { className: "mbsc-schedule-event-all-day-inner" + w }));
        }), u && u.originDates && u.originDates[ee] && !!u.originDates[ee].allDay == !!U && _(xs, K({}, G, { event: u.originDates[ee], hidden: u && !!u.draggedDates, isDrag: !0, resize: ne, onDragStart: r._onEventDragStart, onDragMove: r._onEventDragMove, onDragEnd: r._onEventDragEnd, onDragModeOff: r._onEventDragModeOff })), u && u.draggedDates && u.draggedDates[ee] && !!u.draggedDates[ee].allDay == !!U && _(xs, K({}, G, { event: u.draggedDates[ee], isDrag: !0, resize: ne })));
      }, z = function(P) {
        return p.map(function(Y, q) {
          var U = !q, j = q === p.length - 1;
          return _("div", { key: q, className: "mbsc-flex-col mbsc-flex-1-0 mbsc-schedule-time-wrapper" + w + f + (j ? " mbsc-schedule-time-wrapper-end" : "") + (U && !j && y || j && !U && b ? " mbsc-flex-none" : ""), style: U && !j ? y : j && !U ? b : void 0 }, _("div", { className: "mbsc-flex-1-1 mbsc-schedule-time" + w + f }, U || Y % D == 0 ? r._formatTime(U ? g : Y, P) : ""), r._timesBetween.map(function(ee, ne) {
            var G = Y + (ne + 1) * D;
            return G > g && G < v && _("div", { key: ne, className: "mbsc-flex-1-1 mbsc-schedule-time" + w + f }, r._formatTime(G, P));
          }), j && _("div", { className: "mbsc-schedule-time mbsc-schedule-time-end" + w + f }, r._formatTime(v + 1, P)));
        });
      }, W = function(P, Y, q, U) {
        var j = P.id, ee = m[j][qe][Y] && m[j][qe][Y].allDay[0], ne = l[j][qe][Y] && l[j][qe][Y].allDay[0], G = d[j][qe][Y] && d[j][qe][Y].allDay;
        return _("div", { key: q + "-" + U, className: "mbsc-schedule-all-day-item mbsc-schedule-col-width mbsc-flex-1-0 " + (P.cssClass || "") + w + f + h, style: { background: P.background } }, R(G || [], Y, j, !0), ee && _("div", { className: "mbsc-schedule-invalid mbsc-schedule-invalid-all-day" + ee.cssClass + w }, _("div", { className: "mbsc-schedule-invalid-text" }, ee.title)), ne && _("div", { className: "mbsc-schedule-color mbsc-schedule-color-all-day" + ne.cssClass + w, style: ne.position }, _("div", { className: "mbsc-schedule-color-text" }, ne.title)));
      }, M = function(P, Y, q, U) {
        var j = P.id, ee = m[j][qe][Y] && m[j][qe][Y].data, ne = l[j][qe][Y] && l[j][qe][Y].data, G = d[j][qe][Y], te = G && G.data;
        return _("div", { key: q + "-" + U, className: "mbsc-flex-col mbsc-flex-1-0 mbsc-schedule-column mbsc-schedule-col-width " + (P.cssClass || "") + w + f + h, style: { background: P.background } }, _("div", { className: "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-column-inner" + w + f + h }, _("div", { className: "mbsc-schedule-events" + (G && G.hasMore ? " mbsc-schedule-events-more" : "") + f }, R(te || [], Y, j)), ee && ee.map(function(Z, re) {
          return Z.position && _("div", { key: re, className: "mbsc-schedule-invalid" + Z.cssClass + w, style: Z.position }, _("div", { className: "mbsc-schedule-invalid-text" }, Z.allDay ? "" : Z.title || ""));
        }), ne && ne.map(function(Z, re) {
          return _("div", { key: re, className: "mbsc-schedule-color" + Z.cssClass + w, style: Z.position }, _("div", { className: "mbsc-schedule-color-text" }, Z.title));
        }), p.map(function(Z, re) {
          var fe, he = Od(U, Z), oe = !re, Ee = re === p.length - 1, Ie = ((fe = {}).onDoubleClick = function(Se) {
            return a.onCellDoubleClick({ date: he, domEvent: Se, resource: j, source: N });
          }, fe.onContextMenu = function(Se) {
            return a.onCellRightClick({ date: he, domEvent: Se, resource: j, source: N });
          }, fe);
          return _("div", K({ key: re, className: "mbsc-schedule-item mbsc-flex-1-0" + w + h + (Ee ? " mbsc-schedule-item-last" : "") + (oe && !Ee && y || Ee && !oe && b ? " mbsc-flex-none" : ""), onClick: function(Se) {
            return a.onCellClick({ date: he, domEvent: Se, resource: j, source: N });
          }, style: oe && !Ee ? y : Ee && !oe ? b : void 0 }, Ie));
        })));
      };
      return _("div", { ref: r._setEl, className: "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-wrapper" + w + (r._daysNr > 7 ? " mbsc-schedule-wrapper-multi" : "") }, _("div", { className: "mbsc-schedule-header mbsc-flex mbsc-flex-none" + w + h }, _("div", { className: "mbsc-schedule-time-col mbsc-schedule-time-col-empty" + w + f + h, style: r._timeWidth }), _("div", { className: "mbsc-flex-1-1 mbsc-schedule-header-wrapper" }, _("div", { ref: r._setHeaderCont, className: "mbsc-flex" }, a.type === "day" && a.size === 1 ? _("div", { className: O }, _("div", { className: "mbsc-flex" }, a.showDays && r._headerDays.map(function(P) {
        var Y = P.timestamp;
        return _(ci, K({}, S, { key: Y, cssClass: "mbsc-flex-1-1", day: P.day, events: T[P.dateKey], isToday: r._isToday(Y), label: P.label, selectable: !0, selected: r._selectedDay === Y, timestamp: Y }));
      })), a.resources && _("div", { className: "mbsc-flex" }, B.map(k))) : H ? B.map(function(P, Y) {
        return _("div", { key: Y, className: O }, k(P), _("div", { className: "mbsc-flex" }, a.showDays && A.map(function(q) {
          var U = q.timestamp;
          return _(ci, K({}, S, { background: P.background, key: U, cssClass: "mbsc-flex-1-0 mbsc-schedule-col-width " + (P.cssClass || ""), day: q.day, events: T[q.dateKey], isToday: C && r._isToday(U), label: q.label, resource: P.id, selectable: !1, selected: C && r._isToday(U), timestamp: U }));
        })));
      }) : A.map(function(P, Y) {
        var q = P.timestamp;
        return _("div", { key: Y, className: O }, a.showDays && _(ci, K({}, S, { key: q, day: P.day, events: T[P.dateKey], isToday: C && r._isToday(q), label: P.label, selectable: !1, selected: r._isToday(q), timestamp: q })), a.resources && _("div", { className: "mbsc-flex" }, B.map(k)));
      }))), _("div", { className: "mbsc-schedule-fake-scroll-y" })), _("div", { className: "mbsc-schedule-all-day-cont" + (i.showShadow ? " mbsc-schedule-all-day-wrapper-shadow" : "") + w }, L && _("div", { className: "mbsc-flex mbsc-schedule-timezone-labels", style: r._timeWidth }, L.map(function(P, Y) {
        return _("div", { key: Y, className: "mbsc-flex-1-0-0 mbsc-schedule-timezone-label" + w + f }, P.label);
      })), a.showAllDay && _("div", { className: "mbsc-schedule-all-day-wrapper mbsc-flex-none" + w + h }, _("div", { className: "mbsc-flex mbsc-schedule-all-day" + w }, _("div", { className: "mbsc-schedule-time-col" + w + f, style: r._timeWidth }, !L && _("div", { className: "mbsc-schedule-all-day-text" + w + f }, a.allDayText)), _("div", { className: "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-all-day-group-wrapper" }, _("div", { ref: r._setAllDayCont, className: "mbsc-flex mbsc-flex-1-1" }, H ? B.map(function(P, Y) {
        return _("div", { key: Y, className: "mbsc-flex" + O }, A.map(function(q, U) {
          return W(P, q.dateKey, U, q.timestamp);
        }));
      }) : A.map(function(P, Y) {
        return _("div", { key: Y, className: "mbsc-flex" + O }, B.map(function(q, U) {
          return W(q, P.dateKey, U, P.timestamp);
        }));
      })))))), _("div", { className: "mbsc-flex mbsc-flex-1-1 mbsc-schedule-grid-wrapper" + w }, _("div", { "aria-hidden": "true", className: "mbsc-flex-col mbsc-schedule-time-col mbsc-schedule-time-cont" + w + f, style: r._timeWidth, ref: r._setTimeCont }, _("div", { className: "mbsc-flex mbsc-schedule-time-cont-inner" }, _("div", { className: "mbsc-flex-col mbsc-flex-1-1" }, _("div", { className: "mbsc-flex-1-1 mbsc-schedule-time-cont-pos" + w + (L ? " mbsc-flex" : " mbsc-flex-col mbsc-schedule-time-col-last") }, L ? L.map(function(P, Y) {
        return _("div", { key: Y, className: "mbsc-flex-col" + w + (Y === L.length - 1 ? " mbsc-schedule-time-col-last" : "") }, z(P.timezone));
      }) : z(), r._showTimeIndicator && _(Ld, { amText: a.amText, displayedTime: r._time, displayedDays: r._daysNr, displayTimezone: a.displayTimezone, endDay: a.endDay, firstDay: r._firstDayTz, orientation: "x", pmText: a.pmText, rtl: a.rtl, showDayIndicator: C && !r._isMulti && a.type === "week", startDay: a.startDay, startTime: g, theme: a.theme, timeFormat: a.timeFormat, timezones: L, timezonePlugin: a.timezonePlugin }), r._showCursorTime && _("div", { ref: r._setCursorTimeCont, className: "mbsc-schedule-cursor-time mbsc-schedule-cursor-time-x" + w + f })), i.hasScrollX && _("div", { className: "mbsc-schedule-fake-scroll-x" })), _("div", { className: "mbsc-schedule-fake-scroll-y" }))), _("div", { ref: r._setCont, className: "mbsc-flex-col mbsc-flex-1-1 mbsc-schedule-grid-scroll" + w, onScroll: r._onScroll }, _("div", { className: "mbsc-flex mbsc-flex-1-1" }, _("div", K({ className: "mbsc-flex mbsc-flex-1-0 mbsc-schedule-grid", ref: r._setGridCont }, I), H ? B.map(function(P, Y) {
        return _("div", { key: Y, className: "mbsc-flex" + O }, A.map(function(q, U) {
          return M(P, q.dateKey, U, q.timestamp);
        }));
      }) : A.map(function(P, Y) {
        return _("div", { key: Y, className: "mbsc-flex" + O }, B.map(function(q, U) {
          return M(q, P.dateKey, U, P.timestamp);
        }));
      }))))), u && !i.isTouchDrag && _("div", { className: "mbsc-calendar-dragging" }));
    }(e, t, this);
  }, n;
}(/* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._onScroll = function() {
      var t = e._scrollCont;
      if (t) {
        var a = t.scrollTop, i = "translateX(" + -t.scrollLeft + "px)", r = e._timeCont, o = e._allDayCont, l = e._headerCont, u = (mn ? mn + "T" : "t") + "ransform";
        o && (o.style[u] = i), r && (r.style.marginTop = -a + "px"), l && (l.style[u] = i), a === 0 ? e.setState({ showShadow: !1 }) : e.state.showShadow || e.setState({ showShadow: !0 }), e._onMouseMove();
      }
    }, e._setCont = function(t) {
      e._scrollCont = t;
    }, e._setTimeCont = function(t) {
      e._timeCont = t;
    }, e._setAllDayCont = function(t) {
      e._allDayCont = t;
    }, e._setGridCont = function(t) {
      e._gridCont = t;
    }, e._setHeaderCont = function(t) {
      e._headerCont = t;
    }, e._setCursorTimeCont = function(t) {
      e._cursorTimeCont = t;
    }, e;
  }
  return de(n, s), n.prototype._render = function(e, t) {
    s.prototype._render.call(this, e, t);
    var a = this._prevS, i = e.timezones, r = this._stepCell / 6e4, o = Le(this._startTime / 6e4) % r, l = Le(this._endTime / 6e4) % r + 1;
    if (i !== a.timezones && (this._timeWidth = i ? { width: 4.25 * i.length + "em" } : void 0, this._timezones = void 0, i)) {
      for (var u = [], c = 0, d = i; c < d.length; c++) {
        var m = d[c], h = void 0;
        if (ye(m)) {
          var f = me(e, 1970, 0, 1);
          Vn(f) && f.setTimezone(m);
          var p = f.getTimezoneOffset() / 60 * -1;
          h = { label: "UTC" + (p > 0 ? "+" : "") + p, timezone: m };
        } else
          h = m;
        u.push(h);
      }
      this._timezones = u;
    }
    this._largeDayNames = t.dayNameWidth > 99, this._startCellStyle = o % r != 0 ? { height: (t.cellHeight || 50) * ((r - o) % r / r) + "px" } : void 0, this._endCellStyle = l % r != 0 ? { height: (t.cellHeight || 50) * (l % r) / r + "px" } : void 0;
  }, n;
}(Ad)), c_ = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._isTimeline = !0, e._onScroll = function() {
      for (var t = e.s.rtl, a = e.state, i = e._gridWidth, r = e._scrollCont, o = r.scrollTop, l = r.scrollLeft, u = e._resCont, c = e._sidebarCont, d = e._footerCont, m = e._headerCont, h = e._stickyHeader, f = e._stickyFooter, p = e._days, g = e._daysNr, v = e._cols.length, y = t ? -1 : 1, b = t ? "marginRight" : "marginLeft", D = bt(l * y * (v / e._daysBatchNr) / i), w = i / g, C = w ? $e(Le(l * y / w), 0, g - 1) : 0, T = e._virtualPagesY || [], N = 0, O = 0; O < T.length && T[O].top - a.scrollContHeight / 2 <= o; )
        N = O, O++;
      if (gs && !t || (u && (u.scrollTop = o), c && (c.scrollTop = o)), h && gs) {
        var L = h.style;
        L.marginTop = o < 0 ? -o + "px" : "", L[b] = l * y < 0 ? -l * y + "px" : "";
      }
      if (f && gs) {
        var H = f.style;
        H.marginTop = o < 0 ? -o + "px" : "", H[b] = l * y < 0 ? -l * y + "px" : "";
      }
      if (i) {
        if ((m || d) && e._isDailyResolution) {
          var A = function(B, I) {
            if (B && w) {
              var S = B.offsetWidth, k = B.style, R = $e(Le((l * y + S) / w), 0, g - 1);
              p[C][I + "Index"] !== p[R][I + "Index"] ? k[b] = -(l * y + S - p[R][I + "Index"] * w + 1) + "px" : k[b] = "";
            }
          };
          A(e._stickyDate, "date"), A(e._stickyMonth, "month"), A(e._stickyWeek, "week"), gs || (d && (d.scrollLeft = l), m && (m.scrollLeft = l));
        }
        (D !== a.batchIndexX || N !== a.batchIndexY || (e._stickyDate || e._stickyMonth || e._stickyWeek) && C !== a.dayIndex) && e.setState({ batchIndexX: D, batchIndexY: N, dayIndex: C }), clearTimeout(e._scrollDebounce), e._scrollDebounce = setTimeout(function() {
          if (!e._isScrolling && !e._viewChanged && !e._hasResY) {
            var B = p[C].date, I = e._time * (l * y - C * w) / w;
            e._hook("onActiveChange", { date: new Date(+B + e._startTime + I), scroll: !0 });
          }
        }, 100), e._onMouseMove();
      }
    }, e._setStickyHeader = function(t) {
      e._stickyHeader = t;
    }, e._setStickyFooter = function(t) {
      e._stickyFooter = t;
    }, e._setStickyDay = function(t) {
      e._stickyDate = t;
    }, e._setStickyMonth = function(t) {
      e._stickyMonth = t;
    }, e._setStickyWeek = function(t) {
      e._stickyWeek = t;
    }, e._setCont = function(t) {
      e._scrollCont = t;
    }, e._setResCont = function(t) {
      e._resCont = t;
    }, e._setSidebarCont = function(t) {
      e._sidebarCont = t;
    }, e._setGridCont = function(t) {
      e._gridCont = t;
    }, e._setHeaderCont = function(t) {
      e._headerCont = t;
    }, e._setFooterCont = function(t) {
      e._footerCont = t;
    }, e._setCursorTimeCont = function(t) {
      e._cursorTimeCont = t;
    }, e;
  }
  return de(n, s), n.prototype._onParentClick = function(e, t) {
    t.collapsed = !t.collapsed, this._hook(t.collapsed ? "onResourceCollapse" : "onResourceExpand", { domEvent: e, resource: t.id }), this._visibleResources = this._flattenResources(this._resourcesCopy, [], 0), this._shouldCheckSize = !0, this._isParentClick = !0, this.forceUpdate();
  }, n.prototype._render = function(e, t) {
    s.prototype._render.call(this, e, t), clearTimeout(this._scrollDebounce);
    var a = this._prevS, i = this._eventMap, r = this._resourceTops, o = this._stepCell / 6e4, l = Le(this._startTime / 6e4) % o, u = Le(this._endTime / 6e4) % o + 1;
    if (this._stickyDay = this._days[t.dayIndex || 0] || this._days[0], this._startCellStyle = l % o != 0 ? { width: (t.cellWidth || 64) * ((o - l) % o / o) + "px" } : void 0, this._endCellStyle = u % o != 0 ? { width: (t.cellWidth || 64) * (u % o) / o + "px" } : void 0, e.connections === a.connections && e.eventMap === a.eventMap && e.theme === a.theme && e.rtl === a.rtl || (this._calcConnections = !0), this._hasSlots && (this._connections = void 0), this._calcConnections && !this._hasSlots && !this._shouldCheckSize && r) {
      for (var c = [], d = this._eventHeight, m = this._gridWidth, h = t.hasScrollY ? this._gridHeight : t.scrollContHeight - t.headerHeight, f = 1500 / m, p = e.rtl === !0, g = p ? -1 : 1, v = 750 / m * g, y = 400 / h * g, b = 100 * d / h, D = 0, w = e.connections || []; D < w.length; D++) {
        var C = w[D], T = i[C.from], N = i[C.to], O = C.arrow, L = C.color, H = C.cssClass || "", A = C.from + "__" + C.to, B = C.type || "fs";
        if (T && N) {
          var I = T.position, S = N.position, k = I.width !== void 0, R = S.width !== void 0, z = T.resource, W = N.resource;
          if ((k || R) && r[z] >= 0 && r[W] >= 0) {
            var M = B === "fs" || B === "ff", P = B === "fs" || B === "ss", Y = M ? T.endDate : T.startDate, q = P ? N.startDate : N.endDate, U = q < Y, j = U ? q : Y, ee = U ? Y : q, ne = I.top || 0, G = S.top || 0, te = p ? "right" : "left", Z = k ? +I[te].replace("%", "") : U ? 100 : 0, re = R ? +S[te].replace("%", "") : U ? 0 : 100, fe = k ? +I.width.replace("%", "") : 0, he = k ? +S.width.replace("%", "") : 0, oe = r[W] - r[z], Ee = !oe && (B === "fs" && U || B === "sf" && !U || B === "ff" || B === "ss") && G === ne, Ie = M && P ? re - Z - fe - 2 * f : M && !P ? re - Z + (he - fe) : !M && P ? re - Z : re - Z + he + 2 * f, Se = oe < 0 || !oe && G < ne ? -1 : 1, Ve = 100 * (oe - ne * d + G * d + (Ee ? d : 0)) / h, je = B === "fs" && Ie < 0 || (B === "ff" || B === "ss") && Ee || B === "sf", Ne = B === "ss" && U && !je || B === "ff" && !U && !je || B === "sf" && Ie < 0, E = (p ? 100 - Z : Z) + (M ? fe * g : 0), F = 100 * (r[z] + ne * d + 3 + d / 2) / h;
            if (k && (O === "from" || O === "bidirectional")) {
              var V = M ? v : -1 * v;
              c.push({ color: L, cssClass: "mbsc-connection-arrow " + H, endDate: ee, fill: L, id: A + "__start", pathD: "M " + E + ", " + F + " L " + (E + V) + " " + (F - y) + " L " + (E + V) + " " + (F + y) + " Z", startDate: j });
            }
            var J = "M " + E + ", " + F;
            E += M ? f * g : -f * g, Ne && (E += Ie * g), Ve && (J += " H " + E, Ne || (J += " V " + (F += Ve - (je ? b / 2 : 0) * Se))), Ne || (E += Ie * g), Ve && (J += " H " + E, Ne && (J += " V " + (F += Ve - (je ? b / 2 : 0) * Se))), Ve && je && (J += " V " + (F += b / 2 * Se * (Ee ? -1 : 1))), J += " H " + (E += P ? f * g : -f * g), c.push({ color: L, cssClass: H, id: A, pathD: J, startDate: j, endDate: ee }), R && (O === "to" || O === "bidirectional" || O === !0) && (V = P ? -1 * v : v, c.push({ color: L, cssClass: "mbsc-connection-arrow " + H, endDate: ee, fill: L, id: A + "__end", pathD: "M " + E + ", " + F + " L " + (E + V) + " " + (F - y) + " L " + (E + V) + " " + (F + y) + " Z", startDate: j }));
          }
        }
      }
      this._connections = c, this._calcConnections = !1;
    }
  }, n;
}(Ad);
function d_(s, n, e) {
  var t, a, i, r, o = n.dragData, l = o && o.draggedEvent && o.draggedEvent.id, u = e._hasSlots, c = e._hb, d = e._rtl, m = e._times, h = e._theme, f = e._startTime, p = e._endTime, g = e._stepLabel, v = e._slots, y = "timeline", b = s.eventList, D = s.type === "month", w = e._stepCell < 864e5, C = e._startCellStyle, T = e._endCellStyle, N = e._daysBatch, O = { height: n.headerHeight + "px" }, L = { height: n.footerHeight + "px" }, H = e._days, A = e._daysNr, B = n.dayIndex || 0, I = e._isDailyResolution, S = e._hasResY, k = e._hasResources, R = s.renderHourFooter || s.renderDayFooter || s.renderQuarterFooter || s.renderWeekFooter || s.renderMonthFooter || s.renderYearFooter, z = e._hasRows, W = e._colClass, M = e._dragCol, P = ((t = {}).className = "mbsc-connections" + h, t), Y = ((a = {}).onMouseMove = e._onMouseMove, a.onMouseLeave = e._onMouseLeave, a), q = function(E, F) {
    var V, J;
    if (e._displayTime && e._timeLabels[F])
      if (s.renderHour) {
        var ie = +E.date + F;
        ye(V = s.renderHour({ date: new Date(ie), events: E.eventMap[ie] || [], isActive: E.isActive })) && (J = e._safeHtml(V), e._shouldEnhance = !0);
      } else
        V = e._timeLabels[F];
    return _("div", { key: F, "aria-hidden": "true", className: "mbsc-timeline-header-time mbsc-flex-1-1" + h, dangerouslySetInnerHTML: J }, V);
  }, U = function(E, F) {
    var V, J;
    if (s.renderHourFooter && e._displayTime && e._timeLabels[F]) {
      var ie = +E.date + F;
      ye(V = s.renderHourFooter({ date: new Date(ie), events: E.eventMap[ie] || [], isActive: E.isActive })) && (J = e._safeHtml(V), e._shouldEnhance = !0);
    }
    return _("div", { key: F, className: "mbsc-timeline-footer-time mbsc-flex-1-1 " + h, dangerouslySetInnerHTML: J }, V);
  }, j = function(E, F) {
    var V, J;
    return s.renderDay ? ye(V = s.renderDay({ date: E.date, events: E.eventMap.all, isActive: E.isActive })) && (J = e._safeHtml(V), e._shouldEnhance = !0) : V = E.dateText, _("div", { ref: F ? e._setStickyDay : void 0, "aria-hidden": "true", dangerouslySetInnerHTML: J, className: (F ? "mbsc-timeline-header-text" : "") + (E.isActive && !s.renderDay ? " mbsc-timeline-header-active" : "") + (s.renderDay ? " mbsc-timeline-header-date-cont" : " mbsc-timeline-header-date-text") + h }, V);
  }, ee = function(E, F) {
    var V, J;
    return s.renderWeek ? ye(V = s.renderWeek({ date: E.date, endDate: E.endDate, events: E.eventMap[E.timestamp] || [], isActive: E.isActive, startDate: E.date, weekNr: E.weekNr })) && (J = e._safeHtml(V), e._shouldEnhance = !0) : V = E.weekText, _("div", { ref: F ? e._setStickyWeek : void 0, "aria-hidden": "true", dangerouslySetInnerHTML: J, className: (F ? "mbsc-timeline-header-text" : "") + (s.renderWeek ? " mbsc-timeline-header-week-cont" : " mbsc-timeline-header-week-text") + (E.lastOfWeek ? "  mbsc-timeline-header-week-text-last" : "") + h }, V);
  }, ne = function(E) {
    var F, V;
    return s.renderWeekFooter && ye(F = s.renderWeekFooter({ date: E.date, endDate: E.endDate, events: E.eventMap[E.timestamp] || [], isActive: E.isActive, startDate: E.date, weekNr: E.weekNr })) && (V = e._safeHtml(F), e._shouldEnhance = !0), _("div", { dangerouslySetInnerHTML: V, className: "mbsc-timeline-footer-week-cont" }, F);
  }, G = function(E, F) {
    var V, J;
    return s.renderMonth ? ye(V = s.renderMonth({ date: E.date, events: E.eventMap[E.timestamp] || [], isActive: E.isActive })) && (J = e._safeHtml(V), e._shouldEnhance = !0) : V = E.monthText, _("div", { ref: F ? e._setStickyMonth : void 0, "aria-hidden": "true", dangerouslySetInnerHTML: J, className: (F ? "mbsc-timeline-header-text" : "") + (s.renderMonth ? " mbsc-timeline-header-month-cont" : " mbsc-timeline-header-month-text") + (E.lastOfMonth ? " mbsc-timeline-header-month-text-last" : "") + h }, V);
  }, te = function(E) {
    var F, V;
    return s.renderMonthFooter && ye(F = s.renderMonthFooter({ date: E.date, events: E.eventMap[E.timestamp] || [], isActive: E.isActive })) && (V = e._safeHtml(F), e._shouldEnhance = !0), _("div", { dangerouslySetInnerHTML: V, className: "mbsc-timeline-footer-month-cont" }, F);
  }, Z = function(E) {
    var F, V;
    return s.renderQuarter && ye(F = s.renderQuarter({ date: E.date, events: E.eventMap[E.timestamp] || [], isActive: E.isActive })) && (V = e._safeHtml(F), e._shouldEnhance = !0), _("div", { "aria-hidden": "true", dangerouslySetInnerHTML: V, className: (s.renderQuarter ? " mbsc-timeline-header-month-cont" : " mbsc-timeline-header-month-text") + h }, F);
  }, re = function(E) {
    var F, V;
    return s.renderQuarterFooter && ye(F = s.renderQuarterFooter({ date: E.date, events: E.eventMap[E.timestamp] || [], isActive: E.isActive })) && (V = e._safeHtml(F), e._shouldEnhance = !0), _("div", { dangerouslySetInnerHTML: V, className: "mbsc-timeline-footer-month-cont" }, F);
  }, fe = function(E) {
    var F, V;
    return s.renderYear ? ye(F = s.renderYear({ date: E.date, events: E.eventMap[E.timestamp] || [], isActive: E.isActive })) && (V = e._safeHtml(F), e._shouldEnhance = !0) : F = E.columnTitle, _("div", { "aria-hidden": "true", dangerouslySetInnerHTML: V, className: (E.isActive && !s.renderYear ? " mbsc-timeline-header-active" : "") + (s.renderYear ? " mbsc-timeline-header-year-cont" : " mbsc-timeline-header-year-text") + h }, F);
  }, he = function(E) {
    var F, V;
    return s.renderYearFooter && ye(F = s.renderYearFooter({ date: E.date, events: E.eventMap[E.timestamp] || [], isActive: E.isActive })) && (V = e._safeHtml(F), e._shouldEnhance = !0), _("div", { dangerouslySetInnerHTML: V, className: "mbsc-timeline-footer-year-cont" }, F);
  }, oe = function(E, F) {
    var V, J, ie = E.isParent, _e = (F ? F + "-" : "") + E.id, ve = E.fixed && !S, Oe = { background: E.background, minHeight: e._rowHeights[_e], top: ve ? e._fixedResourceTops[_e] : void 0 };
    return s.renderSidebar && ye(V = s.renderSidebar(E)) && (J = e._safeHtml(V), e._shouldEnhance = !0), _e !== e._dragRow && _("div", { key: _e, className: "mbsc-timeline-sidebar-resource mbsc-timeline-row mbsc-flex-1-0" + (ie ? " mbsc-timeline-parent mbsc-flex" : "") + (ve ? "  mbsc-timeline-row-fixed" : "") + (E.cssClass ? " " + E.cssClass : "") + h + d + c, style: Oe }, _("div", { className: "mbsc-timeline-sidebar-resource-title", dangerouslySetInnerHTML: J }, V));
  }, Ee = function(E, F) {
    var V, J = E.isParent, ie = e._hasHierarchy ? 1.75 * E.depth + "em" : void 0, _e = (F ? F + "-" : "") + E.id, ve = E.fixed && !S, Oe = { background: E.background, minHeight: e._rowHeights[_e], paddingLeft: s.rtl ? void 0 : ie, paddingRight: s.rtl ? ie : void 0, top: ve ? e._fixedResourceTops[_e] + "px" : void 0 }, we = E.name;
    return s.renderResource && ye(we = s.renderResource(E)) && (V = e._safeHtml(we), e._shouldEnhance = !0), _e !== e._dragRow && _("div", { key: _e, className: "mbsc-timeline-resource mbsc-timeline-row mbsc-flex-1-0" + (J ? " mbsc-timeline-parent mbsc-flex" : "") + (ve ? " mbsc-timeline-row-fixed" : "") + (E.cssClass ? " " + E.cssClass : "") + h + d + c, style: Oe }, J && _(tn, { className: "mbsc-timeline-resource-icon" + d + c, svg: E.collapsed ? s.rtl ? s.nextIconRtl : s.nextIcon : s.downIcon, theme: s.theme, onClick: function(Ue) {
      return e._onParentClick(Ue, E);
    } }), _("div", { className: "mbsc-timeline-resource-title" + (J ? " mbsc-flex-1-1" : ""), dangerouslySetInnerHTML: V }, we));
  }, Ie = function(E, F, V, J, ie) {
    var _e = E[F][qe][ie || "all"], ve = [];
    if (_e)
      for (var Oe = 0, we = _e.data; Oe < we.length; Oe++) {
        var Ue = we[Oe];
        (J && l === Ue.id || e._batchStart <= Ue.endDate && e._batchEnd > Ue.startDate) && ve.push(Ue);
      }
    return V(ve, ie || "all", F, qe);
  }, Se = function(E) {
    return E.map(function(F, V) {
      return _("div", { key: V, className: "mbsc-schedule-color mbsc-timeline-color" + F.cssClass + h, style: F.position }, _("div", { className: "mbsc-schedule-color-text" }, F.title));
    });
  }, Ve = function(E) {
    return E.map(function(F, V) {
      return F.position && _("div", { key: V, className: "mbsc-schedule-invalid mbsc-timeline-invalid" + F.cssClass + h, style: F.position }, _("div", { className: "mbsc-schedule-invalid-text" }, F.title));
    });
  }, je = function(E, F, V, J) {
    var ie = e._resourcesMap[V].eventResize, _e = V + "__" + J + "__" + F, ve = da(o && o.draggedEvent && o.draggedEvent.original.resize, s.dragToResize, ie), Oe = { displayTimezone: s.displayTimezone, drag: s.dragToMove || s.externalDrag, endDay: s.endDay, eventHeight: e._setRowHeight ? e._eventHeight : void 0, exclusiveEndDates: s.exclusiveEndDates, gridEndTime: p, gridStartTime: f, hasResY: S, isListing: b, isTimeline: !0, lastDay: +e._lastDay, render: s.renderEvent, renderBufferAfter: s.renderBufferAfter, renderBufferBefore: s.renderBufferBefore, renderContent: s.renderEventContent, resource: V, rtl: s.rtl, slot: J, startDay: s.startDay, theme: s.theme, timezonePlugin: s.timezonePlugin };
    return _(ut, null, E.map(function(we) {
      return we.position && _(xs, K({}, Oe, { event: we, inactive: l === we.id, key: we.uid, resize: da(we.original.resize, s.dragToResize, ie), selected: !(!s.selectedEventsMap[we.uid] && !s.selectedEventsMap[we.id]), onClick: e._onEventClick, onDoubleClick: s.onEventDoubleClick, onRightClick: s.onEventRightClick, onHoverIn: s.onEventHoverIn, onHoverOut: s.onEventHoverOut, onDelete: s.onEventDelete, onDragStart: e._onEventDragStart, onDragMove: e._onEventDragMove, onDragEnd: e._onEventDragEnd, onDragModeOn: e._onEventDragModeOn, onDragModeOff: e._onEventDragModeOff }));
    }), o && o.originDates && o.originDates[_e] && _(xs, K({}, Oe, { event: o.originDates[_e], hidden: o && !!o.draggedDates, isDrag: !0, resize: ve, onDragStart: e._onEventDragStart, onDragMove: e._onEventDragMove, onDragEnd: e._onEventDragEnd, onDragModeOff: e._onEventDragModeOff })), o && o.draggedDates && o.draggedDates[_e] && _(xs, K({}, Oe, { event: o.draggedDates[_e], isDrag: !0, resize: ve })));
  }, Ne = function(E, F) {
    var V = E.id, J = (F ? F + "-" : "") + V, ie = E.fixed && !S;
    return _("div", { key: J, className: "mbsc-timeline-row mbsc-flex mbsc-flex-1-0" + (E.isParent ? " mbsc-timeline-parent" : "") + (ie ? " mbsc-timeline-row-fixed" : "") + (J === e._dragRow ? " mbsc-timeline-hidden" : "") + (E.cssClass ? " " + E.cssClass : "") + h + c, style: { background: E.background, minHeight: e._rowHeights[J], top: ie ? e._fixedResourceTops[J] + "px" : void 0 } }, !u && _(ut, null, _("div", { className: "mbsc-timeline-events" }, Ie(e._events, V, je, !0, F)), Ie(e._invalids, V, Ve, void 0, F), Ie(e._colors, V, Se, void 0, F)), _("div", { style: { width: e._placeholderSizeX + "px" }, className: "mbsc-flex-none" }), N.map(function(_e) {
      var ve, Oe = _e.timestamp, we = F || _e.dateKey;
      if (I)
        return _("div", { key: Oe, className: "mbsc-timeline-day mbsc-flex" + h + d + c + (we === M ? " mbsc-timeline-hidden" : "") + (_e.dateIndex < A - 1 && (w || _e.lastOfMonth) ? " mbsc-timeline-day-border" : "") + (n.hasScrollX ? " mbsc-flex-none" : " mbsc-flex-1-0-0") + (D || e._isMulti ? " mbsc-timeline-day-month" : "") }, v.map(function(Be) {
          var ke = Be.id, ze = e._events[V][ke][we], Te = e._colors[V][ke][we], Ae = e._invalids[V][ke][we];
          return _("div", { key: ke, className: "mbsc-flex mbsc-flex-1-1" + (u ? " mbsc-timeline-slot" : "") }, u && _(ut, null, _("div", { className: "mbsc-timeline-events" }, je(ze ? ze.data : [], we, V, ke)), Ae && Ve(Ae.data), Te && Se(Te.data)), m.map(function(Ot, ot) {
            var lt, Qt = Od(Oe, Ot), Lt = !ot, ht = ot === m.length - 1, Vt = ((lt = {}).onDoubleClick = function(xt) {
              return s.onCellDoubleClick({ date: Qt, domEvent: xt, resource: V, slot: ke, source: y });
            }, lt.onContextMenu = function(xt) {
              return s.onCellRightClick({ date: Qt, domEvent: xt, resource: V, slot: ke, source: y });
            }, lt);
            return _("div", K({ key: ot, className: "mbsc-timeline-column mbsc-flex-1-1" + h + d + c + (Lt && !ht && C || ht && !Lt && T ? " mbsc-flex-none" : ""), onClick: function(xt) {
              return s.onCellClick({ date: Qt, domEvent: xt, resource: V, slot: ke, source: y });
            }, style: Lt && !ht ? C : ht && !Lt ? T : void 0 }, Vt));
          }));
        }));
      var Ue = _e.date, et = ((ve = {}).onDoubleClick = function(Be) {
        return s.onCellDoubleClick({ date: Ue, domEvent: Be, resource: V, source: y });
      }, ve.onContextMenu = function(Be) {
        return s.onCellRightClick({ date: Ue, domEvent: Be, resource: V, source: y });
      }, ve);
      return _("div", K({ key: Oe, className: "mbsc-timeline-day mbsc-timeline-column" + h + d + c + (we === M ? " mbsc-timeline-hidden" : "") + (n.hasScrollX ? " mbsc-flex-none" : " mbsc-flex-1-0-0"), onClick: function(Be) {
        return s.onCellClick({ date: Ue, domEvent: Be, resource: V, source: y });
      } }, et));
    }));
  };
  return _("div", { ref: e._setEl, className: "mbsc-timeline mbsc-flex-1-1 mbsc-flex-col" + (n.cellWidth ? "" : " mbsc-hidden") + (e._hasSticky ? " mbsc-has-sticky" : "") + (z ? "" : " mbsc-timeline-no-rows") + (k ? "" : " mbsc-timeline-no-resource") + h + d }, _("div", { ref: e._setStickyHeader, className: "mbsc-timeline-header-sticky mbsc-flex" + h }, z && _("div", { className: "mbsc-timeline-resource-header-cont " + W + h + d + c, style: O }, (s.renderResourceHeader && ye(i = s.renderResourceHeader()) && (r = e._safeHtml(i), e._shouldEnhance = !0), _("div", { className: "mbsc-timeline-resource-header", dangerouslySetInnerHTML: r }, i))), I && _("div", { className: "mbsc-flex-1-1" }, !S && _(ut, null, e._isMulti && _("div", { className: "mbsc-timeline-header-month mbsc-flex" + h + d + c }, G(H[B] || H[0], !0)), s.weekNumbers && _("div", { className: "mbsc-timeline-header-week mbsc-flex" + h + d + c }, ee(H[B] || H[0], !0)), (u || w) && _("div", { className: "mbsc-timeline-header-date mbsc-flex" + h + d + c }, j(H[B] || H[0], !0)))), z && s.renderSidebar && _("div", { className: "mbsc-timeline-sidebar-header-cont mbsc-timeline-sidebar-col" + h + d + c, style: O }, function() {
    var E, F;
    return s.renderSidebarHeader && ye(E = s.renderSidebarHeader()) && (F = e._safeHtml(E), e._shouldEnhance = !0), _("div", { className: "mbsc-timeline-sidebar-header", dangerouslySetInnerHTML: F }, E);
  }()), n.hasScrollY && _("div", { className: "mbsc-schedule-fake-scroll-y" })), R && _("div", { ref: e._setStickyFooter, className: "mbsc-timeline-footer-sticky mbsc-flex" + h }, z && _("div", { className: "mbsc-timeline-resource-footer-cont " + W + h + d + c, style: L }, function() {
    var E, F;
    return s.renderResourceFooter && ye(E = s.renderResourceFooter()) && (F = e._safeHtml(E), e._shouldEnhance = !0), _("div", { className: "mbsc-timeline-resource-footer", dangerouslySetInnerHTML: F }, E);
  }()), I && _("div", { className: "mbsc-flex-1-1" }), z && s.renderSidebar && _("div", { className: "mbsc-timeline-sidebar-footer-cont mbsc-timeline-sidebar-col" + h + d + c, style: L }, function() {
    var E, F;
    return s.renderSidebarFooter && ye(E = s.renderSidebarFooter()) && (F = e._safeHtml(E), e._shouldEnhance = !0), _("div", { className: "mbsc-timeline-sidebar-footer", dangerouslySetInnerHTML: F }, E);
  }()), n.hasScrollY && _("div", { className: "mbsc-schedule-fake-scroll-y" })), _("div", { ref: e._setCont, className: "mbsc-timeline-grid-scroll mbsc-flex-col mbsc-flex-1-1" + h + d + c, onScroll: e._onScroll }, _("div", { className: "mbsc-flex-none", style: e._hasSticky ? void 0 : O }), _("div", { className: "mbsc-timeline-header mbsc-flex" + h + d + c, ref: e._setHeaderCont }, z && _("div", { className: "mbsc-timeline-resource-header-cont " + W + h + d + c }), _("div", { className: "mbsc-timeline-header-bg mbsc-flex-1-0 mbsc-flex" + h }, _("div", { className: "mbsc-timeline-time-indicator-cont", style: { height: (n.scrollContHeight || 0) - (n.headerHeight || 0) + "px", width: n.hasScrollX ? e._gridWidth + "px" : void 0 } }, e._showTimeIndicator && _(Ld, { amText: s.amText, displayedTime: e._time, displayedDays: A, displayTimezone: s.displayTimezone, endDay: s.endDay, firstDay: e._firstDayTz, orientation: "y", pmText: s.pmText, rtl: s.rtl, startDay: s.startDay, startTime: f, theme: s.theme, timeFormat: s.timeFormat, timezonePlugin: s.timezonePlugin, hasResY: S }), e._showCursorTime && _("div", { ref: e._setCursorTimeCont, className: "mbsc-schedule-cursor-time mbsc-schedule-cursor-time-y" + h })), _("div", { className: "mbsc-flex-none", style: { width: e._placeholderSizeX + "px" } }), _("div", { className: n.hasScrollX ? "mbsc-flex-none" : "mbsc-flex-1-1" }, I ? _(ut, null, e._isMulti && !S && _("div", { className: "mbsc-flex" }, N.map(function(E) {
    var F = E.lastOfMonth;
    if (E.dateKey !== M)
      return _("div", { key: E.timestamp, className: "mbsc-timeline-month mbsc-flex-1-0-0" + h + d + c + (E.dateIndex < A - 1 && F ? " mbsc-timeline-day mbsc-timeline-day-border" : "") }, _("div", { className: "mbsc-timeline-header-month" + h + d + c + (F ? " mbsc-timeline-header-month-last" : "") }, E.monthTitle && G(E, !1)));
  })), s.weekNumbers && _("div", { className: "mbsc-flex" }, N.map(function(E) {
    var F = E.lastOfWeek;
    if (E.dateKey !== M)
      return _("div", { key: E.timestamp, className: "mbsc-timeline-month mbsc-flex-1-0-0" + h + d + c + (E.dateIndex < A - 1 && F && (w || E.lastOfMonth) ? " mbsc-timeline-day mbsc-timeline-day-border" : "") }, _("div", { className: "mbsc-timeline-header-week" + h + d + c + (F ? " mbsc-timeline-header-week-last" : "") }, E.weekTitle && ee(E, !1)));
  })), _("div", { className: "mbsc-flex" }, N.map(function(E) {
    if (E.dateKey !== M)
      return _("div", { key: E.timestamp, className: "mbsc-timeline-day mbsc-flex-1-0-0" + h + d + c + (E.dateIndex < A - 1 && (w || E.lastOfMonth) ? " mbsc-timeline-day-border" : "") + (D || e._isMulti ? " mbsc-timeline-day-month" : "") }, !S && _("div", { className: "mbsc-timeline-header-date" + h + d + c }, j(E), E.label && _("div", { className: "mbsc-hidden-content" }, E.label)), u && _("div", { className: "mbsc-flex mbsc-timeline-slots" + h }, v.map(function(F) {
        return _("div", { key: F.id, className: "mbsc-timeline-slot mbsc-timeline-slot-header mbsc-flex-1-1" + d + h }, F.name && function(V) {
          var J, ie = V.slot, _e = ie.name;
          return s.renderSlot && ye(_e = s.renderSlot(V)) && (J = e._safeHtml(_e), e._shouldEnhance = !0), _("div", { key: ie.id, className: "mbsc-timeline-slot-title", dangerouslySetInnerHTML: J }, _e);
        }({ slot: F, date: E.date }));
      })), _("div", { "aria-hidden": "true", className: "mbsc-flex" }, m.map(function(F, V) {
        var J = !V, ie = V === m.length - 1;
        return _("div", { key: V, style: J && !ie ? C : ie && !J ? T : void 0, className: "mbsc-flex mbsc-flex-1-1 mbsc-timeline-header-column" + h + d + c + (!e._displayTime || u ? " mbsc-timeline-no-height" : "") + (g > e._stepCell && m[V + 1] % g ? " mbsc-timeline-no-border" : "") + (J && C || ie && T ? " mbsc-flex-none" : "") }, q(E, F), e._timesBetween.map(function(_e, ve) {
          var Oe = F + (ve + 1) * g;
          return Oe > f && Oe < p && q(E, Oe);
        }));
      })));
  }))) : _("div", { className: "mbsc-flex" }, N.map(function(E) {
    if (E.dateKey !== M)
      return _("div", { key: E.timestamp, className: "mbsc-timeline-day mbsc-flex-1-0-0" + h + d + c }, _("div", { className: "mbsc-timeline-header-week mbsc-timeline-header-week-last" + h + d + c }, _("div", { className: "mbsc-timeline-header-week-text mbsc-timeline-header-week-text-last" + (E.isActive && !(s.renderWeek || s.renderMonth || s.renderQuarter || s.renderYear) ? " mbsc-timeline-header-active" : "") + h }, function(F) {
        switch (s.resolution) {
          case "week":
            if (s.renderWeek)
              return ee(F, !1);
            break;
          case "month":
            if (s.renderMonth)
              return G(F, !1);
            break;
          case "quarter":
            if (s.renderQuarter)
              return Z(F);
            break;
          case "year":
            if (s.renderYear)
              return fe(F);
        }
        return F.columnTitle;
      }(E))));
  })))), z && s.renderSidebar && _("div", { className: "mbsc-timeline-sidebar-header-cont mbsc-timeline-sidebar-col" + h + d + c })), _("div", { className: "mbsc-flex mbsc-flex-1-1" }, _("div", { className: "mbsc-flex mbsc-flex-1-1" }, z && _("div", { className: "mbsc-timeline-resources mbsc-flex-col " + W + h + d, ref: e._setResCont }, _("div", { className: "mbsc-flex-none", style: e._hasSideSticky ? void 0 : O }), _("div", { className: "mbsc-timeline-resource-bg mbsc-flex-1-1" + (e._hasHierarchy || n.hasScrollY ? "" : " mbsc-flex-col") + h }, _("div", { style: { height: e._placeholderSizeY + "px" }, className: "mbsc-flex-none" }), e._rowBatch.map(function(E) {
    var F = E.day, V = F ? F.dateKey : "";
    return !E.hidden && F ? k ? _("div", { key: V, className: "mbsc-timeline-row-group mbsc-flex mbsc-flex-1-0" + h + c }, _("div", { className: "mbsc-timeline-row-date mbsc-timeline-row-date-col mbsc-flex-none" + d + h + c }, j(F)), _("div", { className: "mbsc-timeline-row-resource-col mbsc-flex-1-1 mbsc-flex-col" }, E.rows.map(function(J) {
      return Ee(J, V);
    }))) : _("div", { key: V, className: "mbsc-timeline-row-date mbsc-flex-1-0" + d + h + c, style: { minHeight: e._rowHeights[V + "-" + qe] } }, j(F)) : E.rows.map(function(J) {
      return Ee(J, V);
    });
  })), _("div", { className: "mbsc-flex-none", style: e._hasSideSticky ? void 0 : L })), z && _("div", { className: e._hasSideSticky ? "" : W }), _("div", { className: "mbsc-timeline-hidden" }, _("div", { className: "mbsc-timeline-row mbsc-timeline-empty-row" + h }), _("div", { className: "mbsc-timeline-row mbsc-timeline-parent mbsc-timeline-empty-parent" + h }), _("div", { className: "mbsc-timeline-row-gutter" + h })), _("div", K({ className: "mbsc-timeline-grid mbsc-flex-1-0" + (e._hasHierarchy || n.hasScrollY ? "" : " mbsc-flex-col"), ref: e._setGridCont, style: { height: n.hasScrollY ? e._gridHeight + "px" : void 0, width: n.hasScrollX ? e._gridWidth + "px" : void 0 } }, Y), _("div", { style: { height: e._placeholderSizeY + "px" }, className: "mbsc-flex-none" }), e._rowBatch.map(function(E) {
    var F = E.day, V = F ? F.dateKey : "";
    return F && k ? _("div", { key: V, className: "mbsc-timeline-row-group mbsc-flex-col mbsc-flex-1-0" + h + c }, E.rows.map(function(J) {
      return Ne(J, V);
    })) : _(ut, { key: V }, E.rows.map(function(J) {
      return Ne(J, V);
    }));
  }), e._connections && _("svg", K({ viewBox: "0 0 100 100", preserveAspectRatio: "none" }, P), e._connections.map(function(E) {
    var F, V = ((F = {}).className = "mbsc-connection " + E.cssClass + h, F.d = E.pathD, F.style = { stroke: E.color, fill: E.fill }, F["vector-effect"] = "non-scaling-stroke", F);
    return ss(e._batchStart, e._batchEnd, E.startDate, E.endDate, !0) && _("path", K({ key: E.id }, V));
  }))), z && s.renderSidebar && _("div", { className: "mbsc-timeline-sidebar mbsc-timeline-sidebar-col mbsc-flex-col" + h + d, ref: e._setSidebarCont }, _("div", { className: "mbsc-flex-none", style: e._hasSideSticky ? void 0 : O }), _("div", { className: "mbsc-timeline-resource-bg mbsc-flex-1-1" + (e._hasHierarchy || n.hasScrollY ? "" : " mbsc-flex-col") + h }, _("div", { style: { height: e._placeholderSizeY + "px" }, className: "mbsc-flex-none" }), e._rowBatch.map(function(E) {
    var F = E.day, V = F ? F.dateKey : "";
    return F && k ? _("div", { key: V, className: "mbsc-timeline-row-group mbsc-flex-col mbsc-flex-1-0" + h + c }, E.rows.map(function(J) {
      return oe(J, V);
    })) : E.rows.map(function(J) {
      return oe(J, V);
    });
  })), _("div", { className: "mbsc-flex-none", style: e._hasSideSticky ? void 0 : L })), z && s.renderSidebar && _("div", { className: e._hasSideSticky ? "" : "mbsc-timeline-sidebar-col" }))), R && _(ut, null, _("div", { className: "mbsc-flex-none", style: e._hasSticky ? void 0 : L }), _("div", { className: "mbsc-timeline-footer mbsc-flex" + h + d + c, ref: e._setFooterCont }, z && _("div", { className: "mbsc-timeline-resource-footer-cont " + W + h + d + c }), _("div", { className: "mbsc-timeline-footer-bg mbsc-flex-1-0 mbsc-flex" + h }, _("div", { className: "mbsc-flex-none", style: { width: e._placeholderSizeX + "px" } }), _("div", { className: n.hasScrollX ? "mbsc-flex-none" : "mbsc-flex-1-1" }, _("div", { className: "mbsc-flex" }, N.map(function(E) {
    if (E.dateKey !== M)
      return I ? _("div", { key: E.timestamp, className: "mbsc-timeline-day mbsc-flex-1-0-0" + h + d + c + (E.dateIndex < A - 1 && (w || E.lastOfMonth) ? " mbsc-timeline-day-border" : "") + (D || e._isMulti ? " mbsc-timeline-day-month" : "") }, _("div", { className: "mbsc-flex" }, m.map(function(F, V) {
        var J = !V, ie = V === m.length - 1;
        return _("div", { key: V, style: J && !ie ? C : ie && !J ? T : void 0, className: "mbsc-flex mbsc-flex-1-1 mbsc-timeline-column mbsc-timeline-footer-column" + h + d + c + (!e._displayTime || u ? " mbsc-timeline-no-height" : "") + (g > e._stepCell && m[V + 1] % g ? "mbsc-timeline-no-border" : "") + (J && !ie && C || ie && !J && T ? " mbsc-flex-none" : "") }, U(E, F), e._timesBetween.map(function(_e, ve) {
          var Oe = F + (ve + 1) * g;
          return Oe > f && Oe < p && U(E, Oe);
        }));
      })), s.renderDayFooter && _("div", { className: "mbsc-timeline-footer-date" + h + d + c }, function(F) {
        var V, J;
        return s.renderDayFooter && ye(V = s.renderDayFooter({ date: F.date, events: F.eventMap.all })) && (J = e._safeHtml(V), e._shouldEnhance = !0), _("div", { className: "mbsc-timeline-footer-date-cont", dangerouslySetInnerHTML: J }, V);
      }(E)), u && _("div", { className: "mbsc-flex" }, v.map(function(F) {
        return _("div", { key: F.id, className: "mbsc-timeline-slot mbsc-flex-1-1" + d + h });
      }))) : _("div", { key: E.timestamp, className: "mbsc-timeline-day mbsc-flex-1-0-0" + h + d + c }, _("div", { className: "mbsc-timeline-footer-week mbsc-timeline-footer-week-last" + h + d + c }, _("div", { className: "mbsc-timeline-footer-week-text" + h }, function(F) {
        switch (s.resolution) {
          case "week":
            if (s.renderWeekFooter)
              return ne(F);
            break;
          case "month":
            if (s.renderMonthFooter)
              return te(F);
            break;
          case "quarter":
            if (s.renderQuarterFooter)
              return re(F);
            break;
          case "year":
            if (s.renderYearFooter)
              return he(F);
        }
      }(E))));
  })))), z && s.renderSidebar && _("div", { className: "mbsc-timeline-sidebar-footer-cont mbsc-timeline-sidebar-col" + h + d + c })))), o && !n.isTouchDrag && _("div", { className: "mbsc-calendar-dragging" }));
}
var u_ = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e, t) {
    return d_(e, t, this);
  }, n;
}(c_), Rd = dd({}), kr = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype.componentWillUnmount = function() {
    this._changes && this._changes.unsubscribe(this._handler);
  }, n.prototype.render = function() {
    var e = this, t = this.props, a = t.host, i = t.component, r = t.view, o = Bn(t, ["host", "component", "view"]), l = r || a && a._calendarView;
    return l && !this._changes && (this._changes = l.s.instanceService.onComponentChange, this._handler = this._changes.subscribe(function() {
      e.forceUpdate();
    })), _(Rd.Consumer, null, function(u) {
      var c = u.instance || r || a && a._calendarView;
      return c && _(i, K({ inst: c }, o));
    });
  }, n;
}(ud), h_ = function(s) {
  var n = s.inst, e = s.className;
  return _(dn, { ariaLabel: n.s.prevPageText, className: "mbsc-calendar-button " + (e || ""), disabled: n._isPrevDisabled(), iconSvg: n._prevIcon, onClick: n.prevPage, theme: n.s.theme, themeVariant: n.s.themeVariant, type: "button", variant: "flat" });
}, m_ = function(s) {
  var n = s.inst, e = s.className;
  return _(dn, { ariaLabel: n.s.nextPageText, disabled: n._isNextDisabled(), className: "mbsc-calendar-button " + (e || ""), iconSvg: n._nextIcon, onClick: n.nextPage, theme: n.s.theme, themeVariant: n.s.themeVariant, type: "button", variant: "flat" });
}, p_ = function(s) {
  var n = s.inst, e = s.className;
  return _(dn, { className: "mbsc-calendar-button mbsc-calendar-button-today " + (e || ""), onClick: n._onTodayClick, theme: n.s.theme, themeVariant: n.s.themeVariant, type: "button", variant: "flat" }, n.s.todayText);
}, f_ = function(s) {
  var n = s.inst, e = s.className, t = n.s, a = n._theme, i = n._view;
  return _("div", { "aria-live": "polite", className: (e || "") + a }, n._title.map(function(r, o) {
    return (n._pageNr === 1 || o === 0 || n._hasPicker || i === "page") && _(dn, { className: "mbsc-calendar-button" + (n._pageNr > 1 ? " mbsc-flex-1-1" : ""), "data-index": o, onClick: n._onPickerBtnClick, key: o, theme: t.theme, themeVariant: t.themeVariant, type: "button", variant: "flat" }, (n._hasPicker || i === "page") && (r.title ? _("span", { className: "mbsc-calendar-title" + a }, r.title) : _(ut, null, n._yearFirst && _("span", { className: "mbsc-calendar-title mbsc-calendar-year" + a }, r.yearTitle), _("span", { className: "mbsc-calendar-title mbsc-calendar-month" + a }, r.monthTitle), !n._yearFirst && _("span", { className: "mbsc-calendar-title mbsc-calendar-year" + a }, r.yearTitle))), !n._hasPicker && i !== "page" && _("span", { className: "mbsc-calendar-title" + a }, n._viewTitle), t.downIcon && n._pageNr === 1 ? _(tn, { svg: i === "page" ? t.downIcon : t.upIcon, theme: t.theme }) : null);
  }));
}, Mr = function(s) {
  var n = s.calendar, e = s.view, t = Bn(s, ["calendar", "view"]);
  return _(kr, K({ component: h_, host: n, view: e }, t));
};
Mr._name = "CalendarPrev";
var Ir = function(s) {
  var n = s.calendar, e = s.view, t = Bn(s, ["calendar", "view"]);
  return _(kr, K({ component: m_, host: n, view: e }, t));
};
Ir._name = "CalendarNext";
var Nr = function(s) {
  var n = s.calendar, e = s.view, t = Bn(s, ["calendar", "view"]);
  return _(kr, K({ component: p_, host: n, view: e }, t));
};
Nr._name = "CalendarToday";
var Or = function(s) {
  var n = s.calendar, e = s.view, t = Bn(s, ["calendar", "view"]);
  return _(kr, K({ component: f_, host: n, view: e }, t));
};
Or._name = "CalendarNav";
var __ = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e.state = { height: "sm", pageSize: 0, pickerSize: 0, width: "sm" }, e._dim = {}, e._months = [1, 2, 3], e._title = [], e.PAGE_VIEW = "page", e.MONTH_VIEW = "month", e.YEAR_VIEW = "year", e.MULTI_YEAR_VIEW = "multi-year", e.nextPage = function() {
      switch (e._prevDocClick(), e._view) {
        case "month":
          e._activeMonthChange(1);
          break;
        case "multi-year":
          e._activeYearsChange(1);
          break;
        case "year":
          e._activeYearChange(1);
          break;
        default:
          e._activeChange(1);
      }
    }, e.prevPage = function() {
      switch (e._prevDocClick(), e._view) {
        case "month":
          e._activeMonthChange(-1);
          break;
        case "multi-year":
          e._activeYearsChange(-1);
          break;
        case "year":
          e._activeYearChange(-1);
          break;
        default:
          e._activeChange(-1);
      }
    }, e._changeView = function(t) {
      var a = e.s, i = e._view, r = e._hasPicker, o = a.selectView, l = a.navView, u = a.showCalendar && a.calendarType === "year";
      if (!t) {
        switch (i) {
          case "page":
            t = l || (u ? "multi-year" : "year");
            break;
          case "month":
            t = "year";
            break;
          case "multi-year":
            t = u || l === "multi-year" ? "page" : "year";
            break;
          default:
            t = r && l === "year" || o === "year" || e._prevView !== "multi-year" ? "multi-year" : l === "month" ? "month" : "page";
        }
        o !== "multi-year" && l !== "multi-year" || (t = "multi-year");
      }
      i === "page" && (e._activeMonth = e._active);
      var c = r && t === o;
      e._prevView = i, e.setState({ view: t, viewClosing: c ? void 0 : i, viewOpening: c ? void 0 : t });
    }, e._onDayHoverIn = function(t) {
      e._disableHover || (e._hook("onDayHoverIn", t), e._hoverTimer = setTimeout(function() {
        var a = Pe(t.date);
        e._labels && (t.labels = e._labels[a]), e._marked && (t.marked = e._marked[a]), e._isHover = !0, e._hook("onCellHoverIn", t);
      }, 150));
    }, e._onDayHoverOut = function(t) {
      if (!e._disableHover && (e._hook("onDayHoverOut", t), clearTimeout(e._hoverTimer), e._isHover)) {
        var a = Pe(t.date);
        e._labels && (t.labels = e._labels[a]), e._marked && (t.marked = e._marked[a]), e._isHover = !1, e._hook("onCellHoverOut", t);
      }
    }, e._onLabelClick = function(t) {
      e._isLabelClick = !0, e._hook("onLabelClick", t);
    }, e._onDayClick = function(t) {
      e._shouldFocus = !e._isLabelClick, e._prevAnim = !1, e._isLabelClick = !1, e._hook("onDayClick", t);
    }, e._onTodayClick = function(t) {
      e._prevAnim = !1, e._hook("onActiveChange", { date: +wo(me(e.s)), today: !0 }), e._hook("onTodayClick", {});
    }, e._onNavDayClick = function(t) {
      if (!t.disabled) {
        var a = t.date, i = Jn(a, e.s);
        e._prevDocClick(), e._changeView("page"), e._shouldFocus = !0, e._prevAnim = !e._hasPicker, e._hook("onActiveChange", { date: +a, nav: !0, pageChange: i !== e._pageIndex, today: !0 });
      }
    }, e._onMonthClick = function(t) {
      if (!t.disabled) {
        var a = e.s, i = new Date(t.date);
        if (a.selectView === "year")
          e._hook("onDayClick", t);
        else if (e._prevDocClick(), e._shouldFocus = !0, e._prevAnim = !e._hasPicker, e._activeMonth = +i, a.navView === "year" || a.navView === void 0) {
          var r = Jn(i, a);
          e._changeView("page"), e._hook("onActiveChange", { date: +i, nav: !0, pageChange: r !== e._pageIndex, today: !0 });
        } else
          e._changeView("month");
      }
    }, e._onYearClick = function(t) {
      if (!t.disabled) {
        var a = t.date, i = e.s, r = i.selectView;
        if (r === "multi-year")
          e._hook("onDayClick", t);
        else if (e._shouldFocus = !0, e._prevAnim = r === "year", e._activeMonth = +a, e._prevDocClick(), i.navView === "multi-year" || i.calendarType === "year") {
          var o = Jn(a, i);
          e._changeView("page"), e._hook("onActiveChange", { date: +a, pageChange: o !== e._pageIndex, today: !0 });
        } else
          e._changeView("year");
      }
    }, e._onPageChange = function(t) {
      e._isSwipeChange = !0, e._activeChange(t.diff);
    }, e._onMonthPageChange = function(t) {
      e._activeMonthChange(t.diff);
    }, e._onYearPageChange = function(t) {
      e._activeYearChange(t.diff);
    }, e._onYearsPageChange = function(t) {
      e._activeYearsChange(t.diff);
    }, e._onAnimationEnd = function(t) {
      e._disableHover = !1, e._isIndexChange && (e._pageLoaded(), e._isIndexChange = !1);
    }, e._onStart = function() {
      clearTimeout(e._hoverTimer);
    }, e._onGestureStart = function(t) {
      e._disableHover = !0, e._hook("onGestureStart", t);
    }, e._onGestureEnd = function(t) {
      e._prevDocClick();
    }, e._onPickerClose = function() {
      e.setState({ view: "page" });
    }, e._onPickerOpen = function() {
      var t = e._pickerCont.clientHeight, a = e._pickerCont.clientWidth;
      e.setState({ pickerSize: e._isVertical ? t : a });
    }, e._onPickerBtnClick = function(t) {
      e._view === "page" && (e._pickerBtn = t.currentTarget), e._prevDocClick(), e._changeView();
    }, e._onDocClick = function() {
      var t = e.s.selectView;
      e._prevClick || e._hasPicker || e._view === t || e._changeView(t);
    }, e._onViewAnimationEnd = function() {
      e.state.viewClosing && e.setState({ viewClosing: void 0 }), e.state.viewOpening && e.setState({ viewOpening: void 0 });
    }, e._onResize = function() {
      if (e._body && Mt) {
        var t = e.s, a = e.state, i = t.showCalendar, r = i ? e._body.querySelector(".mbsc-calendar-body-inner") : e._body, o = e._el.offsetWidth, l = e._el.offsetHeight, u = r.clientHeight, c = r.clientWidth, d = e._isVertical ? u : c, m = e._hasPicker ? a.pickerSize : d, h = i !== void 0, f = "sm", p = "sm", g = void 0, v = !1, y = 0, b = 0;
        if (t.responsiveStyle && !e._isGrid && (u > 300 && (p = "md"), c > 767 && (f = "md")), f !== a.width || p !== a.height)
          e._shouldCheckSize = !0, e.setState({ width: f, height: p });
        else {
          if (e._labels && i) {
            var D = r.querySelector(".mbsc-calendar-text"), w = r.querySelector(".mbsc-calendar-day-inner"), C = w.querySelector(".mbsc-calendar-labels"), T = D ? Tp(D, "marginBottom") : 2, N = D ? D.offsetHeight : 18;
            y = C.offsetTop, v = r.scrollHeight > r.clientHeight, b = N + T, g = Math.max(1, Le((w.clientHeight - y) / b));
          }
          e._hook("onResize", { height: l, target: e._el, width: o }), t.navService.pageSize = d;
          var O = e._shouldPageLoad ? (a.update || 0) + 1 : a.update;
          e.setState({ cellTextHeight: y, hasScrollY: v, labelHeight: b, maxLabels: g, pageSize: d, pickerSize: m, ready: h, update: O });
        }
      }
    }, e._onKeyDown = function(t) {
      var a, i = e.s, r = e._view, o = r === "page" ? e._active : e._activeMonth, l = new Date(o), u = i.getYear(l), c = i.getMonth(l), d = i.getDay(l), m = i.getDate, h = i.weeks, f = i.calendarType === "month";
      if (r === "multi-year") {
        var p = void 0;
        switch (t.keyCode) {
          case 37:
            p = u - 1 * e._rtlNr;
            break;
          case 39:
            p = u + 1 * e._rtlNr;
            break;
          case 38:
            p = u - 3;
            break;
          case 40:
            p = u + 3;
            break;
          case 36:
            p = e._getPageYears(e._yearsIndex);
            break;
          case 35:
            p = e._getPageYears(e._yearsIndex) + 11;
            break;
          case 33:
            p = u - 12;
            break;
          case 34:
            p = u + 12;
        }
        p && e._minYears <= p && e._maxYears >= p && (t.preventDefault(), e._shouldFocus = !0, e._prevAnim = !1, e._activeMonth = +m(p, 0, 1), e.forceUpdate());
      } else if (r === "year") {
        switch (t.keyCode) {
          case 37:
            a = m(u, c - 1 * e._rtlNr, 1);
            break;
          case 39:
            a = m(u, c + 1 * e._rtlNr, 1);
            break;
          case 38:
            a = m(u, c - 3, 1);
            break;
          case 40:
            a = m(u, c + 3, 1);
            break;
          case 36:
            a = m(u, 0, 1);
            break;
          case 35:
            a = m(u, 11, 1);
            break;
          case 33:
            a = m(u - 1, c, 1);
            break;
          case 34:
            a = m(u + 1, c, 1);
        }
        a && e._minYear <= a && e._maxYear >= a && (t.preventDefault(), e._shouldFocus = !0, e._prevAnim = !1, e._activeMonth = +a, e.forceUpdate());
      } else {
        switch (t.keyCode) {
          case 37:
            a = m(u, c, d - 1 * e._rtlNr);
            break;
          case 39:
            a = m(u, c, d + 1 * e._rtlNr);
            break;
          case 38:
            a = m(u, c, d - 7);
            break;
          case 40:
            a = m(u, c, d + 7);
            break;
          case 36:
            a = m(u, c, 1);
            break;
          case 35:
            a = m(u, c + 1, 0);
            break;
          case 33:
            a = t.altKey ? m(u - 1, c, d) : f ? m(u, c - 1, d) : m(u, c, d - 7 * h);
            break;
          case 34:
            a = t.altKey ? m(u + 1, c, d) : f ? m(u, c + 1, d) : m(u, c, d + 7 * h);
        }
        if (a && e._minDate <= a && e._maxDate >= a) {
          t.preventDefault();
          var g = Jn(a, i);
          e._shouldFocus = !0, e._prevAnim = !1, r === "month" ? (e._activeMonth = +a, e.forceUpdate()) : (e._pageChange = i.noOuterChange && g !== e._pageIndex, e._hook("onActiveChange", { date: +a, pageChange: e._pageChange }));
        }
      }
    }, e._setHeader = function(t) {
      e._headerElement = t;
    }, e._setBody = function(t) {
      e._body = t;
    }, e._setPickerCont = function(t) {
      e._pickerCont = t;
    }, e;
  }
  return de(n, s), n.prototype._getPageDay = function(e) {
    return +_s(e, this.s);
  }, n.prototype._getPageStyle = function(e, t, a, i) {
    var r;
    return (r = {})[(mn ? mn + "T" : "t") + "ransform"] = "translate" + this._axis + "(" + 100 * (e - t) * this._rtlNr + "%)", r.position = e === a ? "relative" : "", r.width = 100 / (i || 1) + "%", r;
  }, n.prototype._getPageMonth = function(e) {
    var t = this.s, a = t.refDate ? ue(t.refDate) : Bt, i = t.getYear(a), r = t.getMonth(a);
    return +t.getDate(i, r + e, 1);
  }, n.prototype._getPageYear = function(e) {
    var t = this.s, a = t.refDate ? ue(t.refDate) : Bt;
    return t.getYear(a) + e;
  }, n.prototype._getPageYears = function(e) {
    var t = this.s, a = t.refDate ? ue(t.refDate) : Bt;
    return t.getYear(a) + 12 * e;
  }, n.prototype._getPickerClass = function(e) {
    var t, a = e === this.s.selectView ? " mbsc-calendar-picker-main" : "", i = "mbsc-calendar-picker", r = this._hasPicker, o = this.state, l = o.viewClosing, u = o.viewOpening;
    switch (e) {
      case "page":
        t = r ? "" : (u === "page" ? "in-down" : "") + (l === "page" ? "out-down" : "");
        break;
      case "month":
        t = r && l === "page" ? "" : (u === "month" ? "in-down" : "") + (l === "month" ? "out-down" : "");
        break;
      case "multi-year":
        t = r && l === "page" ? "" : (u === "multi-year" ? "in-up" : "") + (l === "multi-year" ? "out-up" : "");
        break;
      default:
        t = !r || u !== "page" && l !== "page" ? (u === "year" ? l === "multi-year" ? "in-down" : "in-up" : "") + (l === "year" ? u === "multi-year" ? "out-down" : "out-up" : "") : "";
    }
    return i + a + (Ja && t ? " " + i + "-" + t : "");
  }, n.prototype._isNextDisabled = function(e) {
    if (!this._hasPicker || e) {
      var t = this._view;
      if (t === "multi-year")
        return this._yearsIndex + 1 > this._maxYearsIndex;
      if (t === "year")
        return this._yearIndex + 1 > this._maxYearIndex;
      if (t === "month")
        return this._monthIndex + 1 > this._maxMonthIndex;
    }
    return this._pageIndex + 1 > this._maxIndex;
  }, n.prototype._isPrevDisabled = function(e) {
    if (!this._hasPicker || e) {
      var t = this._view;
      if (t === "multi-year")
        return this._yearsIndex - 1 < this._minYearsIndex;
      if (t === "year")
        return this._yearIndex - 1 < this._minYearIndex;
      if (t === "month")
        return this._monthIndex - 1 < this._minMonthIndex;
    }
    return this._pageIndex - 1 < this._minIndex;
  }, n.prototype._render = function(e, t) {
    var a = e.getDate, i = e.getYear, r = e.getMonth, o = e.showCalendar, l = e.calendarType, u = e.eventRange, c = e.eventRangeSize || 1, d = e.firstDay, m = l === "week", h = l === "month", f = l === "year" ? 12 : +(e.size || 1), p = f > 1 && !m, g = o ? m ? e.weeks : 6 : 0, v = e.activeDate || this._active || +/* @__PURE__ */ new Date(), y = v !== this._active, b = new Date(v), D = this._prevS, w = e.dateFormat, C = e.monthNames, T = e.yearSuffix, N = Kc(e.labelList) ? +e.labelList + 1 : e.labelList === "all" ? -1 : 0, O = e.labelList !== D.labelList, L = e.navService, H = L.pageIndex, A = L.firstDay, B = L.lastDay, I = L.viewStart, S = L.viewEnd;
    if (this._minDate = L.minDate, this._maxDate = L.maxDate, Dt(e.min))
      this._minIndex = -1 / 0, this._minYears = -1 / 0, this._minYearsIndex = -1 / 0, this._minYear = -1 / 0, this._minYearIndex = -1 / 0, this._minMonthIndex = -1 / 0;
    else {
      var k = Ce(this._minDate);
      this._minDate = Ce(k), this._minYear = a(i(k), r(k), 1), this._minYears = i(k), this._minIndex = Jn(k, e), this._minYearIndex = ni(k, e), this._minYearsIndex = ti(k, e), this._minMonthIndex = si(k, e);
    }
    if (Dt(e.max))
      this._maxIndex = 1 / 0, this._maxYears = 1 / 0, this._maxYearsIndex = 1 / 0, this._maxYear = 1 / 0, this._maxYearIndex = 1 / 0, this._maxMonthIndex = 1 / 0;
    else {
      var R = this._maxDate;
      this._maxYear = a(i(R), r(R) + 1, 1), this._maxYears = i(R), this._maxIndex = Jn(R, e), this._maxYearIndex = ni(R, e), this._maxYearsIndex = ti(R, e), this._maxMonthIndex = si(R, e);
    }
    var z = l !== D.calendarType || u !== D.eventRange || d !== D.firstDay || e.eventRangeSize !== D.eventRangeSize || e.refDate !== D.refDate || e.showCalendar !== D.showCalendar || e.weeks !== D.weeks;
    z && this._pageIndex !== void 0 && (this._prevAnim = !0), y && (this._activeMonth = v), this._view = t.view || e.selectView, this._yearsIndex = ti(new Date(this._activeMonth), e), this._yearIndex = ni(new Date(this._activeMonth), e), this._monthIndex = si(new Date(this._activeMonth), e);
    var W = p ? 1 : Td(e.pages, t.pageSize), M = e.calendarScroll === "vertical" && e.pages !== "auto" && (e.pages === void 0 || e.pages === 1), P = e.showOuterDays !== void 0 ? e.showOuterDays : !M && W < 2 && (m || !f || f < 2), Y = w.search(/m/i), q = w.search(/y/i);
    if (this._view === "month") {
      var U = new Date(this._getPageMonth(this._monthIndex)), j = C[r(U)], ee = i(U) + T;
      this._viewTitle = q < Y ? ee + " " + j : j + " " + ee;
    } else if (this._view === "year")
      this._viewTitle = this._getPageYear(this._yearIndex) + "";
    else if (this._view === "multi-year") {
      var ne = this._getPageYears(this._yearsIndex);
      this._viewTitle = ne + " - " + (ne + 11);
    }
    if (p && (this._monthsMulti = [], H !== void 0)) {
      for (var G = Le(0.96 * t.pageSize / 325.6) || 1; f % G; )
        G--;
      for (var te = 0; te < f / G; ++te) {
        for (var Z = [], re = 0; re < G; ++re)
          Z.push(+a(i(A), r(A) + te * G + re, 1));
        this._monthsMulti.push(Z);
      }
    }
    (l !== D.calendarType || e.theme !== D.theme || e.calendarScroll !== D.calendarScroll || e.hasContent !== D.hasContent || e.showCalendar !== D.showCalendar || e.showSchedule !== D.showSchedule || e.showWeekNumbers !== D.showWeekNumbers || e.weeks !== D.weeks || O) && (this._shouldCheckSize = !0), D.width === e.width && D.height === e.height || (this._dim = { height: On(e.height), width: On(e.width) }), this._cssClass = "mbsc-calendar mbsc-font mbsc-flex-col" + this._theme + this._rtl + (t.ready ? "" : " mbsc-hidden") + (p ? " mbsc-calendar-grid-view" : " mbsc-calendar-height-" + t.height + " mbsc-calendar-width-" + t.width) + " " + e.cssClass, this._dayNames = t.width === "sm" || p ? e.dayNamesMin : e.dayNamesShort, this._isSwipeChange = !1, this._yearFirst = q < Y, this._pageNr = W, this._variableRow = N;
    var fe = e.pageLoad !== D.pageLoad, he = +I != +this._viewStart || +S != +this._viewEnd;
    if (this._pageIndex !== void 0 && he && (this._isIndexChange = !this._isSwipeChange && !z), H !== void 0 && (this._pageIndex = H), H !== void 0 && (e.marked !== D.marked || e.colors !== D.colors || e.labels !== D.labels || e.invalid !== D.invalid || e.valid !== D.valid || t.maxLabels !== this._maxLabels || he || O || fe)) {
      this._maxLabels = t.maxLabels, this._viewStart = I, this._viewEnd = S;
      var oe = e.labelsMap || qt(e.labels, I, S, e), Ee = oe && Ed(e, oe, I, S, this._variableRow || this._maxLabels || 1, 7, !1, d, !0, e.eventOrder, !P, e.showLabelCount, e.moreEventsText, e.moreEventsPluralText);
      Ee && !this._labels && (this._shouldCheckSize = !0), (Ee && t.maxLabels || !Ee) && (this._shouldPageLoad = !this._isIndexChange || this._prevAnim || !o || fe), this._labelsLayout = Ee, this._labels = oe, this._marked = oe ? void 0 : e.marksMap || qt(e.marked, I, S, e), this._colors = qt(e.colors, I, S, e), this._valid = qt(e.valid, I, S, e, !0), this._invalid = qt(e.invalid, I, S, e, !0);
    }
    if (he || y || u !== D.eventRange || c !== D.eventRangeSize || e.monthNames !== D.monthNames) {
      this._title = [];
      var Ie = ce(B, -1), Se = H === void 0 ? b : A;
      if (m) {
        Se = b;
        for (var Ve = 0, je = Object.keys(e.selectedDates); Ve < je.length; Ve++) {
          var Ne = je[Ve];
          if (+Ne >= +A && +Ne < +B) {
            Se = /* @__PURE__ */ new Date(+Ne);
            break;
          }
        }
      }
      if (this._pageNr > 1)
        for (te = 0; te < W; te++) {
          var E = a(i(A), r(A) + te, 1), F = i(E) + T, V = C[r(E)];
          this._title.push({ yearTitle: F, monthTitle: V });
        }
      else {
        var J = { yearTitle: i(Se) + T, monthTitle: C[r(Se)] }, ie = e.showSchedule && c === 1 ? u : o ? l : u, _e = u && !o && (!e.showSchedule || c > 1);
        switch (ie) {
          case "year":
            J.title = i(A) + T, c > 1 && (J.title += " - " + (i(Ie) + T));
            break;
          case "month":
            if (c > 1 && !o) {
              var ve = C[r(A)], Oe = i(A) + T, we = this._yearFirst ? Oe + " " + ve : ve + " " + Oe, Ue = C[r(Ie)], et = i(Ie) + T, Be = this._yearFirst ? et + " " + Ue : Ue + " " + et;
              J.title = we + " - " + Be;
            } else
              p && (J.title = i(A) + T);
            break;
          case "day":
          case "week":
            if (_e) {
              var ke = w.search(/d/i) < Y ? "D MMM, YYYY" : "MMM D, YYYY";
              J.title = Xe(ke, A, e), (ie === "week" || c > 1) && (J.title += " - " + Xe(ke, Ie, e));
            }
        }
        this._title.push(J);
      }
    }
    this._active = v, this._hasPicker = e.hasPicker || p || !h || !o || t.width === "md" && e.hasPicker !== !1, this._axis = M ? "Y" : "X", this._rtlNr = !M && e.rtl ? -1 : 1, this._weeks = g, this._nextIcon = M ? e.nextIconV : e.rtl ? e.prevIconH : e.nextIconH, this._prevIcon = M ? e.prevIconV : e.rtl ? e.nextIconH : e.prevIconH, this._mousewheel = e.mousewheel === void 0 ? M : e.mousewheel, this._isGrid = p, this._isVertical = M, this._showOuter = P, this._showDaysTop = M || !!N && f === 1;
  }, n.prototype._mounted = function() {
    this._observer = Do(this._el, this._onResize, this._zone), this._doc = vn(this._el), pe(this._doc, Ut, this._onDocClick);
  }, n.prototype._updated = function() {
    var e = this;
    if (this._shouldCheckSize ? (setTimeout(function() {
      e._onResize();
    }), this._shouldCheckSize = !1) : this._shouldPageLoad && (this._pageLoaded(), this._shouldPageLoad = !1), this._shouldFocus && setTimeout(function() {
      e._focusActive(), e._shouldFocus = !1;
    }), this.s.instanceService && this.s.instanceService.onComponentChange.next({}), this._pageChange = !1, this._variableRow && this.s.showCalendar) {
      var t = this._body.querySelector(".mbsc-calendar-body-inner"), a = t.scrollHeight > t.clientHeight;
      a !== this.state.hasScrollY && (this._shouldCheckSize = !0, this.setState({ hasScrollY: a }));
    }
  }, n.prototype._destroy = function() {
    this._observer && this._observer.detach(), le(this._doc, Ut, this._onDocClick), clearTimeout(this._hoverTimer);
  }, n.prototype._getActiveCell = function() {
    var e = this._view, t = e === "page" ? this._body : this._pickerCont, a = e === "multi-year" ? "year" : e === "year" ? "month" : "cell";
    return t && t.querySelector(".mbsc-calendar-" + a + '[tabindex="0"]');
  }, n.prototype._focusActive = function() {
    var e = this._getActiveCell();
    e && e.focus();
  }, n.prototype._pageLoaded = function() {
    var e = this.s.navService;
    this._hook("onPageLoaded", { activeElm: this._getActiveCell(), firstDay: e.firstPageDay, lastDay: e.lastPageDay, month: this.s.calendarType === "month" ? e.firstDay : void 0, viewEnd: e.viewEnd, viewStart: e.viewStart });
  }, n.prototype._activeChange = function(e) {
    var t = this._pageIndex + e;
    this._minIndex <= t && this._maxIndex >= t && (this._prevAnim = !1, this._pageChange = !0, this._hook("onActiveChange", { date: this._getPageDay(t), dir: e, pageChange: !0 }));
  }, n.prototype._activeMonthChange = function(e) {
    var t = this._monthIndex + e;
    this._minMonthIndex <= t && this._maxMonthIndex >= t && (this._prevAnim = !1, this._activeMonth = this._getPageMonth(t), this.forceUpdate());
  }, n.prototype._activeYearsChange = function(e) {
    var t = this._yearsIndex + e;
    if (this._minYearsIndex <= t && this._maxYearsIndex >= t) {
      var a = this._getPageYears(t);
      this._prevAnim = !1, this._activeMonth = +this.s.getDate(a, 0, 1), this.forceUpdate();
    }
  }, n.prototype._activeYearChange = function(e) {
    var t = this._yearIndex + e;
    if (this._minYearIndex <= t && this._maxYearIndex >= t) {
      var a = this._getPageYear(t);
      this._prevAnim = !1, this._activeMonth = +this.s.getDate(a, 0, 1), this.forceUpdate();
    }
  }, n.prototype._prevDocClick = function() {
    var e = this;
    this._prevClick = !0, setTimeout(function() {
      e._prevClick = !1;
    });
  }, n;
}(it), Ys = {}, v_ = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._onClick = function(t) {
      if (e._isDrag)
        t.stopPropagation();
      else {
        e._triggerEvent("onClick", t);
        var a = e.s, i = Ys[a.id];
        i && a.selected && i.next({ hasFocus: !1 });
      }
    }, e._onRightClick = function(t) {
      e._triggerEvent("onRightClick", t);
    }, e._onDocTouch = function(t) {
      le(e._doc, "touchstart", e._onDocTouch), le(e._doc, pt, e._onDocTouch), e._isDrag = !1, e._hook("onDragModeOff", { domEvent: t, event: e.s.event });
    }, e._updateState = function(t) {
      e.s.showText && e.setState(t);
    }, e._triggerEvent = function(t, a) {
      e._hook(t, { domEvent: a, label: e.s.event, target: e._el });
    }, e;
  }
  return de(n, s), n.prototype._mounted = function() {
    var e, t = this, a = this.s, i = this._el, r = a.id, o = a.isPicker, l = Ys[r];
    l || (l = new Fn(), Ys[r] = l), this._unsubscribe = l.subscribe(this._updateState), this._doc = vn(i), this._unlisten = Kt(i, { keepFocus: !0, onBlur: function() {
      o || l.next({ hasFocus: !1 });
    }, onDoubleClick: function(u) {
      u.domEvent.stopPropagation(), t._hook("onDoubleClick", { domEvent: u.domEvent, label: t.s.event, target: i });
    }, onEnd: function(u) {
      if (t._isDrag) {
        var c = t.s, d = K({}, u);
        d.domEvent.preventDefault(), d.event = c.event, c.resize && e ? (d.resize = !0, d.direction = e) : c.drag && (d.drag = !0), t._hook("onDragEnd", d), c.isUpdate || (t._isDrag = !1), i && d.moved && i.blur();
      }
      clearTimeout(t._touchTimer), e = void 0;
    }, onFocus: function() {
      o || l.next({ hasFocus: !0 });
    }, onHoverIn: function(u) {
      t._isDrag || o || (l.next({ hasHover: !0 }), t._triggerEvent("onHoverIn", u));
    }, onHoverOut: function(u) {
      l.next({ hasHover: !1 }), t._triggerEvent("onHoverOut", u);
    }, onKeyDown: function(u) {
      var c = t.s.event;
      switch (u.keyCode) {
        case 13:
        case 32:
          i.click(), u.preventDefault();
          break;
        case 8:
        case 46:
          c && c.editable !== !1 && t._hook("onDelete", { domEvent: u, event: c, source: "calendar" });
      }
    }, onMove: function(u) {
      var c = t.s, d = K({}, u);
      if (d.event = c.event, e)
        d.resize = !0, d.direction = e;
      else {
        if (!c.drag)
          return;
        d.drag = !0;
      }
      c.event && c.event.editable !== !1 && (t._isDrag ? (d.domEvent.preventDefault(), t._hook("onDragMove", d)) : (Math.abs(d.deltaX) > 7 || Math.abs(d.deltaY) > 7) && (clearTimeout(t._touchTimer), d.isTouch || (t._isDrag = !0, t._hook("onDragStart", d))));
    }, onStart: function(u) {
      var c = t.s, d = K({}, u), m = d.domEvent.target;
      if (d.event = c.event, c.resize && m.classList.contains("mbsc-calendar-label-resize"))
        e = m.classList.contains("mbsc-calendar-label-resize-start") ? "start" : "end", d.resize = !0, d.direction = e;
      else {
        if (!c.drag)
          return;
        d.drag = !0;
      }
      c.event && c.event.editable !== !1 && (!t._isDrag && d.isTouch || d.domEvent.stopPropagation(), t._isDrag ? t._hook("onDragStart", d) : d.isTouch && (t._touchTimer = setTimeout(function() {
        t._hook("onDragModeOn", d), t._hook("onDragStart", d), t._isDrag = !0;
      }, 350)));
    } }), this._isDrag && (pe(this._doc, "touchstart", this._onDocTouch), pe(this._doc, pt, this._onDocTouch));
  }, n.prototype._destroy = function() {
    if (this._el && this._el.blur(), this._unsubscribe) {
      var e = this.s.id, t = Ys[e];
      t && (t.unsubscribe(this._unsubscribe), t.nr || delete Ys[e]);
    }
    this._unlisten && this._unlisten(), le(this._doc, "touchstart", this._onDocTouch), le(this._doc, pt, this._onDocTouch);
  }, n.prototype._render = function(e, t) {
    var a, i, r, o, l, u, c = e.event, d = new Date(e.date), m = e.render || e.renderContent, h = !1;
    if (this._isDrag = this._isDrag || e.isUpdate, this._content = void 0, this._title = e.more || e.count || !e.showEventTooltip ? void 0 : function(T) {
      if (Je && T) {
        var N = Je.createElement("div");
        return N.innerHTML = T, N.textContent.trim();
      }
      return T || "";
    }(c.tooltip || c.title || c.text), this._tabIndex = e.isActiveMonth && e.showText && !e.count && !e.isPicker ? 0 : -1, c) {
      var f = c.allDay, p = f ? void 0 : e;
      a = c.start ? ue(c.start, p) : null, i = c.end ? ue(c.end, p) : null;
      var g = a && i && Xt(e, f, a, i, !0), v = ce(Et(d, e), 7), y = e.lastDay && e.lastDay < v ? e.lastDay : v;
      r = !(h = a && g && !Ke(a, g)) || a && Ke(a, d), o = !h || g && Ke(g, d), l = !h || (e.showText ? g < y : o), this._hasResizeStart = e.resize && r, this._hasResizeEnd = e.resize && l;
      var b = c.color;
      if (!b && c.resource && e.resourcesMap) {
        var D = e.resourcesMap[at(c.resource) ? c.resource[0] : c.resource];
        b = D && D.color;
      }
      e.showText && (this._textColor = b ? Ts(b) : void 0), this._color = e.render || e.template ? void 0 : c.textColor && !b ? "transparent" : b;
    }
    if (c && e.showText && (m || e.contentTemplate || e.template)) {
      var w = c.allDay || !a || h && !r && !o;
      if (this._data = { end: !w && o && i ? Xe(e.timeFormat, i, e) : "", id: c.id, isMultiDay: h, original: c, start: !w && r && a ? Xe(e.timeFormat, a, e) : "", title: this._title }, m) {
        var C = m(this._data);
        ye(C) ? u = C : this._content = C;
      }
    } else
      u = e.more || e.count || e.showText && (c.title || c.text) || "";
    u !== this._text && (this._text = u, this._html = u ? this._safeHtml(u) : void 0, this._shouldEnhance = u && c && e.showText && !!m), this._cssClass = "mbsc-calendar-text" + this._theme + this._rtl + (t.hasFocus && !e.inactive && !e.selected || e.selected && e.showText ? " mbsc-calendar-label-active " : "") + (!t.hasHover || e.inactive || this._isDrag ? "" : " mbsc-calendar-label-hover") + (e.more ? " mbsc-calendar-text-more" : e.render || e.template ? " mbsc-calendar-custom-label" : " mbsc-calendar-label") + (e.inactive ? " mbsc-calendar-label-inactive" : "") + (e.isUpdate ? " mbsc-calendar-label-dragging" : "") + (e.hidden ? " mbsc-calendar-label-hidden" : "") + (r ? " mbsc-calendar-label-start" : "") + (l ? " mbsc-calendar-label-end" : "") + (c && c.editable === !1 ? " mbsc-readonly-event" : "") + (c && c.cssClass ? " " + c.cssClass : "");
  }, n;
}(it), g_ = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return function(t, a) {
      var i, r = t.event && t.event.editable !== !1, o = ((i = {}).onContextMenu = a._onRightClick, i);
      return _("div", K({ "aria-hidden": t.showText ? void 0 : "true", className: a._cssClass, "data-id": t.showText && t.event ? t.event.id : null, onClick: a._onClick, ref: a._setEl, role: t.showText ? "button" : void 0, style: { color: a._color }, tabIndex: a._tabIndex, title: a._title }, o), a._hasResizeStart && r && _("div", { className: "mbsc-calendar-label-resize mbsc-calendar-label-resize-start" + a._rtl + (t.isUpdate ? " mbsc-calendar-label-resize-start-touch" : "") }), a._hasResizeEnd && r && _("div", { className: "mbsc-calendar-label-resize mbsc-calendar-label-resize-end" + a._rtl + (t.isUpdate ? " mbsc-calendar-label-resize-end-touch" : "") }), t.showText && !t.more && !t.render && _("div", { className: "mbsc-calendar-label-background" + a._theme }), t.showText && !t.more && t.render ? a._html ? _("div", { dangerouslySetInnerHTML: a._html }, void 0) : a._content : _("div", { className: "mbsc-calendar-label-inner" + a._theme, style: { color: a._textColor } }, _("div", { "aria-hidden": "true", className: "mbsc-calendar-label-text" + a._theme, dangerouslySetInnerHTML: a._html, style: { color: t.event && t.event.textColor } }, a._content), t.label && _("div", { className: "mbsc-hidden-content" }, t.label)));
    }(e, this);
  }, n;
}(v_);
function hs(s, n, e, t, a, i, r) {
  return _(g_, { key: r, amText: n.amText, count: e.count ? e.count + " " + (e.count > 1 ? n.eventsText : n.eventText) : void 0, date: n.date, dataTimezone: n.dataTimezone, displayTimezone: n.displayTimezone, drag: n.dragToMove, resize: da(e.event && e.event.resize, n.dragToResize), event: e.event, exclusiveEndDates: n.exclusiveEndDates, firstDay: n.firstDay, hidden: a, id: e.id, inactive: !i && e.event && n.dragData && n.dragData.draggedEvent && e.event.id === n.dragData.draggedEvent.id, isActiveMonth: n.isActiveMonth, isPicker: n.isPicker, isUpdate: i, label: e.label, lastDay: e.lastDay, more: e.more, pmText: n.pmText, resourcesMap: n.resourcesMap, rtl: n.rtl, selected: e.event && n.selectedEventsMap && !(!n.selectedEventsMap[e.id] && !n.selectedEventsMap[e.event.id]), showEventTooltip: n.showEventTooltip, showText: t, theme: n.theme, timeFormat: n.timeFormat, timezonePlugin: n.timezonePlugin, render: n.renderLabel, renderContent: n.renderLabelContent, onClick: s._onLabelClick, onDoubleClick: s._onLabelDoubleClick, onRightClick: s._onLabelRightClick, onHoverIn: s._onLabelHoverIn, onHoverOut: s._onLabelHoverOut, onDelete: n.onLabelDelete, onDragStart: n.onLabelUpdateStart, onDragMove: n.onLabelUpdateMove, onDragEnd: n.onLabelUpdateEnd, onDragModeOn: n.onLabelUpdateModeOn, onDragModeOff: n.onLabelUpdateModeOff });
}
function y_(s, n) {
  var e, t, a = n._draggedLabel, i = n._draggedLabelOrig, r = n._theme, o = ((e = {}).onContextMenu = n._onRightClick, e);
  return s.renderDay && (t = s.renderDay(n._data)), s.renderDayContent && (t = s.renderDayContent(n._data)), ye(t) && (t = _("div", { dangerouslySetInnerHTML: n._safeHtml(t) }), n._shouldEnhance = !0), _("div", K({ ref: n._setEl, className: n._cssClass, onClick: n._onClick, style: n._cellStyles, tabIndex: s.disabled ? void 0 : s.active ? 0 : -1 }, o), _("div", { className: "mbsc-calendar-cell-inner mbsc-calendar-" + s.type + "-inner" + r + (s.type === "day" ? "" : n._hb) + (s.display ? "" : " mbsc-calendar-day-hidden") }, s.renderDay ? t : _(ut, null, s.text === 1 && _("div", { "aria-hidden": "true", className: "mbsc-calendar-month-name" + r + n._rtl }, s.monthShort), _("div", { "aria-label": n._ariaLabel, role: "button", "aria-pressed": s.selected, className: "mbsc-calendar-cell-text mbsc-calendar-" + s.type + "-text" + r + n._todayClass, style: n._circleStyles }, s.text), s.marks && _("div", null, _("div", { className: "mbsc-calendar-marks" + r + n._rtl }, s.marks.map(function(l, u) {
    return _("div", { className: "mbsc-calendar-mark " + (l.markCssClass || "") + r, key: u, style: { background: l.color } });
  }))), s.renderDayContent && t), s.labels && _("div", null, i && i.event && _("div", { className: "mbsc-calendar-labels mbsc-calendar-labels-dragging" }, _("div", { style: { width: i.width + "%" || "100%" } }, hs(n, s, { id: 0, event: i.event }, !0, !!s.dragData.draggedDates, !0))), a && a.event && _("div", { className: "mbsc-calendar-labels mbsc-calendar-labels-dragging" }, _("div", { className: "mbsc-calendar-label-wrapper", style: { width: a.width + "%" || "100%" } }, hs(n, s, { id: 0, event: a.event }, !0, !1, !0))), _("div", { className: "mbsc-calendar-labels" }, s.labels.data.map(function(l) {
    return function(u, c, d) {
      var m = d.id;
      return d.placeholder ? _("div", { className: "mbsc-calendar-text mbsc-calendar-text-placeholder", key: m }) : d.more || d.count ? hs(u, c, d, !0, !1, !1, m) : d.multiDay ? [_("div", { className: "mbsc-calendar-label-wrapper", style: { width: d.width + "%" }, key: m }, hs(u, c, d, !0)), hs(u, c, d, !1, !1, !1, "-" + m)] : hs(u, c, d, d.showText, !1, !1, m);
    }(n, s, l);
  })), _("div", { className: "mbsc-calendar-text mbsc-calendar-text-placeholder" }))));
}
var Gi = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return y_(e, this);
  }, n;
}(/* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._onClick = function(t) {
      e._cellClick("onDayClick", t);
    }, e._onRightClick = function(t) {
      e._cellClick("onDayRightClick", t);
    }, e._onLabelClick = function(t) {
      e._labelClick("onLabelClick", t);
    }, e._onLabelDoubleClick = function(t) {
      e._labelClick("onLabelDoubleClick", t);
    }, e._onLabelRightClick = function(t) {
      e._labelClick("onLabelRightClick", t);
    }, e._onLabelHoverIn = function(t) {
      e._labelClick("onLabelHoverIn", t);
    }, e._onLabelHoverOut = function(t) {
      e._labelClick("onLabelHoverOut", t);
    }, e;
  }
  return de(n, s), n.prototype._mounted = function() {
    var e, t, a, i = this;
    this._unlisten = Kt(this._el, { click: !0, onBlur: function() {
      i.setState({ hasFocus: !1 });
    }, onDoubleClick: function(r) {
      var o = i.s;
      o.clickToCreate && o.clickToCreate !== "single" && o.labels && !o.disabled && o.display && (i._hook("onLabelUpdateStart", r), i._hook("onLabelUpdateEnd", r)), i._cellClick("onDayDoubleClick", r.domEvent);
    }, onEnd: function(r) {
      e && (r.domEvent.preventDefault(), i._hook("onLabelUpdateEnd", r), e = !1), clearTimeout(a), e = !1, t = !1;
    }, onFocus: function() {
      i.setState({ hasFocus: !0 });
    }, onHoverIn: function(r) {
      var o = i.s;
      o.disabled || i.setState({ hasHover: !0 }), i._hook("onHoverIn", { date: new Date(o.date), domEvent: r, hidden: !o.display, outer: o.outer, target: i._el });
    }, onHoverOut: function(r) {
      var o = i.s;
      i.setState({ hasHover: !1 }), i._hook("onHoverOut", { date: new Date(o.date), domEvent: r, hidden: !o.display, outer: o.outer, target: i._el });
    }, onKeyDown: function(r) {
      switch (r.keyCode) {
        case 13:
        case 32:
          r.preventDefault(), i._onClick(r);
      }
    }, onMove: function(r) {
      e && i.s.dragToCreate ? (r.domEvent.preventDefault(), i._hook("onLabelUpdateMove", r)) : t && i.s.dragToCreate && (Math.abs(r.deltaX) > 7 || Math.abs(r.deltaY) > 7) ? (e = !r.isTouch, i._hook("onLabelUpdateStart", r)) : clearTimeout(a);
    }, onStart: function(r) {
      var o = i.s;
      r.create = !0, o.disabled || !o.dragToCreate && !o.clickToCreate || !o.labels || e || _a(r.domEvent.target, ".mbsc-calendar-text", i._el) || (r.isTouch && o.dragToCreate ? a = setTimeout(function() {
        i._hook("onLabelUpdateStart", r), i._hook("onLabelUpdateModeOn", r), e = !0;
      }, 350) : o.clickToCreate === "single" ? (i._hook("onLabelUpdateStart", r), e = !0) : t = !r.isTouch);
    } });
  }, n.prototype._render = function(e, t) {
    var a = me(e), i = e.date, r = e.colors, o = e.display, l = e.dragData, u = e.hoverEnd, c = e.hoverStart, d = e.labels, m = e.rangeEnd, h = e.rangeStart, f = new Date(i), p = Pe(f), g = Ke(a, f), v = d && d.events, y = r && r[0], b = y && y.background, D = y && y.highlight, w = "", C = "";
    this._draggedLabel = l && l.draggedDates && l.draggedDates[p], this._draggedLabelOrig = l && l.originDates && l.originDates[p], this._todayClass = g ? " mbsc-calendar-today" : "", this._cellStyles = b && o ? { backgroundColor: b, color: Ts(b) } : void 0, this._circleStyles = D ? { backgroundColor: D, color: Ts(y.highlight) } : void 0, this._ariaLabel = e.type === "day" ? (g ? e.todayText + ", " : "") + e.day + ", " + e.month + " " + e.text + ", " + e.year : e.type === "month" ? e.month : "", o && ((h && i >= h && i <= (m || h) || m && i <= m && i >= (h || m)) && (C = " mbsc-range-day" + (i === (h || m) ? " mbsc-range-day-start" : "") + (i === (m || h) ? " mbsc-range-day-end" : "")), c && u && i >= c && i <= u && (C += " mbsc-range-hover" + (i === c ? " mbsc-range-hover-start mbsc-hover" : "") + (i === u ? " mbsc-range-hover-end mbsc-hover" : ""))), e.marks && e.marks.forEach(function(T) {
      w += T.cellCssClass ? " " + T.cellCssClass : "";
    }), r && r.forEach(function(T) {
      w += T.cellCssClass ? " " + T.cellCssClass : "";
    }), v && v.forEach(function(T) {
      w += T.cellCssClass ? " " + T.cellCssClass : "";
    }), this._cssClass = "mbsc-calendar-cell mbsc-flex-1-0-0 mbsc-calendar-" + e.type + this._theme + this._rtl + this._hb + w + (d ? " mbsc-calendar-day-labels" : "") + (r ? " mbsc-calendar-day-colors" : "") + (e.outer ? " mbsc-calendar-day-outer" : "") + (e.hasMarks ? " mbsc-calendar-day-marked" : "") + (e.disabled ? " mbsc-disabled" : "") + (o ? "" : " mbsc-calendar-day-empty") + (e.selected ? " mbsc-selected" : "") + (t.hasFocus ? " mbsc-focus" : "") + (!t.hasHover || i !== c && i !== u && (c || u) ? "" : " mbsc-hover") + (this._draggedLabel ? " mbsc-calendar-day-highlight" : "") + C, this._data = { date: f, events: e.events || [], selected: e.selected };
  }, n.prototype._destroy = function() {
    this._unlisten && this._unlisten();
  }, n.prototype._cellClick = function(e, t) {
    var a = this.s;
    a.display && this._hook(e, { date: new Date(a.date), disabled: a.disabled, domEvent: t, outer: a.outer, selected: a.selected, source: "calendar", target: this._el });
  }, n.prototype._labelClick = function(e, t) {
    var a = this.s;
    t.date = new Date(a.date), t.labels = a.labels.events, this._hook(e, t);
  }, n;
}(it)), Pd = function(s) {
  var n = s.firstDay, e = s.hidden, t = s.rtl, a = s.theme, i = s.dayNamesShort, r = s.showWeekNumbers, o = s.hasScroll;
  return _("div", { "aria-hidden": "true", className: "mbsc-calendar-week-days mbsc-flex" + (e ? " mbsc-hidden" : "") }, r && _("div", { className: "mbsc-calendar-week-day mbsc-flex-none mbsc-calendar-week-nr" + a + t }), Xc.map(function(l, u) {
    return _("div", { className: "mbsc-calendar-week-day mbsc-flex-1-0-0" + a + t, key: u }, i[(u + n) % 7]);
  }), o && _("div", { className: "mbsc-schedule-fake-scroll-y" }));
}, b_ = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._isActive = function(e) {
    return this.s.isActive && e === this.s.activeDate;
  }, n.prototype._isInvalid = function(e) {
    var t = this.s;
    return as(t, yn(t, new Date(e)), t.invalid, t.valid, +t.min, +t.max);
  }, n.prototype._isSelected = function(e) {
    var t = new Date(e), a = yn(this.s, t);
    return !!this.s.selectedDates[+a];
  }, n.prototype._getWeekNr = function(e, t) {
    var a = new Date(t);
    return "" + e.getWeekNumber(e.getDate(a.getFullYear(), a.getMonth(), a.getDate() + (7 - e.firstDay + 1) % 7));
  }, n.prototype._render = function(e) {
    var t = e.weeks || 6, a = e.firstDay, i = new Date(e.firstPageDay), r = e.getYear(i), o = e.getMonth(i), l = e.getDay(i), u = e.getDate(r, o, l).getDay(), c = a - u > 0 ? 7 : 0, d = [], m = 0;
    this._rowHeights = [], this._rows = [], this._days = Xc;
    for (var h = 0; h < 7 * t; h++) {
      var f = e.getDate(r, o, h + a - c - u + l), p = Pe(f), g = e.getMonth(f), v = g !== o && e.calendarType !== "week", y = e.marked && e.marked[p], b = y ? e.showSingleMark ? [{}] : y : null, D = e.labels && e.labels[p], w = D ? D.data.length : 0, C = h % 7 == 0;
      if (e.variableRow) {
        if (C && v && h)
          break;
        w > m && (m = w), h % 7 == 6 && (this._rowHeights.push(m * (e.labelHeight || 20) + (e.cellTextHeight || 0) + 3), m = 0);
      }
      C && (d = [], this._rows.push(d)), d.push({ colors: e.colors && e.colors[p], date: +f, day: e.dayNames[f.getDay()], display: !v || e.showOuter, events: e.events && e.events[p], labels: D, marks: b, month: e.monthNames[g], monthShort: e.monthNamesShort[g], outer: v, text: e.getDay(f), year: e.getYear(f) });
    }
  }, n;
}(it), ql = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e) {
    return function(t, a) {
      var i = t.showWeekNumbers, r = t.showWeekDays ? _(Pd, { dayNamesShort: t.dayNamesShort, firstDay: t.firstDay, rtl: a._rtl, showWeekNumbers: i, theme: a._theme }) : null;
      return _("div", { "aria-hidden": t.isActive ? void 0 : "true", className: "mbsc-calendar-table mbsc-flex-col mbsc-flex-1-1" + (t.isActive ? " mbsc-calendar-table-active" : "") }, r, a._rows.map(function(o, l) {
        var u = i ? a._getWeekNr(t, o[0].date) : "";
        return _("div", { className: "mbsc-calendar-row mbsc-flex mbsc-flex-1-0", key: l, style: { minHeight: a._rowHeights[l] } }, i && _("div", { className: "mbsc-calendar-cell mbsc-flex-none mbsc-calendar-day mbsc-calendar-week-nr" + a._theme }, _("div", { "aria-hidden": "true" }, u), _("div", { className: "mbsc-hidden-content" }, t.weekText.replace("{count}", u))), o.map(function(c, d) {
          return _(Gi, { active: c.display && a._isActive(c.date), amText: t.amText, clickToCreate: t.clickToCreate, colors: c.colors, date: c.date, day: c.day, disabled: a._isInvalid(c.date), display: c.display, dataTimezone: t.dataTimezone, displayTimezone: t.displayTimezone, dragData: t.dragData, dragToCreate: t.dragToCreate, dragToResize: t.dragToResize, dragToMove: t.dragToMove, eventText: t.eventText, events: c.events, eventsText: t.eventsText, exclusiveEndDates: t.exclusiveEndDates, firstDay: t.firstDay, hasMarks: t.hasMarks, hoverEnd: t.hoverEnd, hoverStart: t.hoverStart, isActiveMonth: t.isActive, isPicker: t.isPicker, key: c.date, labels: c.labels, pmText: t.pmText, marks: c.marks, month: c.month, monthShort: c.monthShort, onDayClick: t.onDayClick, onDayDoubleClick: t.onDayDoubleClick, onDayRightClick: t.onDayRightClick, onLabelClick: t.onLabelClick, onLabelDoubleClick: t.onLabelDoubleClick, onLabelRightClick: t.onLabelRightClick, onLabelHoverIn: t.onLabelHoverIn, onLabelHoverOut: t.onLabelHoverOut, onLabelDelete: t.onLabelDelete, onLabelUpdateStart: t.onLabelUpdateStart, onLabelUpdateMove: t.onLabelUpdateMove, onLabelUpdateEnd: t.onLabelUpdateEnd, onLabelUpdateModeOn: t.onLabelUpdateModeOn, onLabelUpdateModeOff: t.onLabelUpdateModeOff, outer: c.outer, renderDay: t.renderDay, renderDayContent: t.renderDayContent, renderLabel: t.renderLabel, renderLabelContent: t.renderLabelContent, rangeEnd: t.rangeEnd, rangeStart: t.rangeStart, resourcesMap: t.resourcesMap, selectedEventsMap: t.selectedEventsMap, rtl: t.rtl, showEventTooltip: t.showEventTooltip, selected: a._isSelected(c.date), text: c.text, theme: t.theme, timeFormat: t.timeFormat, timezonePlugin: t.timezonePlugin, todayText: t.todayText, type: "day", year: c.year, onHoverIn: t.onDayHoverIn, onHoverOut: t.onDayHoverOut });
        }));
      }));
    }(e, this);
  }, n;
}(b_), Gl = 0, D_ = /* @__PURE__ */ function(s) {
  function n() {
    return s !== null && s.apply(this, arguments) || this;
  }
  return de(n, s), n.prototype._template = function(e, t) {
    return function(a, i, r, o) {
      var l, u;
      Gl++;
      var c = r._variableRow, d = r._view !== "page", m = ((l = {}).onAnimationEnd = r._onViewAnimationEnd, l), h = ((u = {}).onKeyDown = r._onKeyDown, u), f = function(y, b) {
        return _(ql, K({}, b, { activeDate: r._active, amText: a.amText, calendarType: a.calendarType, cellTextHeight: i.cellTextHeight, clickToCreate: a.clickToCreate, colors: r._colors, dayNames: a.dayNames, dayNamesShort: r._dayNames, dataTimezone: a.dataTimezone, displayTimezone: a.displayTimezone, eventText: a.eventText, events: a.eventMap, eventsText: a.eventsText, exclusiveEndDates: a.exclusiveEndDates, firstDay: a.firstDay, firstPageDay: y, getDate: a.getDate, getDay: a.getDay, getMonth: a.getMonth, getWeekNumber: a.getWeekNumber, getYear: a.getYear, hasMarks: !!r._marked, hoverEnd: a.hoverEnd, hoverStart: a.hoverStart, isPicker: a.isPicker, invalid: r._invalid, labels: r._labelsLayout, labelHeight: i.labelHeight, marked: r._marked, max: r._maxDate, min: r._minDate, monthNames: a.monthNames, monthNamesShort: a.monthNamesShort, onDayClick: r._onDayClick, onDayDoubleClick: a.onDayDoubleClick, onDayRightClick: a.onDayRightClick, onDayHoverIn: r._onDayHoverIn, onDayHoverOut: r._onDayHoverOut, onLabelClick: r._onLabelClick, onLabelDoubleClick: a.onLabelDoubleClick, onLabelRightClick: a.onLabelRightClick, onLabelHoverIn: a.onLabelHoverIn, onLabelHoverOut: a.onLabelHoverOut, onLabelDelete: a.onLabelDelete, pmText: a.pmText, rangeEnd: a.rangeEnd, rangeStart: a.rangeStart, resourcesMap: a.resourcesMap, rtl: a.rtl, selectedDates: a.selectedDates, selectedEventsMap: a.selectedEventsMap, showEventTooltip: a.showEventTooltip, showOuter: r._showOuter, showWeekDays: !r._showDaysTop, showWeekNumbers: a.showWeekNumbers, showSingleMark: !!a.marksMap, todayText: a.todayText, theme: a.theme, timeFormat: a.timeFormat, timezonePlugin: a.timezonePlugin, valid: r._valid, weeks: r._weeks, weekText: a.weekText, renderDay: a.renderDay, renderDayContent: a.renderDayContent, renderLabel: a.renderLabel, renderLabelContent: a.renderLabelContent, variableRow: r._variableRow }));
      }, p = r._showDaysTop && a.showCalendar ? _(Pd, { dayNamesShort: r._dayNames, rtl: r._rtl, theme: r._theme, firstDay: a.firstDay, hasScroll: i.hasScrollY, hidden: r._view !== "page" && !r._hasPicker, showWeekNumbers: a.showWeekNumbers }) : null, g = { axis: r._axis, batchSize: 1, changeOnEnd: !0, className: "mbsc-calendar-scroll-wrapper" + r._theme, data: Gl, easing: "ease-out", itemSize: i.pickerSize, items: r._months, mousewheel: r._mousewheel, prevAnim: r._prevAnim, rtl: a.rtl, snap: !0, time: 200 }, v = _("div", { ref: r._setPickerCont, className: r._hasPicker ? "mbsc-calendar-picker-wrapper" : "" }, (i.view === "multi-year" || i.viewClosing === "multi-year" || a.selectView === "multi-year") && _("div", K({ className: r._getPickerClass("multi-year") }, m), _(Ws, K({ key: "years", itemRenderer: function(y, b) {
        var D = y.key, w = r._getPageYears(D), C = a.getYear(new Date(r._active)), T = a.getYear(new Date(r._activeMonth));
        return _("div", { "aria-hidden": r._yearsIndex === D ? void 0 : "true", className: "mbsc-calendar-picker-slide mbsc-calendar-slide" + r._theme + r._rtl, key: D, style: r._getPageStyle(D, b, r._yearsIndex) }, _("div", { className: "mbsc-calendar-table mbsc-flex-col" }, gl.map(function(N, O) {
          return _("div", { className: "mbsc-calendar-row mbsc-flex mbsc-flex-1-0", key: O }, vl.map(function(L, H) {
            var A = w + 3 * O + H, B = +a.getDate(A, 0, 1);
            return _(Gi, { active: A === T, date: B, display: !0, selected: A === C, disabled: A < r._minYears || A > r._maxYears, rtl: a.rtl, text: A + a.yearSuffix, theme: a.theme, type: "year", onDayClick: r._onYearClick, key: A });
          }));
        })));
      }, maxIndex: r._maxYearsIndex, minIndex: r._minYearsIndex, onGestureEnd: r._onGestureEnd, onIndexChange: r._onYearsPageChange, selectedIndex: r._yearsIndex }, g))), (i.view === "year" || i.viewClosing === "year" || a.selectView === "year") && _("div", K({ className: r._getPickerClass("year") }, m), _(Ws, K({ key: "year", itemRenderer: function(y, b) {
        var D = y.key, w = r._getPageYear(D), C = new Date(r._activeMonth), T = a.getYear(C), N = a.getMonth(C), O = new Date(r._active), L = a.getYear(O), H = a.getMonth(O);
        return _("div", { "aria-hidden": r._yearIndex === D ? void 0 : "true", className: "mbsc-calendar-picker-slide mbsc-calendar-slide" + r._theme + r._rtl, key: D, style: r._getPageStyle(D, b, r._yearIndex) }, _("div", { className: "mbsc-calendar-table mbsc-flex-col" }, gl.map(function(A, B) {
          return _("div", { className: "mbsc-calendar-row mbsc-flex mbsc-flex-1-0", key: B }, vl.map(function(I, S) {
            var k = a.getDate(w, 3 * B + S, 1), R = a.getYear(k), z = a.getMonth(k);
            return _(Gi, { active: R === T && z === N, date: +k, display: !0, selected: R === L && z === H, disabled: k < r._minYear || k >= r._maxYear, month: a.monthNames[z], rtl: a.rtl, text: a.monthNamesShort[z], theme: a.theme, type: "month", onDayClick: r._onMonthClick, key: +k });
          }));
        })));
      }, maxIndex: r._maxYearIndex, minIndex: r._minYearIndex, onGestureEnd: r._onGestureEnd, onIndexChange: r._onYearPageChange, selectedIndex: r._yearIndex }, g))), r._hasPicker && (i.view === "month" || i.viewClosing === "month") && _("div", K({ className: r._getPickerClass("month") }, m), _(Ws, K({ key: "month", itemRenderer: function(y, b) {
        var D = y.key;
        return _("div", { className: "mbsc-calendar-picker-slide mbsc-calendar-slide" + r._theme + r._rtl, key: D, style: r._getPageStyle(D, b, 1) }, _(ql, { activeDate: r._activeMonth, dataTimezone: a.dataTimezone, dayNames: a.dayNames, dayNamesShort: a.dayNamesMin, displayTimezone: a.displayTimezone, firstDay: a.firstDay, firstPageDay: r._getPageMonth(D), getDate: a.getDate, getDay: a.getDay, getMonth: a.getMonth, getYear: a.getYear, isActive: D >= r._monthIndex && D < r._monthIndex + 1, max: r._maxDate, min: r._minDate, monthNames: a.monthNames, monthNamesShort: a.monthNamesShort, onDayClick: r._onNavDayClick, rtl: a.rtl, selectedDates: a.selectedDates, showOuter: !0, showWeekDays: !r._showDaysTop, theme: a.theme, timezonePlugin: a.timezonePlugin, todayText: a.todayText }));
      }, maxIndex: r._maxMonthIndex, minIndex: r._minMonthIndex, onGestureEnd: r._onGestureEnd, onIndexChange: r._onMonthPageChange, selectedIndex: r._monthIndex }, g))));
      return _("div", { className: r._cssClass, ref: r._setEl, style: r._dim, onClick: fa }, _("div", { className: "mbsc-calendar-wrapper mbsc-flex-col" + r._theme + r._hb + (a.hasContent || !a.showCalendar ? " mbsc-calendar-wrapper-fixed mbsc-flex-none" : " mbsc-flex-1-1") }, _("div", { className: "mbsc-calendar-header" + r._theme + r._hb + (r._showDaysTop ? " mbsc-calendar-header-vertical" : ""), ref: r._setHeader }, a.showControls && function() {
        var y, b;
        if (a.renderHeader)
          ye(y = a.renderHeader()) && (y !== r._headerHTML && (r._headerHTML = y, r._shouldEnhanceHeader = !0), b = r._safeHtml(y));
        else {
          var D = r._pageNr > 1;
          y = _(ut, null, _(Or, { className: "mbsc-flex mbsc-flex-1-1 mbsc-calendar-title-wrapper" }), _(Mr, { className: "mbsc-calendar-button-prev" + (D ? " mbsc-calendar-button-prev-multi" : "") }), a.showToday && _(Nr, { className: "mbsc-calendar-header-today" }), _(Ir, { className: "mbsc-calendar-button-next" + (D ? " mbsc-calendar-button-next-multi" : "") }));
        }
        var w = _("div", { className: "mbsc-calendar-controls mbsc-flex" + r._theme, dangerouslySetInnerHTML: b }, y);
        return _(Rd.Provider, { children: w, value: { instance: r } });
      }(), p), _("div", K({ className: "mbsc-calendar-body mbsc-flex-col mbsc-flex-1-1" + r._theme, ref: r._setBody }, h), a.showCalendar && _("div", { className: "mbsc-calendar-body-inner mbsc-flex-col mbsc-flex-1-1" + (c ? " mbsc-calendar-body-inner-variable" : "") }, r._isGrid ? _("div", { "aria-hidden": d ? "true" : void 0, className: "mbsc-calendar-grid mbsc-flex-1-1 mbsc-flex-col" + r._theme + r._hb }, r._monthsMulti.map(function(y, b) {
        return _("div", { key: b, className: "mbsc-calendar-grid-row mbsc-flex mbsc-flex-1-1" }, y.map(function(D, w) {
          return _("div", { key: w, className: "mbsc-calendar-grid-item mbsc-flex-col mbsc-flex-1-1" + r._theme }, _("div", { className: "mbsc-calendar-month-title" + r._theme }, a.monthNames[new Date(D).getMonth()]), f(D, { isActive: !0 }));
        }));
      })) : c ? _("div", { "aria-hidden": d ? "true" : void 0, className: "mbsc-calendar-slide mbsc-calendar-slide-active " + r._getPickerClass("page") }, f(+a.navService.firstDay, { dragData: a.dragData, dragToCreate: a.dragToCreate, dragToMove: a.dragToMove, dragToResize: a.dragToResize, isActive: !0, onLabelUpdateEnd: a.onLabelUpdateEnd, onLabelUpdateModeOff: a.onLabelUpdateModeOff, onLabelUpdateModeOn: a.onLabelUpdateModeOn, onLabelUpdateMove: a.onLabelUpdateMove, onLabelUpdateStart: a.onLabelUpdateStart })) : a.selectView === "page" && _("div", K({ "aria-hidden": d ? "true" : void 0, className: r._getPickerClass("page") }, m), _(Ws, K({}, g, { itemNr: r._pageNr, itemSize: i.pageSize / r._pageNr, itemRenderer: function(y, b) {
        var D = y.key, w = D >= r._pageIndex && D < r._pageIndex + r._pageNr && r._view === "page", C = { dragData: a.dragData, dragToCreate: a.dragToCreate, dragToMove: a.dragToMove, dragToResize: a.dragToResize, isActive: w, onLabelUpdateEnd: a.onLabelUpdateEnd, onLabelUpdateModeOff: a.onLabelUpdateModeOff, onLabelUpdateModeOn: a.onLabelUpdateModeOn, onLabelUpdateMove: a.onLabelUpdateMove, onLabelUpdateStart: a.onLabelUpdateStart };
        return _("div", { className: "mbsc-calendar-slide" + (w ? " mbsc-calendar-slide-active" : "") + r._theme + r._rtl, key: D, style: r._getPageStyle(D, b, r._pageIndex, r._pageNr) }, f(r._getPageDay(D), C));
      }, maxIndex: r._maxIndex, minIndex: r._minIndex, mouseSwipe: a.mouseSwipe, onAnimationEnd: r._onAnimationEnd, onGestureStart: r._onGestureStart, onIndexChange: r._onPageChange, onStart: r._onStart, selectedIndex: r._pageIndex, swipe: a.swipe }))), !r._hasPicker && v))), o, r._hasPicker && _(va, { anchor: r._pickerBtn, closeOnScroll: !0, contentPadding: !1, context: a.context, cssClass: "mbsc-calendar-popup", display: "anchored", isOpen: r._view !== "page", locale: a.locale, onClose: r._onPickerClose, onOpen: r._onPickerOpen, rtl: a.rtl, scrollLock: !1, showOverlay: !1, theme: a.theme, themeVariant: a.themeVariant }, _("div", K({}, h), _("div", { className: "mbsc-calendar-controls mbsc-flex" + r._theme }, _("div", { "aria-live": "polite", className: "mbsc-calendar-picker-button-wrapper mbsc-calendar-title-wrapper mbsc-flex mbsc-flex-1-1" + r._theme }, _(dn, { className: "mbsc-calendar-button", onClick: r._onPickerBtnClick, theme: a.theme, themeVariant: a.themeVariant, type: "button", variant: "flat" }, r._viewTitle)), _(dn, { className: "mbsc-calendar-button", ariaLabel: a.prevPageText, disabled: r._isPrevDisabled(!0), iconSvg: r._prevIcon, onClick: r.prevPage, theme: a.theme, themeVariant: a.themeVariant, type: "button", variant: "flat" }), _(dn, { className: "mbsc-calendar-button", ariaLabel: a.nextPageText, disabled: r._isNextDisabled(!0), iconSvg: r._nextIcon, onClick: r.nextPage, theme: a.theme, themeVariant: a.themeVariant, type: "button", variant: "flat" })), v)));
    }(e, t, this, e.children);
  }, n.prototype._updated = function() {
    s.prototype._updated.call(this), this._shouldEnhanceHeader && (ns(this._headerElement, { view: this }), this._shouldEnhanceHeader = !1);
  }, n;
}(__);
function Xl(s, n, e, t, a, i, r) {
  var o, l = !s._colorEventList, u = i ? "popover" : "agenda", c = !i || s.state.showPopover, d = s._theme, m = r ? r.eventContent : a.renderEventContent, h = r ? r.event : a.renderEvent, f = i ? s.state.popoverHost : void 0, p = n.original, g = { __html: n.html }, v = m ? m(n) : _("div", { className: "mbsc-event-text " + d, title: n.tooltip, dangerouslySetInnerHTML: g }, void 0);
  ye(v) ? (v = _("div", { className: "mbsc-event-content mbsc-flex-1-1 " + d, dangerouslySetInnerHTML: { __html: v } }), s._shouldEnhance = c && u) : v = _("div", { className: "mbsc-event-content mbsc-flex-1-1 " + d }, v);
  var y = h ? h(n) : _(ut, null, _("div", { className: "mbsc-event-color" + d + s._rtl, style: n.style }), v, _("div", { className: "mbsc-event-time" + (f ? " mbsc-event-date" : "") + d + s._rtl }, n.allDayText && _("div", { className: "mbsc-event-all-day" + d }, n.allDayText), n.lastDay && _("div", { className: "mbsc-event-until" + d }, n.lastDay), n.start && _("div", { className: "mbsc-event-start" + d }, n.start), n.start && n.end && _("div", { className: "mbsc-event-sep" + d }, "-"), n.end && _("div", { className: "mbsc-event-end" + d }, n.end)));
  return ye(y) && (o = { __html: y }, y = void 0, s._shouldEnhance = c && u), _(r_, { className: "mbsc-event" + (l ? "" : " mbsc-colored-event") + (p.cssClass ? " " + p.cssClass : ""), "data-id": p.id, key: e, actionable: a.actionableEvents, dangerouslySetInnerHTML: o, drag: i && (s._showEventLabels || f) && (a.dragToMove || a.externalDrag), event: p, eventData: n, rtl: a.rtl, selected: !(!s._selectedEventsMap[n.uid] && !s._selectedEventsMap[n.id]), style: l ? void 0 : n.style, theme: a.theme, themeVariant: a.themeVariant, onClick: function(b) {
    return s._onEventClick({ date: t, domEvent: b.domEvent, event: p, source: u });
  }, onDoubleClick: function(b) {
    return s._onEventDoubleClick({ date: t, domEvent: b, event: p, source: u });
  }, onContextMenu: function(b) {
    return s._onEventRightClick({ date: t, domEvent: b, event: p, source: u });
  }, onHoverIn: function(b) {
    var D = b.domEvent;
    return s._onEventHoverIn({ date: t, domEvent: D, event: p, source: u });
  }, onHoverOut: function(b) {
    var D = b.domEvent;
    return s._onEventHoverOut({ date: t, domEvent: D, event: p, source: u });
  }, onDelete: s._onEventDelete, onDragEnd: f ? f._onEventDragEnd : s._onLabelUpdateEnd, onDragModeOff: f ? f._onEventDragModeOff : s._onLabelUpdateModeOff, onDragModeOn: f ? f._onEventDragModeOn : s._onLabelUpdateModeOn, onDragMove: f ? f._onEventDragMove : s._onLabelUpdateMove, onDragStart: f ? f._onEventDragStart : s._onLabelUpdateStart }, y);
}
function w_(s, n, e, t) {
  var a;
  e._listDays || (e._listDays = {}), e._showEventList && (a = function(o, l, u) {
    var c, d = o.theme, m = l._listDays, h = l.state.eventList || [], f = u ? u.agenda : o.renderAgenda, p = u ? u.agendaEmpty : o.renderAgendaEmpty;
    if (f && l._eventListHTML === void 0)
      return f(h, o, m);
    if (!h.length) {
      var g = p && p(), v = ye(g) && { __html: g };
      v ? (c = _("div", { dangerouslySetInnerHTML: v }), l._shouldEnhance = l._list) : c = _("div", { className: g ? "" : "mbsc-event-list-empty" + l._theme }, g || o.noEventsText);
    }
    return _(jl, { theme: d, themeVariant: o.themeVariant, rtl: o.rtl }, !h.length && c, h.map(function(y, b) {
      return _("div", { className: "mbsc-event-group" + l._theme, key: b, ref: function(D) {
        return m[y.timestamp] = D;
      } }, (l._eventListType !== "day" || l._eventListSize > 1) && _(a_, { theme: d, themeVariant: o.themeVariant, className: "mbsc-event-day" }, y.date), y.events.map(function(D, w) {
        return Xl(l, D, w, y.timestamp, o, void 0, u);
      }));
    }));
  }(s, e, t), ye(a) && (e._eventListHTML = { __html: a }, e._shouldLoadDays = !0, e._shouldEnhance = !0, a = void 0));
  var i = { amText: s.amText, clickToCreate: s.clickToCreate, dataTimezone: s.dataTimezone, dateFormat: s.dateFormat, dayNames: s.dayNames, dayNamesMin: s.dayNamesMin, dayNamesShort: s.dayNamesShort, displayTimezone: s.displayTimezone, dragBetweenResources: s.dragBetweenResources, dragInTime: s.dragInTime, dragToCreate: s.dragToCreate, dragToResize: s.dragToResize, eventMap: e._eventMap, eventOrder: s.eventOrder, exclusiveEndDates: s.exclusiveEndDates, firstDay: s.firstDay, fromText: s.fromText, getDate: s.getDate, getDay: s.getDay, getMaxDayOfMonth: s.getMaxDayOfMonth, getMonth: s.getMonth, getWeekNumber: s.getWeekNumber, getYear: s.getYear, monthNames: s.monthNames, monthNamesShort: s.monthNamesShort, onActiveChange: e._onActiveChange, onEventDragEnter: e._onEventDragEnter, onEventDragLeave: e._onEventDragLeave, pmText: s.pmText, refDate: e._refDate, renderDay: t ? t.day : s.renderDay, rtl: s.rtl, selectedEventsMap: e._selectedEventsMap, showEventTooltip: s.showEventTooltip, theme: s.theme, themeVariant: s.themeVariant, timeFormat: s.timeFormat, timezonePlugin: s.timezonePlugin, toText: s.toText }, r = K({}, i, { allDayText: s.allDayText, checkSize: e._checkSize, colorsMap: e._colorsMap, currentTimeIndicator: e._currentTimeIndicator, dateFormatFull: s.dateFormatFull, dateFormatLong: s.dateFormatLong, dragTimeStep: e._dragTimeStep, dragToMove: s.dragToMove, eventDragEnd: e._onEventDragStop, eventOverlap: s.eventOverlap, extendDefaultEvent: s.extendDefaultEvent, externalDrag: s.externalDrag, externalDrop: s.externalDrop, groupBy: s.groupBy, height: n.height, immutableData: s.immutableData, invalidateEvent: s.invalidateEvent, invalidsMap: e._invalidsMap, maxDate: e._maxDate, minDate: e._minDate, moreEventsPluralText: s.moreEventsPluralText, moreEventsText: s.moreEventsText, navService: e._navService, navigateToEvent: e._navigateToEvent, newEventText: s.newEventText, onCellClick: e._onCellClick, onCellDoubleClick: e._onCellDoubleClick, onCellRightClick: e._onCellRightClick, onEventClick: e._onEventClick, onEventDelete: e._onEventDelete, onEventDoubleClick: e._onEventDoubleClick, onEventDragEnd: e._onEventDragEnd, onEventDragStart: e._onEventDragStart, onEventHoverIn: e._onEventHoverIn, onEventHoverOut: e._onEventHoverOut, onEventRightClick: e._onEventRightClick, onMoreClick: e._onMoreClick, onPopoverClose: e._onPopoverClose, renderBufferAfter: t ? t.bufferAfter : s.renderBufferAfter, renderBufferBefore: t ? t.bufferBefore : s.renderBufferBefore, renderEvent: t ? t.scheduleEvent : s.renderScheduleEvent, renderEventContent: t ? t.scheduleEventContent : s.renderScheduleEventContent, renderResource: t ? t.resource : s.renderResource, resources: s.resources, scroll: e._shouldScrollSchedule, selected: e._selectedDateTime, showEventBuffer: s.showEventBuffer, width: n.width });
  return _(D_, K({ ref: e._setEl }, i, { activeDate: e._active, calendarScroll: e._calendarScroll, calendarType: e._calendarType, colors: s.colors, context: s.context, cssClass: e._cssClass, downIcon: s.downIcon, dragData: n.labelDragData, dragToMove: s.dragToMove || s.externalDrag, endDay: e._rangeEndDay, eventRange: e._rangeType, eventRangeSize: e._showSchedule ? e._scheduleSize : e._showTimeline ? e._timelineSize : e._eventListSize, hasContent: e._showEventList || e._showSchedule || e._showTimeline, hasPicker: !0, height: s.height, invalid: s.invalid, instanceService: e._instanceService, labels: s.labels, labelList: e._calendarLabelList, labelsMap: e._labelsMap, marked: s.marked, marksMap: e._marksMap, max: s.max, min: s.min, mouseSwipe: !s.dragToCreate && s.clickToCreate !== "single" || !e._showEventLabels && !e._showEventCount, mousewheel: s.mousewheel, navService: e._navService, navView: e._navView, nextIconH: s.nextIconH, nextIconV: s.nextIconV, nextPageText: s.nextPageText, noOuterChange: !e._showEventList, onCellHoverIn: e._onCellHoverIn, onCellHoverOut: e._onCellHoverOut, onDayClick: e._onDayClick, onDayDoubleClick: e._onDayDoubleClick, onDayRightClick: e._onDayRightClick, onGestureStart: e._onGestureStart, onLabelClick: e._onLabelClick, onLabelDoubleClick: e._onLabelDoubleClick, onLabelRightClick: e._onLabelRightClick, onLabelHoverIn: e._onLabelHoverIn, onLabelHoverOut: e._onLabelHoverOut, onLabelDelete: e._onEventDelete, onLabelUpdateStart: e._onLabelUpdateStart, onLabelUpdateMove: e._onLabelUpdateMove, onLabelUpdateEnd: e._onLabelUpdateEnd, onLabelUpdateModeOn: e._onLabelUpdateModeOn, onLabelUpdateModeOff: e._onLabelUpdateModeOff, onPageChange: e._onPageChange, onPageLoaded: e._onPageLoaded, onPageLoading: e._onPageLoading, onResize: e._onResize, pageLoad: e._pageLoad, prevIconH: s.prevIconH, prevIconV: s.prevIconV, prevPageText: s.prevPageText, resourcesMap: e._resourcesMap, responsiveStyle: !0, renderHeader: t ? t.header : s.renderHeader, renderDayContent: t ? t.dayContent : s.renderDayContent, renderLabel: t ? t.label : s.renderLabel, renderLabelContent: t ? t.labelContent : s.renderLabelContent, selectedDates: e._selectedDates, selectView: "page", showCalendar: e._showCalendar, showControls: s.showControls, showLabelCount: e._showEventCount, showOuterDays: e._showOuterDays, showSchedule: e._showSchedule || e._showTimeline, showToday: s.showToday, showWeekNumbers: e._showWeekNumbers, size: e._calendarSize, startDay: e._rangeStartDay, swipe: !n.isTouchDrag, upIcon: s.upIcon, valid: s.valid, weeks: e._calendarSize, width: s.width, eventText: s.eventText, eventsText: s.eventsText, fromText: s.fromText, moreEventsPluralText: s.moreEventsPluralText, moreEventsText: s.moreEventsText, todayText: s.todayText, toText: s.toText, weekText: s.weekText, yearSuffix: s.yearSuffix }), e._showDate && _("div", { className: "mbsc-schedule-date-header mbsc-flex" + e._theme + e._hb }, e._showSchedule && !e._showCalendar && s.resources && _("div", { className: "mbsc-schedule-time-col" }), _("div", { className: "mbsc-schedule-date-header-text mbsc-flex-1-1" + e._theme }, e._selectedDateHeader), e._showSchedule && !e._showCalendar && s.resources && _("div", { className: "mbsc-schedule-fake-scroll-y" })), e._showEventList && _("div", { className: "mbsc-flex-1-1 mbsc-event-list" + (n.isListScrollable ? " mbsc-event-list-scroll" : ""), dangerouslySetInnerHTML: e._eventListHTML, onScroll: e._onScroll, ref: e._setList }, a), e._showSchedule && _(l_, K({}, r, { endDay: e._scheduleEndDay, endTime: e._scheduleEndTime, maxEventStack: e._scheduleMaxEventStack, minEventWidth: e._scheduleMinEventWidth, renderDayContent: t ? t.dayContent : s.renderDayContent, showAllDay: e._showScheduleAllDay, showDays: e._showScheduleDays, size: e._scheduleSize, startDay: e._scheduleStartDay, startTime: e._scheduleStartTime, timeCellStep: e._scheduleTimeCellStep, timeLabelStep: e._scheduleTimeLabelStep, timezones: e._scheduleTimezones, type: e._scheduleType, onWeekDayClick: e._onWeekDayClick })), e._showTimeline && _(u_, K({}, r, { connections: s.connections, downIcon: s.chevronIconDown, dragBetweenSlots: s.dragBetweenSlots, dragToCreate: !s.slots && s.dragToCreate, dragToResize: !s.slots && s.dragToResize, endDay: e._timelineEndDay, endTime: e._timelineEndTime, eventList: e._timelineListing, maxEventStack: e._timelineMaxEventStack, nextIcon: s.nextIconH, nextIconRtl: s.prevIconH, onResourceCollapse: e._proxy, onResourceExpand: e._proxy, quarterText: s.quarterText, renderDayFooter: t ? t.dayFooter : s.renderDayFooter, renderHour: t ? t.hour : s.renderHour, renderHourFooter: t ? t.hourFooter : s.renderHourFooter, renderMonth: t ? t.month : s.renderMonth, renderMonthFooter: t ? t.monthFooter : s.renderMonthFooter, renderQuarter: t ? t.quarter : s.renderQuarter, renderQuarterFooter: t ? t.quarterFooter : s.renderQuarterFooter, renderWeek: t ? t.week : s.renderWeek, renderWeekFooter: t ? t.weekFooter : s.renderWeekFooter, renderYear: t ? t.year : s.renderYear, renderYearFooter: t ? t.yearFooter : s.renderYearFooter, renderResourceFooter: t ? t.resourceFooter : s.renderResourceFooter, renderResourceHeader: t ? t.resourceHeader : s.renderResourceHeader, renderSidebar: t ? t.sidebar : s.renderSidebar, renderSidebarFooter: t ? t.sidebarFooter : s.renderSidebarFooter, renderSidebarHeader: t ? t.sidebarHeader : s.renderSidebarHeader, renderSlot: t ? t.slot : s.renderSlot, resolution: e._timelineResolution, resolutionVertical: e._timelineResolutionVertical, rowHeight: e._timelineRowHeight, weekNumbers: e._showTimelineWeekNumbers, weekText: s.weekText, size: e._timelineSize, slots: s.slots, startDay: e._timelineStartDay, startTime: e._timelineStartTime, timeCellStep: e._timelineTimeCellStep, timeLabelStep: e._timelineTimeLabelStep, type: e._timelineType, virtualScroll: !e._print && e._timelineVirtualScroll })), _(va, { anchor: e._anchor, closeOnScroll: !0, contentPadding: !1, context: n.popoverContext || s.context, cssClass: "mbsc-calendar-popup " + (n.popoverHidden ? "mbsc-popover-hidden " : "") + e._popoverClass, display: "anchored", isOpen: n.showPopover, locale: s.locale, maxHeight: "24em", onClose: e._onPopoverClose, rtl: s.rtl, scrollLock: !1, showOverlay: !1, theme: s.theme, themeVariant: s.themeVariant }, n.popoverList && _(jl, { ref: e._setPopoverList, theme: s.theme, themeVariant: s.themeVariant, rtl: s.rtl, className: "mbsc-popover-list" }, n.popoverList.map(function(o, l) {
    return Xl(e, o, l, n.popoverDate, s, !0, t);
  }))), n.labelDragData && n.labelDragData.draggedEvent && !n.isTouchDrag && _("div", { className: "mbsc-calendar-dragging" }));
}
var x_ = /* @__PURE__ */ function(s) {
  function n() {
    var e = s !== null && s.apply(this, arguments) || this;
    return e._instanceService = new s_(), e;
  }
  return de(n, s), n.prototype._template = function(e, t) {
    return w_(e, t, this);
  }, n;
}(n_), C_ = { before: function(s, n) {
  n.selectedDate && (n.defaultSelectedDate = n.selectedDate, delete n.selectedDate);
} }, S_ = (Ir._selector = "[mbsc-calendar-next]", Or), T_ = (Mr._selector = "[mbsc-calendar-prev]", Ir), E_ = (Nr._selector = "[mbsc-calendar-today]", Mr), k_ = (Or._selector = "[mbsc-calendar-nav]", Nr), M_ = /* @__PURE__ */ go(x_, C_), zd = /* @__PURE__ */ go(va, of);
const $ = lu({
  isLoading: !0,
  occupancyCollection: {},
  stockCollection: {},
  lang: "en",
  env: "",
  engine: "",
  userTableKey: "",
  userToken: "",
  groupId: "",
  calendarStartDate: "",
  calendarType: "",
  showFilter: !1,
  showSettings: !1,
  showDetails: !1,
  height: "",
  appType: "",
  viewId: null,
  userGraphqlToken: "",
  userId: null,
  selectedEvent: {},
  settings: {},
  locale: {},
  userAdvancedSettings: {},
  userGraphqlModel: {},
  groupGraphqlModel: {},
  propsFilters: [],
  propsSettings: {},
  calendarError: null,
  sessionId: "",
  sorting: {},
  filter: {
    filters: [],
    page: {
      size: 25,
      current: 1
    },
    query: ""
  }
}), Hd = {
  /**
   * Get data for calendar resources
   * 
   * @returns {Object[] | []}
   */
  getResources: ls(() => {
    const { value: s } = $.filter.filters.find((t) => t.key === "occupancy_stock_id") || { value: [] }, n = $.stockCollection.items || [];
    return (s.length ? n.filter((t) => s.includes(t.id)) : n).map((t) => ({
      id: t.id,
      name: t.name,
      capacity: t.capacity
    }));
  }),
  /**
   * Get "Room" list for filter
   * 
   * @returns {Object[] | []}
   */
  getFilterResources: ls(() => ($.stockCollection.items || []).map((n) => ({
    value: n.id,
    text: n.name
  }))),
  /**
   * Get calendar event data
   * 
   * @returns {Object[] | []}
   */
  getCalendarData: ls(() => ($.occupancyCollection.items || []).map((n) => ({
    start: n.occupancyStartDateTime,
    end: n.occupancyEndDateTime,
    title: n.occupancyTicketName,
    color: n.occupancyEventCardColorCodeCustom,
    resource: n.occupancyStockId,
    additionalData: n
  }))),
  /**
   * Get calendar "count inside" event data
   *
   * @returns {Object[] | []}
  */
  getCalendarDataCountInside: ls(() => $.occupancyCollection.itemsCountInside || []),
  /**
   * Get selected event data
   * 
   * @returns {Object}
   */
  getEventData: ls(() => {
    var s, n;
    return ((n = (s = $.selectedEvent) == null ? void 0 : s.event) == null ? void 0 : n.additionalData) || {};
  }),
  /**
   * Get current calendar type settings
   * 
   * @returns {Object}
   */
  getCalendarSettings: ls(() => {
    const s = Im[$.calendarType];
    return ge(ge({}, s), $.settings);
  })
}, I_ = {
  /**
   * Initializing states
   *
   * @param {Object} payload: data for states
   * @returns {Void}
   */
  initStates(s) {
    $.lang = s.lang, $.env = s.env, $.engine = s.engine, $.userTableKey = s.userTableKey, $.userToken = s.userToken, $.groupId = s.groupId, $.calendarStartDate = s.calendarStartDate, $.calendarType = s.calendarType, $.userGraphqlToken = s.userGraphqlToken, $.userId = s.userId, $.filter = s.filter, $.settings = s.settings, $.locale = s.locale, $.height = s.height, $.appType = s.appType, $.userAdvancedSettings = s.userAdvancedSettings, $.viewId = s.viewId, $.propsFilters = s.propsFilters, $.propsSettings = s.propsSettings, $.calendarError = s.calendarError, $.sorting = s.sorting;
  },
  /**
   * Init collections data and fetch occupancy data with stocks
   *
   * @param {Object} payload: params for requests
   * @returns {Void}
   */
  fetchInitialData(s) {
    return Re(this, null, function* () {
      var n, e;
      try {
        const { fetchStocks: t, fetchOccupancy: a } = s;
        $.isLoading = !0, $.stockCollection = new mp(t), $.occupancyCollection = new Us(a), yield Promise.all([$.stockCollection.fetch(), $.occupancyCollection.fetchAllPages()]), $.isLoading = !1, Hd.getResources.value.length !== 0 && jt({ message: $.locale["calendar-updated"] });
      } catch (t) {
        const a = ((e = (n = t == null ? void 0 : t.response) == null ? void 0 : n.data) == null ? void 0 : e.message) || (t == null ? void 0 : t.message);
        throw $.calendarError = t, $.isLoading = !1, jt({ message: a }), new Error(t);
      }
    });
  },
  /**
   * Fetch occupancy data
   *
   * @param {Object} payload: params for request
   * @returns {Void}
   */
  fetchOccupancy(s) {
    return Re(this, null, function* () {
      var n, e;
      try {
        $.isLoading = !0, $.occupancyCollection = new Us(s), yield $.occupancyCollection.fetchAllPages(), $.isLoading = !1, jt({ message: $.locale["calendar-updated"] });
      } catch (t) {
        const a = ((e = (n = t == null ? void 0 : t.response) == null ? void 0 : n.data) == null ? void 0 : e.message) || (t == null ? void 0 : t.message);
        throw $.calendarError = t, $.isLoading = !1, jt({ message: a }), new Error(t);
      }
    });
  },
  /**
   * Fetch user data by graphql
   *
   * @param {Object} payload: params for request
   * @retunrs {Void}
   */
  fetchInitGraphqlData(s) {
    return Re(this, null, function* () {
      var n, e;
      try {
        $.isLoading = !0, $.userGraphqlModel = new Km(s.fetchUser), $.groupGraphqlModel = new qm(s.fetchGroup), yield Promise.all([$.userGraphqlModel.fetch(), $.groupGraphqlModel.fetch()]);
      } catch (t) {
        const a = ((e = (n = t == null ? void 0 : t.response) == null ? void 0 : n.data) == null ? void 0 : e.message) || (t == null ? void 0 : t.message);
        throw $.calendarError = t, $.isLoading = !1, jt({ message: a }), new Error(t);
      }
    });
  },
  /**
   * Update settings in user data
   *
   * @param {Object} payload: params for request
   * @returns {Void}
   */
  patchSettings(s) {
    return Re(this, null, function* () {
      var n, e;
      try {
        $.isLoading = !0, yield qr(s), yield $.userGraphqlModel.fetch(), $.userAdvancedSettings = ge({}, $.userGraphqlModel.advancedSettingsCustomObject), $.isLoading = !1, jt({ message: $.locale["calendar-updated"] });
      } catch (t) {
        const a = ((e = (n = t == null ? void 0 : t.response) == null ? void 0 : n.data) == null ? void 0 : e.message) || (t == null ? void 0 : t.message);
        throw $.calendarError = t, $.isLoading = !1, jt({ message: a }), new Error(t);
      }
    });
  },
  /**
   * Update filter in user data
   *
   * @param {Object} payload: params for request
   * @returns {Void}
   */
  patchFilter(s) {
    return Re(this, null, function* () {
      var n, e;
      try {
        $.isLoading = !0;
        const { fetchParams: t, patchParams: a } = s;
        $.occupancyCollection = new Us(t), yield Promise.all([$.occupancyCollection.fetchAllPages(), qr(a)]), yield $.userGraphqlModel.fetch(), $.userAdvancedSettings = ge({}, $.userGraphqlModel.advancedSettingsCustomObject), $.isLoading = !1, jt({ message: $.locale["calendar-updated"] });
      } catch (t) {
        const a = ((e = (n = t == null ? void 0 : t.response) == null ? void 0 : n.data) == null ? void 0 : e.message) || (t == null ? void 0 : t.message);
        throw $.calendarError = t, $.isLoading = !1, jt({ message: a }), new Error(t);
      }
    });
  },
  /**
   * Update calendar type, fetch and set filters/settings from new type
   *
   * @param {Object} payload: params for request
   * @returns {Void}
   */
  patchCalendarType(s) {
    return Re(this, null, function* () {
      var n, e;
      try {
        $.isLoading = !0, yield qr(s);
        const t = Uc({
          userAdvancedSettings: $.userGraphqlModel.advancedSettingsCustomObject,
          calendarType: $.calendarType,
          appType: $.appType,
          groupId: $.groupId,
          viewId: $.viewId
        }), a = {
          propsFilters: $.propsFilters,
          calendarStartDate: $.calendarStartDate,
          calendarType: $.calendarType,
          backendFilters: t.filters
        };
        $.filter = $c(a), $.settings = ge(ge({}, t.settings), $.propsSettings), $.sorting = ge({}, t.sorting);
        const i = {
          engineName: $.engine,
          accessToken: $.userTableKey,
          filter: lr($.filter)
        };
        $.occupancyCollection = new Us(i), yield $.occupancyCollection.fetchAllPages(), $.isLoading = !1, jt({ message: $.locale["calendar-updated"] });
      } catch (t) {
        const a = ((e = (n = t == null ? void 0 : t.response) == null ? void 0 : n.data) == null ? void 0 : e.message) || (t == null ? void 0 : t.message);
        throw $.calendarError = t, $.isLoading = !1, jt({ message: a }), new Error(t);
      }
    });
  },
  /**
   * Get selected event data
   *
   * @param {Object} payload: selected event data
   * @returns {Void}
  */
  setSelectedEvent(s) {
    $.selectedEvent = s;
  },
  /**
   * Get calendar start date
   *
   * @param {String} payload: start date for calendar
   * @returns {Void}
  */
  setCalendarStartDate(s) {
    $.calendarStartDate = s;
  },
  /**
   * Get new filter data
   *
   * @param {Object} payload: filter data
   * @returns {Void}
  */
  setFilter(s) {
    $.filter = s;
  },
  /**
   * Toggle show filter state
   *
   * @param {Boolean} payload: new state for "showFilter"
   * @returns {Void}
   */
  toggleShowFilter(s) {
    $.showFilter = s;
  },
  /**
   * Toggle show settings state
   *
   * @param {Boolean} payload: new state for "showSettings"
   * @returns {Void}
   */
  toggleShowSettings(s) {
    $.showSettings = s;
  },
  /**
   * Toggle show details state
   *
   * @param {Boolean} payload: new state for "showDetails"
   * @returns {Void}
   */
  toggleShowDetails(s) {
    $.showDetails = s;
  },
  /**
   * Get new settings data for current calendar type
   *
   * @param {Object} payload: setting for current calendar type
   * @param {Boolean} hasToast: display toast message or not
   * @returns {Void}
  */
  setSettings(s, n = !0) {
    $.settings = ge({}, s), n && jt({ message: $.locale["settings-changed"] });
  },
  setCalendarType(s) {
    $.calendarType = s;
  },
  setCalendarError(s) {
    $.calendarError = s;
  },
  setUserAdvancedSettings(s) {
    $.userAdvancedSettings = s;
  },
  setUserToken(s) {
    $.userToken = s;
  },
  setUserTableKey(s) {
    $.userTableKey = s;
  },
  setUserGraphqlToken(s) {
    $.userGraphqlToken = s;
  },
  setSessionId(s) {
    $.sessionId = s;
  },
  setSorting(s) {
    $.sorting = s;
  },
  resetStates() {
    $.isLoading = !0, $.occupancyCollection = {}, $.stockCollection = {}, $.lang = "en", $.env = "", $.engine = "", $.userTableKey = "", $.userToken = "", $.groupId = "", $.calendarStartDate = "", $.calendarType = "", $.showFilter = !1, $.showSettings = !1, $.showDetails = !1, $.height = "", $.appType = "", $.viewId = null, $.userGraphqlToken = "", $.userId = null, $.selectedEvent = {}, $.settings = {}, $.locale = {}, $.userAdvancedSettings = {}, $.userGraphqlModel = {}, $.groupGraphqlModel = {}, $.propsFilters = [], $.propsSettings = {}, $.calendarError = null, $.sessionId = "", $.sorting = {}, $.filter = {
      filters: [],
      page: {
        size: 25,
        current: 1
      },
      query: ""
    };
  }
}, x = {
  state: ou($),
  getters: Hd,
  methods: I_
};
const N_ = { class: "bad-connection" }, O_ = { class: "bad-connection--content-text" }, L_ = {
  __name: "BadConnection",
  emits: ["refresh-button:clicked"],
  setup(s, { emit: n }) {
    const e = n, t = () => {
      try {
        bs.info("ACTION. Bad connection refresh button clicked");
      } catch (a) {
        console.warn("Error while logger service", a);
      }
      e("refresh-button:clicked", !0);
    };
    return (a, i) => (Me(), gt("div", N_, [
      ae("p", O_, Ge(Q(x).state.locale["check-connection-try-again"]), 1),
      ae("button", {
        class: "bad-connection--button-refresh",
        onClick: t
      }, Ge(Q(x).state.locale.refresh), 1)
    ]));
  }
};
const A_ = { class: "no-resources" }, R_ = { class: "no-resources--content-text" }, P_ = {
  __name: "NoResources",
  setup(s) {
    return (n, e) => (Me(), gt("div", A_, [
      ae("p", R_, Ge(Q(x).state.locale["create-resources-first"]), 1)
    ]));
  }
};
const z_ = { class: "mbsc-text-style" }, H_ = {
  __name: "BaseStatus",
  props: {
    type: String,
    caption: String
  },
  setup(s) {
    const n = s;
    return (e, t) => (Me(), gt("span", null, [
      ae("span", {
        class: na(n.type || "default")
      }, null, 2),
      ae("span", z_, Ge(Q(x).state.locale[n.caption] || Q(x).state.locale.unknown), 1)
    ]));
  }
};
const F_ = {
  id: "custom-event-tooltip-popup",
  class: "mbsc-smeetzz mbsc-tooltip"
}, Y_ = { class: "mbsc-tooltip-time" }, U_ = { class: "mbsc-tooltip-content" }, B_ = { class: "mbsc-tooltip-text-bold" }, V_ = { class: "mbsc-tooltip-space-left--mini" }, j_ = { class: "mbsc-tooltip-status" }, W_ = /* @__PURE__ */ ae("hr", null, null, -1), $_ = { class: "mbsc-tooltip-text-bold" }, q_ = { class: "mbsc-tooltip-space-left--mini" }, G_ = { class: "mbsc-tooltip-text-bold" }, X_ = { class: "mbsc-tooltip-space-left--mini" }, K_ = { class: "mbsc-tooltip-text-bold" }, Q_ = { class: "mbsc-tooltip-space-left--mini" }, J_ = {
  key: 0,
  class: "mbsc-tooltip-list"
}, Z_ = { key: 1 }, ev = { class: "mbsc-tooltip-button-wrapper" }, tv = {
  "mbsc-button": "",
  "data-variant": "outline",
  class: "mbsc-smeetzz mbsc-tooltip-button js-tooltip-edit-order-button"
}, nv = {
  __name: "EventDetailsTooltip",
  emits: ["edit-button:clicked"],
  setup(s, { emit: n }) {
    let e, t = {};
    const a = n, i = () => {
      e = zd("#custom-event-tooltip-popup", {
        theme: "smeetzz",
        display: "anchored",
        touchUi: !1,
        showOverlay: !0,
        contentPadding: !1,
        closeOnOverlayClick: !0,
        width: 350
      });
    }, r = (u) => {
      e.setOptions({ anchor: u.domEvent.target }), e.open();
    }, o = () => {
      e.close(), a("edit-button:clicked", x.getters.getEventData.value);
    }, l = () => {
      o();
    };
    return sa(
      () => x.state.selectedEvent,
      (u) => {
        r(u);
      }
    ), sa(
      () => x.state.showDetails,
      (u) => {
        !u && e && e.close();
      }
    ), fn(() => {
      t = document.querySelector(".js-tooltip-edit-order-button"), t.addEventListener("click", l), i();
    }), Ms(() => {
      t != null && t.removeEventListener && t.removeEventListener("click", l);
    }), (u, c) => (Me(), gt("div", F_, [
      ae("div", {
        class: "mbsc-tooltip-header mbsc-tooltip-text-bold",
        style: qa({
          "background-color": Q(x).getters.getEventData.value.occupancyEventCardColorCodeCustom
        })
      }, [
        ae("span", null, Ge(Q(x).getters.getEventData.value.occupancyCustomerFullNameCustom || " "), 1),
        ae("span", Y_, Ge(Q(x).getters.getEventData.value.occupancyStartEndDateTimeCustom), 1)
      ], 4),
      ae("div", U_, [
        ae("div", null, [
          ae("span", B_, Ge(Q(x).state.locale["booking-ref-dots"]), 1),
          ae("span", V_, Ge(Q(x).getters.getEventData.value.occupancyBookingReference), 1),
          ae("span", j_, [
            Zi(H_, {
              type: Q(x).getters.getEventData.value.occupancyBookingStatusColorTypeCustom,
              caption: Q(x).getters.getEventData.value.occupancyBookingStatusLangKeyCustom
            }, null, 8, ["type", "caption"])
          ])
        ]),
        W_,
        ae("div", null, [
          ae("span", $_, Ge(Q(x).state.locale["product-dots"]), 1),
          ae("span", q_, Ge(Q(x).getters.getEventData.value.occupancyProductName), 1)
        ]),
        ae("div", null, [
          ae("span", G_, Ge(Q(x).state.locale["ticket-dots"]), 1),
          ae("span", X_, Ge(Q(x).getters.getEventData.value.occupancyTicketName), 1)
        ]),
        ae("div", null, [
          ae("span", K_, Ge(Q(x).state.locale["extras-dots"]), 1),
          ae("span", Q_, [
            Q(x).getters.getEventData.value.occupancyRetailProductsCustomArray && Q(x).getters.getEventData.value.occupancyRetailProductsCustomArray.length !== 0 ? (Me(), gt("ul", J_, [
              (Me(!0), gt(yi, null, ic(Q(x).getters.getEventData.value.occupancyRetailProductsCustomArray, (d, m) => (Me(), gt("li", { key: m }, Ge(`${d.quantity} ${d.product_name}`), 1))), 128))
            ])) : (Me(), gt("span", Z_, Ge(Q(x).state.locale.none), 1))
          ])
        ]),
        ae("div", ev, [
          ae("button", tv, Ge(Q(x).state.locale["edit-order"]), 1)
        ])
      ])
    ]));
  }
}, sv = ["id", "placeholder"], Ln = {
  __name: "BaseSelect",
  props: {
    elId: String,
    // element id
    value: [Number, String, Array],
    // init value
    label: String,
    // field label
    selectMultiple: Boolean,
    // enable/disable multiple select
    list: Array
    // init list for dropdown content [{ value: [], text: [] }]
  },
  emits: ["change"],
  setup(s, { emit: n }) {
    const e = s, t = n;
    let a = null;
    const i = () => {
      a = fr(`#${e.elId}`, {
        locale: oa[x.state.lang],
        theme: "smeetzz",
        display: "anchored",
        filter: !0,
        selectMultiple: e.selectMultiple,
        tags: !0,
        onChange: (r) => {
          t("change", { value: r.valueText ? r.value : null });
        }
      });
    };
    return fn(() => {
      i(), a.setOptions({ data: e.list }), a.setVal(e.value);
    }), Ms(() => {
      a != null && a.destroy && a.destroy();
    }), (r, o) => (Me(), gt("label", null, [
      ae("span", null, Ge(e.label), 1),
      ae("input", {
        id: e.elId,
        "mbsc-input": "",
        "data-dropdown": "true",
        "data-input-style": "box",
        "data-label-style": "stacked",
        class: "mbsc-smeetzz",
        placeholder: Q(x).state.locale["please-select"]
      }, null, 8, sv)
    ]));
  }
}, av = ["id", "placeholder"], rv = 1, Ba = {
  __name: "SelectAppSearch",
  props: {
    elId: String,
    // element id
    value: [Number, String, Array],
    // init value
    label: String,
    // field label
    selectMultiple: Boolean,
    // enable/disable multiple select
    list: Array,
    // init list for dropdown content [{ value: [], text: [] }]
    valueKey: String,
    // field name from model that will be used like value in dropdown "occupancyProductId"
    labelKey: String,
    // field name from model that will be used like label in dropdown "occupancyProductName"
    groupBy: String,
    // name of the field by which you want to get only unique data: "occupancy_product_id"
    resultFields: Object,
    // object of fields that need to be get from the app search: { occupancy_product_id: { raw: {} } }
    searchFields: Object
    // object of fields by which we will be search: { occupancy_product_id: {} }
  },
  emits: ["change"],
  setup(s, { emit: n }) {
    const e = s, t = n;
    let a = null;
    const i = () => {
      a = fr(`#${e.elId}`, {
        locale: oa[x.state.lang],
        theme: "smeetzz",
        display: "anchored",
        filter: !0,
        selectMultiple: e.selectMultiple,
        tags: !0,
        onChange: (u) => {
          t("change", {
            value: u.valueText ? u.value : null,
            label: u.valueText
          });
        },
        onFilter: (u) => (r(u.filterText), !1),
        onOpen: () => {
          r("");
        }
      });
    }, r = (u) => Re(this, null, function* () {
      const d = (yield o(u)).map((m) => ({
        value: m[e.valueKey],
        text: m[e.labelKey]
      }));
      a.setOptions({ data: d });
    }), o = (u) => Re(this, null, function* () {
      const c = { group: { field: e.groupBy, size: rv } }, d = e.resultFields ? { result_fields: ge({}, e.resultFields) } : {}, m = e.searchFields ? { search_fields: ge({}, e.searchFields) } : {}, h = Qm(), f = {
        engineName: x.state.engine,
        accessToken: x.state.userTableKey,
        env: x.state.env,
        filter: ge(ge(ge(ct(ge({}, h), {
          query: u
        }), c), d), m)
      }, p = new Us(f);
      return yield p.fetch(), u === "" ? l(p.items) : p.items;
    }), l = (u) => u.sort((c, d) => {
      const m = c[e.labelKey].toLowerCase(), h = d[e.labelKey].toLowerCase();
      return m < h ? -1 : m > h ? 1 : 0;
    });
    return fn(() => {
      i(), a.setOptions({ data: e.list }), a.setVal(e.value);
    }), Ms(() => {
      a != null && a.destroy && a.destroy();
    }), (u, c) => (Me(), gt("label", null, [
      ae("span", null, Ge(e.label), 1),
      ae("input", {
        id: e.elId,
        "mbsc-input": "",
        "data-dropdown": "true",
        "data-input-style": "box",
        "data-label-style": "stacked",
        class: "mbsc-smeetzz",
        placeholder: Q(x).state.locale["please-select"]
      }, null, 8, av)
    ]));
  }
};
const iv = { class: "mbsc-filter-sidebar mbsc-flex-none" }, ov = { class: "mbsc-filter-sidebar-header" }, lv = { class: "mbsc-filter-sidebar-title" }, cv = ["src"], dv = { class: "mbsc-filter-save-button-wrapper" }, uv = {
  __name: "FilterSidebar",
  emits: ["filter:changed"],
  setup(s, { emit: n }) {
    const e = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgNi40MUwxNy41OSA1IDEyIDEwLjU5IDYuNDEgNSA1IDYuNDEgMTAuNTkgMTIgNSAxNy41OSA2LjQxIDE5IDEyIDEzLjQxIDE3LjU5IDE5IDE5IDE3LjU5IDEzLjQxIDEyeiIvPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48L3N2Zz4=", self.location).href, t = n, a = ln({}), i = ln({}), r = ln(!1), o = () => {
      a.value = x.state.filter.filters.reduce((d, m) => {
        let h = [];
        if (m.label) {
          const f = m.label.split(", ");
          h = m.value.map((p, g) => ({
            value: p,
            text: f[g] || ""
          }));
        }
        return d[m.key] = { value: m.value, list: h }, d;
      }, {});
    }, l = () => {
      x.methods.toggleShowFilter(!1);
    }, u = () => {
      const d = Object.keys(i.value), m = Object.values(i.value).filter(
        (f) => f.value !== null
      );
      let h = x.state.filter.filters.filter(
        (f) => !d.includes(f.key)
      );
      h = h.concat(m), x.methods.setFilter(ct(ge({}, x.state.filter), { filters: h })), t("filter:changed");
    }, c = (d, m, h) => {
      i.value[h] = ge({ key: h, option: m }, d);
    };
    return fn(() => {
      o(), r.value = !0;
    }), (d, m) => {
      var h, f, p, g, v, y, b, D, w, C;
      return Me(), gt("div", iv, [
        ae("div", ov, [
          ae("span", lv, Ge(Q(x).state.locale.filters), 1),
          ae("img", {
            src: Q(e),
            class: "mbsc-filter-sidebar-header-close",
            onClick: l
          }, null, 8, cv)
        ]),
        r.value ? (Me(), _t(Ba, {
          key: 0,
          elId: "select-product",
          label: Q(x).state.locale.product,
          selectMultiple: !0,
          value: ((h = a.value.occupancy_product_id) == null ? void 0 : h.value) || [],
          list: ((f = a.value.occupancy_product_id) == null ? void 0 : f.list) || [],
          groupBy: "occupancy_product_id",
          valueKey: "occupancyProductId",
          labelKey: "occupancyProductName",
          resultFields: {
            occupancy_product_id: { raw: {} },
            occupancy_product_name: { raw: {} }
          },
          searchFields: { occupancy_product_name: {} },
          onChange: m[0] || (m[0] = (T) => c(
            T,
            Q(Fe).selectAutocompleteAnyOf,
            "occupancy_product_id"
          ))
        }, null, 8, ["label", "value", "list"])) : mt("", !0),
        r.value ? (Me(), _t(Ba, {
          key: 1,
          elId: "select-ticket",
          label: Q(x).state.locale.ticket,
          selectMultiple: !0,
          value: ((p = a.value.occupancy_ticket_id) == null ? void 0 : p.value) || [],
          list: ((g = a.value.occupancy_ticket_id) == null ? void 0 : g.list) || [],
          groupBy: "occupancy_ticket_id",
          valueKey: "occupancyTicketId",
          labelKey: "occupancyTicketName",
          resultFields: {
            occupancy_ticket_id: { raw: {} },
            occupancy_ticket_name: { raw: {} }
          },
          searchFields: { occupancy_ticket_name: {} },
          onChange: m[1] || (m[1] = (T) => c(
            T,
            Q(Fe).selectAutocompleteAnyOf,
            "occupancy_ticket_id"
          ))
        }, null, 8, ["label", "value", "list"])) : mt("", !0),
        r.value ? (Me(), _t(Ln, {
          key: 2,
          elId: "select-stock",
          label: Q(x).state.locale.resource,
          selectMultiple: !0,
          value: ((v = a.value.occupancy_stock_id) == null ? void 0 : v.value) || [],
          list: Q(x).getters.getFilterResources.value,
          onChange: m[2] || (m[2] = (T) => c(
            T,
            Q(Fe).selectAutocompleteAnyOf,
            "occupancy_stock_id"
          ))
        }, null, 8, ["label", "value", "list"])) : mt("", !0),
        r.value ? (Me(), _t(Ba, {
          key: 3,
          elId: "select-customer-full-name",
          label: Q(x).state.locale["customer-full-name"],
          selectMultiple: !0,
          value: ((y = a.value.occupancy_customer_id) == null ? void 0 : y.value) || [],
          list: ((b = a.value.occupancy_customer_id) == null ? void 0 : b.list) || [],
          groupBy: "occupancy_customer_id",
          valueKey: "occupancyCustomerId",
          labelKey: "occupancyCustomerFullName",
          resultFields: {
            occupancy_customer_id: { raw: {} },
            occupancy_customer_full_name: { raw: {} }
          },
          searchFields: { occupancy_customer_full_name: {} },
          onChange: m[3] || (m[3] = (T) => c(
            T,
            Q(Fe).selectAutocompleteAnyOf,
            "occupancy_customer_id"
          ))
        }, null, 8, ["label", "value", "list"])) : mt("", !0),
        r.value ? (Me(), _t(Ba, {
          key: 4,
          elId: "select-booking-ref",
          label: Q(x).state.locale["booking-ref"],
          selectMultiple: !0,
          value: ((D = a.value.occupancy_booking_reference) == null ? void 0 : D.value) || [],
          list: ((w = a.value.occupancy_booking_reference) == null ? void 0 : w.list) || [],
          groupBy: "occupancy_booking_reference",
          valueKey: "occupancyBookingReference",
          labelKey: "occupancyBookingReference",
          resultFields: { occupancy_booking_reference: { raw: {} } },
          searchFields: { occupancy_booking_reference: {} },
          onChange: m[4] || (m[4] = (T) => c(
            T,
            Q(Fe).selectAutocompleteAnyOf,
            "occupancy_booking_reference"
          ))
        }, null, 8, ["label", "value", "list"])) : mt("", !0),
        r.value ? (Me(), _t(Ln, {
          key: 5,
          elId: "select-booking-state",
          label: Q(x).state.locale["booking-state"],
          selectMultiple: !0,
          value: ((C = a.value.occupancy_booking_state) == null ? void 0 : C.value) || [],
          list: Q(Lm)(),
          onChange: m[5] || (m[5] = (T) => c(T, Q(Fe).statusAnyOf, "occupancy_booking_state"))
        }, null, 8, ["label", "value", "list"])) : mt("", !0),
        ae("div", dv, [
          ae("button", {
            "mbsc-button": "",
            "data-variant": "outline",
            class: "mbsc-smeetzz",
            onClick: u
          }, Ge(Q(x).state.locale.save), 1)
        ])
      ]);
    };
  }
};
const hv = { class: "mbsc-time-range" }, mv = { class: "mbsc-grid mbsc-form-grid mbsc-time-range-content" }, pv = { class: "mbsc-row" }, fv = { class: "mbsc-col-sm-12 mbsc-col-md-6" }, _v = { class: "mbsc-time-range-label" }, vv = ["id"], gv = { class: "mbsc-col-sm-12 mbsc-col-md-6" }, yv = { class: "mbsc-time-range-label" }, bv = ["id"], Dv = {
  __name: "SelectTimeRange",
  props: {
    elStartId: String,
    // start time element id
    elEndId: String,
    // end time element id
    startTime: String,
    // init value
    endTime: String
    // init value
  },
  emits: ["start-time:changed", "end-time:changed"],
  setup(s, { emit: n }) {
    const e = s, t = n, a = [
      { value: "01:00", text: "01:00" },
      { value: "02:00", text: "02:00" },
      { value: "03:00", text: "03:00" },
      { value: "04:00", text: "04:00" },
      { value: "05:00", text: "05:00" },
      { value: "06:00", text: "06:00" },
      { value: "07:00", text: "07:00" },
      { value: "08:00", text: "08:00" },
      { value: "09:00", text: "09:00" },
      { value: "10:00", text: "10:00" },
      { value: "11:00", text: "11:00" },
      { value: "12:00", text: "12:00" },
      { value: "13:00", text: "13:00" },
      { value: "14:00", text: "14:00" },
      { value: "15:00", text: "15:00" },
      { value: "16:00", text: "16:00" },
      { value: "17:00", text: "17:00" },
      { value: "18:00", text: "18:00" },
      { value: "19:00", text: "19:00" },
      { value: "20:00", text: "20:00" },
      { value: "21:00", text: "21:00" },
      { value: "22:00", text: "22:00" },
      { value: "23:00", text: "23:00" },
      { value: "24:00", text: "24:00" }
    ], i = [
      { value: "1:00 AM", text: "1:00 AM" },
      { value: "2:00 AM", text: "2:00 AM" },
      { value: "3:00 AM", text: "3:00 AM" },
      { value: "4:00 AM", text: "4:00 AM" },
      { value: "5:00 AM", text: "5:00 AM" },
      { value: "6:00 AM", text: "6:00 AM" },
      { value: "7:00 AM", text: "7:00 AM" },
      { value: "8:00 AM", text: "8:00 AM" },
      { value: "9:00 AM", text: "9:00 AM" },
      { value: "10:00 AM", text: "10:00 AM" },
      { value: "11:00 AM", text: "11:00 AM" },
      { value: "12:00 PM", text: "12:00 PM" },
      { value: "1:00 PM", text: "1:00 PM" },
      { value: "2:00 PM", text: "2:00 PM" },
      { value: "3:00 PM", text: "3:00 PM" },
      { value: "4:00 PM", text: "4:00 PM" },
      { value: "5:00 PM", text: "5:00 PM" },
      { value: "6:00 PM", text: "6:00 PM" },
      { value: "7:00 PM", text: "7:00 PM" },
      { value: "8:00 PM", text: "8:00 PM" },
      { value: "9:00 PM", text: "9:00 PM" },
      { value: "10:00 PM", text: "10:00 PM" },
      { value: "11:00 PM", text: "11:00 PM" },
      { value: "12:00 AM", text: "12:00 AM" }
    ], r = Object.freeze({
      "1:00 AM": "01:00",
      "2:00 AM": "02:00",
      "3:00 AM": "03:00",
      "4:00 AM": "04:00",
      "5:00 AM": "05:00",
      "6:00 AM": "06:00",
      "7:00 AM": "07:00",
      "8:00 AM": "08:00",
      "9:00 AM": "09:00",
      "10:00 AM": "10:00",
      "11:00 AM": "11:00",
      "12:00 PM": "12:00",
      "1:00 PM": "13:00",
      "2:00 PM": "14:00",
      "3:00 PM": "15:00",
      "4:00 PM": "16:00",
      "5:00 PM": "17:00",
      "6:00 PM": "18:00",
      "7:00 PM": "19:00",
      "8:00 PM": "20:00",
      "9:00 PM": "21:00",
      "10:00 PM": "22:00",
      "11:00 PM": "23:00",
      "12:00 AM": "24:00"
    }), o = Object.freeze({
      "01:00": "1:00 AM",
      "02:00": "2:00 AM",
      "03:00": "3:00 AM",
      "04:00": "4:00 AM",
      "05:00": "5:00 AM",
      "06:00": "6:00 AM",
      "07:00": "7:00 AM",
      "08:00": "8:00 AM",
      "09:00": "9:00 AM",
      "10:00": "10:00 AM",
      "11:00": "11:00 AM",
      "12:00": "12:00 PM",
      "13:00": "1:00 PM",
      "14:00": "2:00 PM",
      "15:00": "3:00 PM",
      "16:00": "4:00 PM",
      "17:00": "5:00 PM",
      "18:00": "6:00 PM",
      "19:00": "7:00 PM",
      "20:00": "8:00 PM",
      "21:00": "9:00 PM",
      "22:00": "10:00 PM",
      "23:00": "11:00 PM",
      "24:00": "12:00 AM"
    });
    let l = null, u = null, c = [];
    const d = (p, g) => {
      l = fr(`#${e.elStartId}`, {
        locale: oa[x.state.lang],
        theme: "smeetzz",
        display: "anchored",
        data: p,
        onChange: (v) => {
          m(v.valueText ? v.value : null, "startTime");
        }
      }), u = fr(`#${e.elEndId}`, {
        locale: oa[x.state.lang],
        theme: "smeetzz",
        display: "anchored",
        data: g,
        onChange: (v) => {
          m(v.valueText ? v.value : null, "endTime");
        }
      });
    }, m = (p, g) => {
      if (g === "startTime") {
        const v = x.state.groupGraphqlModel.timeFormatB2b ? r[p] : p, y = h(c, v, "endTime");
        f(y, "endTime"), t("start-time:changed", { value: v });
      } else {
        const v = x.state.groupGraphqlModel.timeFormatB2b ? r[p] : p, y = h(c, v, "startTime");
        f(y, "startTime"), t("end-time:changed", { value: v });
      }
    }, h = (p, g, v) => {
      const y = Dm(), b = al(`${y} ${g}`);
      return p.map((D) => {
        const w = x.state.groupGraphqlModel.timeFormatB2b ? r[D.value] : D.value, C = al(`${y} ${w}`);
        return ct(ge({}, D), {
          disabled: v === "startTime" ? C >= b : C <= b
        });
      });
    }, f = (p, g) => {
      if (g === "startTime") {
        const { _options: v } = u.getInst();
        l.destroy(), d(p, v);
      }
      if (g === "endTime") {
        const { _options: v } = l.getInst();
        u.destroy(), d(v, p);
      }
    };
    return fn(() => {
      c = x.state.groupGraphqlModel.timeFormatB2b ? [...i] : [...a];
      const p = x.state.groupGraphqlModel.timeFormatB2b ? o[e.startTime] : e.startTime, g = x.state.groupGraphqlModel.timeFormatB2b ? o[e.endTime] : e.endTime, v = h(
        c,
        g,
        "startTime"
      ), y = h(c, p, "endTime");
      d(v, y), l.setVal(p || ""), u.setVal(g || "");
    }), Ms(() => {
      l != null && l.destroy && l.destroy(), u != null && u.destroy && u.destroy();
    }), (p, g) => (Me(), gt("div", hv, [
      ae("div", mv, [
        ae("div", pv, [
          ae("div", fv, [
            ae("label", _v, [
              ae("span", null, Ge(Q(x).state.locale["start-time"]), 1),
              ae("input", {
                id: e.elStartId,
                "mbsc-input": "",
                "data-dropdown": "true",
                "data-input-style": "box",
                "data-label-style": "stacked",
                class: "mbsc-ios mbsc-ltr mbsc-smeetzz mbsc-textfield mbsc-textfield-box mbsc-select mbsc-textfield-stacked mbsc-textfield-box-stacked"
              }, null, 8, vv)
            ])
          ]),
          ae("div", gv, [
            ae("label", yv, [
              ae("span", null, Ge(Q(x).state.locale["end-time"]), 1),
              ae("input", {
                id: e.elEndId,
                "mbsc-input": "",
                "data-dropdown": "true",
                "data-input-style": "box",
                "data-label-style": "stacked",
                class: "mbsc-ios mbsc-ltr mbsc-smeetzz mbsc-textfield mbsc-textfield-box mbsc-select mbsc-textfield-stacked mbsc-textfield-box-stacked"
              }, null, 8, bv)
            ])
          ])
        ])
      ])
    ]));
  }
};
/**!
 * Sortable 1.15.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function Kl(s, n) {
  var e = Object.keys(s);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(s);
    n && (t = t.filter(function(a) {
      return Object.getOwnPropertyDescriptor(s, a).enumerable;
    })), e.push.apply(e, t);
  }
  return e;
}
function pn(s) {
  for (var n = 1; n < arguments.length; n++) {
    var e = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Kl(Object(e), !0).forEach(function(t) {
      wv(s, t, e[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(s, Object.getOwnPropertyDescriptors(e)) : Kl(Object(e)).forEach(function(t) {
      Object.defineProperty(s, t, Object.getOwnPropertyDescriptor(e, t));
    });
  }
  return s;
}
function nr(s) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? nr = function(n) {
    return typeof n;
  } : nr = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, nr(s);
}
function wv(s, n, e) {
  return n in s ? Object.defineProperty(s, n, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : s[n] = e, s;
}
function Cn() {
  return Cn = Object.assign || function(s) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];
      for (var t in e)
        Object.prototype.hasOwnProperty.call(e, t) && (s[t] = e[t]);
    }
    return s;
  }, Cn.apply(this, arguments);
}
function xv(s, n) {
  if (s == null)
    return {};
  var e = {}, t = Object.keys(s), a, i;
  for (i = 0; i < t.length; i++)
    a = t[i], !(n.indexOf(a) >= 0) && (e[a] = s[a]);
  return e;
}
function Cv(s, n) {
  if (s == null)
    return {};
  var e = xv(s, n), t, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(s);
    for (a = 0; a < i.length; a++)
      t = i[a], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(s, t) && (e[t] = s[t]);
  }
  return e;
}
var Sv = "1.15.2";
function xn(s) {
  if (typeof window != "undefined" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(s);
}
var Sn = xn(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), ga = xn(/Edge/i), Ql = xn(/firefox/i), Qs = xn(/safari/i) && !xn(/chrome/i) && !xn(/android/i), Fd = xn(/iP(ad|od|hone)/i), Yd = xn(/chrome/i) && xn(/android/i), Ud = {
  capture: !1,
  passive: !1
};
function We(s, n, e) {
  s.addEventListener(n, e, !Sn && Ud);
}
function Ye(s, n, e) {
  s.removeEventListener(n, e, !Sn && Ud);
}
function vr(s, n) {
  if (n) {
    if (n[0] === ">" && (n = n.substring(1)), s)
      try {
        if (s.matches)
          return s.matches(n);
        if (s.msMatchesSelector)
          return s.msMatchesSelector(n);
        if (s.webkitMatchesSelector)
          return s.webkitMatchesSelector(n);
      } catch (e) {
        return !1;
      }
    return !1;
  }
}
function Tv(s) {
  return s.host && s !== document && s.host.nodeType ? s.host : s.parentNode;
}
function en(s, n, e, t) {
  if (s) {
    e = e || document;
    do {
      if (n != null && (n[0] === ">" ? s.parentNode === e && vr(s, n) : vr(s, n)) || t && s === e)
        return s;
      if (s === e)
        break;
    } while (s = Tv(s));
  }
  return null;
}
var Jl = /\s+/g;
function zt(s, n, e) {
  if (s && n)
    if (s.classList)
      s.classList[e ? "add" : "remove"](n);
    else {
      var t = (" " + s.className + " ").replace(Jl, " ").replace(" " + n + " ", " ");
      s.className = (t + (e ? " " + n : "")).replace(Jl, " ");
    }
}
function be(s, n, e) {
  var t = s && s.style;
  if (t) {
    if (e === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? e = document.defaultView.getComputedStyle(s, "") : s.currentStyle && (e = s.currentStyle), n === void 0 ? e : e[n];
    !(n in t) && n.indexOf("webkit") === -1 && (n = "-webkit-" + n), t[n] = e + (typeof e == "string" ? "" : "px");
  }
}
function Cs(s, n) {
  var e = "";
  if (typeof s == "string")
    e = s;
  else
    do {
      var t = be(s, "transform");
      t && t !== "none" && (e = t + " " + e);
    } while (!n && (s = s.parentNode));
  var a = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return a && new a(e);
}
function Bd(s, n, e) {
  if (s) {
    var t = s.getElementsByTagName(n), a = 0, i = t.length;
    if (e)
      for (; a < i; a++)
        e(t[a], a);
    return t;
  }
  return [];
}
function hn() {
  var s = document.scrollingElement;
  return s || document.documentElement;
}
function vt(s, n, e, t, a) {
  if (!(!s.getBoundingClientRect && s !== window)) {
    var i, r, o, l, u, c, d;
    if (s !== window && s.parentNode && s !== hn() ? (i = s.getBoundingClientRect(), r = i.top, o = i.left, l = i.bottom, u = i.right, c = i.height, d = i.width) : (r = 0, o = 0, l = window.innerHeight, u = window.innerWidth, c = window.innerHeight, d = window.innerWidth), (n || e) && s !== window && (a = a || s.parentNode, !Sn))
      do
        if (a && a.getBoundingClientRect && (be(a, "transform") !== "none" || e && be(a, "position") !== "static")) {
          var m = a.getBoundingClientRect();
          r -= m.top + parseInt(be(a, "border-top-width")), o -= m.left + parseInt(be(a, "border-left-width")), l = r + i.height, u = o + i.width;
          break;
        }
      while (a = a.parentNode);
    if (t && s !== window) {
      var h = Cs(a || s), f = h && h.a, p = h && h.d;
      h && (r /= p, o /= f, d /= f, c /= p, l = r + c, u = o + d);
    }
    return {
      top: r,
      left: o,
      bottom: l,
      right: u,
      width: d,
      height: c
    };
  }
}
function Zl(s, n, e) {
  for (var t = Hn(s, !0), a = vt(s)[n]; t; ) {
    var i = vt(t)[e], r = void 0;
    if (e === "top" || e === "left" ? r = a >= i : r = a <= i, !r)
      return t;
    if (t === hn())
      break;
    t = Hn(t, !1);
  }
  return !1;
}
function ks(s, n, e, t) {
  for (var a = 0, i = 0, r = s.children; i < r.length; ) {
    if (r[i].style.display !== "none" && r[i] !== De.ghost && (t || r[i] !== De.dragged) && en(r[i], e.draggable, s, !1)) {
      if (a === n)
        return r[i];
      a++;
    }
    i++;
  }
  return null;
}
function xo(s, n) {
  for (var e = s.lastElementChild; e && (e === De.ghost || be(e, "display") === "none" || n && !vr(e, n)); )
    e = e.previousElementSibling;
  return e || null;
}
function Wt(s, n) {
  var e = 0;
  if (!s || !s.parentNode)
    return -1;
  for (; s = s.previousElementSibling; )
    s.nodeName.toUpperCase() !== "TEMPLATE" && s !== De.clone && (!n || vr(s, n)) && e++;
  return e;
}
function ec(s) {
  var n = 0, e = 0, t = hn();
  if (s)
    do {
      var a = Cs(s), i = a.a, r = a.d;
      n += s.scrollLeft * i, e += s.scrollTop * r;
    } while (s !== t && (s = s.parentNode));
  return [n, e];
}
function Ev(s, n) {
  for (var e in s)
    if (s.hasOwnProperty(e)) {
      for (var t in n)
        if (n.hasOwnProperty(t) && n[t] === s[e][t])
          return Number(e);
    }
  return -1;
}
function Hn(s, n) {
  if (!s || !s.getBoundingClientRect)
    return hn();
  var e = s, t = !1;
  do
    if (e.clientWidth < e.scrollWidth || e.clientHeight < e.scrollHeight) {
      var a = be(e);
      if (e.clientWidth < e.scrollWidth && (a.overflowX == "auto" || a.overflowX == "scroll") || e.clientHeight < e.scrollHeight && (a.overflowY == "auto" || a.overflowY == "scroll")) {
        if (!e.getBoundingClientRect || e === document.body)
          return hn();
        if (t || n)
          return e;
        t = !0;
      }
    }
  while (e = e.parentNode);
  return hn();
}
function kv(s, n) {
  if (s && n)
    for (var e in n)
      n.hasOwnProperty(e) && (s[e] = n[e]);
  return s;
}
function di(s, n) {
  return Math.round(s.top) === Math.round(n.top) && Math.round(s.left) === Math.round(n.left) && Math.round(s.height) === Math.round(n.height) && Math.round(s.width) === Math.round(n.width);
}
var Js;
function Vd(s, n) {
  return function() {
    if (!Js) {
      var e = arguments, t = this;
      e.length === 1 ? s.call(t, e[0]) : s.apply(t, e), Js = setTimeout(function() {
        Js = void 0;
      }, n);
    }
  };
}
function Mv() {
  clearTimeout(Js), Js = void 0;
}
function jd(s, n, e) {
  s.scrollLeft += n, s.scrollTop += e;
}
function Wd(s) {
  var n = window.Polymer, e = window.jQuery || window.Zepto;
  return n && n.dom ? n.dom(s).cloneNode(!0) : e ? e(s).clone(!0)[0] : s.cloneNode(!0);
}
function $d(s, n, e) {
  var t = {};
  return Array.from(s.children).forEach(function(a) {
    var i, r, o, l;
    if (!(!en(a, n.draggable, s, !1) || a.animated || a === e)) {
      var u = vt(a);
      t.left = Math.min((i = t.left) !== null && i !== void 0 ? i : 1 / 0, u.left), t.top = Math.min((r = t.top) !== null && r !== void 0 ? r : 1 / 0, u.top), t.right = Math.max((o = t.right) !== null && o !== void 0 ? o : -1 / 0, u.right), t.bottom = Math.max((l = t.bottom) !== null && l !== void 0 ? l : -1 / 0, u.bottom);
    }
  }), t.width = t.right - t.left, t.height = t.bottom - t.top, t.x = t.left, t.y = t.top, t;
}
var Yt = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function Iv() {
  var s = [], n;
  return {
    captureAnimationState: function() {
      if (s = [], !!this.options.animation) {
        var t = [].slice.call(this.el.children);
        t.forEach(function(a) {
          if (!(be(a, "display") === "none" || a === De.ghost)) {
            s.push({
              target: a,
              rect: vt(a)
            });
            var i = pn({}, s[s.length - 1].rect);
            if (a.thisAnimationDuration) {
              var r = Cs(a, !0);
              r && (i.top -= r.f, i.left -= r.e);
            }
            a.fromRect = i;
          }
        });
      }
    },
    addAnimationState: function(t) {
      s.push(t);
    },
    removeAnimationState: function(t) {
      s.splice(Ev(s, {
        target: t
      }), 1);
    },
    animateAll: function(t) {
      var a = this;
      if (!this.options.animation) {
        clearTimeout(n), typeof t == "function" && t();
        return;
      }
      var i = !1, r = 0;
      s.forEach(function(o) {
        var l = 0, u = o.target, c = u.fromRect, d = vt(u), m = u.prevFromRect, h = u.prevToRect, f = o.rect, p = Cs(u, !0);
        p && (d.top -= p.f, d.left -= p.e), u.toRect = d, u.thisAnimationDuration && di(m, d) && !di(c, d) && // Make sure animatingRect is on line between toRect & fromRect
        (f.top - d.top) / (f.left - d.left) === (c.top - d.top) / (c.left - d.left) && (l = Ov(f, m, h, a.options)), di(d, c) || (u.prevFromRect = c, u.prevToRect = d, l || (l = a.options.animation), a.animate(u, f, d, l)), l && (i = !0, r = Math.max(r, l), clearTimeout(u.animationResetTimer), u.animationResetTimer = setTimeout(function() {
          u.animationTime = 0, u.prevFromRect = null, u.fromRect = null, u.prevToRect = null, u.thisAnimationDuration = null;
        }, l), u.thisAnimationDuration = l);
      }), clearTimeout(n), i ? n = setTimeout(function() {
        typeof t == "function" && t();
      }, r) : typeof t == "function" && t(), s = [];
    },
    animate: function(t, a, i, r) {
      if (r) {
        be(t, "transition", ""), be(t, "transform", "");
        var o = Cs(this.el), l = o && o.a, u = o && o.d, c = (a.left - i.left) / (l || 1), d = (a.top - i.top) / (u || 1);
        t.animatingX = !!c, t.animatingY = !!d, be(t, "transform", "translate3d(" + c + "px," + d + "px,0)"), this.forRepaintDummy = Nv(t), be(t, "transition", "transform " + r + "ms" + (this.options.easing ? " " + this.options.easing : "")), be(t, "transform", "translate3d(0,0,0)"), typeof t.animated == "number" && clearTimeout(t.animated), t.animated = setTimeout(function() {
          be(t, "transition", ""), be(t, "transform", ""), t.animated = !1, t.animatingX = !1, t.animatingY = !1;
        }, r);
      }
    }
  };
}
function Nv(s) {
  return s.offsetWidth;
}
function Ov(s, n, e, t) {
  return Math.sqrt(Math.pow(n.top - s.top, 2) + Math.pow(n.left - s.left, 2)) / Math.sqrt(Math.pow(n.top - e.top, 2) + Math.pow(n.left - e.left, 2)) * t.animation;
}
var ms = [], ui = {
  initializeByDefault: !0
}, ya = {
  mount: function(n) {
    for (var e in ui)
      ui.hasOwnProperty(e) && !(e in n) && (n[e] = ui[e]);
    ms.forEach(function(t) {
      if (t.pluginName === n.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(n.pluginName, " more than once");
    }), ms.push(n);
  },
  pluginEvent: function(n, e, t) {
    var a = this;
    this.eventCanceled = !1, t.cancel = function() {
      a.eventCanceled = !0;
    };
    var i = n + "Global";
    ms.forEach(function(r) {
      e[r.pluginName] && (e[r.pluginName][i] && e[r.pluginName][i](pn({
        sortable: e
      }, t)), e.options[r.pluginName] && e[r.pluginName][n] && e[r.pluginName][n](pn({
        sortable: e
      }, t)));
    });
  },
  initializePlugins: function(n, e, t, a) {
    ms.forEach(function(o) {
      var l = o.pluginName;
      if (!(!n.options[l] && !o.initializeByDefault)) {
        var u = new o(n, e, n.options);
        u.sortable = n, u.options = n.options, n[l] = u, Cn(t, u.defaults);
      }
    });
    for (var i in n.options)
      if (n.options.hasOwnProperty(i)) {
        var r = this.modifyOption(n, i, n.options[i]);
        typeof r != "undefined" && (n.options[i] = r);
      }
  },
  getEventProperties: function(n, e) {
    var t = {};
    return ms.forEach(function(a) {
      typeof a.eventProperties == "function" && Cn(t, a.eventProperties.call(e[a.pluginName], n));
    }), t;
  },
  modifyOption: function(n, e, t) {
    var a;
    return ms.forEach(function(i) {
      n[i.pluginName] && i.optionListeners && typeof i.optionListeners[e] == "function" && (a = i.optionListeners[e].call(n[i.pluginName], t));
    }), a;
  }
};
function Lv(s) {
  var n = s.sortable, e = s.rootEl, t = s.name, a = s.targetEl, i = s.cloneEl, r = s.toEl, o = s.fromEl, l = s.oldIndex, u = s.newIndex, c = s.oldDraggableIndex, d = s.newDraggableIndex, m = s.originalEvent, h = s.putSortable, f = s.extraEventProperties;
  if (n = n || e && e[Yt], !!n) {
    var p, g = n.options, v = "on" + t.charAt(0).toUpperCase() + t.substr(1);
    window.CustomEvent && !Sn && !ga ? p = new CustomEvent(t, {
      bubbles: !0,
      cancelable: !0
    }) : (p = document.createEvent("Event"), p.initEvent(t, !0, !0)), p.to = r || e, p.from = o || e, p.item = a || e, p.clone = i, p.oldIndex = l, p.newIndex = u, p.oldDraggableIndex = c, p.newDraggableIndex = d, p.originalEvent = m, p.pullMode = h ? h.lastPutMode : void 0;
    var y = pn(pn({}, f), ya.getEventProperties(t, n));
    for (var b in y)
      p[b] = y[b];
    e && e.dispatchEvent(p), g[v] && g[v].call(n, p);
  }
}
var Av = ["evt"], At = function(n, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = t.evt, i = Cv(t, Av);
  ya.pluginEvent.bind(De)(n, e, pn({
    dragEl: se,
    parentEl: dt,
    ghostEl: xe,
    rootEl: tt,
    nextEl: Zn,
    lastDownEl: sr,
    cloneEl: st,
    cloneHidden: Rn,
    dragStarted: $s,
    putSortable: St,
    activeSortable: De.active,
    originalEvent: a,
    oldIndex: ys,
    oldDraggableIndex: Zs,
    newIndex: Ht,
    newDraggableIndex: An,
    hideGhostForTarget: Kd,
    unhideGhostForTarget: Qd,
    cloneNowHidden: function() {
      Rn = !0;
    },
    cloneNowShown: function() {
      Rn = !1;
    },
    dispatchSortableEvent: function(o) {
      It({
        sortable: e,
        name: o,
        originalEvent: a
      });
    }
  }, i));
};
function It(s) {
  Lv(pn({
    putSortable: St,
    cloneEl: st,
    targetEl: se,
    rootEl: tt,
    oldIndex: ys,
    oldDraggableIndex: Zs,
    newIndex: Ht,
    newDraggableIndex: An
  }, s));
}
var se, dt, xe, tt, Zn, sr, st, Rn, ys, Ht, Zs, An, Va, St, vs = !1, gr = !1, yr = [], Kn, Zt, hi, mi, tc, nc, $s, ps, ea, ta = !1, ja = !1, ar, Tt, pi = [], Xi = !1, br = [], Lr = typeof document != "undefined", Wa = Fd, sc = ga || Sn ? "cssFloat" : "float", Rv = Lr && !Yd && !Fd && "draggable" in document.createElement("div"), qd = function() {
  if (Lr) {
    if (Sn)
      return !1;
    var s = document.createElement("x");
    return s.style.cssText = "pointer-events:auto", s.style.pointerEvents === "auto";
  }
}(), Gd = function(n, e) {
  var t = be(n), a = parseInt(t.width) - parseInt(t.paddingLeft) - parseInt(t.paddingRight) - parseInt(t.borderLeftWidth) - parseInt(t.borderRightWidth), i = ks(n, 0, e), r = ks(n, 1, e), o = i && be(i), l = r && be(r), u = o && parseInt(o.marginLeft) + parseInt(o.marginRight) + vt(i).width, c = l && parseInt(l.marginLeft) + parseInt(l.marginRight) + vt(r).width;
  if (t.display === "flex")
    return t.flexDirection === "column" || t.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (t.display === "grid")
    return t.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (i && o.float && o.float !== "none") {
    var d = o.float === "left" ? "left" : "right";
    return r && (l.clear === "both" || l.clear === d) ? "vertical" : "horizontal";
  }
  return i && (o.display === "block" || o.display === "flex" || o.display === "table" || o.display === "grid" || u >= a && t[sc] === "none" || r && t[sc] === "none" && u + c > a) ? "vertical" : "horizontal";
}, Pv = function(n, e, t) {
  var a = t ? n.left : n.top, i = t ? n.right : n.bottom, r = t ? n.width : n.height, o = t ? e.left : e.top, l = t ? e.right : e.bottom, u = t ? e.width : e.height;
  return a === o || i === l || a + r / 2 === o + u / 2;
}, zv = function(n, e) {
  var t;
  return yr.some(function(a) {
    var i = a[Yt].options.emptyInsertThreshold;
    if (!(!i || xo(a))) {
      var r = vt(a), o = n >= r.left - i && n <= r.right + i, l = e >= r.top - i && e <= r.bottom + i;
      if (o && l)
        return t = a;
    }
  }), t;
}, Xd = function(n) {
  function e(i, r) {
    return function(o, l, u, c) {
      var d = o.options.group.name && l.options.group.name && o.options.group.name === l.options.group.name;
      if (i == null && (r || d))
        return !0;
      if (i == null || i === !1)
        return !1;
      if (r && i === "clone")
        return i;
      if (typeof i == "function")
        return e(i(o, l, u, c), r)(o, l, u, c);
      var m = (r ? o : l).options.group.name;
      return i === !0 || typeof i == "string" && i === m || i.join && i.indexOf(m) > -1;
    };
  }
  var t = {}, a = n.group;
  (!a || nr(a) != "object") && (a = {
    name: a
  }), t.name = a.name, t.checkPull = e(a.pull, !0), t.checkPut = e(a.put), t.revertClone = a.revertClone, n.group = t;
}, Kd = function() {
  !qd && xe && be(xe, "display", "none");
}, Qd = function() {
  !qd && xe && be(xe, "display", "");
};
Lr && !Yd && document.addEventListener("click", function(s) {
  if (gr)
    return s.preventDefault(), s.stopPropagation && s.stopPropagation(), s.stopImmediatePropagation && s.stopImmediatePropagation(), gr = !1, !1;
}, !0);
var Qn = function(n) {
  if (se) {
    n = n.touches ? n.touches[0] : n;
    var e = zv(n.clientX, n.clientY);
    if (e) {
      var t = {};
      for (var a in n)
        n.hasOwnProperty(a) && (t[a] = n[a]);
      t.target = t.rootEl = e, t.preventDefault = void 0, t.stopPropagation = void 0, e[Yt]._onDragOver(t);
    }
  }
}, Hv = function(n) {
  se && se.parentNode[Yt]._isOutsideThisEl(n.target);
};
function De(s, n) {
  if (!(s && s.nodeType && s.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(s));
  this.el = s, this.options = n = Cn({}, n), s[Yt] = this;
  var e = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(s.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return Gd(s, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(r, o) {
      r.setData("Text", o.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: De.supportPointer !== !1 && "PointerEvent" in window && !Qs,
    emptyInsertThreshold: 5
  };
  ya.initializePlugins(this, s, e);
  for (var t in e)
    !(t in n) && (n[t] = e[t]);
  Xd(n);
  for (var a in this)
    a.charAt(0) === "_" && typeof this[a] == "function" && (this[a] = this[a].bind(this));
  this.nativeDraggable = n.forceFallback ? !1 : Rv, this.nativeDraggable && (this.options.touchStartThreshold = 1), n.supportPointer ? We(s, "pointerdown", this._onTapStart) : (We(s, "mousedown", this._onTapStart), We(s, "touchstart", this._onTapStart)), this.nativeDraggable && (We(s, "dragover", this), We(s, "dragenter", this)), yr.push(this.el), n.store && n.store.get && this.sort(n.store.get(this) || []), Cn(this, Iv());
}
De.prototype = /** @lends Sortable.prototype */
{
  constructor: De,
  _isOutsideThisEl: function(n) {
    !this.el.contains(n) && n !== this.el && (ps = null);
  },
  _getDirection: function(n, e) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, n, e, se) : this.options.direction;
  },
  _onTapStart: function(n) {
    if (n.cancelable) {
      var e = this, t = this.el, a = this.options, i = a.preventOnFilter, r = n.type, o = n.touches && n.touches[0] || n.pointerType && n.pointerType === "touch" && n, l = (o || n).target, u = n.target.shadowRoot && (n.path && n.path[0] || n.composedPath && n.composedPath()[0]) || l, c = a.filter;
      if ($v(t), !se && !(/mousedown|pointerdown/.test(r) && n.button !== 0 || a.disabled) && !u.isContentEditable && !(!this.nativeDraggable && Qs && l && l.tagName.toUpperCase() === "SELECT") && (l = en(l, a.draggable, t, !1), !(l && l.animated) && sr !== l)) {
        if (ys = Wt(l), Zs = Wt(l, a.draggable), typeof c == "function") {
          if (c.call(this, n, l, this)) {
            It({
              sortable: e,
              rootEl: u,
              name: "filter",
              targetEl: l,
              toEl: t,
              fromEl: t
            }), At("filter", e, {
              evt: n
            }), i && n.cancelable && n.preventDefault();
            return;
          }
        } else if (c && (c = c.split(",").some(function(d) {
          if (d = en(u, d.trim(), t, !1), d)
            return It({
              sortable: e,
              rootEl: d,
              name: "filter",
              targetEl: l,
              fromEl: t,
              toEl: t
            }), At("filter", e, {
              evt: n
            }), !0;
        }), c)) {
          i && n.cancelable && n.preventDefault();
          return;
        }
        a.handle && !en(u, a.handle, t, !1) || this._prepareDragStart(n, o, l);
      }
    }
  },
  _prepareDragStart: function(n, e, t) {
    var a = this, i = a.el, r = a.options, o = i.ownerDocument, l;
    if (t && !se && t.parentNode === i) {
      var u = vt(t);
      if (tt = i, se = t, dt = se.parentNode, Zn = se.nextSibling, sr = t, Va = r.group, De.dragged = se, Kn = {
        target: se,
        clientX: (e || n).clientX,
        clientY: (e || n).clientY
      }, tc = Kn.clientX - u.left, nc = Kn.clientY - u.top, this._lastX = (e || n).clientX, this._lastY = (e || n).clientY, se.style["will-change"] = "all", l = function() {
        if (At("delayEnded", a, {
          evt: n
        }), De.eventCanceled) {
          a._onDrop();
          return;
        }
        a._disableDelayedDragEvents(), !Ql && a.nativeDraggable && (se.draggable = !0), a._triggerDragStart(n, e), It({
          sortable: a,
          name: "choose",
          originalEvent: n
        }), zt(se, r.chosenClass, !0);
      }, r.ignore.split(",").forEach(function(c) {
        Bd(se, c.trim(), fi);
      }), We(o, "dragover", Qn), We(o, "mousemove", Qn), We(o, "touchmove", Qn), We(o, "mouseup", a._onDrop), We(o, "touchend", a._onDrop), We(o, "touchcancel", a._onDrop), Ql && this.nativeDraggable && (this.options.touchStartThreshold = 4, se.draggable = !0), At("delayStart", this, {
        evt: n
      }), r.delay && (!r.delayOnTouchOnly || e) && (!this.nativeDraggable || !(ga || Sn))) {
        if (De.eventCanceled) {
          this._onDrop();
          return;
        }
        We(o, "mouseup", a._disableDelayedDrag), We(o, "touchend", a._disableDelayedDrag), We(o, "touchcancel", a._disableDelayedDrag), We(o, "mousemove", a._delayedDragTouchMoveHandler), We(o, "touchmove", a._delayedDragTouchMoveHandler), r.supportPointer && We(o, "pointermove", a._delayedDragTouchMoveHandler), a._dragStartTimer = setTimeout(l, r.delay);
      } else
        l();
    }
  },
  _delayedDragTouchMoveHandler: function(n) {
    var e = n.touches ? n.touches[0] : n;
    Math.max(Math.abs(e.clientX - this._lastX), Math.abs(e.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    se && fi(se), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var n = this.el.ownerDocument;
    Ye(n, "mouseup", this._disableDelayedDrag), Ye(n, "touchend", this._disableDelayedDrag), Ye(n, "touchcancel", this._disableDelayedDrag), Ye(n, "mousemove", this._delayedDragTouchMoveHandler), Ye(n, "touchmove", this._delayedDragTouchMoveHandler), Ye(n, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(n, e) {
    e = e || n.pointerType == "touch" && n, !this.nativeDraggable || e ? this.options.supportPointer ? We(document, "pointermove", this._onTouchMove) : e ? We(document, "touchmove", this._onTouchMove) : We(document, "mousemove", this._onTouchMove) : (We(se, "dragend", this), We(tt, "dragstart", this._onDragStart));
    try {
      document.selection ? rr(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch (t) {
    }
  },
  _dragStarted: function(n, e) {
    if (vs = !1, tt && se) {
      At("dragStarted", this, {
        evt: e
      }), this.nativeDraggable && We(document, "dragover", Hv);
      var t = this.options;
      !n && zt(se, t.dragClass, !1), zt(se, t.ghostClass, !0), De.active = this, n && this._appendGhost(), It({
        sortable: this,
        name: "start",
        originalEvent: e
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (Zt) {
      this._lastX = Zt.clientX, this._lastY = Zt.clientY, Kd();
      for (var n = document.elementFromPoint(Zt.clientX, Zt.clientY), e = n; n && n.shadowRoot && (n = n.shadowRoot.elementFromPoint(Zt.clientX, Zt.clientY), n !== e); )
        e = n;
      if (se.parentNode[Yt]._isOutsideThisEl(n), e)
        do {
          if (e[Yt]) {
            var t = void 0;
            if (t = e[Yt]._onDragOver({
              clientX: Zt.clientX,
              clientY: Zt.clientY,
              target: n,
              rootEl: e
            }), t && !this.options.dragoverBubble)
              break;
          }
          n = e;
        } while (e = e.parentNode);
      Qd();
    }
  },
  _onTouchMove: function(n) {
    if (Kn) {
      var e = this.options, t = e.fallbackTolerance, a = e.fallbackOffset, i = n.touches ? n.touches[0] : n, r = xe && Cs(xe, !0), o = xe && r && r.a, l = xe && r && r.d, u = Wa && Tt && ec(Tt), c = (i.clientX - Kn.clientX + a.x) / (o || 1) + (u ? u[0] - pi[0] : 0) / (o || 1), d = (i.clientY - Kn.clientY + a.y) / (l || 1) + (u ? u[1] - pi[1] : 0) / (l || 1);
      if (!De.active && !vs) {
        if (t && Math.max(Math.abs(i.clientX - this._lastX), Math.abs(i.clientY - this._lastY)) < t)
          return;
        this._onDragStart(n, !0);
      }
      if (xe) {
        r ? (r.e += c - (hi || 0), r.f += d - (mi || 0)) : r = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: c,
          f: d
        };
        var m = "matrix(".concat(r.a, ",").concat(r.b, ",").concat(r.c, ",").concat(r.d, ",").concat(r.e, ",").concat(r.f, ")");
        be(xe, "webkitTransform", m), be(xe, "mozTransform", m), be(xe, "msTransform", m), be(xe, "transform", m), hi = c, mi = d, Zt = i;
      }
      n.cancelable && n.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!xe) {
      var n = this.options.fallbackOnBody ? document.body : tt, e = vt(se, !0, Wa, !0, n), t = this.options;
      if (Wa) {
        for (Tt = n; be(Tt, "position") === "static" && be(Tt, "transform") === "none" && Tt !== document; )
          Tt = Tt.parentNode;
        Tt !== document.body && Tt !== document.documentElement ? (Tt === document && (Tt = hn()), e.top += Tt.scrollTop, e.left += Tt.scrollLeft) : Tt = hn(), pi = ec(Tt);
      }
      xe = se.cloneNode(!0), zt(xe, t.ghostClass, !1), zt(xe, t.fallbackClass, !0), zt(xe, t.dragClass, !0), be(xe, "transition", ""), be(xe, "transform", ""), be(xe, "box-sizing", "border-box"), be(xe, "margin", 0), be(xe, "top", e.top), be(xe, "left", e.left), be(xe, "width", e.width), be(xe, "height", e.height), be(xe, "opacity", "0.8"), be(xe, "position", Wa ? "absolute" : "fixed"), be(xe, "zIndex", "100000"), be(xe, "pointerEvents", "none"), De.ghost = xe, n.appendChild(xe), be(xe, "transform-origin", tc / parseInt(xe.style.width) * 100 + "% " + nc / parseInt(xe.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(n, e) {
    var t = this, a = n.dataTransfer, i = t.options;
    if (At("dragStart", this, {
      evt: n
    }), De.eventCanceled) {
      this._onDrop();
      return;
    }
    At("setupClone", this), De.eventCanceled || (st = Wd(se), st.removeAttribute("id"), st.draggable = !1, st.style["will-change"] = "", this._hideClone(), zt(st, this.options.chosenClass, !1), De.clone = st), t.cloneId = rr(function() {
      At("clone", t), !De.eventCanceled && (t.options.removeCloneOnHide || tt.insertBefore(st, se), t._hideClone(), It({
        sortable: t,
        name: "clone"
      }));
    }), !e && zt(se, i.dragClass, !0), e ? (gr = !0, t._loopId = setInterval(t._emulateDragOver, 50)) : (Ye(document, "mouseup", t._onDrop), Ye(document, "touchend", t._onDrop), Ye(document, "touchcancel", t._onDrop), a && (a.effectAllowed = "move", i.setData && i.setData.call(t, a, se)), We(document, "drop", t), be(se, "transform", "translateZ(0)")), vs = !0, t._dragStartId = rr(t._dragStarted.bind(t, e, n)), We(document, "selectstart", t), $s = !0, Qs && be(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(n) {
    var e = this.el, t = n.target, a, i, r, o = this.options, l = o.group, u = De.active, c = Va === l, d = o.sort, m = St || u, h, f = this, p = !1;
    if (Xi)
      return;
    function g(z, W) {
      At(z, f, pn({
        evt: n,
        isOwner: c,
        axis: h ? "vertical" : "horizontal",
        revert: r,
        dragRect: a,
        targetRect: i,
        canSort: d,
        fromSortable: m,
        target: t,
        completed: y,
        onMove: function(P, Y) {
          return $a(tt, e, se, a, P, vt(P), n, Y);
        },
        changed: b
      }, W));
    }
    function v() {
      g("dragOverAnimationCapture"), f.captureAnimationState(), f !== m && m.captureAnimationState();
    }
    function y(z) {
      return g("dragOverCompleted", {
        insertion: z
      }), z && (c ? u._hideClone() : u._showClone(f), f !== m && (zt(se, St ? St.options.ghostClass : u.options.ghostClass, !1), zt(se, o.ghostClass, !0)), St !== f && f !== De.active ? St = f : f === De.active && St && (St = null), m === f && (f._ignoreWhileAnimating = t), f.animateAll(function() {
        g("dragOverAnimationComplete"), f._ignoreWhileAnimating = null;
      }), f !== m && (m.animateAll(), m._ignoreWhileAnimating = null)), (t === se && !se.animated || t === e && !t.animated) && (ps = null), !o.dragoverBubble && !n.rootEl && t !== document && (se.parentNode[Yt]._isOutsideThisEl(n.target), !z && Qn(n)), !o.dragoverBubble && n.stopPropagation && n.stopPropagation(), p = !0;
    }
    function b() {
      Ht = Wt(se), An = Wt(se, o.draggable), It({
        sortable: f,
        name: "change",
        toEl: e,
        newIndex: Ht,
        newDraggableIndex: An,
        originalEvent: n
      });
    }
    if (n.preventDefault !== void 0 && n.cancelable && n.preventDefault(), t = en(t, o.draggable, e, !0), g("dragOver"), De.eventCanceled)
      return p;
    if (se.contains(n.target) || t.animated && t.animatingX && t.animatingY || f._ignoreWhileAnimating === t)
      return y(!1);
    if (gr = !1, u && !o.disabled && (c ? d || (r = dt !== tt) : St === this || (this.lastPutMode = Va.checkPull(this, u, se, n)) && l.checkPut(this, u, se, n))) {
      if (h = this._getDirection(n, t) === "vertical", a = vt(se), g("dragOverValid"), De.eventCanceled)
        return p;
      if (r)
        return dt = tt, v(), this._hideClone(), g("revert"), De.eventCanceled || (Zn ? tt.insertBefore(se, Zn) : tt.appendChild(se)), y(!0);
      var D = xo(e, o.draggable);
      if (!D || Bv(n, h, this) && !D.animated) {
        if (D === se)
          return y(!1);
        if (D && e === n.target && (t = D), t && (i = vt(t)), $a(tt, e, se, a, t, i, n, !!t) !== !1)
          return v(), D && D.nextSibling ? e.insertBefore(se, D.nextSibling) : e.appendChild(se), dt = e, b(), y(!0);
      } else if (D && Uv(n, h, this)) {
        var w = ks(e, 0, o, !0);
        if (w === se)
          return y(!1);
        if (t = w, i = vt(t), $a(tt, e, se, a, t, i, n, !1) !== !1)
          return v(), e.insertBefore(se, w), dt = e, b(), y(!0);
      } else if (t.parentNode === e) {
        i = vt(t);
        var C = 0, T, N = se.parentNode !== e, O = !Pv(se.animated && se.toRect || a, t.animated && t.toRect || i, h), L = h ? "top" : "left", H = Zl(t, "top", "top") || Zl(se, "top", "top"), A = H ? H.scrollTop : void 0;
        ps !== t && (T = i[L], ta = !1, ja = !O && o.invertSwap || N), C = Vv(n, t, i, h, O ? 1 : o.swapThreshold, o.invertedSwapThreshold == null ? o.swapThreshold : o.invertedSwapThreshold, ja, ps === t);
        var B;
        if (C !== 0) {
          var I = Wt(se);
          do
            I -= C, B = dt.children[I];
          while (B && (be(B, "display") === "none" || B === xe));
        }
        if (C === 0 || B === t)
          return y(!1);
        ps = t, ea = C;
        var S = t.nextElementSibling, k = !1;
        k = C === 1;
        var R = $a(tt, e, se, a, t, i, n, k);
        if (R !== !1)
          return (R === 1 || R === -1) && (k = R === 1), Xi = !0, setTimeout(Yv, 30), v(), k && !S ? e.appendChild(se) : t.parentNode.insertBefore(se, k ? S : t), H && jd(H, 0, A - H.scrollTop), dt = se.parentNode, T !== void 0 && !ja && (ar = Math.abs(T - vt(t)[L])), b(), y(!0);
      }
      if (e.contains(se))
        return y(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    Ye(document, "mousemove", this._onTouchMove), Ye(document, "touchmove", this._onTouchMove), Ye(document, "pointermove", this._onTouchMove), Ye(document, "dragover", Qn), Ye(document, "mousemove", Qn), Ye(document, "touchmove", Qn);
  },
  _offUpEvents: function() {
    var n = this.el.ownerDocument;
    Ye(n, "mouseup", this._onDrop), Ye(n, "touchend", this._onDrop), Ye(n, "pointerup", this._onDrop), Ye(n, "touchcancel", this._onDrop), Ye(document, "selectstart", this);
  },
  _onDrop: function(n) {
    var e = this.el, t = this.options;
    if (Ht = Wt(se), An = Wt(se, t.draggable), At("drop", this, {
      evt: n
    }), dt = se && se.parentNode, Ht = Wt(se), An = Wt(se, t.draggable), De.eventCanceled) {
      this._nulling();
      return;
    }
    vs = !1, ja = !1, ta = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), Ki(this.cloneId), Ki(this._dragStartId), this.nativeDraggable && (Ye(document, "drop", this), Ye(e, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), Qs && be(document.body, "user-select", ""), be(se, "transform", ""), n && ($s && (n.cancelable && n.preventDefault(), !t.dropBubble && n.stopPropagation()), xe && xe.parentNode && xe.parentNode.removeChild(xe), (tt === dt || St && St.lastPutMode !== "clone") && st && st.parentNode && st.parentNode.removeChild(st), se && (this.nativeDraggable && Ye(se, "dragend", this), fi(se), se.style["will-change"] = "", $s && !vs && zt(se, St ? St.options.ghostClass : this.options.ghostClass, !1), zt(se, this.options.chosenClass, !1), It({
      sortable: this,
      name: "unchoose",
      toEl: dt,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: n
    }), tt !== dt ? (Ht >= 0 && (It({
      rootEl: dt,
      name: "add",
      toEl: dt,
      fromEl: tt,
      originalEvent: n
    }), It({
      sortable: this,
      name: "remove",
      toEl: dt,
      originalEvent: n
    }), It({
      rootEl: dt,
      name: "sort",
      toEl: dt,
      fromEl: tt,
      originalEvent: n
    }), It({
      sortable: this,
      name: "sort",
      toEl: dt,
      originalEvent: n
    })), St && St.save()) : Ht !== ys && Ht >= 0 && (It({
      sortable: this,
      name: "update",
      toEl: dt,
      originalEvent: n
    }), It({
      sortable: this,
      name: "sort",
      toEl: dt,
      originalEvent: n
    })), De.active && ((Ht == null || Ht === -1) && (Ht = ys, An = Zs), It({
      sortable: this,
      name: "end",
      toEl: dt,
      originalEvent: n
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    At("nulling", this), tt = se = dt = xe = Zn = st = sr = Rn = Kn = Zt = $s = Ht = An = ys = Zs = ps = ea = St = Va = De.dragged = De.ghost = De.clone = De.active = null, br.forEach(function(n) {
      n.checked = !0;
    }), br.length = hi = mi = 0;
  },
  handleEvent: function(n) {
    switch (n.type) {
      case "drop":
      case "dragend":
        this._onDrop(n);
        break;
      case "dragenter":
      case "dragover":
        se && (this._onDragOver(n), Fv(n));
        break;
      case "selectstart":
        n.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var n = [], e, t = this.el.children, a = 0, i = t.length, r = this.options; a < i; a++)
      e = t[a], en(e, r.draggable, this.el, !1) && n.push(e.getAttribute(r.dataIdAttr) || Wv(e));
    return n;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(n, e) {
    var t = {}, a = this.el;
    this.toArray().forEach(function(i, r) {
      var o = a.children[r];
      en(o, this.options.draggable, a, !1) && (t[i] = o);
    }, this), e && this.captureAnimationState(), n.forEach(function(i) {
      t[i] && (a.removeChild(t[i]), a.appendChild(t[i]));
    }), e && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var n = this.options.store;
    n && n.set && n.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(n, e) {
    return en(n, e || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(n, e) {
    var t = this.options;
    if (e === void 0)
      return t[n];
    var a = ya.modifyOption(this, n, e);
    typeof a != "undefined" ? t[n] = a : t[n] = e, n === "group" && Xd(t);
  },
  /**
   * Destroy
   */
  destroy: function() {
    At("destroy", this);
    var n = this.el;
    n[Yt] = null, Ye(n, "mousedown", this._onTapStart), Ye(n, "touchstart", this._onTapStart), Ye(n, "pointerdown", this._onTapStart), this.nativeDraggable && (Ye(n, "dragover", this), Ye(n, "dragenter", this)), Array.prototype.forEach.call(n.querySelectorAll("[draggable]"), function(e) {
      e.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), yr.splice(yr.indexOf(this.el), 1), this.el = n = null;
  },
  _hideClone: function() {
    if (!Rn) {
      if (At("hideClone", this), De.eventCanceled)
        return;
      be(st, "display", "none"), this.options.removeCloneOnHide && st.parentNode && st.parentNode.removeChild(st), Rn = !0;
    }
  },
  _showClone: function(n) {
    if (n.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Rn) {
      if (At("showClone", this), De.eventCanceled)
        return;
      se.parentNode == tt && !this.options.group.revertClone ? tt.insertBefore(st, se) : Zn ? tt.insertBefore(st, Zn) : tt.appendChild(st), this.options.group.revertClone && this.animate(se, st), be(st, "display", ""), Rn = !1;
    }
  }
};
function Fv(s) {
  s.dataTransfer && (s.dataTransfer.dropEffect = "move"), s.cancelable && s.preventDefault();
}
function $a(s, n, e, t, a, i, r, o) {
  var l, u = s[Yt], c = u.options.onMove, d;
  return window.CustomEvent && !Sn && !ga ? l = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (l = document.createEvent("Event"), l.initEvent("move", !0, !0)), l.to = n, l.from = s, l.dragged = e, l.draggedRect = t, l.related = a || n, l.relatedRect = i || vt(n), l.willInsertAfter = o, l.originalEvent = r, s.dispatchEvent(l), c && (d = c.call(u, l, r)), d;
}
function fi(s) {
  s.draggable = !1;
}
function Yv() {
  Xi = !1;
}
function Uv(s, n, e) {
  var t = vt(ks(e.el, 0, e.options, !0)), a = $d(e.el, e.options, xe), i = 10;
  return n ? s.clientX < a.left - i || s.clientY < t.top && s.clientX < t.right : s.clientY < a.top - i || s.clientY < t.bottom && s.clientX < t.left;
}
function Bv(s, n, e) {
  var t = vt(xo(e.el, e.options.draggable)), a = $d(e.el, e.options, xe), i = 10;
  return n ? s.clientX > a.right + i || s.clientY > t.bottom && s.clientX > t.left : s.clientY > a.bottom + i || s.clientX > t.right && s.clientY > t.top;
}
function Vv(s, n, e, t, a, i, r, o) {
  var l = t ? s.clientY : s.clientX, u = t ? e.height : e.width, c = t ? e.top : e.left, d = t ? e.bottom : e.right, m = !1;
  if (!r) {
    if (o && ar < u * a) {
      if (!ta && (ea === 1 ? l > c + u * i / 2 : l < d - u * i / 2) && (ta = !0), ta)
        m = !0;
      else if (ea === 1 ? l < c + ar : l > d - ar)
        return -ea;
    } else if (l > c + u * (1 - a) / 2 && l < d - u * (1 - a) / 2)
      return jv(n);
  }
  return m = m || r, m && (l < c + u * i / 2 || l > d - u * i / 2) ? l > c + u / 2 ? 1 : -1 : 0;
}
function jv(s) {
  return Wt(se) < Wt(s) ? 1 : -1;
}
function Wv(s) {
  for (var n = s.tagName + s.className + s.src + s.href + s.textContent, e = n.length, t = 0; e--; )
    t += n.charCodeAt(e);
  return t.toString(36);
}
function $v(s) {
  br.length = 0;
  for (var n = s.getElementsByTagName("input"), e = n.length; e--; ) {
    var t = n[e];
    t.checked && br.push(t);
  }
}
function rr(s) {
  return setTimeout(s, 0);
}
function Ki(s) {
  return clearTimeout(s);
}
Lr && We(document, "touchmove", function(s) {
  (De.active || vs) && s.cancelable && s.preventDefault();
});
De.utils = {
  on: We,
  off: Ye,
  css: be,
  find: Bd,
  is: function(n, e) {
    return !!en(n, e, n, !1);
  },
  extend: kv,
  throttle: Vd,
  closest: en,
  toggleClass: zt,
  clone: Wd,
  index: Wt,
  nextTick: rr,
  cancelNextTick: Ki,
  detectDirection: Gd,
  getChild: ks
};
De.get = function(s) {
  return s[Yt];
};
De.mount = function() {
  for (var s = arguments.length, n = new Array(s), e = 0; e < s; e++)
    n[e] = arguments[e];
  n[0].constructor === Array && (n = n[0]), n.forEach(function(t) {
    if (!t.prototype || !t.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(t));
    t.utils && (De.utils = pn(pn({}, De.utils), t.utils)), ya.mount(t);
  });
};
De.create = function(s, n) {
  return new De(s, n);
};
De.version = Sv;
var ft = [], qs, Qi, Ji = !1, _i, vi, Dr, Gs;
function qv() {
  function s() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var n in this)
      n.charAt(0) === "_" && typeof this[n] == "function" && (this[n] = this[n].bind(this));
  }
  return s.prototype = {
    dragStarted: function(e) {
      var t = e.originalEvent;
      this.sortable.nativeDraggable ? We(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? We(document, "pointermove", this._handleFallbackAutoScroll) : t.touches ? We(document, "touchmove", this._handleFallbackAutoScroll) : We(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(e) {
      var t = e.originalEvent;
      !this.options.dragOverBubble && !t.rootEl && this._handleAutoScroll(t);
    },
    drop: function() {
      this.sortable.nativeDraggable ? Ye(document, "dragover", this._handleAutoScroll) : (Ye(document, "pointermove", this._handleFallbackAutoScroll), Ye(document, "touchmove", this._handleFallbackAutoScroll), Ye(document, "mousemove", this._handleFallbackAutoScroll)), ac(), ir(), Mv();
    },
    nulling: function() {
      Dr = Qi = qs = Ji = Gs = _i = vi = null, ft.length = 0;
    },
    _handleFallbackAutoScroll: function(e) {
      this._handleAutoScroll(e, !0);
    },
    _handleAutoScroll: function(e, t) {
      var a = this, i = (e.touches ? e.touches[0] : e).clientX, r = (e.touches ? e.touches[0] : e).clientY, o = document.elementFromPoint(i, r);
      if (Dr = e, t || this.options.forceAutoScrollFallback || ga || Sn || Qs) {
        gi(e, this.options, o, t);
        var l = Hn(o, !0);
        Ji && (!Gs || i !== _i || r !== vi) && (Gs && ac(), Gs = setInterval(function() {
          var u = Hn(document.elementFromPoint(i, r), !0);
          u !== l && (l = u, ir()), gi(e, a.options, u, t);
        }, 10), _i = i, vi = r);
      } else {
        if (!this.options.bubbleScroll || Hn(o, !0) === hn()) {
          ir();
          return;
        }
        gi(e, this.options, Hn(o, !1), !1);
      }
    }
  }, Cn(s, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function ir() {
  ft.forEach(function(s) {
    clearInterval(s.pid);
  }), ft = [];
}
function ac() {
  clearInterval(Gs);
}
var gi = Vd(function(s, n, e, t) {
  if (n.scroll) {
    var a = (s.touches ? s.touches[0] : s).clientX, i = (s.touches ? s.touches[0] : s).clientY, r = n.scrollSensitivity, o = n.scrollSpeed, l = hn(), u = !1, c;
    Qi !== e && (Qi = e, ir(), qs = n.scroll, c = n.scrollFn, qs === !0 && (qs = Hn(e, !0)));
    var d = 0, m = qs;
    do {
      var h = m, f = vt(h), p = f.top, g = f.bottom, v = f.left, y = f.right, b = f.width, D = f.height, w = void 0, C = void 0, T = h.scrollWidth, N = h.scrollHeight, O = be(h), L = h.scrollLeft, H = h.scrollTop;
      h === l ? (w = b < T && (O.overflowX === "auto" || O.overflowX === "scroll" || O.overflowX === "visible"), C = D < N && (O.overflowY === "auto" || O.overflowY === "scroll" || O.overflowY === "visible")) : (w = b < T && (O.overflowX === "auto" || O.overflowX === "scroll"), C = D < N && (O.overflowY === "auto" || O.overflowY === "scroll"));
      var A = w && (Math.abs(y - a) <= r && L + b < T) - (Math.abs(v - a) <= r && !!L), B = C && (Math.abs(g - i) <= r && H + D < N) - (Math.abs(p - i) <= r && !!H);
      if (!ft[d])
        for (var I = 0; I <= d; I++)
          ft[I] || (ft[I] = {});
      (ft[d].vx != A || ft[d].vy != B || ft[d].el !== h) && (ft[d].el = h, ft[d].vx = A, ft[d].vy = B, clearInterval(ft[d].pid), (A != 0 || B != 0) && (u = !0, ft[d].pid = setInterval(function() {
        t && this.layer === 0 && De.active._onTouchMove(Dr);
        var S = ft[this.layer].vy ? ft[this.layer].vy * o : 0, k = ft[this.layer].vx ? ft[this.layer].vx * o : 0;
        typeof c == "function" && c.call(De.dragged.parentNode[Yt], k, S, s, Dr, ft[this.layer].el) !== "continue" || jd(ft[this.layer].el, k, S);
      }.bind({
        layer: d
      }), 24))), d++;
    } while (n.bubbleScroll && m !== l && (m = Hn(m, !1)));
    Ji = u;
  }
}, 30), Jd = function(n) {
  var e = n.originalEvent, t = n.putSortable, a = n.dragEl, i = n.activeSortable, r = n.dispatchSortableEvent, o = n.hideGhostForTarget, l = n.unhideGhostForTarget;
  if (e) {
    var u = t || i;
    o();
    var c = e.changedTouches && e.changedTouches.length ? e.changedTouches[0] : e, d = document.elementFromPoint(c.clientX, c.clientY);
    l(), u && !u.el.contains(d) && (r("spill"), this.onSpill({
      dragEl: a,
      putSortable: t
    }));
  }
};
function Co() {
}
Co.prototype = {
  startIndex: null,
  dragStart: function(n) {
    var e = n.oldDraggableIndex;
    this.startIndex = e;
  },
  onSpill: function(n) {
    var e = n.dragEl, t = n.putSortable;
    this.sortable.captureAnimationState(), t && t.captureAnimationState();
    var a = ks(this.sortable.el, this.startIndex, this.options);
    a ? this.sortable.el.insertBefore(e, a) : this.sortable.el.appendChild(e), this.sortable.animateAll(), t && t.animateAll();
  },
  drop: Jd
};
Cn(Co, {
  pluginName: "revertOnSpill"
});
function So() {
}
So.prototype = {
  onSpill: function(n) {
    var e = n.dragEl, t = n.putSortable, a = t || this.sortable;
    a.captureAnimationState(), e.parentNode && e.parentNode.removeChild(e), a.animateAll();
  },
  drop: Jd
};
Cn(So, {
  pluginName: "removeOnSpill"
});
De.mount(new qv());
De.mount(So, Co);
const Gv = { class: "mbsc-resource-manage-button-wrapper" }, Xv = {
  id: "custom-resource-manage-popup",
  class: "mbsc-smeetzz mbsc-resource-manage-popup-wrapper"
}, Kv = { class: "mbsc-resource-manage-popup-header-wrapper" }, Qv = { class: "mbsc-resource-manage-popup-header-sorting-wrapper" }, Jv = /* @__PURE__ */ ae("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "36px",
  viewBox: "0 -960 960 960",
  width: "36px",
  class: "mbsc-resource-manage-popup-inline"
}, [
  /* @__PURE__ */ ae("path", { d: "m280-400 200-200 200 200H280Z" })
], -1), Zv = [
  Jv
], eg = /* @__PURE__ */ ae("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "36px",
  viewBox: "0 -960 960 960",
  width: "36px",
  class: "mbsc-resource-manage-popup-inline"
}, [
  /* @__PURE__ */ ae("path", { d: "M480-360 280-560h400L480-360Z" })
], -1), tg = [
  eg
], ng = { class: "items-sort" }, sg = { class: "mbsc-resource-manage-content-wrapper" }, ag = ["src"], rg = { class: "mbsc-smeetzz mbsc-resource-manage-content-middle" }, ig = {
  __name: "ResourceManagePopup",
  emits: ["resource-sorting:changed"],
  setup(s, { emit: n }) {
    const e = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjNWY2MzY4Ij48cGF0aCBkPSJNMzYwLTE2MHEtMzMgMC01Ni41LTIzLjVUMjgwLTI0MHEwLTMzIDIzLjUtNTYuNVQzNjAtMzIwcTMzIDAgNTYuNSAyMy41VDQ0MC0yNDBxMCAzMy0yMy41IDU2LjVUMzYwLTE2MFptMjQwIDBxLTMzIDAtNTYuNS0yMy41VDUyMC0yNDBxMC0zMyAyMy41LTU2LjVUNjAwLTMyMHEzMyAwIDU2LjUgMjMuNVQ2ODAtMjQwcTAgMzMtMjMuNSA1Ni41VDYwMC0xNjBaTTM2MC00MDBxLTMzIDAtNTYuNS0yMy41VDI4MC00ODBxMC0zMyAyMy41LTU2LjVUMzYwLTU2MHEzMyAwIDU2LjUgMjMuNVQ0NDAtNDgwcTAgMzMtMjMuNSA1Ni41VDM2MC00MDBabTI0MCAwcS0zMyAwLTU2LjUtMjMuNVQ1MjAtNDgwcTAtMzMgMjMuNS01Ni41VDYwMC01NjBxMzMgMCA1Ni41IDIzLjVUNjgwLTQ4MHEwIDMzLTIzLjUgNTYuNVQ2MDAtNDAwWk0zNjAtNjQwcS0zMyAwLTU2LjUtMjMuNVQyODAtNzIwcTAtMzMgMjMuNS01Ni41VDM2MC04MDBxMzMgMCA1Ni41IDIzLjVUNDQwLTcyMHEwIDMzLTIzLjUgNTYuNVQzNjAtNjQwWm0yNDAgMHEtMzMgMC01Ni41LTIzLjVUNTIwLTcyMHEwLTMzIDIzLjUtNTYuNVQ2MDAtODAwcTMzIDAgNTYuNSAyMy41VDY4MC03MjBxMCAzMy0yMy41IDU2LjVUNjAwLTY0MFoiLz48L3N2Zz4=", self.location).href, t = n;
    let a, i = ln({ type: "", list: [] });
    const r = () => {
      a = zd("#custom-resource-manage-popup", {
        theme: "smeetzz",
        display: "anchored",
        closeOnOverlayClick: !1
      });
    }, o = (m) => Re(this, null, function* () {
      a.setOptions({ anchor: m.target }), i.value.list = x.getters.getResources.value.map(
        (h) => ({ name: h.name, id: h.id })
      ), yield a.open(), l();
    }), l = () => {
      const m = document.querySelector(".items-sort");
      m && De.create(m, {
        animation: 150,
        setData: (h, f) => {
          h.setData("Text", f.textContent);
        },
        onEnd: ({ newIndex: h, oldIndex: f }) => {
          const p = i.value.list[f];
          i.value.type = Nt.custom, i.value.list.splice(f, 1), i.value.list.splice(h, 0, p);
        }
      });
    }, u = (m) => {
      i.value.type = m, (m === Nt.ascending || m === Nt.descending) && (i.value.list = Bc(i.value.list, m));
    }, c = () => {
      var m, h;
      i.value.type = ((h = (m = x.state.sorting) == null ? void 0 : m.resource) == null ? void 0 : h.type) || Nt.custom, a.close();
    }, d = () => {
      let m = [];
      i.value.type === Nt.custom && (m = i.value.list.map((f) => f.id));
      const h = { type: i.value.type, list: m };
      t("resource-sorting:changed", { resource: h }), a.close();
    };
    return fn(() => {
      var m, h;
      i.value.type = ((h = (m = x.state.sorting) == null ? void 0 : m.resource) == null ? void 0 : h.type) || Nt.custom, r();
    }), (m, h) => (Me(), gt(yi, null, [
      ae("div", Gv, [
        ae("button", {
          "mbsc-button": "",
          class: "mbsc-smeetzz mbsc-resource-manage-button-size",
          onClick: o
        }, Ge(Q(x).state.locale["manage-resource-positions"]), 1)
      ]),
      ae("div", Xv, [
        ae("div", Kv, [
          ae("button", {
            "mbsc-button": "",
            "data-variant": "flat",
            class: "mbsc-smeetzz mbsc-resource-manage-popup-header-button",
            onClick: c
          }, Ge(Q(x).state.locale.cancel), 1),
          ae("div", Qv, [
            ae("span", {
              class: na([
                "mbsc-resource-manage-popup-cursor",
                {
                  "mbsc-resource-manage-popup-enabled": Q(i).type === Q(Nt).ascending
                }
              ]),
              onClick: h[0] || (h[0] = (f) => u(Q(Nt).ascending))
            }, Zv, 2),
            ae("span", {
              class: na([
                "mbsc-resource-manage-popup-cursor",
                {
                  "mbsc-resource-manage-popup-enabled": Q(i).type === Q(Nt).descending
                }
              ]),
              onClick: h[1] || (h[1] = (f) => u(Q(Nt).descending))
            }, tg, 2)
          ]),
          ae("button", {
            "mbsc-button": "",
            "data-variant": "flat",
            class: "mbsc-smeetzz mbsc-resource-manage-popup-header-button",
            onClick: d
          }, Ge(Q(x).state.locale.save), 1)
        ]),
        ae("div", ng, [
          (Me(!0), gt(yi, null, ic(Q(i).list, (f) => (Me(), gt("div", {
            key: f.id
          }, [
            ae("div", sg, [
              ae("img", {
                src: Q(e),
                class: "mbsc-resource-manage-popup-inline mbsc-resource-manage-content-middle"
              }, null, 8, ag),
              ae("span", rg, Ge(f.name), 1)
            ])
          ]))), 128))
        ])
      ])
    ], 64));
  }
};
const og = (s, n) => {
  const e = s.__vccOpts || s;
  for (const [t, a] of n)
    e[t] = a;
  return e;
}, lg = { class: "mbsc-smeetzz mbsc-ios mbsc-ltr mbsc-form-control-wrapper mbsc-textfield-wrapper mbsc-font mbsc-textfield-wrapper-box mbsc-textfield-wrapper-stacked" }, cg = { class: "mbsc-smeetzz mbsc-ios mbsc-ltr mbsc-label mbsc-label-stacked mbsc-label-box-stacked" }, dg = { class: "mbsc-smeetzz mbsc-ios mbsc-ltr mbsc-textfield-inner mbsc-textfield-inner-box mbsc-textfield-inner-stacked" }, ug = { class: "mbsc-smeetzz mbsc-ios mbsc-ltr mbsc-textfield mbsc-textfield-box mbsc-textfield-stacked mbsc-textfield-box-stacked" }, hg = { class: "mbsc-color-picker-input-container" }, mg = ["value"], pg = "#30aabc", fg = {
  __name: "ColorPicker",
  props: {
    color: {
      type: String,
      default: "#30aabc"
    },
    label: String
  },
  emits: ["color-picker:changed"],
  setup(s, { emit: n }) {
    const e = s, t = n, a = ln(""), i = (l) => {
      a.value = l, t("color-picker:changed", { value: l });
    };
    fn(() => {
      a.value = e.color;
    });
    const r = () => {
      /^#([0-9A-Fa-f]{6})$/.test(a.value) && t("color-picker:changed", { value: a.value });
    }, o = () => {
      /^#([0-9A-Fa-f]{6})$/.test(a.value) || (a.value = e.color);
    };
    return (l, u) => (Me(), gt("div", lg, [
      ae("span", cg, Ge(e.label), 1),
      ae("span", dg, [
        ae("div", ug, [
          ae("div", hg, [
            oc(ae("input", {
              "onUpdate:modelValue": u[0] || (u[0] = (c) => a.value = c),
              onInput: r,
              onBlur: o,
              type: "text",
              class: "mbsc-color-picker-color-input"
            }, null, 544), [
              [cu, a.value]
            ]),
            ae("input", {
              type: "color",
              value: e.color,
              onInput: u[1] || (u[1] = (c) => {
                var d;
                return i(((d = c == null ? void 0 : c.target) == null ? void 0 : d.value) || pg);
              }),
              class: "mbsc-color-picker-color-input-picker"
            }, null, 40, mg)
          ])
        ])
      ])
    ]));
  }
}, rc = /* @__PURE__ */ og(fg, [["__scopeId", "data-v-8bbef049"]]);
const _g = { class: "mbsc-configs-sidebar mbsc-flex-none" }, vg = { class: "mbsc-configs-sidebar-header" }, gg = { class: "mbsc-configs-sidebar-title" }, yg = ["src"], bg = { class: "mbsc-configs-button-wrapper" }, Dg = {
  __name: "SettingsSidebar",
  emits: ["settings:changed"],
  setup(s, { emit: n }) {
    const e = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgNi40MUwxNy41OSA1IDEyIDEwLjU5IDYuNDEgNSA1IDYuNDEgMTAuNTkgMTIgNSAxNy41OSA2LjQxIDE5IDEyIDEzLjQxIDE3LjU5IDE5IDE5IDE3LjU5IDEzLjQxIDEyeiIvPjxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz48L3N2Zz4=", self.location).href, t = n, a = ln(!1);
    let i = ln({}), r = ln({}), o = ln([]);
    const l = (m, h) => {
      i.value[h] = m.value;
    }, u = (m) => {
      x.methods.setSorting(ge(ge({}, x.state.sorting), m)), t("settings:changed");
    }, c = () => {
      x.methods.toggleShowSettings(!1);
    }, d = () => {
      x.methods.setSettings(ge({}, i.value)), t("settings:changed");
    };
    return fn(() => {
      r.value = Nm[x.state.calendarType] || {};
      const m = Am(), h = m.filter(
        (f) => f.value < 120
      );
      o.value = x.state.calendarType === Qe.dailyCountInside ? h : m, i.value = ge({}, x.getters.getCalendarSettings.value), a.value = !0;
    }), (m, h) => (Me(), gt("div", _g, [
      ae("div", vg, [
        ae("span", gg, Ge(Q(x).state.locale.settings), 1),
        ae("img", {
          src: Q(e),
          class: "mbsc-configs-sidebar-header-close",
          onClick: c
        }, null, 8, yg)
      ]),
      Zi(ig, { "onResourceSorting:changed": u }),
      a.value && Q(r).scanColor ? (Me(), _t(rc, {
        key: 0,
        label: Q(x).state.locale["color-partially-scanned-bookings"],
        color: Q(i).scanColor,
        "onColorPicker:changed": h[0] || (h[0] = (f) => l(f, "scanColor"))
      }, null, 8, ["label", "color"])) : mt("", !0),
      a.value && Q(r).fullScanColor ? (Me(), _t(rc, {
        key: 1,
        label: Q(x).state.locale["color-fully-scanned-bookings"],
        color: Q(i).fullScanColor,
        "onColorPicker:changed": h[1] || (h[1] = (f) => l(f, "fullScanColor"))
      }, null, 8, ["label", "color"])) : mt("", !0),
      a.value && Q(r).cardTitle ? (Me(), _t(Ln, {
        key: 2,
        elId: "select-card-title",
        label: Q(x).state.locale.title,
        value: Q(i).cardTitle,
        list: Q(Hs)(),
        onChange: h[2] || (h[2] = (f) => l(f, "cardTitle"))
      }, null, 8, ["label", "value", "list"])) : mt("", !0),
      a.value && Q(r).cardSubtitle1 ? (Me(), _t(Ln, {
        key: 3,
        elId: "select-card-subtitle-1",
        label: `${Q(x).state.locale.subtitle} 1`,
        value: Q(i).cardSubtitle1,
        list: Q(Hs)(),
        onChange: h[3] || (h[3] = (f) => l(f, "cardSubtitle1"))
      }, null, 8, ["label", "value", "list"])) : mt("", !0),
      a.value && Q(r).cardSubtitle2 ? (Me(), _t(Ln, {
        key: 4,
        elId: "select-card-subtitle-2",
        label: `${Q(x).state.locale.subtitle} 2`,
        value: Q(i).cardSubtitle2,
        list: Q(Hs)(),
        onChange: h[4] || (h[4] = (f) => l(f, "cardSubtitle2"))
      }, null, 8, ["label", "value", "list"])) : mt("", !0),
      a.value && Q(r).cardSubtitle3 ? (Me(), _t(Ln, {
        key: 5,
        elId: "select-card-subtitle-3",
        label: `${Q(x).state.locale.subtitle} 3`,
        value: Q(i).cardSubtitle3,
        list: Q(Hs)(),
        onChange: h[5] || (h[5] = (f) => l(f, "cardSubtitle3"))
      }, null, 8, ["label", "value", "list"])) : mt("", !0),
      a.value && Q(r).cardSubtitle4 ? (Me(), _t(Ln, {
        key: 6,
        elId: "select-card-subtitle-4",
        label: `${Q(x).state.locale.subtitle} 4`,
        value: Q(i).cardSubtitle4,
        list: Q(Hs)(),
        onChange: h[6] || (h[6] = (f) => l(f, "cardSubtitle4"))
      }, null, 8, ["label", "value", "list"])) : mt("", !0),
      a.value && Q(r).timeCellStep ? (Me(), _t(Ln, {
        key: 7,
        elId: "select-time-cell-step",
        label: Q(x).state.locale["time-scale"],
        value: Q(i).timeCellStep,
        list: Q(o),
        onChange: h[7] || (h[7] = (f) => l(f, "timeCellStep"))
      }, null, 8, ["label", "value", "list"])) : mt("", !0),
      a.value && Q(r).startTime && Q(r).endTime ? (Me(), _t(Dv, {
        key: 8,
        elStartId: "start-time",
        elEndId: "end-time",
        startTime: Q(i).startTime,
        endTime: Q(i).endTime,
        "onStartTime:changed": h[8] || (h[8] = (f) => l(f, "startTime")),
        "onEndTime:changed": h[9] || (h[9] = (f) => l(f, "endTime"))
      }, null, 8, ["startTime", "endTime"])) : mt("", !0),
      ae("div", bg, [
        ae("button", {
          "mbsc-button": "",
          "data-variant": "outline",
          class: "mbsc-smeetzz",
          onClick: d
        }, Ge(Q(x).state.locale.save), 1)
      ])
    ]));
  }
};
const wg = {
  __name: "SmeetzCalendar",
  emits: [
    "edit-button:clicked",
    "filter:changed",
    "settings:changed",
    "calendar-type:changed"
  ],
  setup(s, { emit: n }) {
    const e = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiMyNjc0N2IiPjxwYXRoIGQ9Ik0yMDAtODBxLTMzIDAtNTYuNS0yMy41VDEyMC0xNjB2LTU2MHEwLTMzIDIzLjUtNTYuNVQyMDAtODAwaDQwdi04MGg4MHY4MGgzMjB2LTgwaDgwdjgwaDQwcTMzIDAgNTYuNSAyMy41VDg0MC03MjB2NTYwcTAgMzMtMjMuNSA1Ni41VDc2MC04MEgyMDBabTAtODBoNTYwdi00MDBIMjAwdjQwMFptMC00ODBoNTYwdi04MEgyMDB2ODBabTAgMHYtODAgODBabTI4MCAyNDBxLTE3IDAtMjguNS0xMS41VDQ0MC00NDBxMC0xNyAxMS41LTI4LjVUNDgwLTQ4MHExNyAwIDI4LjUgMTEuNVQ1MjAtNDQwcTAgMTctMTEuNSAyOC41VDQ4MC00MDBabS0xNjAgMHEtMTcgMC0yOC41LTExLjVUMjgwLTQ0MHEwLTE3IDExLjUtMjguNVQzMjAtNDgwcTE3IDAgMjguNSAxMS41VDM2MC00NDBxMCAxNy0xMS41IDI4LjVUMzIwLTQwMFptMzIwIDBxLTE3IDAtMjguNS0xMS41VDYwMC00NDBxMC0xNyAxMS41LTI4LjVUNjQwLTQ4MHExNyAwIDI4LjUgMTEuNVQ2ODAtNDQwcTAgMTctMTEuNSAyOC41VDY0MC00MDBaTTQ4MC0yNDBxLTE3IDAtMjguNS0xMS41VDQ0MC0yODBxMC0xNyAxMS41LTI4LjVUNDgwLTMyMHExNyAwIDI4LjUgMTEuNVQ1MjAtMjgwcTAgMTctMTEuNSAyOC41VDQ4MC0yNDBabS0xNjAgMHEtMTcgMC0yOC41LTExLjVUMjgwLTI4MHEwLTE3IDExLjUtMjguNVQzMjAtMzIwcTE3IDAgMjguNSAxMS41VDM2MC0yODBxMCAxNy0xMS41IDI4LjVUMzIwLTI0MFptMzIwIDBxLTE3IDAtMjguNS0xMS41VDYwMC0yODBxMC0xNyAxMS41LTI4LjVUNjQwLTMyMHExNyAwIDI4LjUgMTEuNVQ2ODAtMjgwcTAgMTctMTEuNSAyOC41VDY0MC0yNDBaIi8+PC9zdmc+", self.location).href, t = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiMyNjc0N2IiPjxwYXRoIGQ9Ik0yMDAtMjgwcS0zMyAwLTU2LjUtMjMuNVQxMjAtMzYwdi0yNDBxMC0zMyAyMy41LTU2LjVUMjAwLTY4MGg1NjBxMzMgMCA1Ni41IDIzLjVUODQwLTYwMHYyNDBxMCAzMy0yMy41IDU2LjVUNzYwLTI4MEgyMDBabTAtODBoNTYwdi0yNDBIMjAwdjI0MFptLTgwLTQwMHYtODBoNzIwdjgwSDEyMFptMCA2NDB2LTgwaDcyMHY4MEgxMjBabTgwLTQ4MHYyNDAtMjQwWiIvPjwvc3ZnPg==", self.location).href, a = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiMyNjc0N2IiPjxwYXRoIGQ9Ik00NDAtMTYwcS0xNyAwLTI4LjUtMTEuNVQ0MDAtMjAwdi0yNDBMMTY4LTczNnEtMTUtMjAtNC41LTQydDM2LjUtMjJoNTYwcTI2IDAgMzYuNSAyMnQtNC41IDQyTDU2MC00NDB2MjQwcTAgMTctMTEuNSAyOC41VDUyMC0xNjBoLTgwWm00MC0zMDggMTk4LTI1MkgyODJsMTk4IDI1MlptMCAwWiIvPjwvc3ZnPg==", self.location).href, i = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiMyNjc0N2IiPjxwYXRoIGQ9Im0zNzAtODAtMTYtMTI4cS0xMy01LTI0LjUtMTJUMzA3LTIzNWwtMTE5IDUwTDc4LTM3NWwxMDMtNzhxLTEtNy0xLTEzLjV2LTI3cTAtNi41IDEtMTMuNUw3OC01ODVsMTEwLTE5MCAxMTkgNTBxMTEtOCAyMy0xNXQyNC0xMmwxNi0xMjhoMjIwbDE2IDEyOHExMyA1IDI0LjUgMTJ0MjIuNSAxNWwxMTktNTAgMTEwIDE5MC0xMDMgNzhxMSA3IDEgMTMuNXYyN3EwIDYuNS0yIDEzLjVsMTAzIDc4LTExMCAxOTAtMTE4LTUwcS0xMSA4LTIzIDE1dC0yNCAxMkw1OTAtODBIMzcwWm03MC04MGg3OWwxNC0xMDZxMzEtOCA1Ny41LTIzLjVUNjM5LTMyN2w5OSA0MSAzOS02OC04Ni02NXE1LTE0IDctMjkuNXQyLTMxLjVxMC0xNi0yLTMxLjV0LTctMjkuNWw4Ni02NS0zOS02OC05OSA0MnEtMjItMjMtNDguNS0zOC41VDUzMy02OTRsLTEzLTEwNmgtNzlsLTE0IDEwNnEtMzEgOC01Ny41IDIzLjVUMzIxLTYzM2wtOTktNDEtMzkgNjggODYgNjRxLTUgMTUtNyAzMHQtMiAzMnEwIDE2IDIgMzF0NyAzMGwtODYgNjUgMzkgNjggOTktNDJxMjIgMjMgNDguNSAzOC41VDQyNy0yNjZsMTMgMTA2Wm00Mi0xODBxNTggMCA5OS00MXQ0MS05OXEwLTU4LTQxLTk5dC05OS00MXEtNTkgMC05OS41IDQxVDM0Mi00ODBxMCA1OCA0MC41IDk5dDk5LjUgNDFabS0yLTE0MFoiLz48L3N2Zz4=", self.location).href, r = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAtOTYwIDk2MCA5NjAiIHdpZHRoPSIyNHB4IiBmaWxsPSIjMjY3NDdiIj48cGF0aCBkPSJNNDgwLTE2MHEtMTM0IDAtMjI3LTkzdC05My0yMjdxMC0xMzQgOTMtMjI3dDIyNy05M3E2OSAwIDEzMiAyOC41VDcyMC02OTB2LTExMGg4MHYyODBINTIwdi04MGgxNjhxLTMyLTU2LTg3LjUtODhUNDgwLTcyMHEtMTAwIDAtMTcwIDcwdC03MCAxNzBxMCAxMDAgNzAgMTcwdDE3MCA3MHE3NyAwIDEzOS00NHQ4Ny0xMTZoODRxLTI4IDEwNi0xMTQgMTczdC0xOTYgNjdaIi8+PC9zdmc+", self.location).href, o = n, l = ln(null);
    let u = null, c = {}, d = {}, m = {}, h = {}, f = {}, p = {}, g = {};
    const v = () => {
      const { timeCellStep: M, startTime: P, endTime: Y } = x.getters.getCalendarSettings.value, q = La(x.state.calendarStartDate), U = Oa(), j = x.state.calendarType === Qe.daily ? x.getters.getCalendarData.value : x.getters.getCalendarDataCountInside.value;
      u = M_("#daily-calendar", {
        theme: "smeetzz",
        locale: oa[x.state.lang],
        view: {
          timeline: {
            type: "day",
            timeCellStep: M,
            startTime: P,
            endTime: Y
          }
        },
        selectedDate: `${q} ${U}`,
        firstDay: x.state.groupGraphqlModel.weekStartB2b,
        timeFormat: x.state.groupGraphqlModel.timeFormatB2bCustom,
        dateFormat: x.state.groupGraphqlModel.dateFormatB2bCustom,
        dateFormatLong: x.state.groupGraphqlModel.dateFormatB2bCustom,
        data: j,
        resources: x.getters.getResources.value,
        clickToCreate: !1,
        dragToCreate: !1,
        showEventTooltip: !1,
        renderHeader: C,
        renderResource: T,
        renderResourceHeader: N,
        renderScheduleEventContent: O,
        onEventClick: L,
        onPageChange: H,
        onInit: A
      });
    }, y = (M) => Re(this, null, function* () {
      yield x.methods.toggleShowDetails(!1), o("edit-button:clicked", M);
    }), b = () => {
      const M = {
        engineName: x.state.engine,
        accessToken: x.state.userTableKey,
        filter: lr(x.state.filter)
      };
      x.methods.fetchOccupancy(M);
    }, D = () => {
      const M = {
        engineName: x.state.engine,
        accessToken: x.state.userTableKey,
        filter: lr(x.state.filter)
      }, P = ll(
        x.state.calendarType
      );
      x.methods.patchFilter({ fetchParams: M, patchParams: P }), o("filter:changed");
    }, w = () => {
      const { timeCellStep: M, startTime: P, endTime: Y } = x.getters.getCalendarSettings.value, { _timelineType: q } = u.getInst(), U = ll(
        x.state.calendarType
      );
      u.setOptions({
        view: {
          timeline: {
            type: q || "day",
            timeCellStep: M,
            startTime: P,
            endTime: Y
          }
        }
      }), u.refresh(), x.methods.patchSettings(U), o("settings:changed");
    };
    function C() {
      const M = x.state.locale.filters, P = x.state.locale.settings, Y = x.state.locale.refresh;
      return `
    <div class="mbsc-custom-header-date-controls">
      <div mbsc-calendar-nav></div>
      <div class="mbsc-form-group">
          <label>
            <input mbsc-segmented type="radio" name="settings" class="mbsc-smeetzz js-calendar-type-daily">
              <img src="${e}" class="mbsc-segmented-img-space" />
            </input>
          </label>
          <label>
            <input mbsc-segmented type="radio" name="settings" class="mbsc-smeetzz js-calendar-type-daily-count-inside">
              <img src="${t}" class="mbsc-segmented-img-space" />
            </input>
          </label>
        </div>
      <div>
        <button mbsc-button data-variant="outline" class="mbsc-medium mbsc-smeetzz js-refresh-button">
          <img src="${r}" class="mbsc-button-icon-text" />
          <span>${Y}</span>
        </button>
        <button mbsc-button data-variant="outline" class="mbsc-medium mbsc-smeetzz js-filter-button">
          <img src="${a}" class="mbsc-button-icon-text" />
          <span>${M}</span>
        </button>
        <button mbsc-button data-variant="outline" class="mbsc-medium mbsc-smeetzz js-settings-button">
          <img src="${i}" class="mbsc-button-icon-text" />
          <span>${P}</span>
        </button>
        <button mbsc-calendar-prev />
        <button mbsc-calendar-today />
        <button mbsc-calendar-next />
      </div>
    </div>
  `;
    }
    function T(M) {
      return `
    <div class="mbsc-resource-header-template-cont">
      <div class="mbsc-resource-header-template-name">${M.name}</div>
    </div>
  `;
    }
    function N() {
      return `
    <div class="mbsc-resource-header-template-title">
      <div class="mbsc-resource-header-template-name">${x.state.locale.resource}</div>
    </div>
  `;
    }
    function O(M) {
      const P = [], Y = (M == null ? void 0 : M.original) || {}, q = Y.additionalData || {}, U = Rm(
        q,
        x.getters.getCalendarSettings.value
      );
      return x.state.calendarType === Qe.dailyCountInside ? P.push(`
      <div class="mbsc-schedule-event-count-inside-content">
        <span>${Y.totalOccupancy} | ${Y.totalOccupancyQuantity}</span>
      </div>
    `) : (U.cardTitle && P.push(`<p>${U.cardTitle}</p>`), U.cardSubtitle1 && U.cardSubtitle2 ? P.push(
        `<p class="mbsc-schedule-event-title-content">${U.cardSubtitle1} | ${U.cardSubtitle2}</p>`
      ) : (U.cardSubtitle1 || U.cardSubtitle2) && P.push(
        `<p class="mbsc-schedule-event-title-content">
          ${U.cardSubtitle1 || U.cardSubtitle2}
        </p>`
      ), U.cardSubtitle3 && U.cardSubtitle4 ? P.push(
        `<p class="mbsc-schedule-event-title-content">${U.cardSubtitle3} | ${U.cardSubtitle4}</p>`
      ) : (U.cardSubtitle3 || U.cardSubtitle4) && P.push(
        `<p class="mbsc-schedule-event-title-content">
          ${U.cardSubtitle3 || U.cardSubtitle4}
        </p>`
      )), `
    <div>
      ${P.join("")}
    </div>
  `;
    }
    function L(M) {
      return Re(this, null, function* () {
        x.state.calendarType !== Qe.dailyCountInside && (yield x.methods.toggleShowDetails(!0), x.methods.setSelectedEvent(M), ns(l.value));
      });
    }
    function H(M) {
      x.methods.toggleShowDetails(!1);
      const P = wm(M.firstDay);
      if (P !== x.state.calendarStartDate) {
        x.methods.setCalendarStartDate(P);
        const Y = {
          filter: x.state.filter,
          calendarStartDate: x.state.calendarStartDate,
          calendarType: x.state.calendarType
        }, q = Jm(Y);
        x.methods.setFilter(q), b();
      }
    }
    function A() {
      m = document.querySelector(".js-filter-button"), h = document.querySelector(".js-settings-button"), f = document.querySelector(".js-refresh-button"), p = document.querySelector(".js-calendar-type-daily"), g = document.querySelector(
        ".js-calendar-type-daily-count-inside"
      ), m.addEventListener("click", B), h.addEventListener("click", I), f.addEventListener("click", S), p.addEventListener("click", k), g.addEventListener(
        "click",
        R
      );
    }
    const B = () => Re(this, null, function* () {
      yield x.methods.toggleShowFilter(
        !x.state.showFilter
      ), ns(l.value), x.methods.toggleShowDetails(!1), x.methods.toggleShowSettings(!1);
    }), I = () => Re(this, null, function* () {
      yield x.methods.toggleShowSettings(
        !x.state.showSettings
      ), ns(l.value), x.methods.toggleShowDetails(!1), x.methods.toggleShowFilter(!1);
    }), S = () => {
      b();
    }, k = () => Re(this, null, function* () {
      if (x.methods.toggleShowDetails(!1), x.methods.toggleShowFilter(!1), x.methods.toggleShowSettings(!1), x.state.calendarType !== Qe.daily) {
        const M = cl(Qe.daily), P = La(x.state.calendarStartDate), Y = Oa();
        W(Qe.daily), x.methods.toggleShowSettings(!1), x.methods.toggleShowFilter(!1), x.methods.setCalendarType(Qe.daily), yield x.methods.patchCalendarType(M);
        const { timeCellStep: q, startTime: U, endTime: j } = x.getters.getCalendarSettings.value, { _timelineType: ee } = u.getInst();
        u.setOptions({
          view: {
            timeline: {
              type: ee || "day",
              timeCellStep: q,
              startTime: U,
              endTime: j
            }
          }
        }), u.setOptions({
          selectedDate: `${P} ${Y}`,
          data: x.getters.getCalendarData.value,
          resources: x.getters.getResources.value
        }), u.refresh(), o("calendar-type:changed");
      }
    }), R = () => Re(this, null, function* () {
      if (x.methods.toggleShowDetails(!1), x.methods.toggleShowFilter(!1), x.methods.toggleShowSettings(!1), x.state.calendarType !== Qe.dailyCountInside) {
        const M = cl(Qe.dailyCountInside), P = La(x.state.calendarStartDate), Y = Oa();
        W(Qe.dailyCountInside), x.methods.toggleShowSettings(!1), x.methods.toggleShowFilter(!1), x.methods.setCalendarType(Qe.dailyCountInside), yield x.methods.patchCalendarType(M);
        const { timeCellStep: q, startTime: U, endTime: j } = x.getters.getCalendarSettings.value, { _timelineType: ee } = u.getInst();
        u.setOptions({
          view: {
            timeline: {
              type: ee || "day",
              timeCellStep: q,
              startTime: U,
              endTime: j
            }
          }
        }), u.setOptions({
          selectedDate: `${P} ${Y}`,
          data: x.getters.getCalendarDataCountInside.value,
          resources: x.getters.getResources.value
        }), u.refresh(), o("calendar-type:changed");
      }
    }), z = () => {
      const M = document.getElementsByClassName(
        "js-calendar-type-daily"
      )[0], P = document.getElementsByClassName(
        "js-calendar-type-daily-count-inside"
      )[0];
      switch (c = Il(M), d = Il(P), x.state.calendarType) {
        case Qe.daily:
          c.setOptions({ checked: !0 });
          break;
        case Qe.dailyCountInside:
          d.setOptions({ checked: !0 });
          break;
        default:
          c.setOptions({ checked: !0 });
      }
    }, W = (M) => {
      c.setOptions({ checked: M === Qe.daily }), d.setOptions({
        checked: M === Qe.dailyCountInside
      });
    };
    return sa(
      () => x.state.isLoading,
      (M, P) => {
        if (!M && P && u) {
          const Y = La(x.state.calendarStartDate), q = Oa(), U = x.state.calendarType === Qe.daily ? x.getters.getCalendarData.value : x.getters.getCalendarDataCountInside.value;
          u.setOptions({
            selectedDate: `${Y} ${q}`,
            data: U,
            resources: x.getters.getResources.value
          });
        }
        u || (v(), z());
      }
    ), fn(() => {
      In(ff), In(_f), In(k_), In(S_), In(T_), In(E_), In(Pf), In(zf);
    }), Ms(() => {
      m != null && m.removeEventListener && m.removeEventListener("click", B), h != null && h.removeEventListener && h.removeEventListener("click", I), f != null && f.removeEventListener && f.removeEventListener("click", S), p != null && p.removeEventListener && p.removeEventListener("click", k), g != null && g.removeEventListener && g.removeEventListener(
        "click",
        R
      ), u != null && u.destroy && u.destroy();
    }), (M, P) => (Me(), gt("div", {
      ref_key: "refsWrapper",
      ref: l
    }, [
      Q(x).state.showFilter ? (Me(), _t(uv, {
        key: 0,
        style: qa({ height: Q(x).state.height }),
        "onFilter:changed": D
      }, null, 8, ["style"])) : mt("", !0),
      Q(x).state.showSettings ? (Me(), _t(Dg, {
        key: 1,
        style: qa({ height: Q(x).state.height }),
        class: na({ "mbsc-one-sidebar-space": Q(x).state.showFilter }),
        "onSettings:changed": w,
        "onSorting:changed": w
      }, null, 8, ["style", "class"])) : mt("", !0),
      oc(Zi(nv, { "onEditButton:clicked": y }, null, 512), [
        [du, Q(x).state.showDetails]
      ]),
      ae("div", {
        class: na([
          "mbsc-calendar-wrapper",
          {
            "mbsc-one-sidebar-space mbsc-hide-mobile": Q(x).state.showFilter || Q(x).state.showSettings
          }
        ])
      }, [
        ae("div", {
          id: "daily-calendar",
          style: qa({ height: Q(x).state.height }),
          class: "mbsc-resource-header-template"
        }, null, 4)
      ], 2)
    ], 512));
  }
}, xg = {
  unknown: "Unbekannt",
  capacity: "Kapazität",
  "booking-ref-dots": "Buchungsreferenz:",
  "booking-ref": "Buchungsreferenz",
  "ticket-dots": "Ticket:",
  ticket: "Ticket",
  "quantity-dots": "Menge:",
  quantity: "Menge",
  "edit-order": "Bestellung bearbeiten",
  "not-specified": "Nicht angegeben",
  impossible: "Unmöglich",
  "pending-info": "Ausstehende Informationen",
  "pending-payment": "Ausstehende Zahlungen",
  completed: "Abgeschlossen",
  canceled: "Abgebrochen",
  "auth-capture": "Auth capture",
  "to-refund": "Zur Rückerstattung",
  abandoned: "Abgebrochen",
  resource: "Ressource",
  save: "Speichern",
  close: "Schließen",
  "please-select": "Bitte wählen Sie...",
  status: "Status",
  "customer-full-name": "Vollständiger Name des Kunden",
  "booking-state": "Reservierungsstatus",
  "calendar-updated": "Aktualisierung",
  filters: "Filter",
  settings: "Einstellungen",
  time: "Zeit",
  none: "Keine",
  title: "Titel",
  subtitle: "Untertitel",
  "time-scale": "Zeitskala",
  "settings-changed": "Preferenzen",
  minutes: "Minuten",
  hour: "Stunde",
  hours: "Stunden",
  "display-hours": "Angezeigte Stunden",
  "start-time": "Startzeit",
  "end-time": "Endzeit",
  quoted: "Angebot",
  invoiced: "In Rechnung gestellt",
  refused: "Abgelehnt",
  "partially-paid": "Teilweise bezahlt",
  paid: "Bezahlt",
  "late-payment": "Zahlungsverzug",
  "cancelled-invoice": "Stornierte Rechnung",
  "extras-dots": "Extras:",
  "document-status": "Status des Dokuments",
  "product-dots": "Produkt:",
  product: "Produkt",
  attendee: "teilnehmer",
  attendees: "teilnehmer",
  refresh: "Aktualisieren",
  "check-connection-try-again": "Überprüfen Sie Ihre Verbindung und versuchen Sie es erneut",
  cancel: "Abbrechen",
  "manage-resource-positions": "Verwalten von Ressourcenpositionen",
  "create-resources-first": "Bitte wenden Sie sich an Ihren Account Manager, um Ressourcen zu konfigurieren und diesen Kalender anzuzeigen",
  "number-extras": "Anzahl der Extras",
  "people-inside-tickets": "Personen drinnen / Anzahl der Eintrittskarten",
  "custom-fields": "Benutzerdefinierte Felder",
  "color-partially-scanned-bookings": "Farbe für teilweise gescannte Buchungen",
  "color-fully-scanned-bookings": "Farbe für vollständig gescannte Buchungen"
}, Cg = {
  unknown: "Unknown",
  capacity: "Capacity",
  "booking-ref-dots": "Booking reference:",
  "booking-ref": "Booking reference",
  "ticket-dots": "Ticket:",
  ticket: "Ticket",
  "quantity-dots": "Quantity:",
  quantity: "Quantity",
  "edit-order": "Edit order",
  "not-specified": "Not specified",
  impossible: "Impossible",
  "pending-info": "Pending info",
  "pending-payment": "Pending payment",
  completed: "Completed",
  canceled: "Canceled",
  "auth-capture": "Auth capture",
  "to-refund": "To refund",
  abandoned: "Abandoned",
  resource: "Resource",
  save: "Save",
  close: "Close",
  "please-select": "Please select...",
  status: "Status",
  "customer-full-name": "Customer full name",
  "booking-state": "Booking state",
  "calendar-updated": "Calendar updated",
  filters: "Filters",
  settings: "Settings",
  time: "Time",
  none: "None",
  title: "Title",
  subtitle: "Subtitle",
  "time-scale": "Time scale",
  "settings-changed": "Settings changed",
  minutes: "Minutes",
  hour: "hour",
  hours: "hours",
  "display-hours": "Display hours",
  "start-time": "Start time",
  "end-time": "End time",
  quoted: "Quoted",
  invoiced: "Invoiced",
  refused: "Refused",
  "partially-paid": "Partially paid",
  paid: "Paid",
  "late-payment": "Late payment",
  "cancelled-invoice": "Cancelled invoice",
  "extras-dots": "Extras:",
  "document-status": "Document status",
  "product-dots": "Product:",
  product: "Product",
  attendee: "attendee",
  attendees: "attendees",
  refresh: "Refresh",
  "check-connection-try-again": "Check your connection and try again",
  cancel: "Cancel",
  "manage-resource-positions": "Manage resource positions",
  "create-resources-first": "Please contact your account manager to configure resources and display this calendar",
  "number-extras": "Number of extras",
  "people-inside-tickets": "People inside / Number of tickets",
  "custom-fields": "Custom fields",
  "color-partially-scanned-bookings": "Color for partially scanned bookings",
  "color-fully-scanned-bookings": "Color for fully scanned bookings"
}, Sg = {
  unknown: "Inconnu",
  capacity: "Capacité",
  "booking-ref-dots": "Référence de réservation:",
  "booking-ref": "Référence de réservation",
  "ticket-dots": "Ticket:",
  ticket: "Ticket",
  "quantity-dots": "Quantité:",
  quantity: "Quantité",
  "edit-order": "Modifier commande",
  "not-specified": "Non spécifié",
  impossible: "Impossible",
  "pending-info": "En attente d'information",
  "pending-payment": "En attente de paiement",
  completed: "Terminé",
  canceled: "Annulé",
  "auth-capture": "Authorisé",
  "to-refund": "A rembourser",
  abandoned: "Abandonné",
  resource: "Ressource",
  save: "Sauvegarder",
  close: "Fermer",
  "please-select": "Veuillez choisir...",
  status: "Statut",
  "customer-full-name": "Nom complet du client",
  "booking-state": "Statut de réservation",
  "calendar-updated": "Calendrier mis à jour",
  filters: "Filtres",
  settings: "Réglages",
  time: "Heure",
  none: "Aucun",
  title: "Titre",
  subtitle: "Sous-titre",
  "time-scale": "Echelle de temps",
  "settings-changed": "Paramètres modifiés",
  minutes: "Minutes",
  hour: "heure",
  hours: "heures",
  "display-hours": "Heures affichées",
  "start-time": "Heure de début",
  "end-time": "Heure de fin",
  quoted: "Devis",
  invoiced: "Facturé",
  refused: "Refusé",
  "partially-paid": "Partiellement payé",
  paid: "Payé",
  "late-payment": "Paiement en retard",
  "cancelled-invoice": "Facture annulée",
  "extras-dots": "Extras:",
  "document-status": "Statut du document",
  "product-dots": "Produit:",
  product: "Produit",
  attendee: "participant",
  attendees: "participants",
  refresh: "Rafraîchir",
  "check-connection-try-again": "Vérifiez votre connexion et réessayez",
  cancel: "Annuler",
  "manage-resource-positions": "Changer l'ordre d'affichage des ressources",
  "create-resources-first": "Veuillez contacter votre chargé de compte pour configurer des ressources et afficher ce calendrier",
  "number-extras": "Nombre d'extras",
  "people-inside-tickets": "Personnes à l'intérieur / Nombre de billets",
  "custom-fields": "Champs personnalisés",
  "color-partially-scanned-bookings": "Réservation en partie scannée",
  "color-fully-scanned-bookings": "Réservation entièrement scannée"
}, Tg = {
  de: xg,
  en: Cg,
  fr: Sg
}, Eg = `
  query GetUser($id: String!) {
    User: UserRead(id: $id) {
      AdvancedSettings
    }
  }
`, kg = `
  query GetGroup($id: String!) {
    Group: GroupRead(id: $id) {
      DateFormatB2b
      TimeFormatB2b
      WeekStartB2b
    }
  }
`;
const Mg = {
  key: 0,
  class: "mbsc-loader-wrapper"
}, Ig = /* @__PURE__ */ ae("span", { class: "mbsc-loader" }, null, -1), Ng = [
  Ig
], Rg = {
  __name: "CalendarsApp",
  props: {
    lang: {
      type: String,
      required: !0
    },
    env: {
      type: String,
      required: !0
    },
    userTableKey: {
      type: String,
      required: !0
    },
    userToken: {
      type: String,
      required: !0
    },
    groupId: {
      type: String,
      required: !0
    },
    appType: {
      type: String,
      required: !0
    },
    type: {
      type: String,
      default: Qe.daily
    },
    height: {
      type: String,
      default: "100%"
    },
    userId: {
      required: !0,
      type: String
    },
    userGraphqlToken: {
      required: !0,
      type: String
    },
    date: String,
    filters: Array,
    settings: Object,
    viewId: [String, Number],
    sessionId: {
      type: String,
      default: ""
    }
  },
  emits: [
    "edit-button:clicked",
    "filter:changed",
    "settings:changed",
    "calendar-type:changed",
    "calendar:failed",
    "refresh-button:clicked"
  ],
  setup(s, { emit: n }) {
    const e = s, t = n, a = () => Re(this, null, function* () {
      try {
        x.methods.resetStates(), yield r(), o();
      } catch (p) {
        throw new Error(p);
      }
    }), i = () => Re(this, null, function* () {
      const p = {
        fetchUser: {
          env: e.env,
          accessToken: e.userGraphqlToken,
          variables: { id: String(e.userId) },
          query: Eg
        },
        fetchGroup: {
          env: e.env,
          accessToken: e.userGraphqlToken,
          variables: { id: String(e.groupId) },
          query: kg
        }
      };
      yield x.methods.fetchInitGraphqlData(p);
    }), r = () => Re(this, null, function* () {
      try {
        const p = Om(e.date, e.type), g = {
          lang: e.lang,
          env: e.env,
          engine: Vm(e.env),
          userTableKey: e.userTableKey,
          userToken: e.userToken,
          groupId: e.groupId,
          calendarStartDate: p,
          calendarType: e.type,
          settings: ge({}, e.settings),
          locale: ge({}, Tg[e.lang]),
          height: e.height,
          appType: e.appType,
          userAdvancedSettings: {},
          viewId: e.viewId || null,
          userGraphqlToken: e.userGraphqlToken,
          userId: e.userId,
          propsFilters: e.filters || [],
          propsSettings: ge({}, e.settings),
          calendarError: null,
          sorting: {},
          filter: {
            filters: [],
            page: {
              size: 25,
              current: 1
            },
            query: ""
          }
        };
        x.methods.initStates(g), yield i();
        const v = Pm({
          userAdvancedSettings: x.state.userGraphqlModel.advancedSettingsCustomObject,
          appType: e.appType,
          groupId: e.groupId,
          viewId: e.viewId,
          defaultType: e.type
        }), y = Uc({
          userAdvancedSettings: x.state.userGraphqlModel.advancedSettingsCustomObject,
          calendarType: v,
          appType: e.appType,
          groupId: e.groupId,
          viewId: e.viewId
        }), b = {
          propsFilters: e.filters || [],
          calendarStartDate: p,
          calendarType: v,
          backendFilters: y.filters
        };
        x.methods.setCalendarType(v), x.methods.setFilter($c(b)), x.methods.setSettings(
          ge(ge({}, y.settings), e.settings),
          !1
        ), x.methods.setUserAdvancedSettings(ge({}, x.state.userGraphqlModel.advancedSettingsCustomObject)), x.methods.setSorting(ge({}, y.sorting));
      } catch (p) {
        throw new Error(p);
      }
    }), o = () => {
      const p = {
        fetchStocks: {
          groupId: x.state.groupId,
          accessToken: x.state.userToken,
          env: x.state.env
        },
        fetchOccupancy: {
          engineName: x.state.engine,
          accessToken: x.state.userTableKey,
          filter: lr(x.state.filter)
        }
      };
      x.methods.fetchInitialData(p);
    }, l = (p) => {
      t("edit-button:clicked", p);
    }, u = () => {
      t("filter:changed", x.state.filter.filters);
    }, c = () => {
      t("settings:changed", x.state.settings);
    }, d = () => {
      t("calendar-type:changed", x.state.calendarType);
    }, m = () => {
      t("refresh-button:clicked"), a();
    }, h = () => {
      try {
        bs.info(`Occupancy calendar ${e.appType} is online`, {
          levelName: "INFO"
        });
      } catch (p) {
        console.warn("Error while logger service", p);
      }
    }, f = () => {
      try {
        bs.info(`Occupancy calendar ${e.appType} is offline`, {
          levelName: "INFO"
        });
      } catch (p) {
        console.warn("Error while logger service", p);
      }
    };
    return sa(
      () => x.state.calendarError,
      (p) => {
        p !== null && t("calendar:failed", p);
      }
    ), sa(
      () => JSON.stringify(e),
      () => {
        x.methods.setUserToken(e.userToken), x.methods.setUserTableKey(e.userTableKey), x.methods.setUserGraphqlToken(e.userGraphqlToken);
      }
    ), fn(() => {
      const p = e.sessionId || Hc();
      window.addEventListener("online", h), window.addEventListener("offline", f), x.methods.setSessionId(p), a();
    }), Ms(() => {
      window != null && window.removeEventListener && (window.removeEventListener("online", h), window.removeEventListener("offline", f)), x.methods.resetStates();
    }), (p, g) => (Me(), gt("div", null, [
      Q(x).state.isLoading ? (Me(), gt("div", Mg, Ng)) : mt("", !0),
      Q(x).state.calendarError !== null ? (Me(), _t(Q(L_), {
        key: 1,
        "onRefreshButton:clicked": m
      })) : mt("", !0),
      Q(x).state.calendarError === null && !Q(x).state.isLoading && Q(x).getters.getResources.value.length === 0 ? (Me(), _t(Q(P_), { key: 2 })) : mt("", !0),
      Q(x).state.calendarError === null && Q(x).getters.getResources.value.length !== 0 ? (Me(), _t(Q(wg), {
        key: 3,
        "onEditButton:clicked": l,
        "onFilter:changed": u,
        "onSettings:changed": c,
        "onCalendarType:changed": d
      })) : mt("", !0)
    ]));
  }
};
export {
  Rg as SmeetzCalendars
};
